{
  "generated_at": "2026-10-14T05:00:11.591Z",
  "data": [
    {
      "id": 1,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 1, Part 2, Div 2, s14",
      "section": "Aged Care Code of Conduct",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Aged Care Code of Conduct",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "summaryHTML": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "extract": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631304",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 85,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 5, s14-5",
          "section": "Requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Aged Care Code of Conduct",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "summaryHTML": "<i>Requirements\n\n</i>When delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "extract": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s14"
        },
        {
          "id": 86,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 5, s14-5",
          "section": "Requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Aged Care Code of Conduct",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "summaryHTML": "<i>Requirements\n\n</i>When delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "extract": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s14"
        }
      ]
    },
    {
      "id": 2,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 1, Part 2, Div 2, s14",
      "section": "Aged Care Code of Conduct",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Aged Care Code of Conduct",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "summaryHTML": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "extract": "The rules may prescribe requirements relating to the conduct of the following: \n\n(a) registered providers; \n\n(b) aged care workers of registered providers; \n\n(c) responsible persons of registered providers. \n\nNote: These requirements are the Aged Care Code of Conduct: see section 7.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631304",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": true,
        "dpo": true,
        "rp": true
      },
      "type": "Hook",
      "rules": [
        {
          "id": 85,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 5, s14-5",
          "section": "Requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Aged Care Code of Conduct",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "summaryHTML": "<i>Requirements\n\n</i>When delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "extract": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s14"
        },
        {
          "id": 86,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 5, s14-5",
          "section": "Requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Aged Care Code of Conduct",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "summaryHTML": "<i>Requirements\n\n</i>When delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "extract": "Requirements\n\nWhen delivering funded aged care services to individuals, I must:\n\n(a) act with respect for individuals’ rights to freedom of expression, self-determination and decision-making in accordance with applicable laws and conventions; and\n\n(b) act in a way that treats individuals with dignity and respect, and values their diversity; and\n\n(c) act with respect for the privacy of individuals; and\n\n(d) deliver funded aged care services in a safe and competent manner, with care and skill; and\n\n(e) act with integrity, honesty and transparency; and\n\n(f) promptly take steps to raise and act on concerns about matters that may impact the quality and safety of funded aged care services; and\n\n(g) deliver funded aged care services free from:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct; and\n\n(h) take all reasonable steps to prevent and respond to:\n\n(i) all forms of violence, discrimination, exploitation, neglect and abuse; and\n\n(ii) sexual misconduct",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s14"
        }
      ]
    },
    {
      "id": 3,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 1, Part 2, Div 2, s15",
      "section": "Aged Care Quality Standards",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Compliance with Aged Care Quality Standards",
      "topic": [
        "governance",
        "complaints"
      ],
      "summary": "The rules can set specific quality standards for the aged care services that are funded and provided by registered providers.\n\nNote 1: These quality standards are known as the Aged Care Quality Standards, which you can find in section 7.\n\nNote 2: Only some registered providers need to be audited to ensure they meet these standards before they can be registered. Some providers must follow these standards to maintain their registration, as explained in sections 142 and 146.\n\nIn addition to the previous point (subsection 1), the rules can set standards for the following areas:\n(a) How registered providers should treat and interact with people who want to access or are using funded aged care services.\n\n(b) How these providers should provide funded aged care services, including how they are managed and how they plan and deliver end-of-life care.\n\n(c) The physical spaces where funded aged care services must be provided.\n\n(d) How these providers should ensure that they provide quality and safe medical care, including procedures for preventing and controlling infections.\n\n(e) How they should provide food and drinks that meet the nutritional needs and preferences of individuals.\n\nIn addition to the previous points (subsection 1), the rules can state that certain parts of the Aged Care Quality Standards apply to:\n(a) All registered providers.\n\n(b) Registered providers that fall into specific registration categories.\n\n(c) Certain types of registered providers.\n\n(f) How they should support individuals who are using funded aged care services in approved residential care facilities.\n\n(g) How they should handle and respond to feedback and complaints from individuals.\n\n(h) How they should monitor their services and make improvements to enhance the quality of the funded aged care they provide.",
      "summaryHTML": "The rules can set specific quality standards for the aged care services that are funded and provided by registered providers.\n\nNote 1: These quality standards are known as the Aged Care Quality Standards, which you can find in section 7.\n\nNote 2: Only some registered providers need to be audited to ensure they meet these standards before they can be registered. Some providers must follow these standards to maintain their registration, as explained in sections 142 and 146.\n\nIn addition to the previous point (subsection 1), the rules can set standards for the following areas:\n(a) How registered providers should treat and interact with people who want to access or are using funded aged care services.\n\n(b) How these providers should provide funded aged care services, including how they are managed and how they plan and deliver end-of-life care.\n\n(c) The physical spaces where funded aged care services must be provided.\n\n(d) How these providers should ensure that they provide quality and safe medical care, including procedures for preventing and controlling infections.\n\n(e) How they should provide food and drinks that meet the nutritional needs and preferences of individuals.\n\nIn addition to the previous points (subsection 1), the rules can state that certain parts of the Aged Care Quality Standards apply to:\n(a) All registered providers.\n\n(b) Registered providers that fall into specific registration categories.\n\n(c) Certain types of registered providers.\n\n(f) How they should support individuals who are using funded aged care services in approved residential care facilities.\n\n(g) How they should handle and respond to feedback and complaints from individuals.\n\n(h) How they should monitor their services and make improvements to enhance the quality of the funded aged care they provide.",
      "extract": "(1) The rules may prescribe standards relating to the quality of funded aged care services delivered by a registered provider.\n\nNote 1: These standards are the Aged Care Quality Standards: see section 7.\n\nNote 2: Only registered providers in certain registration categories are required to be audited against these standards before registration: see paragraph 109(2)(d). Certain registered providers are required to comply with the standards as a condition of registration: see sections 142 and 146.\n\n(2) Without limiting subsection (1), the rules may prescribe standards about the following matters:\n\n(a) how registered providers must treat, and engage with, individuals seeking to access, or accessing, funded aged care services;\n\n(b) how registered providers must deliver funded aged care services, including governance arrangements and arrangements for planning and delivery of palliative care;\n\n(c) the physical environments in which funded aged care services are required to be delivered;\n\n(d) how registered providers must deliver quality and safe clinical care to individuals, including infection prevention and control procedures and arrangements;\n\n(e) how registered providers must deliver food and drink to meet the nutritional needs and preferences of individuals;\n\n(f) how registered providers must support individuals accessing funded aged care services in approved residential care homes;\n\n(g) how registered providers must manage and respond to feedback and complaints;\n\n(h) how registered providers must monitor and drive improvements to their delivery of funded aged care services.\n\n(3) Without limiting subsection (1), the rules may provide that a provision of the Aged Care Quality Standards applies to the following:\n\n(a) all registered providers;\n\n(b) registered providers in specified provider registration categories;\n\n(c) specified kinds of registered providers.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631305",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 87,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 1, s15-5(1)-(1A)",
          "section": "Application of standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Standards 1 to 4\n\n(1) Standards 1 to 4 apply to a registered provider in any of the following provider registration categories: \n\n(a) personal and care support in the home or community; \n\n(b) nursing and transition care; \n\n(c) residential care. \n\n(1A) Standards 1 to 4 apply to a registered provider in the provider registration category subscription trial if the provider is also in a provider registration category referred to in paragraph (1)(a) or (b).",
          "summaryHTML": "<i>Standards 1 to 4</i>\n\n(1) Standards 1 to 4 apply to a registered provider in any of the following provider registration categories: \n\n(a) personal and care support in the home or community; \n\n(b) nursing and transition care; \n\n(c) residential care. \n\n(1A) Standards 1 to 4 apply to a registered provider in the provider registration category subscription trial if the provider is also in a provider registration category referred to in paragraph (1)(a) or (b).",
          "extract": "Standards 1 to 4 \n\n(1) Standards 1 to 4 apply to a registered provider in any of the following provider registration categories: \n\n(a) personal and care support in the home or community; \n\n(b) nursing and transition care; \n\n(c) residential care. \n\n(1A) Standards 1 to 4 apply to a registered provider in the provider registration category subscription trial if the provider is also in a provider registration category referred to in paragraph (1)(a) or (b).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 88,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 1, s15-5(2)",
          "section": "Application of standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Standard 5 \n\n(2) Standard 5 applies to a registered provider in either of the following provider registration categories: \n\n(a) nursing and transition care; \n\n(b) residential care. \n\n(2A) Standard 5 applies to a registered provider in the provider registration category subscription trial if the provider is also in the provider registration category referred to in paragraph (2)(a).",
          "summaryHTML": "<i>Standard 5</i> \n\n(2) Standard 5 applies to a registered provider in either of the following provider registration categories: \n\n(a) nursing and transition care; \n\n(b) residential care. \n\n(2A) Standard 5 applies to a registered provider in the provider registration category subscription trial if the provider is also in the provider registration category referred to in paragraph (2)(a).",
          "extract": "Standard 5\n\n(2) Standard 5 applies to a registered provider in either of the following provider registration categories: \n\n(a) nursing and transition care; \n\n(b) residential care. \n\n(2A) Standard 5 applies to a registered provider in the provider registration category subscription trial if the provider is also in the provider registration category referred to in paragraph (2)(a).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 89,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 1, s15-5(3)",
          "section": "Application of standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "(3) Subsections 15-30(1) and (2) (Standard 5—Outcome 5.1—Clinical governance) apply to a registered provider in the provider registration Category 4 - personal care and care support in the home or community that delivers, or intends to deliver, either of the following service types: \n\n(a) care management; \n\n(b) restorative care management.",
          "summaryHTML": "(3) Subsections 15-30(1) and (2) (Standard 5—Outcome 5.1—Clinical governance) apply to a registered provider in the provider registration Category 4 - personal care and care support in the home or community that delivers, or intends to deliver, either of the following service types: \n\n(a) care management; \n\n(b) restorative care management.",
          "extract": "(3) Subsections 15-30(1) and (2) (Standard 5—Outcome 5.1—Clinical governance) apply to a registered provider in the provider registration category personal and care support in the home or community that delivers, or intends to deliver, either of the following service types: \n\n(a) care management; \n\n(b) restorative care management.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 90,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 1, s15-5(4)",
          "section": "Application of standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Standards 6 and 7 \n\n(4) Standards 6 and 7 apply to a registered provider in the provider registration Category 6 - residential care.",
          "summaryHTML": "<i>Standards 6 and 7 </i>\n\n(4) Standards 6 and 7 apply to a registered provider in the provider registration Category 6 - residential care.",
          "extract": "Standards 6 and 7\n\n(4) Standards 6 and 7 apply to a registered provider in the provider registration category residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 91,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-10(1)-(3)",
          "section": "Standard 1—The individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 1.1—Person-centred care \n\n(1) The registered provider demonstrates that the provider understands that the safety, health, wellbeing and quality of life of individuals is the primary consideration in the delivery of funded aged care services.\n\nNote: See also subsection 144(2) of the Act (rights and principles).\n\n(2) The provider demonstrates that the provider understands and values individuals, including their identity, culture, ability, diversity, beliefs and life experiences.\n\nNote: See also section 23 of the Act (Statement of Rights) and section 144 of the Act (rights and principles).\n\n(3) The provider demonstrates that the provider develops funded aged care services with, and tailored to, individuals, taking into account their needs, goals and preferences.",
          "summaryHTML": "<i>Outcome 1.1—Person-centred care </i>\n\n(1) The registered provider demonstrates that the provider understands that the safety, health, wellbeing and quality of life of individuals is the primary consideration in the delivery of funded aged care services.\n\nNote: See also subsection 144(2) of the Act (rights and principles).\n\n(2) The provider demonstrates that the provider understands and values individuals, including their identity, culture, ability, diversity, beliefs and life experiences.\n\nNote: See also section 23 of the Act (Statement of Rights) and section 144 of the Act (rights and principles).\n\n(3) The provider demonstrates that the provider develops funded aged care services with, and tailored to, individuals, taking into account their needs, goals and preferences.",
          "extract": "Outcome 1.1—Person-centred care \n\n(1) The registered provider demonstrates that the provider understands that the safety, health, wellbeing and quality of life of individuals is the primary consideration in the delivery of funded aged care services.\n\nNote: See also subsection 144(2) of the Act (Rights and principles).\n\n(2) The provider demonstrates that the provider understands and values individuals, including their identity, culture, ability, diversity, beliefs and life experiences.\n\nNote: See also section 23 of the Act (Statement of Rights) and section 144 of the Act (Rights and principles).\n\n(3) The provider demonstrates that the provider develops funded aged care services with, and tailored to, individuals, taking into account their needs, goals and preferences.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 92,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-10(4)-(5)",
          "section": "Standard 1—The individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 1.2—Dignity, respect and privacy \n\n(4) The provider must deliver funded aged care services to individuals in a way that:\n\n(a) is free from all forms of discrimination, abuse and neglect; and\n\n(b) treats individuals with dignity and respect; and\n\n(c) respects the personal privacy of individuals.\n\nNote: See section 23 of the Act (Statement of Rights) and section 144 of the Act (rights and principles).\n\n(5) The provider:\n\n(a) demonstrates that the provider understands the rights of individuals under the Statement of Rights; and\n\n(b) must have practices in place to ensure that the provider acts compatibly with the Statement of Rights, in accordance with subsection 24(2) of the Act (acting compatibly with the Statement of Rights).\n\nNote: See also section 144 of the Act (rights and principles).",
          "summaryHTML": "<i>Outcome 1.2—Dignity, respect and privacy </i>\n\n(4) The provider must deliver funded aged care services to individuals in a way that:\n\n(a) is free from all forms of discrimination, abuse and neglect; and\n\n(b) treats individuals with dignity and respect; and\n\n(c) respects the personal privacy of individuals.\n\nNote: See section 23 of the Act (Statement of Rights) and section 144 of the Act (rights and principles).\n\n(5) The provider:\n\n(a) demonstrates that the provider understands the rights of individuals under the Statement of Rights; and\n\n(b) must have practices in place to ensure that the provider acts compatibly with the Statement of Rights, in accordance with subsection 24(2) of the Act (acting compatibly with the Statement of Rights).\n\nNote: See also section 144 of the Act (rights and principles).",
          "extract": "Outcome 1.2—Dignity, respect and privacy \n\n(4) The provider must deliver funded aged care services to individuals in a way that:\n\n(a) is free from all forms of discrimination, abuse and neglect; and\n\n(b) treats individuals with dignity and respect; and\n\n(c) respects the personal privacy of individuals.\n\nNote: See section 23 of the Act (Statement of Rights) and section 144 of the Act (Rights and principles).\n\n(5) The provider:\n\n(a) demonstrates that the provider understands the rights of individuals under the Statement of Rights; and\n\n(b) must have practices in place to ensure that the provider acts compatibly with the Statement of Rights, in accordance with subsection 24(2) of the Act (acting compatibly with the Statement of Rights).\n\nNote: See also section 144 of the Act (Rights and principles).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 93,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-10(6)-(8)",
          "section": "Standard 1—The individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 1.3—Choice, independence and quality of life \n\n(6) The provider must support individuals to exercise choice and make decisions about their funded aged care services, and provide them with support to exercise choice and make decisions when they want or need it.\n\n(7) The provider must provide individuals with timely, accurate, tailored and sufficient information about their funded aged care services, in a way they understand.\n\nNote: See also section 29 of the Act (giving information and documents to supporters).\n\n(8) The provider must support individuals to exercise dignity of risk to achieve their goals and maintain independence and quality of life.",
          "summaryHTML": "<i>Outcome 1.3—Choice, independence and quality of life </i>\n\n(6) The provider must support individuals to exercise choice and make decisions about their funded aged care services, and provide them with support to exercise choice and make decisions when they want or need it.\n\n(7) The provider must provide individuals with timely, accurate, tailored and sufficient information about their funded aged care services, in a way they understand.\n\nNote: See also section 29 of the Act (giving information and documents to supporters).\n\n(8) The provider must support individuals to exercise dignity of risk to achieve their goals and maintain independence and quality of life.",
          "extract": "Outcome 1.3—Choice, independence and quality of life \n\n(6) The provider must support individuals to exercise choice and make decisions about their funded aged care services, and provide them with support to exercise choice and make decisions when they want or need it.\n\n(7) The provider must provide individuals with timely, accurate, tailored and sufficient information about their funded aged care services, in a way they understand.\n\nNote: See also section 29 of the Act (Giving information and documents to supporters).\n\n(8) The provider must support individuals to exercise dignity of risk to achieve their goals and maintain independence and quality of life.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 94,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-10(9)-(10)",
          "section": "Standard 1—The individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Outcome 1.4—Transparency and agreements \n\n(9) Before entering into any agreements with individuals about the delivery of funded aged care services, the provider must provide individuals with:\n\n(a) the opportunity to exercise autonomy; and\n\n(b) the time they need to consider the agreement; and\n\n(c) an opportunity to seek advice.\n\nNote: Refer to sections 148-65 and 148-70 of the rules in relation to the requirements for entering into a service agreement, details and contents of such an agreement. \n\n(10) The provider must support individuals to understand and make informed decisions about their agreements, fees and invoices.",
          "summaryHTML": "<i>Outcome 1.4—Transparency and agreements </i>\n\n(9) Before entering into any agreements with individuals about the delivery of funded aged care services, the provider must provide individuals with:\n\n(a) the opportunity to exercise autonomy; and\n\n(b) the time they need to consider the agreement; and\n\n(c) an opportunity to seek advice.\n\nNote: Refer to sections 148-65 and 148-70 of the rules in relation to the requirements for entering into a service agreement, details and contents of such an agreement. \n\n(10) The provider must support individuals to understand and make informed decisions about their agreements, fees and invoices.",
          "extract": "Outcome 1.4—Transparency and agreements \n\n(9) Before entering into any agreements with individuals about the delivery of funded aged care services, the provider must provide individuals with:\n\n(a) the opportunity to exercise autonomy; and\n\n(b) the time they need to consider the agreement; and\n\n(c) an opportunity to seek advice.\n\nNote: Refer to sections 148-65 and 148-70 of this instrument in relation to the requirements for entering into a service agreement, details and contents of such an agreement. \n\n(10) The provider must support individuals to understand and make informed decisions about their agreements, fees and invoices.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 95,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(1)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 2.1—Partnering with individuals\n\n(1) The registered provider must engage in meaningful and active partnerships with individuals to inform organisational priorities and continuous improvement. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "summaryHTML": "<i>Outcome 2.1—Partnering with individuals\n\n</i>(1) The registered provider must engage in meaningful and active partnerships with individuals to inform organisational priorities and continuous improvement. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "extract": "Outcome 2.1—Partnering with individuals\n\n(1) The registered provider must engage in meaningful and active partnerships with individuals to inform organisational priorities and continuous improvement. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 102,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(2)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "workforce",
            "governance"
          ],
          "summary": "Outcome 2.2a—Quality, safety and inclusion culture to support aged care workers to deliver quality care \n\n(2) The governing body must lead a culture of quality, safety and inclusion that supports aged care workers to provide quality funded aged care services by:\n\n(a) focussing on continuous improvement; and\n\n(b) embracing diversity; and\n\n(c) prioritising the safety, health and wellbeing of aged care workers.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "summaryHTML": "<i>Outcome 2.2a—Quality, safety and inclusion culture to support aged care workers to deliver quality care \n\n</i>(2) The governing body must lead a culture of quality, safety and inclusion that supports aged care workers to provide quality funded aged care services by:\n\n(a) focussing on continuous improvement; and\n\n(b) embracing diversity; and\n\n(c) prioritising the safety, health and wellbeing of aged care workers.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "extract": "Outcome 2.2a—Quality, safety and inclusion culture to support aged care workers to deliver quality care \n\n(2) The governing body must lead a culture of quality, safety and inclusion that supports aged care workers to provide quality funded aged care services by:\n\n(a) focussing on continuous improvement; and\n\n(b) embracing diversity; and\n\n(c) prioritising the safety, health and wellbeing of aged care workers.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 103,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(3)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Outcome 2.2b—Quality, safety and inclusion culture to support individuals \n\n(3) The governing body must lead a culture of quality, safety and inclusion that supports individuals accessing quality funded aged care services by: \n\n(a) focussing on continuous improvement; and \n\n(b) embracing diversity; and \n\n(c) prioritising the safety, health and wellbeing of individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "summaryHTML": "<i>Outcome 2.2b—Quality, safety and inclusion culture to support individuals \n\n</i>(3) The governing body must lead a culture of quality, safety and inclusion that supports individuals accessing quality funded aged care services by: \n\n(a) focussing on continuous improvement; and \n\n(b) embracing diversity; and \n\n(c) prioritising the safety, health and wellbeing of individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "extract": "Outcome 2.2b—Quality, safety and inclusion culture to support individuals \n\n(3) The governing body must lead a culture of quality, safety and inclusion that supports individuals accessing quality funded aged care services by: \n\n(a) focussing on continuous improvement; and \n\n(b) embracing diversity; and \n\n(c) prioritising the safety, health and wellbeing of individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 104,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(4)-(6)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Outcome 2.3—Accountability, quality system and policies and procedures\n\n(4) The governing body is accountable for the delivery of quality funded aged care services and must maintain oversight of all aspects of the provider’s operations. \n\n(5) The provider must use a quality system to enable and drive continuous improvement of the provider’s delivery of funded aged care services. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).\n\n(6) The provider must:\n\n(a) maintain current policies and procedures that guide the way aged care workers undertake their roles; and\n\n(b) require aged care workers to follow the policies and procedures.",
          "summaryHTML": "<i>Outcome 2.3—Accountability, quality system and policies and procedures\n\n</i>(4) The governing body is accountable for the delivery of quality funded aged care services and must maintain oversight of all aspects of the provider’s operations. \n\n(5) The provider must use a quality system to enable and drive continuous improvement of the provider’s delivery of funded aged care services. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).\n\n(6) The provider must:\n\n(a) maintain current policies and procedures that guide the way aged care workers undertake their roles; and\n\n(b) require aged care workers to follow the policies and procedures.",
          "extract": "Outcome 2.3—Accountability, quality system and policies and procedures\n\n(4) The governing body is accountable for the delivery of quality funded aged care services and must maintain oversight of all aspects of the provider’s operations. \n\n(5) The provider must use a quality system to enable and drive continuous improvement of the provider’s delivery of funded aged care services. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).\n\n(6) The provider must:\n\n(a) maintain current policies and procedures that guide the way aged care workers undertake their roles; and\n\n(b) require aged care workers to follow the policies and procedures.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 105,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(7)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 2.4—Risk management \n\n(7) The provider must use a risk management system to identify, manage and continuously review risks to individuals, aged care workers and the provider’s operations.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "summaryHTML": "<i>Outcome 2.4—Risk management \n\n</i>(7) The provider must use a risk management system to identify, manage and continuously review risks to individuals, aged care workers and the provider’s operations.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "extract": "Outcome 2.4—Risk management \n\n(7) The provider must use a risk management system to identify, manage and continuously review risks to individuals, aged care workers and the provider’s operations.\n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 106,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(8)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 2.5—Incident management \n\n(8) The provider must use an incident management system to: \n\n(a) safeguard individuals; and \n\n(b) acknowledge, respond to, effectively manage and learn from incidents. \n\nNote: See also section 164 of the Act and Division 1 of Part 10 of Chapter 4 of the rules (conditions of registration relating to incident management).",
          "summaryHTML": "<i>Outcome 2.5—Incident management \n\n</i>(8) The provider must use an incident management system to: \n\n(a) safeguard individuals; and \n\n(b) acknowledge, respond to, effectively manage and learn from incidents. \n\nNote: See also section 164 of the Act and Division 1 of Part 10 of Chapter 4 of the rules (conditions of registration relating to incident management).",
          "extract": "Outcome 2.5—Incident management \n\n(8) The provider must use an incident management system to: \n\n(a) safeguard individuals; and \n\n(b) acknowledge, respond to, effectively manage and learn from incidents. \n\nNote: See also section 164 of the Act and Division 1 of Part 10 of Chapter 4 of this instrument (conditions of registration relating to incident management).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 107,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(9)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Outcome 2.6a—Complaints and feedback management—for aged care workers\n\n(9) The provider must encourage and support aged care workers to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers).",
          "summaryHTML": "<i>Outcome 2.6a—Complaints and feedback management—for aged care workers\n\n</i>(9) The provider must encourage and support aged care workers to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers).",
          "extract": "Outcome 2.6a—Complaints and feedback management—for aged care workers\n\n(9) The provider must encourage and support aged care workers to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of this instrument (conditions of registration relating to complaints, feedback and whistleblowers).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 96,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(10)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Outcome 2.6b—Complaints and feedback management—for individuals\n\n(10) The provider must encourage and support individuals and others to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers).",
          "summaryHTML": "<i>Outcome 2.6b—Complaints and feedback management—for individuals\n\n</i>(10) The provider must encourage and support individuals and others to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers).",
          "extract": "Outcome 2.6b—Complaints and feedback management—for individuals\n\n(10) The provider must encourage and support individuals and others to make complaints and give feedback about the provider’s delivery of funded aged care services without reprisal. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of this instrument (conditions of registration relating to complaints, feedback and whistleblowers).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 97,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(11)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Outcomes 2.6a and 2.6b—Complaints and feedback management\n\n(11) The provider must:\n(a) acknowledge and transparently manage all complaints and feedback; and\n(b) use complaints and feedback to contribute to the continuous improvement of funded aged care services. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers), and section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "summaryHTML": "<i>Outcomes 2.6a and 2.6b—Complaints and feedback management\n\n</i>(11) The provider must:\n(a) acknowledge and transparently manage all complaints and feedback; and\n(b) use complaints and feedback to contribute to the continuous improvement of funded aged care services. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of the rules (conditions of registration relating to complaints, feedback and whistleblowers), and section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement).",
          "extract": "Outcomes 2.6a and 2.6b—Complaints and feedback management\n\n(11) The provider must acknowledge and transparently manage all complaints and feedback and use complaints and feedback to contribute to the continuous improvement of funded aged care services. \n\nNote: See also section 165 of the Act and Division 2 of Part 10 of Chapter 4 of this instrument (conditions of registration relating to complaints, feedback and whistleblowers), and section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 98,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(12)-(13)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Outcome 2.7—Information management \n\n(12) The provider must ensure that information recorded about an individual: \n\n(a) is accurate and current; and \n\n(b) is able to be accessed and understood by the individual, supporters of the individual, aged care workers, registered health practitioners, allied health professionals, allied health assistants and others involved in the individual’s care. \n\nNote: See also section 155 of the Act (provision of information to individuals) which sets out conditions applicable to registered providers to allow access to records and information to individuals and explain those records and information to those individuals. Subsection 156(3) of the Act in specified circumstances allows independent aged care advocates access to records and information held by a registered provider about an individual. \n\n(13) The provider must ensure that the information of individuals is kept confidential and is managed appropriately, in line with their informed consent.\n\nNote: See also section 154 of the Act (personal information and record keeping) which requires registered providers as a condition of their registration to keep and retain kinds of records in accordance with requirements set out in the rules, and section 168 of the Act (protection of personal information) which requires registered providers to ensure the protection of personal information.",
          "summaryHTML": "<i>Outcome 2.7—Information management \n\n</i>(12) The provider must ensure that information recorded about an individual: \n\n(a) is accurate and current; and \n\n(b) is able to be accessed and understood by the individual, supporters of the individual, aged care workers, registered health practitioners, allied health professionals, allied health assistants and others involved in the individual’s care. \n\nNote: See also section 155 of the Act (provision of information to individuals) which sets out conditions applicable to registered providers to allow access to records and information to individuals and explain those records and information to those individuals. Subsection 156(3) of the Act in specified circumstances allows independent aged care advocates access to records and information held by a registered provider about an individual. \n\n(13) The provider must ensure that the information of individuals is kept confidential and is managed appropriately, in line with their informed consent.\n\nNote: See also section 154 of the Act (personal information and record keeping) which requires registered providers as a condition of their registration to keep and retain kinds of records in accordance with requirements set out in the rules, and section 168 of the Act (protection of personal information) which requires registered providers to ensure the protection of personal information.",
          "extract": "Outcome 2.7—Information management \n\n(12) The provider must ensure that information recorded about an individual: \n\n(a) is accurate and current; and \n\n(b) is able to be accessed and understood by the individual, supporters of the individual, aged care workers, registered health practitioners, allied health professionals, allied health assistants and others involved in the individual’s care. \n\nNote: See also section 155 of the Act (Provision of information to individuals) setting out conditions applicable to registered providers to allow access to records and information to individuals and explain those records and information to those individuals. Subsection 156(3) of the Act in specified circumstances allows independent aged care advocates access to records and information held by a registered provider about an individual. \n\n(13) The provider must ensure that the information of individuals is kept confidential and is managed appropriately, in line with their informed consent.\n\nNote: See also section 154 of the Act (Personal Information and record keeping) that requires registered providers as a condition of their registration to keep and retain kinds of records in accordance with requirements set out in this instrument, and section 168 (Protection of personal information) which requires registered providers to ensure the protection of personal information.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 99,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(14)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Outcome 2.8—Workforce planning \n\n(14) The provider must demonstrate that the provider understands and manages their workforce needs and plans for the future.",
          "summaryHTML": "<i>Outcome 2.8—Workforce planning \n\n</i>(14) The provider must demonstrate that the provider understands and manages their workforce needs and plans for the future.",
          "extract": "Outcome 2.8—Workforce planning \n\n(14) The provider must demonstrate that the provider understands and manages their workforce needs and plans for the future.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 100,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(15)-(16)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Outcome 2.9—Human resource management \n\n(15) The provider must deliver funded aged care services to individuals by aged care workers who: \n\n(a) are skilled and competent in their roles; and \n\n(b) hold relevant qualifications for their roles; and \n\n(c) have expertise and experience relevant to delivering quality funded aged care services. \n\nNote: See also section 152 of the Act (workforce and aged care worker requirements) which requires registered providers as a condition of their registration to comply with workforce screening and other requirements in relation to the employment of aged care workers. \n\n(16) The provider must provide aged care workers with training and supervision to enable them to effectively perform their roles.",
          "summaryHTML": "<i>Outcome 2.9—Human resource management \n\n</i>(15) The provider must deliver funded aged care services to individuals by aged care workers who: \n\n(a) are skilled and competent in their roles; and \n\n(b) hold relevant qualifications for their roles; and \n\n(c) have expertise and experience relevant to delivering quality funded aged care services. \n\nNote: See also section 152 of the Act (workforce and aged care worker requirements) which requires registered providers as a condition of their registration to comply with workforce screening and other requirements in relation to the employment of aged care workers. \n\n(16) The provider must provide aged care workers with training and supervision to enable them to effectively perform their roles.",
          "extract": "Outcome 2.9—Human resource management \n\n(15) The provider must deliver funded aged care services to individuals by aged care workers who: \n\n(a) are skilled and competent in their roles; and \n\n(b) hold relevant qualifications for their roles; and \n\n(c) have expertise and experience relevant to delivering quality funded aged care services. \n\nNote: See also section 152 of the Act (Workforce and aged care worker requirements) that requires registered providers as a condition of their registration to comply with workforce screening and other requirements in relation to the employment of aged care workers. \n\n(16) The provider must provide aged care workers with training and supervision to enable them to effectively perform their roles.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 101,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-15(17)",
          "section": "Standard 2—The organisation",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 2.10—Emergency and disaster management \n\n(17) The provider must demonstrate that emergency and disaster management planning considers and manages risks to the health, safety and wellbeing of individuals and aged care workers.",
          "summaryHTML": "<i>Outcome 2.10—Emergency and disaster management \n\n</i>(17) The provider must demonstrate that emergency and disaster management planning considers and manages risks to the health, safety and wellbeing of individuals and aged care workers.",
          "extract": "Outcome 2.10—Emergency and disaster management \n\n(17) The provider must demonstrate that emergency and disaster management planning considers and manages risks to the health, safety and wellbeing of individuals and aged care workers.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 108,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-20(1)-(3)",
          "section": "Standard 3—The care and services",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Outcome 3.1—Assessment and planning\n\n(1) The registered provider must actively engage with: \n\n(a) individuals to whom the provider delivers funded aged care services; and \n\n(b) supporters of individuals (if any); and \n\n(c) any other persons involved in the care of individuals; \n\nin developing and reviewing the individual’s care and services plans through ongoing communication. \n\n(2) Care and services plans must: \n\n(a) describe the current care needs, goals and preferences of individuals; and \n\n(b) include strategies for risk management and preventative care.\n\n(3) The provider must ensure that care and services plans are regularly reviewed and are used by aged care workers to guide the delivery of funded aged care services.\n\nNote: See also section 148-80 of this instrument (requirements for care and services plans-general) which provides details in relation to the development of care and services plans for an individual. L243",
          "summaryHTML": "<i>Outcome 3.1—Assessment and planning\n\n</i>(1) The registered provider must actively engage with: \n\n(a) individuals to whom the provider delivers funded aged care services; and \n\n(b) supporters of individuals (if any); and \n\n(c) any other persons involved in the care of individuals; \n\nin developing and reviewing the individual’s care and services plans through ongoing communication. \n\n(2) Care and services plans must: \n\n(a) describe the current care needs, goals and preferences of individuals; and \n\n(b) include strategies for risk management and preventative care.\n\n(3) The provider must ensure that care and services plans are regularly reviewed and are used by aged care workers to guide the delivery of funded aged care services.\n\nNote: See also section 148-80 of this instrument (requirements for care and services plans-general) which provides details in relation to the development of care and services plans for an individual. L243",
          "extract": "Outcome 3.1—Assessment and planning\n\n(1) The registered provider must actively engage with: \n\n(a) individuals to whom the provider delivers funded aged care services; and \n\n(b) supporters of individuals (if any); and \n\n(c) any other persons involved in the care of individuals; \n\nin developing and reviewing the individual’s care and services plans through ongoing communication. \n\n(2) Care and services plans must: \n\n(a) describe the current care needs, goals and preferences of individuals; and \n\n(b) include strategies for risk management and preventative care.\n\n(3) The provider must ensure that care and services plans are regularly reviewed and are used by aged care workers to guide the delivery of funded aged care services.\n\nNote: See also section 148-80 (Requirements for care and services plans-general) of this instrument which provides details in relation to the development of care and services plans for an individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 109,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-20(4)-(5)",
          "section": "Standard 3—The care and services",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 3.2—Delivery of funded aged care services \n\n(4) The provider must ensure that individuals receive quality funded aged care services that: \n\n(a) meet their care needs, goals and preferences; and \n\n(b) optimise their quality of life, reablement and maintenance of function. \n\n(5) The provider must ensure that funded aged care services are delivered in a way that is culturally safe and culturally appropriate for individuals with specific needs and diverse backgrounds.",
          "summaryHTML": "<i>Outcome 3.2—Delivery of funded aged care services \n\n</i>(4) The provider must ensure that individuals receive quality funded aged care services that: \n\n(a) meet their care needs, goals and preferences; and \n\n(b) optimise their quality of life, reablement and maintenance of function. \n\n(5) The provider must ensure that funded aged care services are delivered in a way that is culturally safe and culturally appropriate for individuals with specific needs and diverse backgrounds.",
          "extract": "Outcome 3.2—Delivery of funded aged care services \n\n(4) The provider must ensure that individuals receive quality funded aged care services that: \n\n(a) meet their care needs, goals and preferences; and \n\n(b) optimise their quality of life, reablement and maintenance of function. \n\n(5) The provider must ensure that funded aged care services are delivered in a way that is culturally safe and culturally appropriate for individuals with specific needs and diverse backgrounds.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 110,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-20(6)-(7)",
          "section": "Standard 3—The care and services",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Outcome 3.3—Communicating for safety and quality \n\n(6) The provider must ensure that critical information relevant to the delivery of funded aged care services to individuals is communicated effectively: \n\n(a) to the individuals; and \n\n(b) between aged care workers delivering the services; and \n\n(c) to supporters of the individuals and other persons supporting the individuals; and \n\n(d) to registered health practitioners, allied health professionals, allied health assistants and others involved with the individual’s care. \n\n(7) The provider must ensure that risks to individuals, and changes and deterioration in the condition of individuals, are escalated and communicated as appropriate.",
          "summaryHTML": "<i>Outcome 3.3—Communicating for safety and quality \n\n</i>(6) The provider must ensure that critical information relevant to the delivery of funded aged care services to individuals is communicated effectively: \n\n(a) to the individuals; and \n\n(b) between aged care workers delivering the services; and \n\n(c) to supporters of the individuals and other persons supporting the individuals; and \n\n(d) to registered health practitioners, allied health professionals, allied health assistants and others involved with the individual’s care. \n\n(7) The provider must ensure that risks to individuals, and changes and deterioration in the condition of individuals, are escalated and communicated as appropriate.",
          "extract": "Outcome 3.3—Communicating for safety and quality \n\n(6) The provider must ensure that critical information relevant to the delivery of funded aged care services to individuals is communicated effectively: \n\n(a) to the individuals; and \n\n(b) between aged care workers delivering the services; and \n\n(c) with supporters of the individuals and other persons supporting the individuals; and \n\n(d) with registered health practitioners, allied health professionals, allied health assistants and others involved with the individual’s care. \n\n(7) The provider must ensure that risks to individuals, and changes and deterioration in the condition of individuals, are escalated and communicated as appropriate.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 111,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-20(8)",
          "section": "Standard 3—The care and services",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Outcome 3.4—Planning and coordination of funded aged care services \n\n(8) The provider must ensure that individuals receive funded aged care services that are planned and coordinated, including where multiple health providers and registered providers, supporters of individuals and other persons supporting individuals are involved.",
          "summaryHTML": "<i>Outcome 3.4—Planning and coordination of funded aged care services \n\n</i>(8) The provider must ensure that individuals receive funded aged care services that are planned and coordinated, including where multiple health providers and registered providers, supporters of individuals and other persons supporting individuals are involved.",
          "extract": "Outcome 3.4—Planning and coordination of funded aged care services \n\n(8) The provider must ensure that individuals receive funded aged care services that are planned and coordinated, including where multiple health providers and registered providers, supporters of individuals and other persons supporting individuals are involved.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 112,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-25(1)",
          "section": "Standard 4—The environment",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 4.1a—Environment—services delivered in the individual’s home \n\n(1) When delivering funded aged care services to individuals in their homes, the registered provider must support the individuals to mitigate environmental risks relevant to the services.",
          "summaryHTML": "<i>Outcome 4.1a—Environment—services delivered in the individual’s home \n\n</i>(1) When delivering funded aged care services to individuals in their homes, the registered provider must support the individuals to mitigate environmental risks relevant to the services.",
          "extract": "Outcome 4.1a—Environment—services delivered in the individual’s home \n\n(1) When delivering funded aged care services to individuals in their homes, the registered provider must support the individuals to mitigate environmental risks relevant to the services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 113,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-25(2)",
          "section": "Standard 4—The environment",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 4.1b—Environment—services delivered other than in the individual’s home \n\n(2) Where the provider delivers funded aged care services to individuals other than in their homes, the provider must ensure that individuals are able to access funded aged care services in a clean, safe and comfortable environment that optimises their sense of belonging, interaction and function.",
          "summaryHTML": "<i>Outcome 4.1b—Environment—services delivered other than in the individual’s home \n\n</i>(2) Where the provider delivers funded aged care services to individuals other than in their homes, the provider must ensure that individuals are able to access funded aged care services in a clean, safe and comfortable environment that optimises their sense of belonging, interaction and function.",
          "extract": "Outcome 4.1b—Environment—services delivered other than in the individual’s home \n\n(2) Where the provider delivers funded aged care services to individuals other than in their homes, the provider must ensure that individuals are able to access funded aged care services in a clean, safe and comfortable environment that optimises their sense of belonging, interaction and function.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 114,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-25(3)",
          "section": "Standard 4—The environment",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcomes 4.1a and 4.1b—Equipment \n\n(3) Where the provider uses equipment in the delivery of any funded aged care services to individuals, or provides equipment to individuals, the equipment must be safe and must meet the needs of the individuals.",
          "summaryHTML": "<i>Outcomes 4.1a and 4.1b—Equipment \n\n</i>(3) Where the provider uses equipment in the delivery of any funded aged care services to individuals, or provides equipment to individuals, the equipment must be safe and must meet the needs of the individuals.",
          "extract": "Outcomes 4.1a and 4.1b—Equipment \n\n(3) Where the provider uses equipment in the delivery of any funded aged care services to individuals, or provides equipment to individuals, the equipment must be safe and must meet the needs of the individuals.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 115,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-25(4)-(5)",
          "section": "Standard 4—The environment",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 4.2—Infection prevention and control\n\n(4) The provider must have an appropriate infection prevention and control system. \n\n(5) The provider must ensure that aged care workers use hygienic practices and take appropriate infection prevention and control precautions when delivering funded aged care services.",
          "summaryHTML": "<i>Outcome 4.2—Infection prevention and control\n\n</i>(4) The provider must have an appropriate infection prevention and control system. \n\n(5) The provider must ensure that aged care workers use hygienic practices and take appropriate infection prevention and control precautions when delivering funded aged care services.",
          "extract": "Outcome 4.2—Infection prevention and control\n\n(4) The provider must have an appropriate infection prevention and control system. \n\n(5) The provider must ensure that aged care workers use hygienic practices and take appropriate infection prevention and control precautions when delivering funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 116,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(1)-(2)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Outcome 5.1—Clinical governance \n\n(1) The governing body must ensure: \n\n(a) that the governing body continuously improves the safety and quality of clinical care services delivered to individuals; and \n\n(b) that the provider delivers safe and quality clinical care services to individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement). \n\n(2) The registered provider must integrate clinical governance into corporate governance to actively manage and improve the safety and quality of clinical care services delivered to individuals.",
          "summaryHTML": "<i>Outcome 5.1—Clinical governance \n\n</i>(1) The governing body must ensure: \n\n(a) that the governing body continuously improves the safety and quality of clinical care services delivered to individuals; and \n\n(b) that the provider delivers safe and quality clinical care services to individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of the rules (conditions of registration relating to continuous improvement). \n\n(2) The registered provider must integrate clinical governance into corporate governance to actively manage and improve the safety and quality of clinical care services delivered to individuals.",
          "extract": "Outcome 5.1—Clinical governance \n\n(1) The governing body must ensure: \n\n(a) that the governing body continuously improves the safety and quality of clinical care services to individuals; and \n\n(b) that the provider delivers safe and quality clinical care services to individuals. \n\nNote: See also section 147 of the Act and Division 2 of Part 4 of Chapter 4 of this instrument (conditions of registration relating to continuous improvement). \n\n(2) The registered provider must integrate clinical governance into corporate governance to actively manage and improve the safety and quality of clinical care services delivered to individuals.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 120,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(3)-(4)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Outcome 5.2—Preventing and controlling infections in delivering clinical care services\n\n(3) The provider must ensure that individuals, aged care workers, registered health practitioners and others are encouraged and supported to use antimicrobials appropriately to reduce risks of increasing resistance. \n\n(4) The provider must ensure that infection risks are minimised and, if they occur, are controlled effectively.",
          "summaryHTML": "<i>Outcome 5.2—Preventing and controlling infections in delivering clinical care services\n\n</i>(3) The provider must ensure that individuals, aged care workers, registered health practitioners and others are encouraged and supported to use antimicrobials appropriately to reduce risks of increasing resistance. \n\n(4) The provider must ensure that infection risks are minimised and, if they occur, are controlled effectively.",
          "extract": "Outcome 5.2—Preventing and controlling infections in delivering clinical care services\n\n(3) The provider must ensure that individuals, aged care workers, registered health practitioners and others are encouraged and supported to use antimicrobials appropriately to reduce risks of increasing resistance. \n\n(4) The provider must ensure that infection risks are minimised and, if they occur, are controlled effectively.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 121,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(5)-(7)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Outcome 5.3—Safe and quality use of medicines\n\n(5) The provider must encourage and support individuals, aged care workers, registered health practitioners and allied health professionals to use medicines in a way that maximises benefits and minimises the risks of harm. \n\n(6) The provider must ensure that: \n\n(a) before administering medicine to an individual, the medicine has been prescribed for the individual; and \n\n(b) medicines are appropriately and safely administered, monitored and reviewed by registered health practitioners, considering the clinical needs and informed decisions of the individual. \n\n(7) The provider must ensure that medicine-related adverse events are monitored and reported, and are used to inform safety and quality improvement.",
          "summaryHTML": "<i>Outcome 5.3—Safe and quality use of medicines\n\n</i>(5) The provider must encourage and support individuals, aged care workers, registered health practitioners and allied health professionals to use medicines in a way that maximises benefits and minimises the risks of harm. \n\n(6) The provider must ensure that: \n\n(a) before administering medicine to an individual, the medicine has been prescribed for the individual; and \n\n(b) medicines are appropriately and safely administered, monitored and reviewed by registered health practitioners, considering the clinical needs and informed decisions of the individual. \n\n(7) The provider must ensure that medicine-related adverse events are monitored and reported, and are used to inform safety and quality improvement.",
          "extract": "Outcome 5.3—Safe and quality use of medicines\n\n(5) The provider must encourage and support individuals, aged care workers, registered health practitioners and allied health professionals to use medicines in a way that maximises benefits and minimises the risks of harm. \n\n(6) The provider must ensure that: \n\n(a) before administering medicine to an individual, the medicine has been prescribed for the individual; and \n\n(b) medicines are appropriately and safely administered, monitored and reviewed by registered health practitioners, considering the clinical needs and informed decisions of the individual. \n\n(7) The provider must ensure that medicines-related adverse events are monitored and reported, and are used to inform safety and quality improvement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 122,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(8)-(11)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 5.4—Comprehensive care \n\n(8) The provider must ensure that individuals receive comprehensive, safe and quality clinical care services that are evidence-based, person-centred and delivered by registered health practitioners, allied health professionals, allied health assistants or nursing assistants. \n\n(9) Clinical care delivered by the provider must encompass clinical assessment, prevention, planning, treatment, management and review to minimise harm and optimise quality of life, reablement and maintenance of function.\n\n(10) The provider must have systems and processes that support coordinated and multidisciplinary clinical care services:\n\n(a) that are delivered to individuals, in partnership with individuals, supporters of individuals and other persons supporting individuals; and\n\n(b) that are aligned with the individuals’ needs, goals and preferences.\n\n(11) The provider must support early identification of, and response to, changing clinical needs.",
          "summaryHTML": "<i>Outcome 5.4—Comprehensive care \n\n</i>(8) The provider must ensure that individuals receive comprehensive, safe and quality clinical care services that are evidence-based, person-centred and delivered by registered health practitioners, allied health professionals, allied health assistants or nursing assistants. \n\n(9) Clinical care delivered by the provider must encompass clinical assessment, prevention, planning, treatment, management and review to minimise harm and optimise quality of life, reablement and maintenance of function.\n\n(10) The provider must have systems and processes that support coordinated and multidisciplinary clinical care services:\n\n(a) that are delivered to individuals, in partnership with individuals, supporters of individuals and other persons supporting individuals; and\n\n(b) that are aligned with the individuals’ needs, goals and preferences.\n\n(11) The provider must support early identification of, and response to, changing clinical needs.",
          "extract": "Outcome 5.4—Comprehensive care \n\n(8) The provider must ensure that individuals receive comprehensive, safe and quality clinical care services that are evidence-based, person-centred and delivered by registered health practitioners, allied health professionals, allied health assistants or nursing assistants. \n\n(9) Clinical care delivered by the provider must encompass clinical assessment, prevention, planning, treatment, management and review to minimise harm and optimise quality of life, reablement and maintenance of function.\n\n(10) The provider must have systems and processes that support coordinated, multidisciplinary clinical care services:\n\n(a) that are delivered to individuals, in partnership with individuals, supporters of individuals and other persons supporting individuals; and\n\n(b) that are aligned with the individuals’ needs, goals and preferences.\n\n(11) The provider must support early identification of, and response to, changing clinical needs.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 117,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(12)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 5.5—Safety of clinical care services \n\n(12) The provider must identify, monitor and manage high impact and high prevalence risks in the delivery of clinical care services: \n\n(a) to ensure the delivery of safe and quality clinical care services; and \n\n(b) to reduce the risk of harm to individuals.",
          "summaryHTML": "<i>Outcome 5.5—Safety of clinical care services \n\n</i>(12) The provider must identify, monitor and manage high impact and high prevalence risks in the delivery of clinical care services: \n\n(a) to ensure the delivery of safe and quality clinical care services; and \n\n(b) to reduce the risk of harm to individuals.",
          "extract": "Outcome 5.5—Safety of clinical care services \n\n(12) The provider must identify, monitor and manage high impact and high prevalence risks in the delivery of clinical care services: \n\n(a) to ensure the delivery of safe, quality clinical care services; and \n\n(b) to reduce the risk of harm to individuals.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 118,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(13)-(14)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 5.6—Cognitive impairment \n\n(13) The provider must ensure that individuals who experience cognitive impairment (whether acute, chronic or transitory) receive comprehensive funded aged care services that: \n\n(a) optimise clinical outcomes; and \n\n(b) are aligned with the individuals' needs, goals and preferences. \n\n(14) The provider must identify situations and events that may lead to changes in behaviours.",
          "summaryHTML": "<i>Outcome 5.6—Cognitive impairment \n\n</i>(13) The provider must ensure that individuals who experience cognitive impairment (whether acute, chronic or transitory) receive comprehensive funded aged care services that: \n\n(a) optimise clinical outcomes; and \n\n(b) are aligned with the individuals' needs, goals and preferences. \n\n(14) The provider must identify situations and events that may lead to changes in behaviours.",
          "extract": "Outcome 5.6—Cognitive impairment \n\n(13) The provider must ensure that individuals who experience cognitive impairment (whether acute, chronic or transitory) receive comprehensive funded aged care services that: \n\n(a) optimise clinical outcomes; and \n\n(b) are aligned with their needs, goals and preferences. \n\n(14) The provider identifies situations and events that may lead to changes in behaviours.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 119,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-30(15)-(17)",
          "section": "Standard 5—Clinical care",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 5.7—Palliative care and end-of-life care \n\n(15) The provider must recognise and address the needs, goals and preferences of individuals for palliative care and end-of-life care, and must preserve the dignity of individuals in those circumstances.\n\n(16) The provider must ensure that the pain and symptoms of individuals are actively managed, with access to specialist palliative and end-of-life care when required.\n\n(17) The provider must ensure that supporters of individuals and other persons supporting individuals are informed and supported, including during the last days of life.\n\nNote: See also section 29 of the Act (giving information and documents to supporters).",
          "summaryHTML": "<i>Outcome 5.7—Palliative care and end-of-life care \n\n</i>(15) The provider must recognise and address the needs, goals and preferences of individuals for palliative care and end-of-life care, and must preserve the dignity of individuals in those circumstances.\n\n(16) The provider must ensure that the pain and symptoms of individuals are actively managed, with access to specialist palliative and end-of-life care when required.\n\n(17) The provider must ensure that supporters of individuals and other persons supporting individuals are informed and supported, including during the last days of life.\n\nNote: See also section 29 of the Act (giving information and documents to supporters).",
          "extract": "Outcome 5.7—Palliative care and end-of-life care \n\n(15) The provider must recognise and address the needs, goals and preferences of individuals for palliative care and end-of-life care, and must preserve the dignity of individuals in those circumstances.\n\n(16) The provider ensures that the pain and symptoms of individuals are actively managed, with access to specialist palliative and end-of-life care when required.\n\n(17) The provider must ensure that supporters of individuals and other persons supporting individuals are informed and supported, including during the last days of life.\n\nNote: See also section 29 of the Act (Giving information and documents to supporters).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 123,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-35(1)",
          "section": "Standard 6—Food and nutrition",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 6.1—Partnering with individuals on food and drinks\n\n(1) The registered provider must partner with individuals to deliver a quality food and drinks service that includes appetising and varied food and drinks and an enjoyable dining experience. \n\nNote: See also item 9 of the table in section 8-145 of the rules (residential everyday living—meals and refreshments).",
          "summaryHTML": "<i>Outcome 6.1—Partnering with individuals on food and drinks\n\n</i>(1) The registered provider must partner with individuals to deliver a quality food and drinks service that includes appetising and varied food and drinks and an enjoyable dining experience. \n\nNote: See also item 9 of the table in section 8-145 of the rules (residential everyday living—meals and refreshments).",
          "extract": "Outcome 6.1—Partnering with individuals on food and drinks\n\n(1) The registered provider must partner with individuals to deliver a quality food and drinks service that includes appetising and varied food and drinks and an enjoyable dining experience. \n\nNote: See also item 9 of the table in section 8-145 of this instrument (Residential everyday living—meals and refreshments).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 124,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-35(2)",
          "section": "Standard 6—Food and nutrition",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 6.2—Assessment of nutritional needs and preferences \n\n(2) The provider must demonstrate that the provider understands the specific nutritional needs of individuals and assesses the current needs, abilities and preferences of individuals in relation to what and how they eat and drink.",
          "summaryHTML": "<i>Outcome 6.2—Assessment of nutritional needs and preferences \n\n</i>(2) The provider must demonstrate that the provider understands the specific nutritional needs of individuals and assesses the current needs, abilities and preferences of individuals in relation to what and how they eat and drink.",
          "extract": "Outcome 6.2—Assessment of nutritional needs and preferences \n\n(2) The provider must demonstrate that the provider understands the specific nutritional needs of individuals and assesses the current needs, abilities and preferences of individuals in relation to what and how they eat and drink.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 125,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-35(3)",
          "section": "Standard 6—Food and nutrition",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 6.3—Provision of food and drinks \n\n(3) The provider must provide individuals with: \n\n(a) food and drinks that meet their nutritional needs and are appetising and flavoursome; and \n\n(b) variation and choice about what they eat and drink; and \n\n(c) choice about how much they eat and drink.",
          "summaryHTML": "<i>Outcome 6.3—Provision of food and drinks \n\n</i>(3) The provider must provide individuals with: \n\n(a) food and drinks that meet their nutritional needs and are appetising and flavoursome; and \n\n(b) variation and choice about what they eat and drink; and \n\n(c) choice about how much they eat and drink.",
          "extract": "Outcome 6.3—Provision of food and drinks \n\n(3) The provider must provide individuals with: \n\n(a) food and drinks that meet their nutritional needs and are appetising and flavoursome; and \n\n(b) variation and choice about what they eat and drink; and \n\n(c) choice about how much they eat and drink.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 126,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-35(4)-(5)",
          "section": "Standard 6—Food and nutrition",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 6.4—Dining experience \n\n(4) The provider must support individuals to eat and drink.\n\n(5) The provider must ensure that the dining experience meets the needs and preferences of individuals to support social engagement, function and quality of life.",
          "summaryHTML": "<i>Outcome 6.4—Dining experience \n\n</i>(4) The provider must support individuals to eat and drink.\n\n(5) The provider must ensure that the dining experience meets the needs and preferences of individuals to support social engagement, function and quality of life.",
          "extract": "Outcome 6.4—Dining experience \n\n(4) The provider must support individuals to eat and drink.\n\n(5) The provider must ensure that the dining experience meets the needs and preferences of individuals to support social engagement, function and quality of life.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 127,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-40(1)-(2)",
          "section": "Standard 7—The residential community",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 7.1—Daily living \n\n(1) The registered provider must ensure that individuals receive funded aged care services that optimise their quality of life, promote use of their skills and strengths and enable them to do the things they want to do. \n\n(2) The provider must ensure that individuals feel safe in their residential care home.",
          "summaryHTML": "<i>Outcome 7.1—Daily living \n\n</i>(1) The registered provider must ensure that individuals receive funded aged care services that optimise their quality of life, promote use of their skills and strengths and enable them to do the things they want to do. \n\n(2) The provider must ensure that individuals feel safe in their residential care home.",
          "extract": "Outcome 7.1—Daily living \n\n(1) The registered provider must ensure that individuals receive funded aged care services that optimise their quality of life, promote use of their skills and strengths and enable them to do the things they want to do. \n\n(2) The provider must ensure that individuals feel safe in their residential care home.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        },
        {
          "id": 128,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 1, Part 6, Div 2, s15-40(3)-(4)",
          "section": "Standard 7—The residential community",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Outcome 7.2—Transitions \n\n(3) The provider must ensure that individuals experience a well-coordinated transition, whether planned or unplanned, to or from a provider. \n\nNote: See also section 149 of the Act (starting and ceasing the provision of funded aged care services and continuity of those services). \n\n(4) The provider must set out clear responsibility and accountability for the delivery of funded aged care services to individuals between aged care workers, registered health practitioners, allied health professionals and allied health assistants and across organisations.",
          "summaryHTML": "<i>Outcome 7.2—Transitions \n\n</i>(3) The provider must ensure that individuals experience a well-coordinated transition, whether planned or unplanned, to or from a provider. \n\nNote: See also section 149 of the Act (starting and ceasing the provision of funded aged care services and continuity of those services). \n\n(4) The provider must set out clear responsibility and accountability for the delivery of funded aged care services to individuals between aged care workers, registered health practitioners, allied health professionals and allied health assistants and across organisations.",
          "extract": "Outcome 7.2—Transitions \n\n(3) The provider must ensure that individuals experience a well-coordinated transition, whether planned or unplanned, to or from a provider. \n\nNote: See also section 149 of the Act (Starting and ceasing the provision of funded aged care services and continuity of those services). \n\n(4) The provider must set out clear responsibility and accountability for the delivery of funded aged care services to individuals between aged care workers, registered health practitioners, allied health professionals, allied health assistants and across organisations.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s15"
        }
      ]
    },
    {
      "id": 4,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 1, Part 2, Div 2, s18(1)",
      "section": "Restrictive practice requirements",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Restrictive practices",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules regarding the use of restrictive practices for individuals receiving funded aged care services must:\n\n(a) Ensure that such practices are only used as a last resort to prevent harm to the individual or others, and only after considering how it will affect the individual.\n\n(b) Require that alternative methods are tried first before using restrictive practices.\n\n(c) Mandate that any alternative methods considered or used are documented.\n\n(d) Ensure that if restrictive practices are used, they are only applied as much as necessary and are appropriate to the level of risk.\n\n(e) Require that if restrictive practices are necessary, they should be the least restrictive option and used for the shortest time needed to prevent harm.\n\n(f) Ensure that informed consent is obtained from the individual before using any restrictive practice.\n\n(g) Provide for monitoring and reviewing the use of restrictive practices to ensure they are appropriate and effective.",
      "summaryHTML": "The rules regarding the use of restrictive practices for individuals receiving funded aged care services must:\n\n(a) Ensure that such practices are only used as a last resort to prevent harm to the individual or others, and only after considering how it will affect the individual.\n\n(b) Require that alternative methods are tried first before using restrictive practices.\n\n(c) Mandate that any alternative methods considered or used are documented.\n\n(d) Ensure that if restrictive practices are used, they are only applied as much as necessary and are appropriate to the level of risk.\n\n(e) Require that if restrictive practices are necessary, they should be the least restrictive option and used for the shortest time needed to prevent harm.\n\n(f) Ensure that informed consent is obtained from the individual before using any restrictive practice.\n\n(g) Provide for monitoring and reviewing the use of restrictive practices to ensure they are appropriate and effective.",
      "extract": "(1) The rules made for the purposes of section 162 relating to the use of restrictive practices in relation to an individual to whom a registered provider is delivering funded aged care services must:\n\n(a) require that a restrictive practice in relation to the individual is used only:\n\n(i) as a last resort to prevent harm to the individual or other persons; and\n\n(ii) after consideration of the likely impact of the use of the practice on the individual; and\n\n(b) require that, to the extent possible, alternative strategies are used before a restrictive practice in relation to the individual is used; and\n\n(c) require that alternative strategies that have been considered or used in relation to the individual are documented; and\n\n(d) require that a restrictive practice in relation to the individual is used only to the extent that it is necessary and in proportion to the risk of harm to the individual or other persons; and\n\n(e) require that, if a restrictive practice in relation to the individual is used, it is used in the least restrictive form, and for the shortest time, necessary to prevent harm to the individual or other persons; and\n\n(f) require that informed consent is given to the use of a restrictive practice in relation to the individual; and\n\n(g) make provision for, or in relation to, the monitoring and review of the use of a restrictive practice in relation to the individual.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631308",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": true,
        "chsp": false,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 7,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div A, s142(1)-(2)",
      "section": "Conditions of registration",
      "requirement": "Conditions of Registration",
      "subdivision": "Compliance with conditions",
      "sublevel": "Conditions of registration",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A registered provider's registration comes with certain conditions that must be followed:\n(a) The specific conditions mentioned in this section that apply to the provider.\n\n(b) Any additional conditions set by the rules that apply to the provider.\n\n(c) Any conditions that the Commissioner has added to the registration according to section 143.\n\nNote: The conditions mentioned in this section may only apply to specific types of registered providers or certain categories of registration.\n\n(2) In addition to what was mentioned in point (1)(b), the rules can set different requirements for different types of registered providers.\n\nNote: For instance, the rules might have different requirements for registered providers based on their specific registration categories or for those providing funded aged care services under various specialised aged care programs.",
      "summaryHTML": "A registered provider's registration comes with certain conditions that must be followed:\n(a) The specific conditions mentioned in this section that apply to the provider.\n\n(b) Any additional conditions set by the rules that apply to the provider.\n\n(c) Any conditions that the Commissioner has added to the registration according to section 143.\n\nNote: The conditions mentioned in this section may only apply to specific types of registered providers or certain categories of registration.\n\n(2) In addition to what was mentioned in point (1)(b), the rules can set different requirements for different types of registered providers.\n\nNote: For instance, the rules might have different requirements for registered providers based on their specific registration categories or for those providing funded aged care services under various specialised aged care programs.",
      "extract": "(1) The registration of a registered provider is subject to the following conditions: \n\n(a) the conditions set out in this Division that apply in relation to the provider; \n\n(b) any conditions prescribed by the rules that apply in relation to the provider; \n\n(c) any conditions imposed on the registration by the Commissioner under section 143. \n\nNote: The conditions set out in this Division may only apply to certain kinds of registered providers or certain provider registration categories.\n\n(2) Without limiting paragraph (1)(b), the rules may prescribe different requirements for different kinds of registered providers. \n\nNote: For example, the rules might prescribe different rules for registered providers in different provider registration categories or registered providers delivering funded aged care services under different specialist aged care programs.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631471",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 5,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, s143(1)-(2)",
      "section": "Conditions imposed by the Commissioner",
      "requirement": "Conditions of Registration",
      "subdivision": "Compliance with conditions",
      "sublevel": "Conditions of registration",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The Commissioner can set conditions for a registered provider's registration either when they register or later on, following specific rules.",
      "summaryHTML": "The Commissioner can set conditions for a registered provider's registration either when they register or later on, following specific rules.",
      "extract": "(1) The Commissioner may impose conditions on the registration of a registered provider.\n\n(2) A condition may be imposed:\n\n(a) at the time of registration; or\n\n(b) at a later time in accordance with subsection 123(1) or 124(1).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631472",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 6,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, s143(2A)-(3)",
      "section": "Conditions imposed by the Commissioner",
      "requirement": "Conditions of Registration",
      "subdivision": "Compliance with conditions",
      "sublevel": "Conditions of registration",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The Commissioner can only impose certain conditions on a registered provider's registration if those conditions are specified by the rules, except for conditions related to quality and safety of aged care services, audit rules, reporting requirements, financial standards, the Aged Care Code of Conduct, service delivery requirements, and compliance with specific agreements.",
      "summaryHTML": "The Commissioner can only impose certain conditions on a registered provider's registration if those conditions are specified by the rules, except for conditions related to quality and safety of aged care services, audit rules, reporting requirements, financial standards, the Aged Care Code of Conduct, service delivery requirements, and compliance with specific agreements.",
      "extract": "(2A) The Commissioner must not impose a condition unless the condition is of a kind that is prescribed by the rules.\n\n(2B) Subsection (2A) does not apply to a condition covered by subsection (3).\n\n(3) The conditions covered by this subsection are conditions relating to the following matters:\n\n(a) the quality and safety of funded aged care services delivered by a registered provider;\n\n(b) the rules made for the purposes of subsection 110(1) (which deals with audit requirements);\n\n(c) any additional reporting requirements that a registered provider must comply with;\n\n(d) the Financial and Prudential Standards;\n\n(e) the Aged Care Code of Conduct;\n\n(f) requirements relating to the funded aged care services that a registered provider may or may not deliver;\n\n(g) compliance with an agreement referred to in paragraph 133(3)(a) (eligible advisers).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631472",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 8,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div B, s144(1)-(2)",
      "section": "Rights and principles",
      "requirement": "Conditions of Registration",
      "subdivision": "Rights, Principles and Code of Conduct",
      "sublevel": "Rights and principles",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "All registered providers must demonstrate an understanding of an individual's rights (listed in the Statement of Rights) and have practices in place to ensure that services are delivered in accordance with the Statement of Rights.\n\nAll registered providers must demonstrate that an individuals safety, health, wellbeing and quality of life of is the primary consideration when delivering services.",
      "summaryHTML": "All registered providers must demonstrate an understanding of an individual's rights (listed in the Statement of Rights) and have practices in place to ensure that services are delivered in accordance with the Statement of Rights.\n\nAll registered providers must demonstrate that an individuals safety, health, wellbeing and quality of life of is the primary consideration when delivering services.",
      "extract": "Rights\n\n(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) demonstrate that the provider understands the rights of individuals under the Statement of Rights; and \n\n(b) have in place practices to ensure that the provider acts compatibly with the Statement of Rights, in accordance with subsection 24(2) (acting compatibly with the Statement of Rights). \n\nPrinciples—person-centred aged care system \n\n(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must demonstrate that the provider understands that the safety, health, wellbeing and quality of life of individuals is the primary consideration in the delivery of funded aged care services.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631474",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 149,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 3, s144-1",
          "section": "Kinds of providers to which the conditions apply",
          "requirement": "Conditions of Registration",
          "subdivision": "Rights, Principles and Code of Conduct",
          "sublevel": "Rights and principles",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 144(1) and 144(2) all registered providers are prescribed.",
          "summaryHTML": "For section 144(1) and 144(2) all registered providers are prescribed.",
          "extract": "For the purposes of subsections 144(1) and (2) of the Act, every kind of  registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s144(1)-(2)"
        }
      ]
    },
    {
      "id": 9,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div B, s145",
      "section": "Aged Care Code of Conduct",
      "requirement": "Conditions of Registration",
      "subdivision": "Rights, Principles and Code of Conduct",
      "sublevel": "Aged Care Code of Conduct",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers must comply with the Aged Care Code of Conduct and take reasonable steps to ensure that workers and the responsible persons of the provider comply with the  Aged Care Code of Conduct.",
      "summaryHTML": "Registered providers must comply with the Aged Care Code of Conduct and take reasonable steps to ensure that workers and the responsible persons of the provider comply with the  Aged Care Code of Conduct.",
      "extract": "It is a condition of registration that a registered provider must: \n\n(a) comply with the Aged Care Code of Conduct; and \n\n(b) take reasonable steps to ensure that the aged care workers, and the responsible persons, of the registered provider comply with the Aged Care Code of Conduct.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631475",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 10,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div C, s146",
      "section": "Compliance with Aged Care Quality Standards",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Compliance with Aged Care Quality Standards",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with the Aged Care Quality Standards.",
      "summaryHTML": "It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with the Aged Care Quality Standards.",
      "extract": "It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with the Aged Care Quality Standards.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631477",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 150,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 1, s146-5",
          "section": "Kinds of providers that must comply with Aged Care Quality Standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Compliance with Aged Care Quality Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 146, providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care are prescribed. \n\nThis requirement is also prescribed for providers registered in subscription trial if they are also registered in registration Category 4 and 5.",
          "summaryHTML": "For section 146, providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care are prescribed. \n\nThis requirement is also prescribed for providers registered in subscription trial if they are also registered in registration Category 4 and 5.",
          "extract": "For the purposes of section 146 of the Act:\n\n(a) a registered provider registered in any of the following provider registration categories is prescribed:\n\n(i) personal and care support in the home or community;\n\n(ii) nursing and transition care;\n\n(iii) residential care; and\n\n(b) a registered provider registered in the provider registration category subscription trial is prescribed if the provider is also registered in a provider registration category referred to in subparagraph (a)(i) or (ii) of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s146"
        }
      ]
    },
    {
      "id": 11,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div C, s147(1)",
      "section": "Continuous improvement",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Continuous improvement",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "All registered providers must demonstrate the capability for, and commitment to, continuous improvement of delivering high quality care.",
      "summaryHTML": "All registered providers must demonstrate the capability for, and commitment to, continuous improvement of delivering high quality care.",
      "extract": "(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must demonstrate the capability for, and commitment to, continuous improvement towards the delivery of high quality care.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631478",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 152,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 2, s147-5",
          "section": "Kinds of providers that must demonstrate capability and commitment",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Continuous improvement",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For the section 147(1) all registered providers are prescribed.",
          "summaryHTML": "For the section 147(1) all registered providers are prescribed.",
          "extract": "For the purposes of subsection 147(1) of the Act, every kind of registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s147(1)"
        }
      ]
    },
    {
      "id": 12,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div C, s147(2)",
      "section": "Continuous improvement",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Continuous improvement",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care must have a continuous improvement plan.",
      "summaryHTML": "Registered providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care must have a continuous improvement plan.",
      "extract": "(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must have a continuous improvement plan.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631478",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 151,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 2, s147-10",
          "section": "Kinds of providers that must have a continuous improvement plan",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Continuous improvement",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 147(2) providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care are prescribed.\n\nThis requirement is also prescribed for providers registered in subscription trial if they are also registered in registration Category 4 and 5.",
          "summaryHTML": "For section 147(2) providers in registration Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care are prescribed.\n\nThis requirement is also prescribed for providers registered in subscription trial if they are also registered in registration Category 4 and 5.",
          "extract": "For the purposes of subsection 147(2) of the Act:\n\n(a) a registered provider registered in any of the following provider registration categories is prescribed:\n\n(i) personal and care support in the home or community;\n\n(ii) nursing and transition care;\n\n(iii) residential care; and\n\n(b) a registered provider registered in the provider registration category subscription trial is prescribed if the provider is also registered in a provider registration category referred to in subparagraph (a)(i) or (ii) of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s147(2)"
        }
      ]
    },
    {
      "id": 13,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div C, s148",
      "section": "Delivery of funded aged care services",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Delivery of funded aged care services",
      "topic": [
        "agreements",
        "unspecified"
      ],
      "summary": "All registered providers must comply with the requirements in the rules for service delivery, home management, service agreements, care planning, and must deliver services as described in the official list, including within approved residential care homes where applicable.",
      "summaryHTML": "All registered providers must comply with the requirements in the rules for service delivery, home management, service agreements, care planning, and must deliver services as described in the official list, including within approved residential care homes where applicable.",
      "extract": "It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) deliver funded aged care services in accordance with any applicable requirements prescribed by the rules; and \n\n(b) maintain and manage any residential care homes in accordance with any applicable requirements prescribed by the rules; and \n\n(c) have an agreement with each individual accessing funded aged care services (a service agreement) in accordance with any applicable requirements prescribed by the rules; and \n\n(d) deliver funded aged care services to each individual in accordance with that agreement; and \n\n(e) have a plan about the delivery of funded aged care services to an individual (a care and services plan) for each individual accessing funded aged care services in accordance with any applicable requirements prescribed by the rules; and \n\n(f) deliver funded aged care services: \n\n(i) in accordance with the description of each service in the list of services prescribed by the rules for the purposes of subsection 8(1); and \n\n(ii) for a funded aged care service delivered through the residential care service group—in an approved residential care home.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631479",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 153,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div A, s148-5",
          "section": "Kinds of providers to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 148 all registered providers are prescribed.",
          "summaryHTML": "For section 148 all registered providers are prescribed.",
          "extract": "For the purposes of section 148 of the Act, every kind of registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 154,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-15",
          "section": "All registered providers—preventing damage to an individual’s property",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nA registered provider must take reasonable steps to avoid causing damage to an individual's property while delivering funded aged care services.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nA registered provider must take reasonable steps to avoid causing damage to an individual's property while delivering funded aged care services.",
          "extract": "A registered provider must take reasonable steps to prevent damage being caused to an individual’s property by the provider, or an aged care worker of the provider, in delivering funded aged care services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 155,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-20(1)-(1A)",
          "section": "Providers delivering services under certain provider registration categories—requirements for meals, snacks and drinks",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a provider that is registered in Category 1 - home and community services, Category 4 - personal care and care support in the home or community or subscription trial and delivers any of the following funded aged care services:\n\n- the service meal delivery;\n- the service community and centre-based respite;\n- a service in the service type community cottage respite;\n- the service subscription access to meal delivery;\n- the service subscription access to community and centre based respite",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a provider that is registered in Category 1 - home and community services, Category 4 - personal care and care support in the home or community or subscription trial and delivers any of the following funded aged care services:\n\n- the service meal delivery;\n- the service community and centre-based respite;\n- a service in the service type community cottage respite;\n- the service subscription access to meal delivery;\n- the service subscription access to community and centre based respite",
          "extract": "(1) This section applies to a registered provider that:\n\n(a) is registered in any of the following provider registration categories:\n\n(i) home and community services;\n\n(ii) personal and care support in the home and community;\n\n(b) delivers any of the following funded aged care services to an individual on a day through the service group home support under one of the registration categories mentioned in paragraph (a):\n\n(i)  the service meal delivery;\n\n(ii) the service community and centre-based respite;\n\n(iii) a service in the service type community cottage respite.\n\n(1A) This section also applies to a registered provider that:\n\n(a) is registered in the provider registration category subscription trial; and\n\n(b) is also registered in a provider registration category referred to in paragraph (1)(a); and\n\n(c) delivers any of the following funded aged care services to an individual on a day through the service group home support under that provider registration category:\n\n(i) the service subscription access to meal delivery;\n\n(ii) the service subscription access to community and centre based respite.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": true,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": true,
                "ccr": true,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 156,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-20(2)",
          "section": "Providers delivering services under certain provider registration categories—requirements for meals, snacks and drinks",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must deliver meals, snacks and drinks that are nutritious and appetising, considering the individual's needs and preferences.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must deliver meals, snacks and drinks that are nutritious and appetising, considering the individual's needs and preferences.",
          "extract": "(2) The provider must ensure any meals, snacks and drinks delivered to an individual through a funded aged care service referred to in paragraph (1)(b) or (1A)(c) are nutritious and appetising, having regard to the individual’s needs and preferences. \n\nNote: Providers have other statutory obligations in relation to food safety under the Australia New Zealand Food Standards Code.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": true,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": true,
                "ccr": true,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 157,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-20(3)",
          "section": "Providers delivering services under certain provider registration categories—requirements for meals, snacks and drinks",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must have a dietitian evaluate the meals, snacks, and drinks offered through the funded aged care services at least once a year to ensure they are appealing, meet the nutritional needs of individuals (including those with special dietary requirements), and follow evidence-based guidelines.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must have a dietitian evaluate the meals, snacks, and drinks offered through the funded aged care services at least once a year to ensure they are appealing, meet the nutritional needs of individuals (including those with special dietary requirements), and follow evidence-based guidelines.",
          "extract": "(3) The provider must, at least annually, have a dietitian assess the meals, snacks and drinks delivered by the provider through a funded aged care service referred to in paragraph (1)(b) or (1A)(c) to ensure that any meals, snacks and drinks:\n\n(a) are appetising; and\n\n(b) are appropriate for the nutrition needs of individuals accessing funded aged care services, including individuals with specialised dietary needs; and \n\n(c) reflect evidence-based guidelines and practice. \n\nNote: Examples of specialised dietary needs include medical needs, or religious or cultural preferences.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": true,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": true,
                "ccr": true,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 158,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-20(4)",
          "section": "Providers delivering services under certain provider registration categories—requirements for meals, snacks and drinks",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must establish a quality assurance framework to continually enhance the meals, snacks, and drinks offered to individuals in funded aged care services by considering their satisfaction and the dietitian's assessments and recommendations.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must establish a quality assurance framework to continually enhance the meals, snacks, and drinks offered to individuals in funded aged care services by considering their satisfaction and the dietitian's assessments and recommendations.",
          "extract": "(4)  The provider must implement a quality assurance framework to continuously improve the meals, snacks and drinks delivered to individuals through a funded aged care service referred to in paragraph (1)(b) or (1A)(c) by taking into account: \n\n(a) the satisfaction of individuals with the meals, snacks and drinks they are provided; and \n\n(b) the assessments undertaken and any recommendations made by a dietitian based on those assessments in accordance with subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": true,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": true,
                "ccr": true,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 159,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-25(1-2)",
          "section": "Providers delivering services under certain provider registration categories—requirements for service delivery equipment",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis rule applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and registration category subcription trial who deliver funded aged care services using equipment to deliver services or sourcing, supplying and providing of equipment to individuals.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis rule applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and registration category subcription trial who deliver funded aged care services using equipment to deliver services or sourcing, supplying and providing of equipment to individuals.",
          "extract": "(1) This section applies to a registered provider that:\n\n(a) is registered in any of the following provider registration categories:\n\n(i) home and community services;\n\n(ii) assistive technology and home modifications;\n\n(iii) advisory and support services; and\n\n(b) is delivering funded aged care services to an individual on a day under any of the registration categories referred to in paragraph (a).\n\n(2) This section also applies to a registered provider that:\n\n(a) is registered in the provider registration category subscription trial; and\n\n(b) is also registered in a provider registration category referred to in subparagraph (1)(a)(i) or (iii); and\n\n(c) is delivering funded aged care services to an individual on a day under the provider registration category subscription trial.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 160,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-25(3)",
          "section": "Providers delivering services under certain provider registration categories—requirements for service delivery equipment",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must ensure that the equipment is safe and meets the needs of the individual at the time the service is delivered to the individual.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must ensure that the equipment is safe and meets the needs of the individual at the time the service is delivered to the individual.",
          "extract": "(3) If:\n\n(a) the provider uses equipment in delivering the service; or\n\n(b) delivery of the service involves the sourcing, supply and provision of equipment to the individual;\nthe provider must ensure that the equipment is safe and meets the needs of the individual at the time the service is delivered to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 161,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-30(1)-(1A)",
          "section": "Providers delivering services under certain provider registration categories—requirements for personal protective equipment, infection prevention and control",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications and Category 3 - advisory and support services. This section also applies to a registered provider that is registered in the provider registration category subscription trial if the provider is also registered in  provider registration category 1 or 3.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications and Category 3 - advisory and support services. This section also applies to a registered provider that is registered in the provider registration category subscription trial if the provider is also registered in  provider registration category 1 or 3.",
          "extract": "(1) This section applies to a registered provider that is registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services.\n\n(1A) This section also applies to a registered provider that is registered in the provider registration category subscription trial if the provider is also registered in a provider registration category referred to in subparagraph (1)(a) or (c).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 162,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-30(2)",
          "section": "Providers delivering services under certain provider registration categories—requirements for personal protective equipment, infection prevention and control",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must ensure that personal protective equipment is available and that all relevant individuals are supported in its use during the delivery of funded aged care services.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must ensure that personal protective equipment is available and that all relevant individuals are supported in its use during the delivery of funded aged care services.",
          "extract": "(2) When delivering funded aged care services to an individual on a day under any of the registration categories referred to in subsection (1) or (1A), the provider must ensure that:\n\n(a) personal protective equipment is available to the individual, the aged care workers of the provider delivering the services and any other persons who need it;\n\n(b) the persons mentioned in paragraph (a) are supported to correctly use the equipment.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 163,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-30(3)",
          "section": "Providers delivering services under certain provider registration categories—requirements for personal protective equipment, infection prevention and control",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must implement an effective infection prevention and control system and ensure that aged care workers follow hygienic practices during when delivering services.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThe registered provider must implement an effective infection prevention and control system and ensure that aged care workers follow hygienic practices during when delivering services.",
          "extract": "(3) The provider must:\n\n(a) have an appropriate infection prevention and control system for delivery of funded aged care services;\n\n(b) ensure that aged care workers of the provider use hygienic practices and take appropriate infection prevention and control precautions when delivering funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 582,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-33(1)-(2)",
          "section": "Providers delivering services under provider registration category residential care—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This section applies to a registered provider that is registered in category 6 residential care and is delivering funded aged care services to an individual through the service group residential care.\n\nThe services delivered to the individual by the provider must include the services listed and described in Division 8 (residential care service types) of Part 3 of Chapter 1.",
          "summaryHTML": "This section applies to a registered provider that is registered in category 6 residential care and is delivering funded aged care services to an individual through the service group residential care.\n\nThe services delivered to the individual by the provider must include the services listed and described in Division 8 (residential care service types) of Part 3 of Chapter 1.",
          "extract": "(1)\tThis section applies to a registered provider that:\n\t(a)\tis registered in the provider registration category residential care; and\n\t(b)\tis delivering funded aged care services to an individual through the service group residential care.\n\t(2)\tThe services delivered to the individual by the provider must include the services listed and described in Division 8 (residential care service types) of Part 3 of Chapter 1.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 164,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-35(1)-(2)",
          "section": "Providers delivering services under the TCP—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nWhen a registered provider is delivering funded aged care services to an individual under TCP, the provider must deliver transition care management services to the individual.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nWhen a registered provider is delivering funded aged care services to an individual under TCP, the provider must deliver transition care management services to the individual.",
          "extract": "(1) This section applies to a registered provider that is delivering funded aged care services to an individual under the TCP.\n\n(2) The services delivered to the individual by the provider must include the service transition care management in the service type assistance with transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 165,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-40(1)",
          "section": "Providers delivering short-term funded aged care services through the service group home support—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a registered provider delivering services to an individual in the Support at Home Restorative Care Pathway. It does not apply to specialist aged care programs.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a registered provider delivering services to an individual in the Support at Home Restorative Care Pathway. It does not apply to specialist aged care programs.",
          "extract": "(1) This section applies to a registered provider that is delivering short-term funded aged care services to an individual (other than under a specialist aged care program) for the classification level SAH restorative care pathway for the classification type short-term through the service group home support.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 166,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-40(2)",
          "section": "Providers delivering short-term funded aged care services through the service group home support—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to registered providers delivering the Support at Home Restorative Care Pathway.\n\nThe registered provider must deliver a multidisciplinary early intervention care package aimed at enhancing the individual's functioning and independence while delaying the need for ongoing funded aged care services.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to registered providers delivering the Support at Home Restorative Care Pathway.\n\nThe registered provider must deliver a multidisciplinary early intervention care package aimed at enhancing the individual's functioning and independence while delaying the need for ongoing funded aged care services.",
          "extract": "(2) The services delivered to the individual by the provider must comprise a multidisciplinary package of early intervention care that is designed to optimise the functioning and independence of the individual, and reverse or slow the individual’s functional decline, to help delay the individual’s need to access ongoing funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 167,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-40(3)",
          "section": "Providers delivering short-term funded aged care services through the service group home support—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nA registered provider delivering the Support at Home Restorative Care Pathway, without limiting subsection (2) must deliver to the individual the service home support restorative care management and other services which may include a variety allied health and therapy services, and nursing care services as appropriate.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nA registered provider delivering the Support at Home Restorative Care Pathway, without limiting subsection (2) must deliver to the individual the service home support restorative care management and other services which may include a variety allied health and therapy services, and nursing care services as appropriate.",
          "extract": "(3) Without limiting subsection (2), the services delivered to the individual must include the following:\n\n(a) the service home support restorative care management in the service type restorative care management;\n\n(b) other services in accordance with the individual’s access approval which may include: \n\n(i) a variety of services in the service type allied health and therapy; \n\n(ii) services in the service type nursing care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 168,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-40(4)",
          "section": "Providers delivering short-term funded aged care services through the service group home support—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nA registered providers delivering the Support at Home Restorative Care Pathway must ensure that the service type restorative care management is delivered by an aged care worker of the provider (a restorative care partner) who holds relevant health qualifications.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nA registered providers delivering the Support at Home Restorative Care Pathway must ensure that the service type restorative care management is delivered by an aged care worker of the provider (a restorative care partner) who holds relevant health qualifications.",
          "extract": "(4) The provider must ensure an aged care worker of the provider who holds relevant health qualifications (a restorative care partner) delivers the service mentioned in paragraph (3)(a) to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 169,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-45(1)-(2)",
          "section": "Providers delivering certain funded aged care services through the service group home support—requirements for the service home support care management",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a registered provider who deliver ongoing Support at Home and Support at Home's End-of-Life Pathway. This doesn't apply to specialist aged care programs.\n\nThe provider must deliver the service home support care management in the service type care management to the individual at least once in each month where the provider also delivers other services to the individual.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 148.\n\nThis section applies to a registered provider who deliver ongoing Support at Home and Support at Home's End-of-Life Pathway. This doesn't apply to specialist aged care programs.\n\nThe provider must deliver the service home support care management in the service type care management to the individual at least once in each month where the provider also delivers other services to the individual.",
          "extract": "(1) This section applies to a registered provider that:\n\n(a)  is delivering ongoing funded aged care services to an individual (other than under a specialist aged care program) through the service group home support; or \n\n(b) is delivering short-term funded aged care services to an individual (other than under a specialist aged care program) for the classification level SAH end-of-life pathway through the service group home support. \n\n(2) The provider must deliver the service home support care management in the service type care management to the individual at least once in each month where the provider also delivers other services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 170,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div B, s148-46",
          "section": "Providers delivering services to an individual in a class of individuals referred to in section 275A—services that must be delivered",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "unspecified"
          ],
          "summary": "This section applies to a registered provider delivering residential care services. \n\nA registered provider must provide services to an individual if they were providing those services (or a substantially similar service) to this individual immediately before the transition time, or if the provider was delivering, or offered to deliver, the service to any other individual in the same approved residential care home (whether or not that other individual is, or would be, charged a higher everyday living fee by the provider for or in connection with the service). \n\nThis section applies even if the individual was not receiving the service by the provider at any time from transition time to the commencement of this section (1 November 2026).",
          "summaryHTML": "This section applies to a registered provider delivering residential care services. \n\nA registered provider must provide services to an individual if they were providing those services (or a substantially similar service) to this individual immediately before the transition time, or if the provider was delivering, or offered to deliver, the service to any other individual in the same approved residential care home (whether or not that other individual is, or would be, charged a higher everyday living fee by the provider for or in connection with the service). \n\nThis section applies even if the individual was not receiving the service by the provider at any time from transition time to the commencement of this section (1 November 2026).",
          "extract": "(1)\tThis section applies to a registered provider that is delivering ongoing funded aged care services through the service group residential care to an individual in a class of individuals referred to in section 275A of the Act in an approved residential care home. \n\n(2)\tThe services delivered to the individual by the provider at a time (the test time) after the commencement of this section must include a particular service (the transitional service) if: \n\n(a)\timmediately before the transition time, the provider was delivering the transitional service (or a substantially similar service) to the individual in the circumstances specified in subsection 285A‑25(5A); and \n\n(b)\tas at the test time, the provider is delivering, or offers to deliver, the transitional service to any other individual in the approved residential care home (whether or not that other individual is, or would be, charged a higher everyday living fee by the provider for or in connection with the service). \n\n(3)\tTo avoid doubt, subsection (2) applies even if the individual was not being delivered the transitional service by the provider at any time during the period: \n\n(a)\tstarting at the transition time; and \n\n(b)\tending at the commencement of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 171,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(1)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Entry into service agreement \n\nThis rule is only relevant to subsection (c) of section 148.\n\nA registered provider must enter into a service agreement with an individual on or before the individual’s start day; or if the individual is accessing funded aged care services in any of the circumstances specified in subsection 71(4) of the Act, or the registered provider is delivering funded aged care services to the individual under the MPSP or the NATSIFACP—within 28 days after the day the registered provider comences delivery of the services to the individual.",
          "summaryHTML": "<i>Entry into service agreement </i>\n\nThis rule is only relevant to subsection (c) of section 148.\n\nA registered provider must enter into a service agreement with an individual on or before the individual’s start day; or if the individual is accessing funded aged care services in any of the circumstances specified in subsection 71(4) of the Act, or the registered provider is delivering funded aged care services to the individual under the MPSP or the NATSIFACP—within 28 days after the day the registered provider comences delivery of the services to the individual.",
          "extract": "Entry into service agreement\n\n(1) A registered provider must enter into a service agreement with an individual:\n\n(a) unless paragraph (b) applies—on or before the individual’s start day; or\n\n(b) if the individual is accessing funded aged care services in any of the circumstances specified in subsection 71(4) of the Act, or the registered provider is delivering funded aged care services to the individual under the MPSP or the NATSIFACP—within 28 days after the day the registered provider commences delivery of the services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 172,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(2)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nA registered provider must make sure that:\n- The individual participates in creating and discussing the service agreement.\n- If the individual asks, a supporter, family member, caregiver, advocate, or any important person can be present during this process.\n- The service agreement is written in simple language that the individual can easily understand.\n- The individual receives assistance to understand the terms of the service agreement.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nA registered provider must make sure that:\n- The individual participates in creating and discussing the service agreement.\n- If the individual asks, a supporter, family member, caregiver, advocate, or any important person can be present during this process.\n- The service agreement is written in simple language that the individual can easily understand.\n- The individual receives assistance to understand the terms of the service agreement.",
          "extract": "Entry into service agreement\n\n(2) A registered provider must ensure the following: \n\n(a) the individual is involved in the development and negotiation of the service agreement; \n\n(b) if requested by the individual, a supporter, family member, carer or advocate of the individual, or any other person significant to the individual, is present during the development and negotiation of the service agreement; \n\n(c) the service agreement is expressed in plain language and is readily understandable by the individual; \n\n(d) the individual is helped to understand the terms of the service agreement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 173,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(3)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Cooling off period—other than for short term funded aged care services delivered through the service group residential care\n\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual can withdraw from a service agreement by notifying the registered provider either verbally or in writing within 14 days of entering into the agreement and it is before their services start. \n\nIf an individual does this, then the service agreement has no effect and the registered provider must refund any amount paid by the individual under the service agreement.",
          "summaryHTML": "<i>Cooling off period—other than for short term funded aged care services delivered through the service group residential care</i>\n\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual can withdraw from a service agreement by notifying the registered provider either verbally or in writing within 14 days of entering into the agreement and it is before their services start. \n\nIf an individual does this, then the service agreement has no effect and the registered provider must refund any amount paid by the individual under the service agreement.",
          "extract": "Cooling off period—other than for short term funded aged care services delivered through the service group residential care\n\n(3) A service agreement for the delivery of funded aged care services other than short term funded aged care services delivered through the service group residential care must provide that if:\n\n(a) within 14 days after the date of entry into the service agreement; and\n\n(b) before the individual’s start day;\nthe individual notifies (whether verbally or in writing) the registered provider that the individual wishes to withdraw from the service agreement, then:\n\n(c)\tthe service agreement has no effect; and\n\n(d)\tthe registered provider must refund any fees or contributions paid by the individual that are referred to in Part 3 of Chapter 4 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 174,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(3A)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Cooling off period and refunds of booking fees—short term funded aged care services delivered through the service group residential care\n\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual can withdraw from a service agreement for short term residential care by notifying the registered provider either verbally or in writing within 14 days of entering into the agreement and it is before their services start. \n\nIf an individual does this, then the service agreement has no effect and the registered provider must refund any amount paid by the individual under the service agreement.",
          "summaryHTML": "<i>Cooling off period and refunds of booking fees—short term funded aged care services delivered through the service group residential care\n</i>\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual can withdraw from a service agreement for short term residential care by notifying the registered provider either verbally or in writing within 14 days of entering into the agreement and it is before their services start. \n\nIf an individual does this, then the service agreement has no effect and the registered provider must refund any amount paid by the individual under the service agreement.",
          "extract": "Cooling off period and refunds of booking fees—short term funded aged care services delivered through the service group residential care\n\n(3A) A service agreement for the delivery of short term funded aged care services through the service group residential care must:\n\n(a) if the registered provider charges the individual a booking fee for or in connection with the delivery of those services under subsection 283(4) of the Act—set out the effect of subsections 283 15(3) to (7) of this instrument (which deal with refunds of booking fees); and\n\n(b) provide that if:\n\n(i) within 14 days after the date of entry into the service agreement; and\n\n(ii) before the individual’s start day;\n\tthe individual notifies (whether verbally or in writing) the registered provider that the individual wishes to withdraw from the service agreement, then:\n\n(iii) the service agreement has no effect; and\n\n(iv) the registered provider must refund any fees or contributions paid by the individual that are referred to in Division 2, 2A or 3 of Part 3 of Chapter 4 of the Act (other than a booking fee referred to in paragraph (a)).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 175,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(4)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Additional cooling off period—ongoing aged care services delivered through the service group residential care\n\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual who is receiving ongoing funded aged care services in a residential care setting can withdraw from a service agreement by notifying the registered provider either verbally or in writing within 28 days after the date of entry into the service agreement. The registered provider must refund any amount paid by the individual under the service agreement in relation to services that had not been delivered by the termination date.",
          "summaryHTML": "<i>Additional cooling off period—ongoing aged care services delivered through the service group residential care</i>\n\nThis rule is only relevant to subsection (c) of section 148.\n\nAn individual who is receiving ongoing funded aged care services in a residential care setting can withdraw from a service agreement by notifying the registered provider either verbally or in writing within 28 days after the date of entry into the service agreement. The registered provider must refund any amount paid by the individual under the service agreement in relation to services that had not been delivered by the termination date.",
          "extract": "Additional cooling off period—ongoing aged care services delivered through the service group residential care\n\n(4) A service agreement for an individual to whom the registered provider is to deliver funded aged care services under the classification type ongoing through the service group residential care must provide that, if the individual notifies (whether verbally or in writing) the registered provider that the individual wishes to withdraw from the service agreement within 28 days after the date of entry into the service agreement, the registered provider must refund any amount paid by the individual under the service agreement in relation to services that had not been delivered by the termination date.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 176,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(5)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement may be modified either by the provider for tax compliance with proper notice or by mutual consent between the individual and provider after adequate consultation and consent.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement may be modified either by the provider for tax compliance with proper notice or by mutual consent between the individual and provider after adequate consultation and consent.",
          "extract": "Variation of service agreement\n\n(5) A service agreement must provide that the agreement may be varied:\n\n(a) by the registered provider if:\n\n(i) the variation is necessary to implement the A New Tax System (Goods and Services Tax) Act 1999; and\n\n(ii) the provider has given reasonable notice in writing about the variation to the individual; and\n\n(iii) the variation is not inconsistent with the A New Tax System (Goods and Services Tax) Act 1999 or the Act; or\n\n(b) by mutual consent of the individual and the registered provider if:\n\n(i) there has been adequate consultation about the variation between the individual and the provider; and\n\n(ii) the provider has obtained consent from the individual to make the variation; and\n\n(iii) the variation is not inconsistent with the A New Tax System (Goods and Services Tax) Act 1999 or the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 177,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(6)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement must stipulate that the provider will review it at least annually and also upon the individual's request.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement must stipulate that the provider will review it at least annually and also upon the individual's request.",
          "extract": "Review of service agreement \n\n(6) A service agreement between a registered provider and an individual accessing ongoing funded aged care services must provide that the provider will review the service agreement:\n\n(a) at least once every 12 months; and\n\n(b) upon request from the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 178,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-65(7)",
          "section": "Requirements for service agreements—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nDuring the review of the service agreement, the provider must allow the individual to participate, consider whether updates are needed, and make necessary variations in line with subsection (5).",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nDuring the review of the service agreement, the provider must allow the individual to participate, consider whether updates are needed, and make necessary variations in line with subsection (5).",
          "extract": "Review of service agreement\n\n(7) Without limiting the nature of the review, the provider must: \n\n(a) give the individual an opportunity to participate in the review; and \n\n(b) consider whether any updates need to be made to the service agreement; and \n\n(c) if necessary, vary the service agreement in accordance with subsection (5)",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 179,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(1)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nA service agreement must not include any terms that would result in the individual being treated less favourably than they would be under Commonwealth law.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nA service agreement must not include any terms that would result in the individual being treated less favourably than they would be under Commonwealth law.",
          "extract": "All registered providers\n\n(1) A service agreement must not contain any provision that would have the effect of the individual being treated less favourably in relation to any matter than the individual would otherwise be treated, under any law of the Commonwealth, in relation to that matter.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 183,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(2)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nA service agreement must include details about the parties involved, contact information, access approval, agreement commencement, review and end (if applicable) dates, and the individual's involvement in service delivery decisions.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nA service agreement must include details about the parties involved, contact information, access approval, agreement commencement, review and end (if applicable) dates, and the individual's involvement in service delivery decisions.",
          "extract": "All registered providers\n\n(2) A service agreement entered into between a registered provider and an individual must contain the following:\n\n(a) a statement setting out the parties to the agreement, including the following:\n\n(i) the name of the individual;\n\n(ii) the contact details of the individual;\n\n(iii) the name of the provider;\n\n(iv) the contact details of the provider;\n\n(b) the contact details of the supporters of the individual (if any);\n\n(c) a copy of the individual’s access approval;\n\n(d) the approved residential care home (if any) in or from which the provider will deliver funded aged care services to the individual;\n\n(e) the date when the service agreement commences; \n\n(f) the start day for the individual; \n\n(g) if the individual is accessing short-term or hospital transition funded aged care services: \n\n(i) when the provider will cease delivering short-term or hospital transition funded aged care services to the individual; and \n\n(ii) the date when the service agreement ends; \n\n(h) if the individual is accessing ongoing funded aged care services, the date the service agreement is to be reviewed in accordance with subsection 148-65(6); \n\n(i) how the individual will be involved in decisions relating to how, when and by whom funded aged care services are delivered to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 184,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(3)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement under section 148-70(2) does not have to include details about the individual's involvement in service delivery decisions (subsection (2)(i)) if the provider is delivering funded aged care services to the individual under the TCP.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThe service agreement under section 148-70(2) does not have to include details about the individual's involvement in service delivery decisions (subsection (2)(i)) if the provider is delivering funded aged care services to the individual under the TCP.",
          "extract": "All registered providers\n\n(3) Despite subsection (2), a service agreement entered into between a registered provider and an individual does not have to contain the matters specified in paragraph (2)(i) if the provider is delivering funded aged care services to the individual under the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 185,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(4)-(4A)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThis rule applies to the service groups home support, assistive technology, or home modifications. The specialist aged care programs MPSP, NATSIFACP and TCP are excluded. \n\nThese providers must ensure their service agreements clearly detail the services to be delivered, associated pricing (including exceptions and increases), delivery conditions, and termination terms for the individual receiving care.\n \nThere are specific requirements in relation to service agreements for subscription services under section 148-70(4A).",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThis rule applies to the service groups home support, assistive technology, or home modifications. The specialist aged care programs MPSP, NATSIFACP and TCP are excluded. \n\nThese providers must ensure their service agreements clearly detail the services to be delivered, associated pricing (including exceptions and increases), delivery conditions, and termination terms for the individual receiving care.\n \nThere are specific requirements in relation to service agreements for subscription services under section 148-70(4A).",
          "extract": "Certain registered providers delivering services through the service groups home support, assistive technology or home modifications (other than under a specialist aged care program)\n\n(4) A service agreement entered into between a registered provider (to whom subsection (5) applies) and an individual must also contain the following: \n\n(a) the funded aged care services the provider will deliver to the individual, including the following: \n\n(i) the name of each service as provided in the service list under section 8-5 of this instrument; \n\n(ii) if the provider intends for an associated provider to deliver any services to the individual, which services will be delivered by the associated provider; \n\n(b) the prices the provider will charge the individual for each of the funded aged care services the provider will deliver to the individual; \n\n(c) if the individual is to be charged a price for delivery of a funded aged care service that is higher than the price published on the provider’s website or the department’s website—the reason for the higher price; \n\n(d) a statement that the prices mentioned in paragraphs (b) and (c) may be subject to regular price increases to account for indexation and the details of such increases, including: \n\n(i) the date the prices will increase; and \n\n(ii) the method for working out the increase; and \n\n(iii) the reason for the matters specified at subparagraphs (i) and (ii); \n\n(e) a statement that the provider may only cease delivery of funded aged care services to the individual in the circumstances specified in subsection 149-35(2); \n\n(f) if either of the circumstances in paragraphs 149-35(2)(e) or (f) arise, any other requirements for notifying the provider; \n\n(g) how and when the service agreement may be terminated; \n\n(h) a statement that the registered provider will not charge an individual contribution to the individual if the individual has made an application for a fee reduction supplement determination under subsection 197-20(1) and the System Governor has not decided on that application; \n\n(i) a statement that where, in relation to an application mentioned in paragraph (h), the System Governor makes a determination that the fee reduction supplement should not apply to the individual, the registered provider can collect the unpaid individual contributions for the period beginning on the day the application was made. \n\n(4A) If the funded aged care services contained in a service agreement under paragraph (4)(a) include a subscription service, the service agreement must also contain the following:\n\n(a) the parameters of the access provided by the subscription service, including (as applicable) the following:\n\n(i) the days the access will be provided;\n\n(ii) the periods on those days during which the access will be provided;\n\n(iii) any limits on the number of times the access can be used during those periods;\n\n(iv) whether the access is provided on a group basis;\n\n(b) a statement of whether the individual consents to the collection of the individual’s personal information for the purpose of evaluating the delivery of the subscription service;\n\n(c) a statement that the individual may cease to access the subscription service by giving notice in writing to the provider stating the day that the individual wishes the cessation to take effect; and\n\n(d) a statement of the effect of subsections 11A(2) to (4) of the Act and section 11A 5 of this instrument (dealing with when non delivery of funded aged care services is taken to be delivery of funded aged care services).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 188,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(5)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThis subsection applies to providers delivering service groups home support, assistive technology, or home modifications. The specialist aged care programs CHSP, MPSP, NATSIFACP and TCP are excluded.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThis subsection applies to providers delivering service groups home support, assistive technology, or home modifications. The specialist aged care programs CHSP, MPSP, NATSIFACP and TCP are excluded.",
          "extract": "(5) This subsection applies to a registered provider that is delivering funded aged care services to an individual through the service groups home support, assistive technology or home modifications (other than under a specialist aged care program).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 186,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(6)-(7)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Registered providers delivering services under the CHSP, MPSP or NATSIFACP\n\nThis rule is only relevant to subsection (c) of section 148.\n\nA service agreement entered into between an individual and a registered provider that is delivering funded aged care services to an individual under the CHSP, MPSP and/or NATSIFACP must contain the matters mentioned in paragraphs (4)(a), (e), (f) and (g).\n\nA service agreement entered into between an individual and a registered provider delivering CHSP must also contain the fees and contribution that the registered provider will charge the individual for each of the funded aged care services the provider will deliver to the individual.",
          "summaryHTML": "<i>Registered providers delivering services under the CHSP, MPSP or NATSIFACP\n\n</i>This rule is only relevant to subsection (c) of section 148.\n\nA service agreement entered into between an individual and a registered provider that is delivering funded aged care services to an individual under the CHSP, MPSP and/or NATSIFACP must contain the matters mentioned in paragraphs (4)(a), (e), (f) and (g).\n\nA service agreement entered into between an individual and a registered provider delivering CHSP must also contain the fees and contribution that the registered provider will charge the individual for each of the funded aged care services the provider will deliver to the individual.",
          "extract": "Registered providers delivering services under the CHSP, MPSP or NATSIFACP\n\n(6) A service agreement entered into between a registered provider (to whom subsection (9)) applies and an individual must also contain:\n(a) the matters mentioned in paragraphs (4)(a), (e), (f) and (g); and\n\n(b) the fees and contribution that the registered provider will charge the individual for each of the funded aged care services the provider will deliver to the individual.\n\n(7) A service agreement entered into between a registered provider (to whom subsection (10) applies) and an individual must also contain the matters mentioned in paragraphs (4)(a), (e), (f) and (g).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 187,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(8)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A service agreement entered into between a registered provider (to whom subsection (9) or (10) of this section applies) and an individual must also contain a statement that the individual agrees to pay any applicable fees referred to in Division 3 of Part 3 of Chapter 4 of the Act.",
          "summaryHTML": "A service agreement entered into between a registered provider (to whom subsection (9) or (10) of this section applies) and an individual must also contain a statement that the individual agrees to pay any applicable fees referred to in Division 3 of Part 3 of Chapter 4 of the Act.",
          "extract": "Registered providers delivering services under the CHSP, MPSP or NATSIFACP\n\n(8) A service agreement entered into between a registered provider (to whom subsection (9) or (10) of this section applies) and an individual must also contain a statement that the individual agrees to pay any applicable fees referred to in Division 3 of Part 3 of Chapter 4 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 189,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(9)-(10)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nSubsection (9) applies to a registered provider that is delivering funded aged care services to an individual under the CHSP.\n\nSubsection (10) applies to a registered provider that is delivering funded aged care services to an individual under the MPSP or NATSIFACP.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nSubsection (9) applies to a registered provider that is delivering funded aged care services to an individual under the CHSP.\n\nSubsection (10) applies to a registered provider that is delivering funded aged care services to an individual under the MPSP or NATSIFACP.",
          "extract": "(9) This subsection applies to a registered provider that is delivering funded aged care services to an individual under the CHSP.\n(10) This subsection applies to a registered provider that is delivering funded aged care services to an individual under the MPSP or NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 190,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(11)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nRegistered providers delivering residential care must ensure their service agreements specify which fees or contributions (if any) will be charged to the individual.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nRegistered providers delivering residential care must ensure their service agreements specify which fees or contributions (if any) will be charged to the individual.",
          "extract": "Registered providers delivering services through the service group residential care\n\n(9) A service agreement entered into between a registered provider (to whom subsection (13) or (14) of this section applies) and an individual must also contain which fees or contributions (if any), referred to in Division 2, 2A  or 3 of Part 3 of Chapter 4 of the Act, the provider will charge the individual",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 180,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(12)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nA registered providers delivering ongoing residential care must include in the service agreement the limited circumstances under which an individual can be asked to leave (as prescribed in 149-60(1)),  the support the provider will give to help them find alternative accommodation and how and when the service agreement may be terminated. For any fees or contributions that the provider will charge the individual (as set out in the agreement under subsection (11))—the policies and practices the provider will follow in setting and updating the amounts of those fees and contributions.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nA registered providers delivering ongoing residential care must include in the service agreement the limited circumstances under which an individual can be asked to leave (as prescribed in 149-60(1)),  the support the provider will give to help them find alternative accommodation and how and when the service agreement may be terminated. For any fees or contributions that the provider will charge the individual (as set out in the agreement under subsection (11))—the policies and practices the provider will follow in setting and updating the amounts of those fees and contributions.",
          "extract": "Registered providers delivering ongoing funded aged care services through the service group residential care\n\n(12) A service agreement entered into between a registered provider (to whom subsection (13) of this section applies) and an individual must also contain the following:\n\n(a) that the provider may only ask the individual to leave the approved residential care home in the circumstances specified in subsection 149-60(1);\n\n(b) the assistance the provider will provide to the individual to obtain suitable alternative accommodation if the individual is asked to leave the approved residential care home; \n\n(c) how and when the service agreement may be terminated. \n\n(d) for any fees or contributions that the provider will charge the individual (as set out in the agreement under subsection (11))—the policies and practices the provider will follow in setting and updating the amounts of those fees and contributions.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 181,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(13)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThis section only applies to a registered provider that is providing ongoing funded aged care services to an individual in a residential care setting.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThis section only applies to a registered provider that is providing ongoing funded aged care services to an individual in a residential care setting.",
          "extract": "Registered providers delivering ongoing funded aged care services through the service group residential care\n\n(13) This subsection applies to a registered provider that is delivering ongoing funded aged care services to an individual through the service group residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 182,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div C, s148-70(14)",
          "section": "Requirements for service agreements—contents",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (c) of section 148.\n\nThis section only applies to a registered provider that is offering short-term residential care (respite) or providing funded aged care services under the TCP.",
          "summaryHTML": "This rule is only relevant to subsection (c) of section 148.\n\nThis section only applies to a registered provider that is offering short-term residential care (respite) or providing funded aged care services under the TCP.",
          "extract": "Registered providers delivering ongoing funded aged care services through the service group residential care\n\n(14) This subsection applies to a registered provider that:\n\n(a) is delivering short-term funded aged care services to an individual through the service group residential care; or\n\n(b) is delivering funded aged care services to an individual through the service group residential care under the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 191,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-80(1)",
          "section": "Requirements for care and services plans—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "When a care and services plan must be developed —all registered providers\n\nThis rule is only relevant to subsection (e) of section 148.\n\nRegistered providers must create a care and services plan by the individual’s start day or, if specific exceptions apply, within 28 days of access approval.",
          "summaryHTML": "<i>When a care and services plan must be developed —all registered providers</i>\n\nThis rule is only relevant to subsection (e) of section 148.\n\nRegistered providers must create a care and services plan by the individual’s start day or, if specific exceptions apply, within 28 days of access approval.",
          "extract": "When a care and services plan must be developed —all registered providers\n\n(1) A registered provider must develop a care and services plan for an individual:\n\n(a) unless paragraph (b) applies - on or before the individual’s start day; or\n\n(b) if the individual is accessing funded aged care services in any of the circumstances specified in subsection 71(4) of the Act, or the registered provider is delivering funded aged care services to the individual under the MPSP or the NATSIFACP—within 28 days after the day the registered provider commences delivery of the services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 192,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-80(2)",
          "section": "Requirements for care and services plans—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "How a care and services plan is developed —certain registered providers\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and relevant services under registration category subscription trial\n\nThese providers must actively and continuously engage with the individual, their supporters, and other care participants when developing and reviewing the individual's care and services plan.",
          "summaryHTML": "<i>How a care and services plan is developed —certain registered providers</i>\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and relevant services under registration category subscription trial\n\nThese providers must actively and continuously engage with the individual, their supporters, and other care participants when developing and reviewing the individual's care and services plan.",
          "extract": "How a care and services plan is developed —certain registered providers\n\n(2) A registered provider to whom subsection (5) or (6) applies must actively engage with:\n\n(a) the individual; and\n\n(b) supporters of the individual (if any); and\n\n(c) any other persons involved in the care of the individual;\nin developing and reviewing the individual’s care and services plan through ongoing communication.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 193,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-80(3)",
          "section": "Requirements for care and services plans—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Care and services plan to be in line with the individual’s needs —certain registered providers\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and relevant services under registration category subscription trial.\n\nThese providers must ensure care plans reflect the individual’s needs and goals, include risk and prevention strategies, and are reviewed annually for those receiving ongoing care.",
          "summaryHTML": "<i>Care and services plan to be in line with the individual’s needs —certain registered providers</i>\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis rule only applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services and relevant services under registration category subscription trial.\n\nThese providers must ensure care plans reflect the individual’s needs and goals, include risk and prevention strategies, and are reviewed annually for those receiving ongoing care.",
          "extract": "Care and services plan to be in line with the individual’s needs —certain registered providers\n\n(3) A registered provider to whom subsection (5) or (6) applies must ensure an individual’s care and services plan:\n\n(a) describes the current care needs, goals and preferences of the individual;\n\n(b) includes strategies for risk management and preventative care; and\n\n(c) where an individual is accessing ongoing funded aged care services, is reviewed at least once every 12 months.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 194,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-80(4)",
          "section": "Requirements for care and services plans—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Care and services plan to be accessible to individual —all registered providers\n\nThis rule is only relevant to subsection (e) of section 148.\n\nRegistered providers must give individuals a copy of their care and services plan when it is first developed, whenever it is updated, and whenever the individual requests it.",
          "summaryHTML": "<i>Care and services plan to be accessible to individual —all registered providers</i>\n\nThis rule is only relevant to subsection (e) of section 148.\n\nRegistered providers must give individuals a copy of their care and services plan when it is first developed, whenever it is updated, and whenever the individual requests it.",
          "extract": "Care and services plan to be accessible to individual —all registered providers\n\n(4) A registered provider must provide a copy of an individual’s care and services plan to the individual at the following times:\n\n(a) once the plan is developed;\n\n(b) any time the plan is updated;\n\n(c) upon request from the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 195,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-80(5)-(6)",
          "section": "Requirements for care and services plans—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Registered providers that are subject to subsections (2) and (3)\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis subsection applies to providers delivering services under the Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services, and relevant services under registration category subscription trial. \n\nNote: See subsections 15-20(1) to (3) of the rules for the Aged Care Quality Standards relating to care and services plans which apply to providers registered in Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care. Further information on care and services plans, is also in section 8-20 (service type assistance with transition care) and section 8-155 (service type residential clinical care).",
          "summaryHTML": "<i>Registered providers that are subject to subsections (2) and (3)</i>\n\nThis rule is only relevant to subsection (e) of section 148.\n\nThis subsection applies to providers delivering services under the Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services, and relevant services under registration category subscription trial. \n\nNote: See subsections 15-20(1) to (3) of the rules for the Aged Care Quality Standards relating to care and services plans which apply to providers registered in Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care. Further information on care and services plans, is also in section 8-20 (service type assistance with transition care) and section 8-155 (service type residential clinical care).",
          "extract": "Registered providers that are subject to subsections (2) and (3)\n\nCare and services plan to be accessible to individual\n\n(5) This subsection applies to a registered provider that is delivering funded aged care services to an individual under any of the following registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services.\n\n(6) This subsection applies to a registered provider that is registered in the provider registration category subscription trial if the provider is also registered in a provider registration category referred to in paragraph (5)(a) or (c).\n\nNote 1: See subsections 15-20(1) to (3) for the Aged Care Quality Standards relating to care and services plans which apply to providers registered in provider registration categories personal and care support in the home and community, nursing and transition care, and residential care.\n\nNote 2: For funded aged care services relating to care and services plans, see item 1 of the table in section 8-20 and items 1 and 4 in the table in section 8-155.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 196,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-81(1)",
          "section": "Requirements for care and services plans—restorative care partner to be responsible for care and services plans in certain circumstances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (e) of section 148.\n\nThis rule applies to providers delivering short-term aged care services under restorative care pathway through home support (excluding specialist aged care programs). The specialist aged care programs CHSP, MPSP, NATSIFACP and TCP are excluded.",
          "summaryHTML": "This rule is only relevant to subsection (e) of section 148.\n\nThis rule applies to providers delivering short-term aged care services under restorative care pathway through home support (excluding specialist aged care programs). The specialist aged care programs CHSP, MPSP, NATSIFACP and TCP are excluded.",
          "extract": "(1) This section applies to a registered provider that is delivering short-term funded aged care services to an individual (other than under a specialist aged care program) for the classification level SAH restorative care pathway through the service group home support.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 197,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-81(2)",
          "section": "Requirements for care and services plans—restorative care partner to be responsible for care and services plans in certain circumstances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (e) of section 148.\n\nThe registered provider must ensure the restorative care partner creates a care and services plan that meets all applicable requirements under this Subdivision.",
          "summaryHTML": "This rule is only relevant to subsection (e) of section 148.\n\nThe registered provider must ensure the restorative care partner creates a care and services plan that meets all applicable requirements under this Subdivision.",
          "extract": "(2)  The provider must ensure the restorative care partner who will deliver the service services plan for the individual in accordance with any applicable requirements set out in this Subdivision. mentioned in paragraph 148-40(3)(a) to the individual develops a care and",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 198,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-81(3)",
          "section": "Requirements for care and services plans—restorative care partner to be responsible for care and services plans in certain circumstances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (e) of section 148.\n\nThe provider must include exit planning in the care and services plan and make sure that this plan works well with any ongoing services the individual is receiving.",
          "summaryHTML": "This rule is only relevant to subsection (e) of section 148.\n\nThe provider must include exit planning in the care and services plan and make sure that this plan works well with any ongoing services the individual is receiving.",
          "extract": "(3) The provider must consider exit planning as part of the care and services plan and must ensure the plan complements any ongoing services the individual is also accessing.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 199,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-85(1)",
          "section": "Requirements for care and services plans—contents for all individuals (other than individuals accessing services through the service group residential care)",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (e) of section 148.\n\nThis rule applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and registration category subscription trial.",
          "summaryHTML": "This rule is only relevant to subsection (e) of section 148.\n\nThis rule applies to registered providers in Category 1 - home and community services, Category 2 - assistive technology and home modifications, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and registration category subscription trial.",
          "extract": "Application of this section\n\n(1) This section applies to a registered provider that is delivering funded aged care services to an individual under any of the following registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        },
        {
          "id": 200,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 3, Sub Div D, s148-85(2)",
          "section": "Requirements for care and services plans—contents for all individuals (other than individuals accessing services through the service group residential care)",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Delivery of funded aged care services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (e) of section 148.\n\nA care and services plan must set out the services to be delivered (including their frequency and volume), when the plan will be reviewed, and, for ongoing care, the date of the next service agreement review.",
          "summaryHTML": "This rule is only relevant to subsection (e) of section 148.\n\nA care and services plan must set out the services to be delivered (including their frequency and volume), when the plan will be reviewed, and, for ongoing care, the date of the next service agreement review.",
          "extract": "Contents\n\n(2) A care and services plan for an individual must include the following:\n\n(a) the funded aged care services that the provider will deliver to the individual, including:\n\n(i) the frequency of the services; and\n\n(ii) the volume or duration of the services;\n\n(b) when the care and services plan will be reviewed;\n\n(c) if the individual is accessing ongoing funded aged care services, the date the individual’s service agreement is to be reviewed in accordance with subsection 148-65(6).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s148"
        }
      ]
    },
    {
      "id": 14,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div C, s149",
      "section": "Starting and ceasing the provision of funded aged care services and continuity of those services",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
      "topic": [
        "agreements",
        "reporting"
      ],
      "summary": "Registered providers must comply with the relevant rules relating to starting, continuing or stopping delivering funded aged care services, notifying the System Governor and Commissions about starting or stopping delivery of these services, or security of tenure of individuals accessing services in an approved residential care home.",
      "summaryHTML": "Registered providers must comply with the relevant rules relating to starting, continuing or stopping delivering funded aged care services, notifying the System Governor and Commissions about starting or stopping delivery of these services, or security of tenure of individuals accessing services in an approved residential care home.",
      "extract": "It is a condition of registration that a registered provider must comply with any requirements prescribed by the rules relating to the following: \n\n(a) starting the delivery of funded aged care services to an individual; \n\n(b) providing a notification to the System Governor and the Commissioner about starting the delivery of funded aged care services to an individual (a start notification); \n\n(c) ceasing the delivery of funded aged care services to an individual; \n\n(d) providing a notification to the System Governor and the Commissioner about ceasing the delivery of funded aged care services to an individual (a cessation notification); \n\n(e) ceasing to deliver any funded aged care services; \n\n(f) if the provider delivers funded aged care services in an approved residential care home—security of tenure for individuals accessing those services; \n\n(g) continuity of funded aged care services for individuals",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631480",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 201,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div A, s149-5",
          "section": "Requirements relating to starting and ceasing the provision of funded aged care services and continuity of those services",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This Division sets out the requirements providers must follow when starting or ceasing aged care services, and when individuals leave or transition from care. It covers notifications to the System Governor and Commissioner, arrangements for ending service delivery, and the provider’s obligations to ensure security of tenure and continuity of care for individuals in residential settings. Related provisions on service agreements are dealt with separately under subsection 148-70.",
          "summaryHTML": "This Division sets out the requirements providers must follow when starting or ceasing aged care services, and when individuals leave or transition from care. It covers notifications to the System Governor and Commissioner, arrangements for ending service delivery, and the provider’s obligations to ensure security of tenure and continuity of care for individuals in residential settings. Related provisions on service agreements are dealt with separately under subsection 148-70.",
          "extract": "For the purposes of section 149 of the Act, this Division prescribes requirements for the following: \n\n(a) providing a start notification to the System Governor and the Commissioner; \n\n(b) ceasing the delivery of funded aged care services to an individual; \n\n(c) providing a cessation notification to the System Governor and the Commissioner; \n\n(d) ceasing to deliver any funded aged care services; \n\n(e) if the provider delivers funded aged care services in an approved residential care home—security of tenure for individuals accessing those services; \n\n(f) continuity of funded aged care services for individuals. \n\nNote: For requirements relating to a service agreement between an individual and a registered provider, see section 148-70 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 202,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-10(1)-(2)",
          "section": "Requirements for start notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A registered provider must prepare a start notification when they start delivering funded aged care services to an individual, but this is not required if the individual is accessing services through a specialist aged care program, except for the TCP.",
          "summaryHTML": "A registered provider must prepare a start notification when they start delivering funded aged care services to an individual, but this is not required if the individual is accessing services through a specialist aged care program, except for the TCP.",
          "extract": "(1) A registered provider must prepare a start notification for delivering funded aged care services to an individual in accordance with this section.\n\n(2) Despite subsection (1), a registered provider does not have to prepare a start notification for an individual where the individual will access funded aged care services under a specialist aged care program other than the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 203,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-10(3)",
          "section": "Requirements for start notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A start notification must be in an approved form.",
          "summaryHTML": "A start notification must be in an approved form.",
          "extract": "(3) A start notification must be in an approved form.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 204,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-10(4)",
          "section": "Requirements for start notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A start notification for an individual accessing funded aged care services through the service groups home support, assistive technology or home modifications must specify the individual's name, the start day for the individual, and the service delivery branch through which funded aged care services will be delivered to the individual.",
          "summaryHTML": "A start notification for an individual accessing funded aged care services through the service groups home support, assistive technology or home modifications must specify the individual's name, the start day for the individual, and the service delivery branch through which funded aged care services will be delivered to the individual.",
          "extract": "Start notification for an individual accessing funded aged care services through the service groups home support, assistive technology, or home modifications\n\n(4) A start notification for an individual accessing funded aged care services through the service groups home support, assistive technology or home modifications must specify the following: \n\n(a) the name of the individual; \n\n(b) the start day for the individual; \n\n(c) the service delivery branch through which funded aged care services will be delivered to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 205,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-10(5)",
          "section": "Requirements for start notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to the service group residential care. \n\nA start notification for an individual accessing funded aged care services through the classification type ongoing for the service group residential care must specify the individual's name, the start day for the individual, and the approved residential care home at which funded aged care services will be delivered to the individual.",
          "summaryHTML": "This rule applies to the service group residential care. \n\nA start notification for an individual accessing funded aged care services through the classification type ongoing for the service group residential care must specify the individual's name, the start day for the individual, and the approved residential care home at which funded aged care services will be delivered to the individual.",
          "extract": "Start notification for an individual accessing funded aged care services through the classification type ongoing for the service group residential care\n\n(5) A start notification for an individual accessing funded aged care services through the classification type ongoing for the service group residential care must specify the following:\n\n(a) the name of the individual;\n\n(b) the start day for the individual;\n\n(c) the approved residential care home at which funded aged care services will be delivered to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 206,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-10(6)",
          "section": "Requirements for start notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A start notification for an individual accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care must specify the individual's name, the start day for the individual, and the approved residential care home at which funded aged care services will be delivered to the individual.",
          "summaryHTML": "A start notification for an individual accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care must specify the individual's name, the start day for the individual, and the approved residential care home at which funded aged care services will be delivered to the individual.",
          "extract": "Start notification for an individual accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care \n\n(6) A start notification for an individual accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care must specify the following: \n\n(a) the name of the individual; \n\n(b) the start day for the individual; \n\n(c) the approved residential care home at which funded aged care services will be delivered to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 207,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div B, s149-15",
          "section": "Requirements for start notifications—provision to System Governor and Commissioner",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "Under subsection (a) of this rule, a start notification must be given within 28 days for an individual accessing funded aged care services through the service groups home support, assistive technology, and home modifications and when an individual is accessing funded aged care services through the classification type ongoing for the service group residential care.\n\nUnder subsection (b) of this rule, a start notification must be given within 14 days when and individual is accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care.",
          "summaryHTML": "Under subsection (a) of this rule, a start notification must be given within 28 days for an individual accessing funded aged care services through the service groups home support, assistive technology, and home modifications and when an individual is accessing funded aged care services through the classification type ongoing for the service group residential care.\n\nUnder subsection (b) of this rule, a start notification must be given within 14 days when and individual is accessing funded aged care services through the classification type short-term or hospital transition for the service group residential care.",
          "extract": "A registered provider must give a start notification for an individual to the System Governor and the Commissioner:\n\n(a) for an individual mentioned in subsections 149-10(4) and (5)—within 28 days after the individual’s start day; or\n\n(b) for an individual mentioned in subsection 149-10(6)—within 14 days after the individual’s start day.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 208,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div C, s149-20(1)-(2)",
          "section": "Requirements for cessation notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A registered provider must prepare a cessation notification when they cease delivering funded aged care services to an individual, but they do not need to do this if the person is receiving services through a specialist aged care program, except for TCP.",
          "summaryHTML": "A registered provider must prepare a cessation notification when they cease delivering funded aged care services to an individual, but they do not need to do this if the person is receiving services through a specialist aged care program, except for TCP.",
          "extract": "(1) A registered provider must prepare a cessation notification for ceasing the delivery of funded aged care services to an individual in accordance with this section. \n\n(2) Despite subsection (1), a registered provider does not have to prepare a cessation notification for an individual where the individual is accessing funded aged care services under a specialist aged care program other than the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 209,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div C, s149-20(3)",
          "section": "Requirements for cessation notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A cessation notification must be in an approved form.",
          "summaryHTML": "A cessation notification must be in an approved form.",
          "extract": "(3) A cessation notification must be in an approved form.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 210,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div C, s149-20(4)",
          "section": "Requirements for cessation notifications—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "The cessation notification must include the individual's name, the date services ceased, and the reasons for cessation.",
          "summaryHTML": "The cessation notification must include the individual's name, the date services ceased, and the reasons for cessation.",
          "extract": "(4) A cessation notification for an individual must specify the following: \n\n(a) the name of the individual; \n\n(b) the day the provider ceased to deliver funded aged care services to the individual; \n\n(c) the reason for ceasing the delivery of funded aged care services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 211,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div C, s149-25",
          "section": "Requirements for cessation notifications—provision to System Governor and Commissioner",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A registered provider must give a cessation notification to the System Governor and the Commissioner within 14 days for services delivered to individuals accessing services through the classification type short-term for the service group residential care and within 28 days for all other individuals after services have ceased.",
          "summaryHTML": "A registered provider must give a cessation notification to the System Governor and the Commissioner within 14 days for services delivered to individuals accessing services through the classification type short-term for the service group residential care and within 28 days for all other individuals after services have ceased.",
          "extract": "A registered provider must give a cessation notification for an individual to the System Governor and the Commissioner:\n\n(a) for an individual accessing funded aged care services through the classification type short-term for the service group residential care—within 14 days after the cessation of delivery of services through the approved residential care home of the provider;\n\n(b) for all other individuals—within 28 days after the cessation of delivery of services through the approved residential care home or service delivery branch of the provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 212,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-30",
          "section": "Application of this Subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subdivision contains requirements for the ceasing of the delivery of funded aged care services (other than services delivered in an approved residential care home). It applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications.",
          "summaryHTML": "This subdivision contains requirements for the ceasing of the delivery of funded aged care services (other than services delivered in an approved residential care home). It applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications.",
          "extract": "This Subdivision applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 213,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-35(1)-(2)",
          "section": "Application of this Subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must not cease the delivery of funded aged care services to an individual unless one of the circumstances in subsection 149-35(2) applies and notice has been given to the individual as required by section 149-40. \n\nA registered provider may cease delivering funded aged care services to an individual under various circumstances, including inadequate resources for care, changes in the individual's condition, intentional harm to staff, non-payment of fees, written requests to move or discontinue services. \n\n(Note: These circumstances must be outlined in a service agreement made under section 148-70 of the rules).",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must not cease the delivery of funded aged care services to an individual unless one of the circumstances in subsection 149-35(2) applies and notice has been given to the individual as required by section 149-40. \n\nA registered provider may cease delivering funded aged care services to an individual under various circumstances, including inadequate resources for care, changes in the individual's condition, intentional harm to staff, non-payment of fees, written requests to move or discontinue services. \n\n(Note: These circumstances must be outlined in a service agreement made under section 148-70 of the rules).",
          "extract": "(1) A registered provider must not cease to deliver funded aged care services to an individual unless:\n\n(a) one of the circumstances in subsection (2) applies; and \n\n(b) the provider has given notice to the individual in accordance with section 149-40.\n\nCircumstances where registered provider may cease delivery of funded aged care services to an individual\n\n(2) The circumstances in which a registered provider may cease to deliver funded aged care services to an individual are:\n\n(a) the individual cannot be cared for in the home or community with the resources available to the provider; or\n\n(b) the individual’s condition changes to the extent that:\n\n(i) the individual no longer needs the funded aged care services delivered by the provider; or\n\n(ii) the individual’s needs, as assessed by an approved needs assessor, can be more appropriately met by other types of funded aged care services; or\n\n(c) the individual has:\n\n(i) intentionally caused serious injury to an aged care worker of the provider; or\n\n(ii) intentionally infringed the right of an aged care worker of the provider to work in a safe environment; or\n\n(d) the individual: \n\n(i) has not paid to the provider, for a reason within the individual’s control, any fee or contribution specified in the service agreement between the individual and the provider; and \n\n(ii) has not negotiated an alternative arrangement with the provider for payment of the fee or contribution; and \n\n(iii) has no application for the fee reduction supplement in place; or \n\n(e) the individual notifies the provider, in writing, that the individual wishes to move to a location where funded aged care services are not delivered by the provider; or \n\n(f) the individual notifies the provider, in writing, that the individual no longer wishes to receive funded aged care services from the provider. \n\nNote: The circumstances in which a registered provider may cease delivering funded aged care services to an individual must be specified in a service agreement between the individual and the registered provider made under section 148-70 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 214,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-40(1)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about cessation of services",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nIf a registered provider intends to cease delivering funded aged care services to an individual, it must give written notice detailing the decision, reasons, intended cessation date, and the individual's rights in relation to the cessation of the delivery of services, including rights regarding complaints and feedback and access to advocates.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nIf a registered provider intends to cease delivering funded aged care services to an individual, it must give written notice detailing the decision, reasons, intended cessation date, and the individual's rights in relation to the cessation of the delivery of services, including rights regarding complaints and feedback and access to advocates.",
          "extract": "Notice to be given if registered provider intends to cease delivery of funded aged care services\n\n(1) If a registered provider intends to cease delivery of funded aged care services to an individual, the provider must give the individual a written notice which includes the following:\n\n(a) the decision;\n\n(b) the reasons for the decision;\n\n(c) the date the provider intends to cease delivery of funded aged care services to the individual;\n\n(d) the individual’s rights in relation to cessation of the delivery of funded aged care services, including the right to access:\n\n(i) the provider’s complaints and feedback management system; and\n\n(ii) any other mechanisms available to address complaints; and\n\n(iii) independent aged care advocates.\n\nNote: For complaints and feedback management systems, see section 165 of the Act and Division 2 of Part 10 of Chapter 4 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 215,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-40(2)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about cessation of services",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider is required to the written notice required under section 149-40(1) to the individual at least 14 days before the cessation of funded aged care services.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider is required to the written notice required under section 149-40(1) to the individual at least 14 days before the cessation of funded aged care services.",
          "extract": "Notice to be given if registered provider intends to cease delivery of funded aged care services\n\n(2) The registered provider must give the notice to the individual at least 14 days before the date the provider ceases delivery of funded aged care services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 216,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-40(3)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about cessation of services",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nIf a registered provider decided to cease delivering services due to an individual's behaviour, and gave notice of its intention to cease under subsection 149-40(1), but later agrees to continue delivering services because of a change in the behaviour, the provider must give written notice to the individual stating that it no longer intends to cease services.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nIf a registered provider decided to cease delivering services due to an individual's behaviour, and gave notice of its intention to cease under subsection 149-40(1), but later agrees to continue delivering services because of a change in the behaviour, the provider must give written notice to the individual stating that it no longer intends to cease services.",
          "extract": "Notice to be given if registered provider no longer intends to cease delivery of funded aged care services\n(3) If:\n\n(a) the decision to cease the delivery of funded aged care services was based on the individual’s behaviour; and\n\n(b) the registered provider has given the individual a notice under subsection (1); and\n\n(c) after giving the notice, the provider has agreed with the individual that, because of a change in the behaviour, the delivery of funded aged care services will not cease;\nthen the provider must give the individual a written notice stating that the provider no longer intends to cease delivery of funded aged care services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 217,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-45(1)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about unspent portions",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications.\n\nThis rule applies if a registered providers holds an unspent Commonwealth portion or unspent care recipient portion for an individual receiving funded aged care services and sections 226C or 226D of the Act apply.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications.\n\nThis rule applies if a registered providers holds an unspent Commonwealth portion or unspent care recipient portion for an individual receiving funded aged care services and sections 226C or 226D of the Act apply.",
          "extract": "(1) This section applies if:\n\n(a) a registered provider holds an unspent Commonwealth care recipient portion for an individual to funded aged care services; and\n\n(b) section 226C or 226D of the Act apply.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 218,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-45(2)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about unspent portions",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must give a notice relating to an individual's unspent Commonwealth portion or unspent care recipient portion in accordance with this section.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must give a notice relating to an individual's unspent Commonwealth portion or unspent care recipient portion in accordance with this section.",
          "extract": "(2) The registered provider must give a notice relating to the individual’s unspent Commonwealth portion or unspent care recipient portion in accordance with this section.\n\nNote: See paragraphs 226C(2)(a) and 226D(2)(a) of the Act for requirements to give written notice to the System Governor about the unspent Commonwealth portion.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 219,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-45(3)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about unspent portions",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nThe notice regarding an individual's unspent Commonwealth portion or unspent care recipient portion must include specific details about the cessation date, the available balance of the unspent Commonwealth portion for the individual, the balance of the unspent care recipient portion for the individual; and any contributions that reduced the unspent care recipient portion. The notice must also explain the effect of specific provisions in the Act and rules (as set out in this subsection).",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nThe notice regarding an individual's unspent Commonwealth portion or unspent care recipient portion must include specific details about the cessation date, the available balance of the unspent Commonwealth portion for the individual, the balance of the unspent care recipient portion for the individual; and any contributions that reduced the unspent care recipient portion. The notice must also explain the effect of specific provisions in the Act and rules (as set out in this subsection).",
          "extract": "(3) The notice must:\n\n(a) specify the following:\n\n(i) the day the provider ceased to deliver funded aged care services to the individual;\n\n(ii) the available balance (including a nil amount) of the unspent Commonwealth portion for the individual;\n\n(iii) the balance (including a nil amount) of the unspent care recipient portion for the individual;\n\n(iv) if the amount of the unspent care recipient portion for the individual was reduced by the individual contributions charged to the individual by the provider under paragraph 273A-20(a) of this instrument—the amount of those individual contributions;\n\n(b) explain:\n\n(i) the effect of paragraphs 226C(2)(b) and 226D(2)(b) of the Act;\n\n(ii) the effect of subsections 226A(7) to (9) and 226E(5) and (6) of the Act;\n\n(iii) the effect of paragraph 273A-20(b) of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 220,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-45(4)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about unspent portions",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider is required to give the notice required under subsection 149-45(2) of the rules within 28 days after the cessation of delivery of funded aged care services.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider is required to give the notice required under subsection 149-45(2) of the rules within 28 days after the cessation of delivery of funded aged care services.",
          "extract": "When notice must be given\n\n(4) The notice must be given within 28 days after the cessation of delivery of services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 221,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-45(5)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to individual about unspent portions",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to the service groups home support, assistive technology, or home modifications.\n\nThe notice required under subsection 149-45(3) of the rules must be given to the individual or, in the case of the individual's death, to their legal representative or estate. (Additionally, as outlined in the note to this rule, a copy may need to be given to another registered provider under section 149-80 of the rules or a supporter of the individual under section 29 of the Act).",
          "summaryHTML": "This rule applies to the service groups home support, assistive technology, or home modifications.\n\nThe notice required under subsection 149-45(3) of the rules must be given to the individual or, in the case of the individual's death, to their legal representative or estate. (Additionally, as outlined in the note to this rule, a copy may need to be given to another registered provider under section 149-80 of the rules or a supporter of the individual under section 29 of the Act).",
          "extract": "Who notice is given to\n\n(5) The notice must be given to:\n\n(a) the individual; or\n\n(b) if the individual has died:\n\n(i) the individual’s legal representative; or\n\n(ii) the individual’s estate.\n\nNote: A copy of the notice may also need to be given to another registered provider under section 149-80 or a supporter of the individual under section 29 of the Act",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 222,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-46(1)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to new registered provider about account balances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nThis rule applies when a registered provider ceases delivering funded aged care services to an individual through a service delivery branch of the provider and within 60 days after ceasing is notified that the individual has entered into a service agreement with a new registered provider that will deliver funded aged care services to the individual for a classification type for the service groups, home support, assistive technology, or home modifications through a service delivery branch of the new provider.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nThis rule applies when a registered provider ceases delivering funded aged care services to an individual through a service delivery branch of the provider and within 60 days after ceasing is notified that the individual has entered into a service agreement with a new registered provider that will deliver funded aged care services to the individual for a classification type for the service groups, home support, assistive technology, or home modifications through a service delivery branch of the new provider.",
          "extract": "(1) This section applies if:\n\n(a) a registered provider has ceased the delivery of funded aged care services to an individual through a service delivery branch of the provider; and\n\n(b) within 60 days after the day the registered provider ceased to deliver funded aged care services to the individual, the provider is notified that the individual has entered into a service agreement with a new registered provider; and\n\n(c) the new registered provider will deliver funded aged care services to the individual for a classification type for the service groups home support, assistive technology, or home modifications through a service delivery branch of the new registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 223,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-46(2)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to new registered provider about account balances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must notify the new registered provider (referred to in subsection 149-46(1)) of the estimated available balance of the notional accounts for an individual (as listed in this rule) after the provider gives a claim (in accordance with section 251 of the Act) for subsidy payment related to the period when it ceased delivering services to the individual.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must notify the new registered provider (referred to in subsection 149-46(1)) of the estimated available balance of the notional accounts for an individual (as listed in this rule) after the provider gives a claim (in accordance with section 251 of the Act) for subsidy payment related to the period when it ceased delivering services to the individual.",
          "extract": "(2) The registered provider must give a notice to the individual’s new registered provider specifying what the provider estimates will be the available balance of the individual’s:\n\n(a) notional ongoing home support account (if any);\n\n(b) notional short-term home support account (if any);\n\n(c) notional assistive technology account (if any);\n\n(d) notional home modifications account (if any);\n\n(e) notional home care account (if any);\n\nafter the provider gives a claim in accordance with section 251 of the Act for payment of subsidy for the delivery of funded aged care services to the individual for the relevant period where the provider ceased delivering services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 224,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-46(3)",
          "section": "Requirements for ceasing delivery of funded aged care services—notice to new registered provider about account balances",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "agreements",
            "reporting"
          ],
          "summary": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must give the notice required under subsection 149-46(2), regarding the estimated available balances in an individual's account, within 28 days of being notified that the individual has entered into a service agreement with a new registered provider.",
          "summaryHTML": "This rule applies to a registered provider who is delivering funded aged care services to an individual for a classification type for the service groups home support, assistive technology, or home modifications. \n\nA registered provider must give the notice required under subsection 149-46(2), regarding the estimated available balances in an individual's account, within 28 days of being notified that the individual has entered into a service agreement with a new registered provider.",
          "extract": "(3) The notice must be given within 28 days after the registered provider is notified that the individual has entered into a service agreement with the new registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 225,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div D, s149-48",
          "section": "Requirements for ceasing delivery of subscriptions services",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "agreements",
            "reporting"
          ],
          "summary": "A registered provider must not cease to deliver a particular subscription service to an individual unless the provider ceases to deliver funded aged care services to the individual in accordance with section 149-35 or the individual has given the provider notice in writing in relation to the particular subscription service.",
          "summaryHTML": "A registered provider must not cease to deliver a particular subscription service to an individual unless the provider ceases to deliver funded aged care services to the individual in accordance with section 149-35 or the individual has given the provider notice in writing in relation to the particular subscription service.",
          "extract": "A registered provider must not cease to deliver a particular subscription service to an individual unless:\n\n(a) the provider ceases to deliver funded aged care services to the individual in accordance with section 149-35; or\n\n(b) the individual has given the provider notice in writing in relation to the particular subscription service as referred to in paragraph 148 70(4A)(c).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": false,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": false,
                "tsil": true,
                "hcgr": true,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 0,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-50",
          "section": "Application of this subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This Subdivision applies to a registered provider who is delivering funded aged care services to an individual for a classification type ongoing for the service group residential care in an approved residential care home of the registered provider.",
          "summaryHTML": "This Subdivision applies to a registered provider who is delivering funded aged care services to an individual for a classification type ongoing for the service group residential care in an approved residential care home of the registered provider.",
          "extract": "This subdivision applies to a registered provider who is delivering funded aged care services to an individual for a classification type ongoing for the service group residential care in an approved residential care home of the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 66,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-55",
          "section": "Security of tenure—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Security of tenure - general\n\nThis rule concerns security of tenure and provides that a registered provider must not take action to make an individual leave an approved residential care home, or imply that an individual must leave an approved residential care home, unless one of the circumstances in subsection 149-60(1) apply, suitable alternative accommodation is available that meets the requirements in subsection 149-60(2), and notice has been given to the individual under section 149-65.",
          "summaryHTML": "<i>Security of tenure - general\n\n</i>This rule concerns security of tenure and provides that a registered provider must not take action to make an individual leave an approved residential care home, or imply that an individual must leave an approved residential care home, unless one of the circumstances in subsection 149-60(1) apply, suitable alternative accommodation is available that meets the requirements in subsection 149-60(2), and notice has been given to the individual under section 149-65.",
          "extract": "A registered provider must not take action to make an individual accessing funded aged care services in an approved residential care home of the registered provider leave the home, or imply that the individual must leave the home, unless:\n\n(a) one of the circumstances in subsection 149-60(1) apply; and\n\n(b) suitable alternative accommodation is available for the individual that meets the requirements in subsection 149-60(2); and \n\n(c) the provider has given notice to the individual in accordance with section 149-65.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 67,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-60(1)",
          "section": "Security of tenure—circumstances where registered provider may ask an individual to leave an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider can request an individual to leave an approved residential care home in specific circumstances, including home closure, inability of the provider to deliver services suitable for the individual's needs (as assessed under subsection (4)), changes in the individual's needs, non-payment of fees, intentional damage or injury caused by the individual, or extended absence of individual.",
          "summaryHTML": "A registered provider can request an individual to leave an approved residential care home in specific circumstances, including home closure, inability of the provider to deliver services suitable for the individual's needs (as assessed under subsection (4)), changes in the individual's needs, non-payment of fees, intentional damage or injury caused by the individual, or extended absence of individual.",
          "extract": "(1) A registered provider may only ask an individual accessing funded aged care services in an approved residential care home of the registered provider to leave the residential care home if:\n\n(a) the approved residential care home is closing;\n\n(b) the provider can no longer provide accommodation and funded aged care services through the approved residential care home which are suitable for the individual, having regard to the individual’s needs as assessed in accordance with subsection (4) and the provider has not agreed to deliver funded aged care services of the kind that the individual presently needs;\n\n(c) the individual no longer needs the funded aged care services delivered through the approved residential care home, as assessed by an approved needs assessor in accordance with subsection 64(2) of the Act;\n\n(d) the individual has been accessing funded aged care services under a specialist dementia care agreement and a clinical advisory committee constituted in accordance with the agreement has determined that the individual is not suitable to continue accessing those services;\n\n(e) the individual has not paid any agreed fee or contribution to the provider within 42 days after the day when it is payable, for a reason within the individual’s control;\n\n(f) the individual has intentionally caused:\n\n(i) serious damage to the approved residential care home; or\n\n(ii) serious injury to an aged care worker of the provider, or to another individual accessing funded aged care services at the approved residential care home;\n\n(g) the individual is away from the approved residential care home for a continuous period of at least 7 days for a reason other than:\n\n(i) emergency leave; or\n\n(ii) hospital leave; or\n\n(iii) hospital transition leave; or\n\n(iv) extended hospital leave; or\n\n(v) social leave.\n\nNote 1: For when an individual is on leave, see section 244 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 74,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-60(2)",
          "section": "Security of tenure—circumstances where registered provider may ask an individual to leave an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Before requesting an individual to leave an approved residential care home, the registered provider must ensure that suitable alternative accommodation is available with another registered provider that meets the individual’s needs and is affordable by the individual or in a place more suited to the individual’s long term needs.",
          "summaryHTML": "Before requesting an individual to leave an approved residential care home, the registered provider must ensure that suitable alternative accommodation is available with another registered provider that meets the individual’s needs and is affordable by the individual or in a place more suited to the individual’s long term needs.",
          "extract": "Suitable accommodation to be available before individual can be required to leave approved residential care home\n\n(2) If a registered provider intends to ask an individual to leave the approved residential care home, the provider must ensure suitable alternative accommodation is available: \n\n(a) with an alternative registered provider that meets the individual’s needs and is affordable by the individual; or \n\n(b) in a place more suited to the individual’s long term needs.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 75,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-60(3)",
          "section": "Security of tenure—circumstances where registered provider may ask an individual to leave an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Suitable alternative accommodation with an alternative registered provider (as referred to in subsection 149(60)(2)) will be available if the alternative registered provider has offered to enter into a service agreement with the individual under section 148-70 of the rules for the delivery of funded aged care services to the individual.",
          "summaryHTML": "Suitable alternative accommodation with an alternative registered provider (as referred to in subsection 149(60)(2)) will be available if the alternative registered provider has offered to enter into a service agreement with the individual under section 148-70 of the rules for the delivery of funded aged care services to the individual.",
          "extract": "Suitable accommodation to be available before individual can be required to leave approved residential care home\n\n(3) Without limiting subsection (2), suitable alternative accommodation with an alternative registered provider will be available if the alternative registered provider has offered to enter into a service agreement with the individual under section 148-70 of this instrument for the delivery of funded aged care services to the individual. \n\nNote: A registered provider is required to detail the steps taken to ensure any alternative accommodation meets the needs of the individual in a continuity of care plan for the individual prepared under section 149-75 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 76,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-60(4)",
          "section": "Security of tenure—circumstances where registered provider may ask an individual to leave an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subsection relates to an assessment of an individual's needs when a registered provider asks an individual to leave a residential care home in the circumstances outlined in section 149-60(1)(b). The assessment of those needs must be conducted by either an approved needs assessor or by at least two medical or other health practitioners, one of whom must be independent of the registered provider and chosen by the individual and both must be competent to assess the needs of the individual.",
          "summaryHTML": "This subsection relates to an assessment of an individual's needs when a registered provider asks an individual to leave a residential care home in the circumstances outlined in section 149-60(1)(b). The assessment of those needs must be conducted by either an approved needs assessor or by at least two medical or other health practitioners, one of whom must be independent of the registered provider and chosen by the individual and both must be competent to assess the needs of the individual.",
          "extract": "Assessing the individual’s needs\n\n(4) For the purposes of paragraph (1)(b), the needs of the individual must be assessed by:\n\n(a) an approved needs assessor; or\n\n(b) at least 2 medical or other health practitioners who meet the following criteria:\n\n(i) one must be independent of the registered provider and the approved residential care home, and must be chosen by the individual;\n\n(ii) both must be competent to assess the aged care needs of the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 77,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-65(1)",
          "section": "Security of tenure—notice requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "If a registered provider decides to ask an individual to leave an approved residential care home, they must give written notice detailing the decision, the reasons, the departure date, the individual's rights regarding the decision (including rights regarding feedback and complaints and access to independent aged care advocates) and a copy of the continuity of care plan.",
          "summaryHTML": "If a registered provider decides to ask an individual to leave an approved residential care home, they must give written notice detailing the decision, the reasons, the departure date, the individual's rights regarding the decision (including rights regarding feedback and complaints and access to independent aged care advocates) and a copy of the continuity of care plan.",
          "extract": "Notice to be given if individual asked to leave residential care service\n\n(1) If a registered provider of an approved residential care home decides to ask an individual to leave the approved residential care home, the provider must give the individual a written notice which includes the following:\n\n(a) the decision;\n\n(b) the reasons for the decision;\n\n(c) the date the individual is to leave;\n\n(d) the individual’s rights in relation to being asked to leave the approved residential care home, including the right to access:\n\n(i) the provider’s complaints and feedback management system;\n\n(ii) any other mechanisms available to address complaints;\n\n(iii) independent aged care advocates;\n\n(e) a copy of the continuity of care plan for the individual.\n\nNote: For complaints and feedback management systems, see section 165 of the Act and Division 2 of Part 10 of Chapter 4 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 78,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-65(2)",
          "section": "Security of tenure—notice requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "A registered provider must provide written notice to the individual at least 14 days prior to the individual's departure from the approved residential care home.",
          "summaryHTML": "A registered provider must provide written notice to the individual at least 14 days prior to the individual's departure from the approved residential care home.",
          "extract": "Notice to be given if individual asked to leave residential care service\n\n(2) The registered provider must give the notice to the individual at least 14 days before the individual is to leave.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 79,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-65(3)",
          "section": "Security of tenure—notice requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "reporting"
          ],
          "summary": "If a registered provider decided to ask an individual to leave a residential care home due to their behaviour, and gave a notice under subsection 149-65(1), but later agrees with the individual that the individual can stay because of a change in behaviour, it must provide written notice stating that the individual is no longer required to leave.",
          "summaryHTML": "If a registered provider decided to ask an individual to leave a residential care home due to their behaviour, and gave a notice under subsection 149-65(1), but later agrees with the individual that the individual can stay because of a change in behaviour, it must provide written notice stating that the individual is no longer required to leave.",
          "extract": "Notice to be given if individual no longer required to leave approved residential care home\n\n(3) If:\n\n(a) the decision to require the individual to leave the approved residential care home was based on the individual’s behaviour; and\n\n(b) the registered provider has given the individual a notice under subsection (1); and\n\n(c) after giving the notice, the provider has agreed with the individual that, because of a change in the behaviour, the individual should not be required to leave the residential care home;\nthen the provider must give the individual a written notice stating that the individual is no longer required to leave the residential care home.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 80,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div E, s149-70(1)",
          "section": "Security of tenure—movement of individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must not move an individual within the residential care home unless the circumstances in this rule apply. The circumstances include that the move is at the individual's request; by mutual agreement; necessary on medical grounds (as assessed by an approved assessor or at least 2 medical or other health practitioners who meet the criteria in subparagraphs 149-60(4)(b)(i) and (ii)); due to a suitability assessments related to a specialist dementia care agreement; necessary for repairs or in an emergency; or the individual has been repeatedly violent towards another person in the same room or in close proximity.  In the case of a move necessary for repairs, the individual has the right to return to the room.",
          "summaryHTML": "A registered provider must not move an individual within the residential care home unless the circumstances in this rule apply. The circumstances include that the move is at the individual's request; by mutual agreement; necessary on medical grounds (as assessed by an approved assessor or at least 2 medical or other health practitioners who meet the criteria in subparagraphs 149-60(4)(b)(i) and (ii)); due to a suitability assessments related to a specialist dementia care agreement; necessary for repairs or in an emergency; or the individual has been repeatedly violent towards another person in the same room or in close proximity.  In the case of a move necessary for repairs, the individual has the right to return to the room.",
          "extract": "(1) A registered provider must not move an individual from a room, or part of a room, in the approved residential care home to another room, or part of a room, in the home unless:\n\n(a) the move is at the individual’s request;\n\n(b) the individual agrees to the move after being fully consulted and without being subjected to any pressure;\n\n(c) the move is necessary on genuine medical grounds as assessed by one of the following:\n\n(i) an approved needs assessor;\n\n(ii) at least 2 medical or other health practitioners who meet the criteria in subparagraphs 149-60(4)(b)(i) and (ii);\n\n(d) the individual has been accessing funded aged care services under a specialist dementia care agreement and a clinical advisory committee constituted in accordance with the agreement has determined that the individual is not suitable to continue receiving those services in the individual’s current room, or part of a room;\n\n(e) the move is necessary to carry out repairs or improvements to the home and the individual has the right to return to the room, or the part of the room, if it continues to exist as a room, or part of a room, for individuals when the repairs or improvements are finished; or \n\n(f) the move is necessary due to an emergency that includes but are not limited to the following: \n\n(i) during serious medical situations such as disease outbreak, viral pandemic and epidemic; \n\n(ii) in circumstances in which the safety of the individual is compromised such as during a fire, natural disaster or flood; \n\n(iii) the individual has been repeatedly violent towards another person in the same room or in close proximity to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 81,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-75(1)",
          "section": "Continuity of care plan",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "If a registered provider intends to ask an individual to leave an approved residential care home in the circumstances outlined in subsection 149-60(1), they are required to prepare a continuity of care plan to ensure the individual continues to receive funded aged care services.",
          "summaryHTML": "If a registered provider intends to ask an individual to leave an approved residential care home in the circumstances outlined in subsection 149-60(1), they are required to prepare a continuity of care plan to ensure the individual continues to receive funded aged care services.",
          "extract": "(1) A registered provider must prepare a plan for ensuring the continuity of funded aged care services for an individual (a continuity of care plan) in accordance with this section if the provider intends to ask an individual to leave an approved residential care home of the provider in any of the circumstances prescribed in subsection 149-60(1) of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 82,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-75(2)",
          "section": "Continuity of care plan",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "This rule contains requirements for the continuity of care plan for an individual accessing funded aged care services through the classification type ongoing for the service group residential care as required under subsection 149-75(1) when an individual is asked to leave an approved residential care home. The plan must specify details about alternative accommodation; steps taken to ensure that alternative accommodation meets the individual's needs; records transfer processes; intended start dates with the alternative registered provider; reasons for not continuing to access services with an alternative provider (if applicable); assistance with moving; and measures for refunding fees or contributions and managing refundable deposits.",
          "summaryHTML": "This rule contains requirements for the continuity of care plan for an individual accessing funded aged care services through the classification type ongoing for the service group residential care as required under subsection 149-75(1) when an individual is asked to leave an approved residential care home. The plan must specify details about alternative accommodation; steps taken to ensure that alternative accommodation meets the individual's needs; records transfer processes; intended start dates with the alternative registered provider; reasons for not continuing to access services with an alternative provider (if applicable); assistance with moving; and measures for refunding fees or contributions and managing refundable deposits.",
          "extract": "Continuity of care plan for individuals accessing funded aged care services in an approved residential care home\n\n(2) A continuity of care plan for an individual accessing funded aged care services through the classification type ongoing for the service group residential care in an approved residential care home of a registered provider must specify the following:\n\n(a) details of any suitable alternative accommodation that is available that meet the requirements in subsection 149-60(2);\n\n(b) the steps the registered provider has taken to ensure that any alternative accommodation meets the individual’s needs;\n\n(c) how any records relating to ensuring the continuity of funded aged care services for the individual will be transferred to a suitable alternative registered provider if required under section 149-80;\n\n(d) the intended start date (if any) for the individual with a suitable alternative registered provider;\n\n(e) where an individual will not continue accessing funded aged care services with an alternative registered provider, the reason for this; \n\n(f) the way in which the registered provider proposes to help the individual move (with their personal possessions);\n\n(g) the measures that the registered provider proposes to take to refund any fees or contributions to the individual as required by Part 3 of Chapter 4 of the Act;\n\n(h) the measures that the registered provider proposes to take to deal with any refundable deposit balance paid by the individual as required by Division 7 of Part 4 of Chapter 4 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 226,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-80(1)",
          "section": "Transfer of records between registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This rule concerns the transfer of records between registered providers and applies when a registered provider (the outgoing provider) ceases delivering funded aged care services to an individual and another registered provider (the incoming provider) starts delivering those services.",
          "summaryHTML": "This rule concerns the transfer of records between registered providers and applies when a registered provider (the outgoing provider) ceases delivering funded aged care services to an individual and another registered provider (the incoming provider) starts delivering those services.",
          "extract": "(1) This section applies if:\n\n(a) a registered provider (the outgoing provider) ceases to deliver funded aged care services to an individual; and\n\n(b) another registered provider (the incoming provider) starts the delivery of funded aged care services to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 227,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-80(2)",
          "section": "Transfer of records between registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "An incoming provider may request an outgoing provider give records relating to an individual which are necessary to ensure the continuity of funded aged care services for the individual.",
          "summaryHTML": "An incoming provider may request an outgoing provider give records relating to an individual which are necessary to ensure the continuity of funded aged care services for the individual.",
          "extract": "Records to be given to incoming provider on request \n(2) The incoming provider may request the outgoing provider give records relating to the individual which are necessary to ensure the continuity of funded aged care services for the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 228,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-80(3)",
          "section": "Transfer of records between registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Upon receiving a request for records, the outgoing provider must provide the necessary records or copies to the incoming provider within 28 days.",
          "summaryHTML": "Upon receiving a request for records, the outgoing provider must provide the necessary records or copies to the incoming provider within 28 days.",
          "extract": "(3) If a request for records is made under subsection (2), the outgoing provider must give the incoming provider the records, or copies of such records, within 28 days after the request is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        },
        {
          "id": 229,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 4, Div 4, Sub Div F, s149-80(4)",
          "section": "Transfer of records between registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Starting and ceasing the provision of funded aged care services and continuity of those services",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "An outgoing provider must give to an incoming provider any records the provider is required to keep under section 7 of the Records Principles 2014 and records required to be kept under section 154-1000 of the rules.",
          "summaryHTML": "An outgoing provider must give to an incoming provider any records the provider is required to keep under section 7 of the <i>Records Principles 2014 </i>and records required to be kept under section 154-1000 of the rules.",
          "extract": "(4) Without limiting subsections (2) and (3), the outgoing provider must give the following records:\n\n(a) any records relating to the individual the provider is required to keep under section 7 of the Records Principles 2014;\n\n(b) any records relating to the individual the provider is required to keep under section 154-3100 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s149"
        }
      ]
    },
    {
      "id": 15,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div D, s150(1)-(2)",
      "section": "Compliance with Financial and Prudential Standards",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Compliance with Financial and Prudential Standards",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "A registered provider must follow the Financial and Prudential Standards that apply to them as a condition of their registration, and if they belong to a specific category defined by the rules, they must also meet any extra financial requirements set by those rules.",
      "summaryHTML": "A registered provider must follow the Financial and Prudential Standards that apply to them as a condition of their registration, and if they belong to a specific category defined by the rules, they must also meet any extra financial requirements set by those rules.",
      "extract": "(1) It is a condition of registration that a registered provider must comply with the provisions of the Financial and Prudential Standards that apply to the provider.\n\n(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with any additional prudential requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631482",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 84,
          "source": "Aged Care Act 2024",
          "citation": "Aged Care Act 2024, Ch 5, Part 3, Div 7, s376",
          "section": "Compliance with Financial and Prudential Standards",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Compliance with Financial and Prudential Standards",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Please refer to Chapter 5, Part 3, Division 7, section 376 for further information.",
          "summaryHTML": "Please refer to Chapter 5, Part 3, Division 7, section 376 for further information.",
          "extract": "Please refer to Chapter 5, Part 3, Division 7, s376 for further information.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631811",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s150(1)-(2)"
        }
      ]
    },
    {
      "id": 16,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div D, s151",
      "section": "Fees, payments, contributions and subsidies",
      "requirement": "Conditions of Registration",
      "subdivision": "Key Concepts",
      "sublevel": "Fees, payments, contributions and subsidies",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers must comply with Chapter 4 of the Act and any relevant rules relating to matters dealt with in Chapter 4.",
      "summaryHTML": "Registered providers must comply with Chapter 4 of the Act and any relevant rules relating to matters dealt with in Chapter 4.",
      "extract": "It is a condition of registration that a registered provider must comply with:\n\n(a) Chapter 4 of this Act; and\n\n(b) any requirements prescribed by the rules relating to matters dealt with in that Chapter.\n\nNote: For example, there are requirements in Chapter 4 relating to prices and amounts that may be charged by providers to individuals accessing funded aged care services.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631484",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 83,
          "source": "Aged Care Act 2024",
          "citation": "Aged Care Act 2024, Ch 4, Part 5, s150A",
          "section": "Fees, payments, contributions and subsidies",
          "requirement": "Conditions of Registration",
          "subdivision": "Key Concepts",
          "sublevel": "Fees, payments, contributions and subsidies",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Please refer to section 150A (Chapter 4, Part 5) of the Aged Care Act 2024 and Part 5—Conditions relating to financial matters 150A(1)-(35) in the associated Rules for further information.",
          "summaryHTML": "Please refer to section 150A (Chapter 4, Part 5) of the Aged Care Act 2024 and Part 5—Conditions relating to financial matters 150A(1)-(35) in the associated Rules for further information.",
          "extract": "Please refer to s150A (Chapter 4, Part 5) of the Aged Care Act 2024 and Part 5—Conditions relating to financial matters 150A(1) to (35) in the associated rules for further information.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631483",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s151"
        }
      ]
    },
    {
      "id": 17,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div E, s152(1)",
      "section": "Workforce and aged care worker requirement",
      "requirement": "Conditions of Registration",
      "subdivision": "Conditions relating to aged care workers",
      "sublevel": "Workforce and aged care worker requirements",
      "topic": [
        "workforce",
        "unspecified"
      ],
      "summary": "All registered providers must comply with the worker screening requirements in the rules and ensure that workers and responsible persons of the provider also comply with these rules. Registered providers must also ensure that workers meet the qualifications and training requirements in the rules, are given opportunities to develop their capability to provide services, and ensure that workers meet any other requirements prescribed by the rules.",
      "summaryHTML": "All registered providers must comply with the worker screening requirements in the rules and ensure that workers and responsible persons of the provider also comply with these rules. Registered providers must also ensure that workers meet the qualifications and training requirements in the rules, are given opportunities to develop their capability to provide services, and ensure that workers meet any other requirements prescribed by the rules.",
      "extract": "(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) comply with the worker screening requirements prescribed by the rules; and \n\n(b) ensure that aged care workers and responsible persons of the provider comply with the worker screening requirements prescribed by the rules; and \n\n(c) ensure that aged care workers meet any qualifications and training requirements prescribed by the rules; and \n\n(d) ensure that aged care workers are given opportunities to develop their capability to provide funded aged care services; and\n \n(e) ensure that aged care workers meet any other requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631486",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 230,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div A, s152-5",
          "section": "Kinds of provider to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "summaryHTML": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "extract": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 231,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(1)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that each responsible person is either someone who has a police certificate and meets the requirements in subsection 152-25(1), someone who meets the requirements in subsection (2) of this section, or someone who has a valid NDIS clearance decision.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider, except for those covered by subsections (5) or (6), must make sure that each responsible person is either someone who has a police certificate and meets the requirements in subsection 152-25(1), someone who meets the requirements in subsection (2) of this section, or someone who has a valid NDIS clearance decision.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must ensure that each responsible person of the provider is: \n\n(a) a person to whom subsection 152-25(1) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 232,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(2)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of murder or sexual assault, and that they have never been convicted of any other type of assault that resulted in imprisonment.",
          "summaryHTML": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of murder or sexual assault, and that they have never been convicted of any other type of assault that resulted in imprisonment.",
          "extract": "(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of murder or sexual assault; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 233,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(3)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must take reasonable steps to ensure that each responsible person notifies the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended; or they have been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider, except for those covered by subsections (5) or (6), must take reasonable steps to ensure that each responsible person notifies the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended; or they have been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must take reasonable measures to require each responsible person of the provider to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the person; or \n\n(b) an NDIS clearance decision in respect of the person is suspended; or \n\n(c) the person has been: \n\n(i) convicted of murder or sexual assault; or\n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 234,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(4)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that a responsible person cannot continue in their role if the provider has reasonable grounds to believe that the person has been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that a responsible person cannot continue in their role if the provider has reasonable grounds to believe that the person has been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must ensure that a responsible person of the provider is not allowed to continue as a responsible person if the provider is satisfied on reasonable grounds that the person has been: \n\n(a) convicted of murder or sexual assault; or \n\n(b) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 235,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(5)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Registered providers in relation to whom this section does not apply\n\nThis subsection applies to a registered provider, who provides funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "<i>Registered providers in relation to whom this section does not apply\n</i>\nThis subsection applies to a registered provider, who provides funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Registered providers in relation to whom this section does not apply\n\n(5) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 236,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(6)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Continuation requirements \n\n(6) This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 237,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(1)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies, or a person to whom subsection (2) of this section applies, or a person in respect of whom an NDIS clearance decision is in force. \n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n</i>\nA registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies, or a person to whom subsection (2) of this section applies, or a person in respect of whom an NDIS clearance decision is in force. \n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is: \n\n(a) a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 238,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(2)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of causing someone's death and have never been convicted of any other serious offence that resulted in a prison sentence of at least one year.",
          "summaryHTML": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of causing someone's death and have never been convicted of any other serious offence that resulted in a prison sentence of at least one year.",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of an offence involving the death of a person; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 239,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(3)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "For the purposes of subparagraph (2)(c)(ii), the offences include any sex-related offence, such as sexual assault (against either an adult or a child), offences involving child abuse material, or indecent acts involving a child, or any offence that involves dishonesty.",
          "summaryHTML": "For the purposes of subparagraph (2)(c)(ii), the offences include any sex-related offence, such as sexual assault (against either an adult or a child), offences involving child abuse material, or indecent acts involving a child, or any offence that involves dishonesty.",
          "extract": "Clearance requirements \n\n(3) For the purposes of subparagraph (2)(c)(ii), the offences are the following: \n\n(a) a sex related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n (b) an offence involving dishonesty.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 240,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(4)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider that falls under subsections (6), (7), or (8) must take reasonable steps to ensure that each responsible person informs the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended, they have been convicted of an offence that resulted in someone's death, or they have been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider that falls under subsections (6), (7), or (8) must take reasonable steps to ensure that each responsible person informs the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended, they have been convicted of an offence that resulted in someone's death, or they have been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Notification requirements \n\n(4) A registered provider to whom subsection (6), (7) or (8) applies must take reasonable measures to require each responsible person of the provider to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the person; or \n\n(b) an NDIS clearance decision in respect of the person is suspended; or \n\n(c) the person is, after the commencement of this section:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 241,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(5)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider that falls under subsections (6), (7), or (8) must make sure that a responsible person cannot keep their position if the provider has reasonable grounds to believe that the person has been convicted of an offence that caused someone's death, or has been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider that falls under subsections (6), (7), or (8) must make sure that a responsible person cannot keep their position if the provider has reasonable grounds to believe that the person has been convicted of an offence that caused someone's death, or has been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Continuation requirements \n\n(5) A registered provider to whom subsection (6), (7) or (8) applies must ensure that a responsible person of the provider is not allowed to continue as a responsible person if the provider is satisfied on reasonable grounds that the responsible person is, after the commencement of this section:\n\n(a) convicted of an offence involving the death of a person; or \n\n(b) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 242,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(6)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Registered providers in relation to whom this section applies\n\nThis subsection applies to a registered provider that only provides funded aged care services under CHSP.",
          "summaryHTML": "<i>Registered providers in relation to whom this section applies</i>\n\nThis subsection applies to a registered provider that only provides funded aged care services under CHSP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services only under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 243,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(7)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 244,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(8)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 245,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(1)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Section 152-17 prescribes requirements for responsible persons of other registered providers.\n\nA registered provider that meets either subsection (2) or (3), and also meets the requirements of subsection (4), must follow all the requirements listed in section 152-16.",
          "summaryHTML": "Section 152-17 prescribes requirements for responsible persons of other registered providers.\n\nA registered provider that meets either subsection (2) or (3), and also meets the requirements of subsection (4), must follow all the requirements listed in section 152-16.",
          "extract": "(1) A registered provider: \n\n(a) to whom either or both subsection (2) or (3) applies; and \n\n(b) to whom subsection (4) applies;  \n\nmust comply with each of the requirements mentioned in section 152-16.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 246,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(2)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider, who provides funded aged care services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider, who provides funded aged care services under CHSP.",
          "extract": "(2) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 247,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(3)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "extract": "(3) This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 248,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(4)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(4) This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 249,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(1)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must make sure that every aged care worker, except for those mentioned in sections (5) or (6), is someone whom subsection 152-25(1) (police certificates) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who meets the criteria in (a) or (c).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for aged care workers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider must make sure that every aged care worker, except for those mentioned in sections (5) or (6), is someone whom subsection 152-25(1) (police certificates) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who meets the criteria in (a) or (c).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider must ensure that each aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is: \n\n(a) a person to whom subsection 152-25(1) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force; or \n\n(d) a secondary school student on a formal work experience placement with the provider and the worker is directly supervised by a person to whom paragraph (a) or (c) applies.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 250,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(2)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of murder or sexual assault; and has never been convicted of any other type of assault that resulted in a prison sentence.",
          "summaryHTML": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of murder or sexual assault; and has never been convicted of any other type of assault that resulted in a prison sentence.",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of murder or sexual assault; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 251,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(3)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must take reasonable steps to ensure that every aged care worker, except for those mentioned in sections (5) or (6), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision has been suspended; or the worker has been convicted of murder, sexual assault, or convicted of any other type of assault that resulted in a prison sentence.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider must take reasonable steps to ensure that every aged care worker, except for those mentioned in sections (5) or (6), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision has been suspended; or the worker has been convicted of murder, sexual assault, or convicted of any other type of assault that resulted in a prison sentence.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider must take reasonable measures to require each aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the worker; or \n\n(b) an NDIS clearance decision in respect of the worker is suspended; or \n\n(c) the worker has been: \n\n(i) convicted of murder or sexual assault; or \n\n (ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 252,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(4)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been convicted of murder, sexual assault, or convicted of, and sentenced to imprisonment for, any other form of assault. \n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been convicted of murder, sexual assault, or convicted of, and sentenced to imprisonment for, any other form of assault. \n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been: \n\n(a) convicted of murder or sexual assault; or \n\n(b) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 253,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(5)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Aged care workers in relation to whom this section does not apply\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "<i>Aged care workers in relation to whom this section does not apply</i>\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Aged care workers in relation to whom this section does not apply\n\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 254,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(6)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (for aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (for aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 255,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(1)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must ensure that every aged care worker, who falls under sections (5), (6), or (7), is someone to whom section 152-25(2), (3) or (5) (police certificate) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who has a police certificate or an NDIS clearance.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must ensure that every aged care worker, who falls under sections (5), (6), or (7), is someone to whom section 152-25(2), (3) or (5) (police certificate) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who has a police certificate or an NDIS clearance.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider must ensure that each aged care worker of the provider to whom subsection (5), (6) or (7) applies is: \n\n(a) a person to whom subsection 152-25(2), (3) or (5) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force; or \n\n(d) a secondary school student on a formal work experience placement with the provider and the worker is directly supervised by a person to whom paragraph (a) or (c) applies.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 256,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(2)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of a crime that resulted in someone's death; and has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "summaryHTML": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of a crime that resulted in someone's death; and has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of an offence involving the death of a person; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 257,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(3)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must take reasonable steps to ensure that every aged care worker, who falls under sections (5), (6), or (7), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision is suspended; or the worker is, after the commencement of this section, convicted of a crime involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must take reasonable steps to ensure that every aged care worker, who falls under sections (5), (6), or (7), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision is suspended; or the worker is, after the commencement of this section, convicted of a crime involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider must take reasonable measures to require each aged care worker of the provider to whom subsection (5), (6) or (7) applies to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the worker; or \n\n(b) an NDIS clearance decision in respect of the worker is suspended; or \n\n(c) the worker is, after the commencement of this section: \n\n(i) convicted of an offence involving the death of a person; or \n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 258,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(4)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must make sure that an aged care worker, who falls under sections (5), (6), or (7), cannot continue working as an aged care worker if the provider has reasonable grounds to believe that the worker is, after commencement of this section, convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must make sure that an aged care worker, who falls under sections (5), (6), or (7), cannot continue working as an aged care worker if the provider has reasonable grounds to believe that the worker is, after commencement of this section, convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider must ensure that an aged care worker of the provider to whom subsection (5), (6) or (7) applies is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker is, after the commencement of this section: \n\n(a) convicted of an offence involving the death of a person; or \n\n(b) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 259,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(5)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Aged care workers in relation to whom this section applies\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "summaryHTML": "<i>Aged care workers in relation to whom this section applies</i>\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "extract": "Aged care workers in relation to whom this section applies\n\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 260,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(6)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "extract": "(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 261,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(7)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 262,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(1)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "A registered provider must ensure that an aged care worker, who meets the criteria in either subsection (2) or (3), and also falls under subsection (4), follows all the requirements listed in section 152-21.\n\nSummary of the subsections mentioned above:\n(2)This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.\n(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "A registered provider must ensure that an aged care worker, who meets the criteria in either subsection (2) or (3), and also falls under subsection (4), follows all the requirements listed in section 152-21.\n\nSummary of the subsections mentioned above:\n(2)This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.\n(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(1) A registered provider in respect of an aged care worker of the provider: \n\n(a) to whom either or both subsection (2) or (3) applies; and \n\n(b) to whom subsection (4) applies; must comply with each of the requirements mentioned in section 152-21.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 263,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(2)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "extract": "(2) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 264,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(3)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 265,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(4)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 266,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(1)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\nThis subsection applies to a person who has a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "summaryHTML": "<i>Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nThis subsection applies to a person who has a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\n(1) This subsection applies to a person if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault; and \n\n(c) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 267,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(1)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\nThis subsection applies to a person if there is a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "summaryHTML": "<i>Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nThis subsection applies to a person if there is a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\n(1) This subsection applies to a person if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault; and \n\n(c) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 268,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(2)-(3)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n</i>\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services under CHSP\n\n(2) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) there is for the person a police certificate that is not more than 3 years old; and\n\n(b) either:\n\n(i) the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section; or\n\n(ii) the police certificate was issued after the commencement of this section; and\n\n(c) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and\n\n(d) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences:\n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child;\n\n(ii) an offence involving dishonesty; and\n\n(e) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.\n\n(3) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) the person was engaged as a responsible person or aged care worker of the registered provider before the commencement of this section; and\n\n(b) there is for the person a police certificate that:\n\n(i) was issued before the commencement of this section; and\n\n(ii) is not more than 3 years old.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 269,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(2)-(3)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n</i>\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services under CHSP\n\n(2) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) there is for the person a police certificate that is not more than 3 years old; and\n\n(b) either:\n\n(i) the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section; or\n\n(ii) the police certificate was issued after the commencement of this section; and\n\n(c) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and\n\n(d) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences:\n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child;\n\n(ii) an offence involving dishonesty; and\n\n(e) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.\n\n(3) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) the person was engaged as a responsible person or aged care worker of the registered provider before the commencement of this section; and\n\n(b) there is for the person a police certificate that:\n\n(i) was issued before the commencement of this section; and\n\n(ii) is not more than 3 years old.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 270,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(4)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under CHSP \n\n(4) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 271,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(4)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under CHSP \n\n(4) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 272,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(5)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under NATSIFACP \n\n(5) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under NATSIFACP </i>\n\n(5) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "extract": "Responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(5) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty; and\n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 273,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(5)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(4) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of  registered providers delivering services under NATSIFACP </i>\n\n(4) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "extract": "Responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(5) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty; and\n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 274,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(6)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under NATSIFACP \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under NATSIFACP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care; \n\n(vi) residential care.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 275,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(6)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under NATSIFACP \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under NATSIFACP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care; \n\n(vi) residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 276,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div C, s152-35",
          "section": "Qualifications and training requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Qualifications and training requirements \n\nFor the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "summaryHTML": "<i>Qualifications and training requirements </i>\n\nFor the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "extract": "For the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        }
      ]
    },
    {
      "id": 18,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div E, s152(1)",
      "section": "Workforce and aged care worker requirement",
      "requirement": "Conditions of Registration",
      "subdivision": "Conditions relating to aged care workers",
      "sublevel": "Workforce and aged care worker requirements",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "All registered providers must comply with the worker screening requirements in the rules and ensure that workers and responsible persons of the provider also comply with these rules. Registered providers must also ensure that workers meet the qualifications and training requirements in the rules, are given opportunities to develop their capability to provide services, and ensure that workers meet any other requirements prescribed by the rules.",
      "summaryHTML": "All registered providers must comply with the worker screening requirements in the rules and ensure that workers and responsible persons of the provider also comply with these rules. Registered providers must also ensure that workers meet the qualifications and training requirements in the rules, are given opportunities to develop their capability to provide services, and ensure that workers meet any other requirements prescribed by the rules.",
      "extract": "(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) comply with the worker screening requirements prescribed by the rules; and \n\n(b) ensure that aged care workers and responsible persons of the provider comply with the worker screening requirements prescribed by the rules; and \n\n(c) ensure that aged care workers meet any qualifications and training requirements prescribed by the rules; and \n\n(d) ensure that aged care workers are given opportunities to develop their capability to provide funded aged care services; and\n \n(e) ensure that aged care workers meet any other requirements prescribed by the rules.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631486",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": true,
        "dpo": false,
        "rp": true
      },
      "type": "Hook",
      "rules": [
        {
          "id": 230,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div A, s152-5",
          "section": "Kinds of provider to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "summaryHTML": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "extract": "For the purposes of section 152(1) of the Act, every kind of registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 231,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(1)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that each responsible person is either someone who has a police certificate and meets the requirements in subsection 152-25(1), someone who meets the requirements in subsection (2) of this section, or someone who has a valid NDIS clearance decision.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider, except for those covered by subsections (5) or (6), must make sure that each responsible person is either someone who has a police certificate and meets the requirements in subsection 152-25(1), someone who meets the requirements in subsection (2) of this section, or someone who has a valid NDIS clearance decision.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must ensure that each responsible person of the provider is: \n\n(a) a person to whom subsection 152-25(1) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 232,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(2)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of murder or sexual assault, and that they have never been convicted of any other type of assault that resulted in imprisonment.",
          "summaryHTML": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of murder or sexual assault, and that they have never been convicted of any other type of assault that resulted in imprisonment.",
          "extract": "(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of murder or sexual assault; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 233,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(3)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must take reasonable steps to ensure that each responsible person notifies the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended; or they have been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider, except for those covered by subsections (5) or (6), must take reasonable steps to ensure that each responsible person notifies the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended; or they have been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must take reasonable measures to require each responsible person of the provider to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the person; or \n\n(b) an NDIS clearance decision in respect of the person is suspended; or \n\n(c) the person has been: \n\n(i) convicted of murder or sexual assault; or\n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 234,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(4)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that a responsible person cannot continue in their role if the provider has reasonable grounds to believe that the person has been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for responsible persons of registered providers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider, except for those covered by subsections (5) or (6), must make sure that a responsible person cannot continue in their role if the provider has reasonable grounds to believe that the person has been convicted of murder or sexual assault, or convicted of any other type of assault that resulted in imprisonment.\n\nSubsection (5) or (6) mean that this subsection does not apply to providers that are delivering services under CHSP or NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider (other than a registered provider to whom subsection (5) or (6) applies) must ensure that a responsible person of the provider is not allowed to continue as a responsible person if the provider is satisfied on reasonable grounds that the person has been: \n\n(a) convicted of murder or sexual assault; or \n\n(b) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 235,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(5)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Registered providers in relation to whom this section does not apply\n\nThis subsection applies to a registered provider, who provides funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "<i>Registered providers in relation to whom this section does not apply\n</i>\nThis subsection applies to a registered provider, who provides funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Registered providers in relation to whom this section does not apply\n\n(5) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 236,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-15(6)",
          "section": "Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-15 (Responsible persons of registered providers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Continuation requirements \n\n(6) This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 237,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(1)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies, or a person to whom subsection (2) of this section applies, or a person in respect of whom an NDIS clearance decision is in force. \n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n</i>\nA registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies, or a person to whom subsection (2) of this section applies, or a person in respect of whom an NDIS clearance decision is in force. \n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider to whom subsection (6), (7) or (8) applies must ensure that each responsible person of the provider is: \n\n(a) a person to whom subsection 152-25 (2), (3) or (5) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 238,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(2)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of causing someone's death and have never been convicted of any other serious offence that resulted in a prison sentence of at least one year.",
          "summaryHTML": "This subsection applies to a person who is waiting for an NDIS screening application or a police certificate and is being properly supervised during that time. The person must also provide the registered provider with a statutory declaration stating that they have never been convicted of causing someone's death and have never been convicted of any other serious offence that resulted in a prison sentence of at least one year.",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of an offence involving the death of a person; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 239,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(3)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "For the purposes of subparagraph (2)(c)(ii), the offences include any sex-related offence, such as sexual assault (against either an adult or a child), offences involving child abuse material, or indecent acts involving a child, or any offence that involves dishonesty.",
          "summaryHTML": "For the purposes of subparagraph (2)(c)(ii), the offences include any sex-related offence, such as sexual assault (against either an adult or a child), offences involving child abuse material, or indecent acts involving a child, or any offence that involves dishonesty.",
          "extract": "Clearance requirements \n\n(3) For the purposes of subparagraph (2)(c)(ii), the offences are the following: \n\n(a) a sex related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n (b) an offence involving dishonesty.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 240,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(4)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider that falls under subsections (6), (7), or (8) must take reasonable steps to ensure that each responsible person informs the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended, they have been convicted of an offence that resulted in someone's death, or they have been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider that falls under subsections (6), (7), or (8) must take reasonable steps to ensure that each responsible person informs the provider if there is an NDIS exclusion decision against them, their NDIS clearance decision is suspended, they have been convicted of an offence that resulted in someone's death, or they have been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP. \n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Notification requirements \n\n(4) A registered provider to whom subsection (6), (7) or (8) applies must take reasonable measures to require each responsible person of the provider to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the person; or \n\n(b) an NDIS clearance decision in respect of the person is suspended; or \n\n(c) the person is, after the commencement of this section:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 241,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(5)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider that falls under subsections (6), (7), or (8) must make sure that a responsible person cannot keep their position if the provider has reasonable grounds to believe that the person has been convicted of an offence that caused someone's death, or has been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider that falls under subsections (6), (7), or (8) must make sure that a responsible person cannot keep their position if the provider has reasonable grounds to believe that the person has been convicted of an offence that caused someone's death, or has been convicted of any offence listed in subsection (3) that resulted in a prison sentence of at least one year.\n\nSummary of the subsections mentioned above:\n(6) This subsection applies to a registered provider, who provides funded aged care services only under CHSP \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.\n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Continuation requirements \n\n(5) A registered provider to whom subsection (6), (7) or (8) applies must ensure that a responsible person of the provider is not allowed to continue as a responsible person if the provider is satisfied on reasonable grounds that the responsible person is, after the commencement of this section:\n\n(a) convicted of an offence involving the death of a person; or \n\n(b) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection (3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 242,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(6)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Registered providers in relation to whom this section applies\n\nThis subsection applies to a registered provider that only provides funded aged care services under CHSP.",
          "summaryHTML": "<i>Registered providers in relation to whom this section applies</i>\n\nThis subsection applies to a registered provider that only provides funded aged care services under CHSP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services only under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 243,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(7)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(7) This subsection applies to a registered provider that delivers funded aged care services only under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 244,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-16(8)",
          "section": "Responsible persons of registered providers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Registered providers in relation to whom this section applies \n\n(8) This subsection applies to a registered provider that delivers funded aged care services only under CHSP and NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 245,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(1)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Section 152-17 prescribes requirements for responsible persons of other registered providers.\n\nA registered provider that meets either subsection (2) or (3), and also meets the requirements of subsection (4), must follow all the requirements listed in section 152-16.",
          "summaryHTML": "Section 152-17 prescribes requirements for responsible persons of other registered providers.\n\nA registered provider that meets either subsection (2) or (3), and also meets the requirements of subsection (4), must follow all the requirements listed in section 152-16.",
          "extract": "(1) A registered provider: \n\n(a) to whom either or both subsection (2) or (3) applies; and \n\n(b) to whom subsection (4) applies;  \n\nmust comply with each of the requirements mentioned in section 152-16.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 246,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(2)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider, who provides funded aged care services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider, who provides funded aged care services under CHSP.",
          "extract": "(2) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 247,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(3)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "extract": "(3) This subsection applies to a registered provider that delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 248,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-17(4)",
          "section": "Responsible persons of other registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(4) This subsection applies to a registered provider that delivers funded aged care services other than under CHSP or NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 249,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(1)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must make sure that every aged care worker, except for those mentioned in sections (5) or (6), is someone whom subsection 152-25(1) (police certificates) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who meets the criteria in (a) or (c).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for aged care workers delivering services other than under CHSP or NATSIFACP</i>\n\nA registered provider must make sure that every aged care worker, except for those mentioned in sections (5) or (6), is someone whom subsection 152-25(1) (police certificates) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who meets the criteria in (a) or (c).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider must ensure that each aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is: \n\n(a) a person to whom subsection 152-25(1) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force; or \n\n(d) a secondary school student on a formal work experience placement with the provider and the worker is directly supervised by a person to whom paragraph (a) or (c) applies.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 250,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(2)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of murder or sexual assault; and has never been convicted of any other type of assault that resulted in a prison sentence.",
          "summaryHTML": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of murder or sexual assault; and has never been convicted of any other type of assault that resulted in a prison sentence.",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of murder or sexual assault; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 251,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(3)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must take reasonable steps to ensure that every aged care worker, except for those mentioned in sections (5) or (6), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision has been suspended; or the worker has been convicted of murder, sexual assault, or convicted of any other type of assault that resulted in a prison sentence.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider must take reasonable steps to ensure that every aged care worker, except for those mentioned in sections (5) or (6), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision has been suspended; or the worker has been convicted of murder, sexual assault, or convicted of any other type of assault that resulted in a prison sentence.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider must take reasonable measures to require each aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the worker; or \n\n(b) an NDIS clearance decision in respect of the worker is suspended; or \n\n(c) the worker has been: \n\n(i) convicted of murder or sexual assault; or \n\n (ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 252,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(4)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n\nA registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been convicted of murder, sexual assault, or convicted of, and sentenced to imprisonment for, any other form of assault. \n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for aged care workers delivering services other than under CHSP or NATSIFACP\n</i>\nA registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been convicted of murder, sexual assault, or convicted of, and sentenced to imprisonment for, any other form of assault. \n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider must ensure that an aged care worker of the provider, other than a worker to whom subsection (5) or (6) applies, is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker has been: \n\n(a) convicted of murder or sexual assault; or \n\n(b) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 253,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(5)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Aged care workers in relation to whom this section does not apply\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "<i>Aged care workers in relation to whom this section does not apply</i>\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.\n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "Aged care workers in relation to whom this section does not apply\n\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 254,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-20(6)",
          "section": "Aged care workers delivering services other than under CHSP or NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (for aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP. \n\nNote: This subsection relates to the exclusion of types of providers from section 152-20 (for aged care workers delivering services other than under CHSP or NATSIFACP). Please see the link to the rules for further information on this section.",
          "extract": "(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 255,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(1)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Clearance requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must ensure that every aged care worker, who falls under sections (5), (6), or (7), is someone to whom section 152-25(2), (3) or (5) (police certificate) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who has a police certificate or an NDIS clearance.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Clearance requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must ensure that every aged care worker, who falls under sections (5), (6), or (7), is someone to whom section 152-25(2), (3) or (5) (police certificate) applies; or someone who meets the criteria in subsection (2) of this section; or someone who has a valid NDIS clearance; or a high school student doing a formal work experience placement with the provider, as long as they are directly supervised by someone who has a police certificate or an NDIS clearance.\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Clearance requirements \n\n(1) A registered provider must ensure that each aged care worker of the provider to whom subsection (5), (6) or (7) applies is: \n\n(a) a person to whom subsection 152-25(2), (3) or (5) (police certificates) applies; or \n\n(b) a person to whom subsection (2) of this section applies; or \n\n(c) a person in respect of whom an NDIS clearance decision is in force; or \n\n(d) a secondary school student on a formal work experience placement with the provider and the worker is directly supervised by a person to whom paragraph (a) or (c) applies.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 256,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(2)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of a crime that resulted in someone's death; and has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "summaryHTML": "This section applies to a person who has an NDIS screening application or a police certificate that is pending and is being properly supervised while waiting for that application or certificate; and has provided the registered provider with a statutory declaration that the person has never been convicted of a crime that resulted in someone's death; and has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "extract": "Clearance requirements \n\n(2) This subsection applies to a person: \n\n(a) in respect of whom an NDIS screening application or a police certificate is pending; and \n\n(b) who is subject to appropriate supervision while that application or certificate is pending; and \n\n(c) who has made, and given to the registered provider, a statutory declaration stating the person: \n\n(i) has never been convicted of an offence involving the death of a person; and \n\n(ii) has never been convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 257,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(3)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Notification requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must take reasonable steps to ensure that every aged care worker, who falls under sections (5), (6), or (7), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision is suspended; or the worker is, after the commencement of this section, convicted of a crime involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Notification requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must take reasonable steps to ensure that every aged care worker, who falls under sections (5), (6), or (7), informs the provider if there is an NDIS exclusion decision in force against the worker; or the worker's NDIS clearance decision is suspended; or the worker is, after the commencement of this section, convicted of a crime involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Notification requirements \n\n(3) A registered provider must take reasonable measures to require each aged care worker of the provider to whom subsection (5), (6) or (7) applies to notify the provider if: \n\n(a) an NDIS exclusion decision is in force in respect of the worker; or \n\n(b) an NDIS clearance decision in respect of the worker is suspended; or \n\n(c) the worker is, after the commencement of this section: \n\n(i) convicted of an offence involving the death of a person; or \n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 258,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(4)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Continuation requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP\n\nA registered provider must make sure that an aged care worker, who falls under sections (5), (6), or (7), cannot continue working as an aged care worker if the provider has reasonable grounds to believe that the worker is, after commencement of this section, convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "<i>Continuation requirements for aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP</i>\n\nA registered provider must make sure that an aged care worker, who falls under sections (5), (6), or (7), cannot continue working as an aged care worker if the provider has reasonable grounds to believe that the worker is, after commencement of this section, convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year, for an offence mentioned in subsection 152-16(3).\n\nSummary of the subsections mentioned above:\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP. \n(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP. \n(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "Continuation requirements \n\n(4) A registered provider must ensure that an aged care worker of the provider to whom subsection (5), (6) or (7) applies is not allowed to continue as an aged care worker if the provider is satisfied on reasonable grounds that the worker is, after the commencement of this section: \n\n(a) convicted of an offence involving the death of a person; or \n\n(b) convicted of, and sentenced to imprisonment for at least one year for, an offence referred to in subsection 152-16(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 259,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(5)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Aged care workers in relation to whom this section applies\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "summaryHTML": "<i>Aged care workers in relation to whom this section applies</i>\n\nThis subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "extract": "Aged care workers in relation to whom this section applies\n\n(5) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 260,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(6)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "extract": "(6) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 261,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-21(7)",
          "section": "Aged care workers delivering services only under CHSP, NATSIFACP, or CHSP and NATSIFACP",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "extract": "(7) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services only under CHSP and NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 262,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(1)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "A registered provider must ensure that an aged care worker, who meets the criteria in either subsection (2) or (3), and also falls under subsection (4), follows all the requirements listed in section 152-21.\n\nSummary of the subsections mentioned above:\n(2)This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.\n(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "A registered provider must ensure that an aged care worker, who meets the criteria in either subsection (2) or (3), and also falls under subsection (4), follows all the requirements listed in section 152-21.\n\nSummary of the subsections mentioned above:\n(2)This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP. \n(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.\n(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(1) A registered provider in respect of an aged care worker of the provider: \n\n(a) to whom either or both subsection (2) or (3) applies; and \n\n(b) to whom subsection (4) applies; must comply with each of the requirements mentioned in section 152-21.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 263,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(2)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "extract": "(2) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 264,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(3)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "extract": "(3) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services under NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 265,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-22(4)",
          "section": "Other aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "summaryHTML": "This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "extract": "(4) This subsection applies to an aged care worker of a registered provider if the worker delivers funded aged care services other than under CHSP or NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 266,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(1)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\nThis subsection applies to a person who has a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "summaryHTML": "<i>Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nThis subsection applies to a person who has a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\n(1) This subsection applies to a person if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault; and \n\n(c) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 267,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(1)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\nThis subsection applies to a person if there is a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "summaryHTML": "<i>Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n</i>\nThis subsection applies to a person if there is a police certificate that is no more than three years old and shows no convictions for murder, sexual assault, or any other type of assault resulting in imprisonment. Additionally, this section applies to a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia and they have made a statutory declaration stating that the person has never been convicted of murder or sexual assault or convicted of, and sentenced to imprisonment for, any other form of assault.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services other than under CHSP or NATSIFACP\n\n(1) This subsection applies to a person if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault; and \n\n(c) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of murder or sexual assault; or \n\n(ii) convicted of, and sentenced to imprisonment for, any other form of assault.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 268,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(2)-(3)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n</i>\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services under CHSP\n\n(2) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) there is for the person a police certificate that is not more than 3 years old; and\n\n(b) either:\n\n(i) the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section; or\n\n(ii) the police certificate was issued after the commencement of this section; and\n\n(c) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and\n\n(d) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences:\n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child;\n\n(ii) an offence involving dishonesty; and\n\n(e) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.\n\n(3) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) the person was engaged as a responsible person or aged care worker of the registered provider before the commencement of this section; and\n\n(b) there is for the person a police certificate that:\n\n(i) was issued before the commencement of this section; and\n\n(ii) is not more than 3 years old.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 269,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(2)-(3)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under CHSP \n</i>\nSubsections (2) and (3) apply to persons who are a responsible person or an aged care worker of a registered provider to which subsection (4) applies (which prescribes registered providers that deliver services under CHSP, if:\n\n(2) There is a police certificate that is no more than three years old and either the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section, or the police certificate was issued after the commencement of this section. \n\nThe police certificate does not record that the person has been convicted of an offence involving the death of a person and does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty. \n\nFor a person who has been a citizen or permanent resident of a country other than Australia, after the age of 16, the person has made a statutory declaration stating that they have never been convicted of an offence involving the death of a person or convicted of, and sentenced to imprisonment for at least one year for a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child, or an offence involving dishonesty.\n\n(3) If the person was engaged before the commencement of this section and there is a police certificate that was issued before the commencement of this section, which is not more than 3 years old.",
          "extract": "Responsible persons or aged care workers of registered providers delivering services under CHSP\n\n(2) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) there is for the person a police certificate that is not more than 3 years old; and\n\n(b) either:\n\n(i) the person was engaged as a responsible person or aged care worker of the registered provider on or after the commencement of this section; or\n\n(ii) the police certificate was issued after the commencement of this section; and\n\n(c) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and\n\n(d) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences:\n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child;\n\n(ii) an offence involving dishonesty; and\n\n(e) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been:\n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.\n\n(3) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (4) applies if:\n\n(a) the person was engaged as a responsible person or aged care worker of the registered provider before the commencement of this section; and\n\n(b) there is for the person a police certificate that:\n\n(i) was issued before the commencement of this section; and\n\n(ii) is not more than 3 years old.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 270,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(4)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under CHSP \n\n(4) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 271,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(4)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under CHSP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under CHSP \n\n(4) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under CHSP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 272,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(5)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of registered providers delivering services under NATSIFACP \n\n(5) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of registered providers delivering services under NATSIFACP </i>\n\n(5) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "extract": "Responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(5) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty; and\n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 273,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(5)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Police certificates for responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(4) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "summaryHTML": "<i>Police certificates for responsible persons or aged care workers of  registered providers delivering services under NATSIFACP </i>\n\n(4) This section applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) (which prescribes registered providers that delivers services under NATSIFACP) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty. \n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "extract": "Responsible persons or aged care workers of  registered providers delivering services under NATSIFACP \n\n(5) This subsection applies to a person who is a responsible person or aged care worker of a registered provider to which subsection (6) applies if: \n\n(a) there is for the person a police certificate that is not more than 3 years old; and \n\n(b) the police certificate does not record that the person has been convicted of an offence involving the death of a person; and \n\n(c) the police certificate does not record that in the 5 years before the date of the certificate, the person has been convicted of, and sentenced to imprisonment for at least one year for, any of the following offences: \n\n(i) a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; \n\n(ii) an offence involving dishonesty; and\n\n(d) for a person who has been, at any time after turning 16, a citizen or permanent resident of a country other than Australia—the person has made a statutory declaration stating that the person has never been: \n\n(i) convicted of an offence involving the death of a person; or\n\n(ii) convicted of, and sentenced to imprisonment for at least one year for, a sex-related offence, including sexual assault (whether against an adult or child), child abuse material offences, or an indecent act involving a child; or\n\n(iii) convicted of, and sentenced to imprisonment for at least one year for, an offence involving dishonesty.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 274,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(6)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under NATSIFACP \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under NATSIFACP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care; \n\n(vi) residential care.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 275,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div B, s152-25(6)",
          "section": "Police certificates",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "summaryHTML": "This subsection applies to a registered provider that is delivering services under NATSIFACP.",
          "extract": "Responsible persons or aged care workers of certain registered providers delivering services under NATSIFACP \n\n(6) This subsection applies to a registered provider that: \n\n(a) delivers funded aged care services under NATSIFACP; and \n\n(b) is registered in any of the following provider registration categories: \n\n(i) home and community services; \n\n(ii) assistive technology and home modifications; \n\n(iii) advisory and support services; \n\n(iv) personal and care support in the home or community; \n\n(v) nursing and transition care; \n\n(vi) residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        },
        {
          "id": 276,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 1, Sub Div C, s152-35",
          "section": "Qualifications and training requirements",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Workforce and aged care worker requirements",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Qualifications and training requirements \n\nFor the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "summaryHTML": "<i>Qualifications and training requirements </i>\n\nFor the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "extract": "For the purposes of paragraph 152(c) of the Act, the requirements are that aged care workers of a registered provider must have appropriate qualifications, skills or experience to provide the funded aged care services that the provider delivers to individuals.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s152(1)"
        }
      ]
    },
    {
      "id": 19,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div E, s153(1)-(2)",
      "section": "Vaccination",
      "requirement": "Conditions of Registration",
      "subdivision": "Conditions relating to aged care workers",
      "sublevel": "Vaccination",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers in Category 6 - residential care must provide free access to specified vaccinations for individuals receiving funded aged care services and for aged care workers likely to access service premises. The specified vaccinations are: influenza vaccination, COVID-19 vaccination, and any other vaccinations as prescribed by the rules.",
      "summaryHTML": "Registered providers in Category 6 - residential care must provide free access to specified vaccinations for individuals receiving funded aged care services and for aged care workers likely to access service premises. The specified vaccinations are: influenza vaccination, COVID-19 vaccination, and any other vaccinations as prescribed by the rules.",
      "extract": "(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must, in accordance with any requirements prescribed by the rules: \n\n(a) provide access to the vaccinations mentioned in subsection (2) for free to: \n\n(i) individuals to whom the provider is delivering funded aged care services; and \n\n(ii) aged care workers of the provider who access, or are reasonably likely to access, any premises where the delivery of funded aged care services occurs (service staff); and \n\n(b) promote the benefits, for the individuals and service staff mentioned in paragraph (a), of those individuals and service staff receiving the vaccinations mentioned in subsection (2). \n\n(2) For the purposes of subsection (1), the vaccinations are the following:\n\n(a) an influenza vaccination;\n\n(b) a COVID-19 vaccination;\n\n(c) any other vaccination prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631487",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": true,
        "chsp": false,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 277,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 2, s153-5",
          "section": "Kinds of provider to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Vaccination",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 153(1) providers in registration Category 6 - residential care are prescribed.",
          "summaryHTML": "For section 153(1) providers in registration Category 6 - residential care are prescribed.",
          "extract": "For the purposes of subsection 153(1) of the Act, a registered provider registered in the registration category residential care is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s153(1)-(2)"
        },
        {
          "id": 278,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 6, Div 2, s153-10",
          "section": "Requirements for providing access to vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Conditions relating to aged care workers",
          "sublevel": "Vaccination",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Where registered providers provide free access to vaccinations in accordance with s 153(1)(a), it must be done in accordance with the National Immunisation Program Schedule published by the Department.",
          "summaryHTML": "Where registered providers provide free access to vaccinations in accordance with s 153(1)(a), it must be done in accordance with the National Immunisation Program Schedule published by the Department.",
          "extract": "For the purposes of subsection 153(1) of the Act, the requirement in accordance with which a registered provider must provide access to the vaccinations mentioned in subsection 153(2) of the Act for free to individuals to whom the provider is delivering funded aged care services is that the provider must do so in accordance with the National Immunisation Program Schedule, published by the Department, as existing from time to time.\n\t\nNote:    The National Immunisation Program Schedule could in 2026 be viewed on the Department’s website (https://www.health.gov.au).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s153(1)-(2)"
        }
      ]
    },
    {
      "id": 20,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s154",
      "section": "Personal information and record keeping",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Personal information and record keeping",
      "topic": [
        "governance",
        "complaints"
      ],
      "summary": "Registered providers must keep and retain the kinds of records proscribed by the rules in a manner consistent with section 168 of the Act.",
      "summaryHTML": "Registered providers must keep and retain the kinds of records proscribed by the rules in a manner consistent with section 168 of the Act.",
      "extract": "It is a condition of registration that a registered provider must: \n\n(a) keep, and retain, the kinds of records prescribed by the rules, in accordance with any requirements prescribed by the rules; and \n\n(b) do so, in a manner consistent with the requirements in section 168.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631489",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 316,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div B, s154-2(1)-(2)",
          "section": "Requirement to keep and retain information provided to an individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to keep and retain information provided to an individual\n\nA registered provider must keep records demonstrating their compliance with their obligations and conditions of registration under Chapter 3.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made.",
          "summaryHTML": "<i>Requirement to keep and retain information provided to an individual</i>\n\nA registered provider must keep records demonstrating their compliance with their obligations and conditions of registration under Chapter 3.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made.",
          "extract": "(1) A registered provider must keep records demonstrating their compliance with their obligations and conditions of registration under Chapter 3.\n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 317,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div B, s154-3(1)-(2)",
          "section": "Requirement to correct personal information",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to correct personal information\n\nThis section applies to a registered provider that is not:\n\n(a) an APP entity within the meaning of the Privacy Act 1988;\n\n(b) a State or Territory; or\n\n(c) a body established for a public purpose by or under a law of the State or Territory (other than a local government authority).\n\nWhen a registered provider keeps and retains records, they must comply with Australian Privacy Principle 13 as set out in Schedule 1 of the Privacy Act 1988, as if it were an organisation for the purposes of that Act. \n\nNote: A registered provider that is an APP entity remains subject to the Privacy Act 1988, including APP 13.",
          "summaryHTML": "<i>Requirement to correct personal information</i>\n\nThis section applies to a registered provider that is not:\n\n(a) an APP entity within the meaning of the Privacy Act 1988;\n\n(b) a State or Territory; or\n\n(c) a body established for a public purpose by or under a law of the State or Territory (other than a local government authority).\n\nWhen a registered provider keeps and retains records, they must comply with Australian Privacy Principle 13 as set out in Schedule 1 of the Privacy Act 1988, as if it were an organisation for the purposes of that Act. \n\nNote: A registered provider that is an APP entity remains subject to the Privacy Act 1988, including APP 13.",
          "extract": "(1) This section applies to a registered provider that is not any of the following:\n\n(a) an APP entity within the meaning of the Privacy Act 1988;\n\n(b) a State or Territory; or\n\n(c) a body established for a public purpose by or under a law of the State or Territory (other than a local government authority).\n\n(2) It is a requirement that when a registered provider keeps and retains records, the registered provider must comply with Australian Privacy Principle 13 as set out in Schedule 1 of the Privacy Act 1988, as if it were an organisation for the purposes of that Act. \n\nNote: A registered provider that is an APP entity remains subject to the Privacy Act 1988, including APP 13.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 287,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-5",
          "section": "Application of this Subdivision to certain registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For this subdivision providers in registration Category 6 - residential care are prescribed.",
          "summaryHTML": "For this subdivision providers in registration Category 6 - residential care are prescribed.",
          "extract": "This Subdivision applies to a registered provider registered in the provider registration category residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 279,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-10(1)",
          "section": "Records about service staff—influenza vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The registered provider must maintain annual records of the total number of service staff at the approved residential care home and the number of those staff who have reported receiving the annual seasonal influenza vaccination.",
          "summaryHTML": "The registered provider must maintain annual records of the total number of service staff at the approved residential care home and the number of those staff who have reported receiving the annual seasonal influenza vaccination.",
          "extract": "(1) A registered provider must keep records, for each calendar year, of the following information:\n\n(a) the total number of service staff in relation to the approved residential care home;\n\n(b) the number of those service staff who have informed the registered provider, whether voluntarily or as required under a law of a State or Territory, that they have received the annual seasonal influenza vaccination for that year (regardless of whether it was under the registered provider’s influenza vaccination scheme, if any).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 280,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-10(2)",
          "section": "Records about service staff—influenza vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 281,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-15(1)",
          "section": "Records about service staff—COVID-19 vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The registered provider must keep annual records of the total number of service staff at the approved residential care home and the number of those staff who have voluntarily reported receiving a COVID-19 vaccination.",
          "summaryHTML": "The registered provider must keep annual records of the total number of service staff at the approved residential care home and the number of those staff who have voluntarily reported receiving a COVID-19 vaccination.",
          "extract": "(1) A registered provider must keep records, for each calendar year, of the following information:\n\n(a) the total number of service staff in relation to the approved residential care home;\n\n(b) the number of those service staff who have voluntarily informed the registered provider that they have received a COVID-19 vaccination in that year.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 282,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-15(2)",
          "section": "Records about service staff—COVID-19 vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 283,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-20(1)",
          "section": "Records about individuals receiving residential care—influenza vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The registered provider must maintain annual records of the total number of individuals receiving funded aged care services at the approved residential care home and the number of those individuals who have voluntarily reported receiving the annual seasonal influenza vaccination.",
          "summaryHTML": "The registered provider must maintain annual records of the total number of individuals receiving funded aged care services at the approved residential care home and the number of those individuals who have voluntarily reported receiving the annual seasonal influenza vaccination.",
          "extract": "(1) A registered provider must keep records, for each calendar year, of the following information:\n\n(a) the total number of individuals accessing funded aged care services in the approved residential care home;\n\n(b) the number of those individuals who have  voluntarily informed the registered provider that they have received the annual seasonal influenza vaccination for that year.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 284,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-20(2)",
          "section": "Records about individuals receiving residential care—influenza vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 285,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-25(1)",
          "section": "Records about individuals receiving residential care—COVID-19 vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must maintain annual records of the total number of individuals receiving funded aged care services and details regarding their COVID-19 vaccination status.",
          "summaryHTML": "A registered provider must maintain annual records of the total number of individuals receiving funded aged care services and details regarding their COVID-19 vaccination status.",
          "extract": "(1) A registered provider must keep records, for each calendar year, of the following information:\n\n(a) the total number of individuals accessing funded aged care services in the approved residential care home;\n\n(b) the number of those individuals who have voluntarily informed the registered provider that they had received one or more COVID-19 vaccinations in that year;\n\n(c) the number of individuals covered by paragraph (b) who have informed the registered provider that they had received only one COVID-19 vaccination;\n\n(d) the number of individuals covered by paragraph (b) who have informed the registered provider that they had received 2 COVID-19 vaccinations.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 286,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div C, s154-25(2)",
          "section": "Records about individuals receiving residential care—COVID-19 vaccinations",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 288,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div D, s154-105",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Quality Indicators\n\nThis Subdivision applies to registered providers that must submit a quality indicators report under rule section 166-110.",
          "summaryHTML": "<i>Quality Indicators</i>\n\nThis Subdivision applies to registered providers that must submit a quality indicators report under rule section 166-110.",
          "extract": "This Subdivision applies to a registered provider that is required to give a quality indicators report under section 166-110.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 289,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div D, s154-110(1)-(2)",
          "section": "Requirements for records on quality indicators",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep and retain quality indicators report and records relating to the collection and measurement of quality indicators.\n\nA registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.\n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "summaryHTML": "A registered provider must keep and retain quality indicators report and records relating to the collection and measurement of quality indicators.\n\nA registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.\n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that a registered provider must keep and retain: \n\n(a) a quality indicators report; \n\n(b) records relating to the collection and measurements of quality indicators. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 313,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div E, s154-150",
          "section": "Requirements for records of system-recording details of incidents",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep and retain the details recorded in relation to an incident under section 164-25(1) of the rules in written or electronic form for seven years starting on the day the record is made or received",
          "summaryHTML": "A registered provider must keep and retain the details recorded in relation to an incident under section 164-25(1) of the rules in written or electronic form for seven years starting on the day the record is made or received",
          "extract": "A registered provider must keep and retain the details recorded in relation to an incident under section 164-25(1) of this instrument in written or electronic form for 7 years starting on the day the record is made or received.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 290,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div F, s154-200",
          "section": "Application of Subdivision to feedback received",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Application of subdivision to feedback received\n\nThis subdivision applies to feedback received by a registered provider:\n\n(a) that is managed in accordance with section 165-30; and\n\n(b) raises an issue as referred to in subsection 165-30(2).",
          "summaryHTML": "<i>Application of subdivision to feedback received</i>\n\nThis subdivision applies to feedback received by a registered provider:\n\n(a) that is managed in accordance with section 165-30; and\n\n(b) raises an issue as referred to in subsection 165-30(2).",
          "extract": "This Subdivision applies to feedback received by a registered provider:\n\n(a) that is managed in accordance with section 165-30; and\n\n(b) raises an issue as referred to in subsection 165-30(2).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 291,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div F, s154-205(1)",
          "section": "Requirements for records of complaints and feedback",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "complaints"
          ],
          "summary": "A registered provider must keep and retain prescribed records regarding complaints and feedback: \n- complaints and feedback received each year and their nature\n- action taken to resolve complaints and feedback and responses provided to individuals\n- improvements made by the provider and evaluations of the effectiveness of actions taken\n- time taken to resolve complaints and feedback\n- education and training delivered to aged care workers and responsible persons.",
          "summaryHTML": "A registered provider must keep and retain prescribed records regarding complaints and feedback: \n- complaints and feedback received each year and their nature\n- action taken to resolve complaints and feedback and responses provided to individuals\n- improvements made by the provider and evaluations of the effectiveness of actions taken\n- time taken to resolve complaints and feedback\n- education and training delivered to aged care workers and responsible persons.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that the registered provider must keep and retain:\n\n(a) complaints and feedback received each year;\n\n(b) the nature of complaints and feedback;\n\n(c) the action taken to resolve complaints and feedback;\n\n(d) responses provided to individuals about their complaints and feedback;\n\n(e) any improvements made by the registered provider in relation to complaints and feedback;\n\n(f) an evaluation of the effectiveness of the actions taken by the registered provider and their related outcome in relation to each complaint and feedback;\n\n(g) a record of the number of days taken to resolve each complaint and feedback;\n\n(h) the education and training that has been delivered to the aged care workers and responsible persons of the registered provider in relation to each complaint and feedback.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 292,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div F, s154-205(2)",
          "section": "Requirements for records of complaints and feedback",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "complaints"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 293,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div G, s154-300(1)",
          "section": "Requirement to keep and retain financial and prudential reports",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Registered providers must keep and retain the following financial records:\n- an aged care financial report\n- a quarterly financial report \n- a general purpose financial report\n- an annual prudential compliance statement.",
          "summaryHTML": "Registered providers must keep and retain the following financial records:\n- an aged care financial report\n- a quarterly financial report \n- a general purpose financial report\n- an annual prudential compliance statement.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that a registered provider must keep and retain:\n\n(a) an aged care financial report;\n\n(b) a quarterly financial report;\n\n(c) a general purpose financial report;\n\n(d) an annual prudential compliance statement.\n\nNote: See Subdivision F of Division 3 of Part 2 of Chapter 5 of this instrument for requirements relating to each record prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 294,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div G, s154-300(2)",
          "section": "Requirement to keep and retain financial and prudential reports",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "A registered provider must keep prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 295,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div H, s154-400",
          "section": "Application of Subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subdivision applies to providers registered in one or more of the following categories, and deliver funded aged cares services under the CHSP:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services \nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "summaryHTML": "This subdivision applies to providers registered in one or more of the following categories, and deliver funded aged cares services under the CHSP:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services \nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "extract": "This Subdivision applies to a registered provider of a kind who is registered in one or more of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistance technology and home modifications;\n\n(c) advisory and support services; \n\n(d) personal and care support in the home or community; \n\n(e) nursing and transition care; \n\nand delivers funded aged care services under the CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 296,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div H, s154-405(1)-(2)",
          "section": "Requirements for records",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Each of the following kinds of records are prescribed kinds of records that the registered provider, delivering funded aged cares services under the CHSP must keep and retain:\n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider within a particular financial year;\n\n(b) any individual fees and contributions collected over the financial year;\n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement;\n\n(d) any surplus and uncommitted funds from the previous financial year;\n\n(e) service types, and the duration of services, delivered to each individual;\n\n(f) activity and performance data.\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "Each of the following kinds of records are prescribed kinds of records that the registered provider, delivering funded aged cares services under the CHSP must keep and retain:\n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider within a particular financial year;\n\n(b) any individual fees and contributions collected over the financial year;\n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement;\n\n(d) any surplus and uncommitted funds from the previous financial year;\n\n(e) service types, and the duration of services, delivered to each individual;\n\n(f) activity and performance data.\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that the registered provider must keep and retain:\n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider within a particular financial year; \n\n(b) any individual fees and contributions collected over the financial year; \n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement; \n\n(d) any surplus and uncommitted funds from the previous financial year; \n\n(e) service types, and the duration of services, delivered to each individual; \n\n(f) activity and performance data. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 297,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div J, s154-500",
          "section": "Application of Subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subdivision applies to providers registered in one or more of the following categories, and deliver funded aged care services under the NATSIFACP : \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services \nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care and/or \nCategory 6 - residential care.",
          "summaryHTML": "This subdivision applies to providers registered in one or more of the following categories, and deliver funded aged care services under the NATSIFACP : \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services \nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care and/or \nCategory 6 - residential care.",
          "extract": "This Subdivision applies to a registered provider of a kind who is registered in one or more of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistance technology and home modifications;\n\n(c) advisory and support services; \n\n(d) personal and care support in the home or community; \n\n(e) nursing and transition care; \n\n(f) residential care; \n\nand delivers funded aged care services under the NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 298,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div J, s154-505(1)-(2)",
          "section": "Requirements for records",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Each of the following kinds of records are prescribed kinds of records that the registered provider, delivering funded aged cares services under the NATSIFACP must keep and retain:\n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider under subsection 264(2) of the Act within a particular financial year;\n\n(b) any individual fees and contributions collected over the financial year;\n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement;\n\n(d) any surplus and uncommitted funds from the previous financial year;\n\n(e) service types, and the duration of services, delivered to each individual;\n\n(f) individual care and services plans;\n\n(g) progress in embedding a wellness and reablement approach to service delivery;\n\n(h) individual service agreements;\n\n(i) a summary of the activities undertaken to prevent disease outbreaks;\n\n(j) the number of individuals who are waiting to access funded aged care services for the financial year and the reason for the waitlist.\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "Each of the following kinds of records are prescribed kinds of records that the registered provider, delivering funded aged cares services under the NATSIFACP must keep and retain:\n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider under subsection 264(2) of the Act within a particular financial year;\n\n(b) any individual fees and contributions collected over the financial year;\n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement;\n\n(d) any surplus and uncommitted funds from the previous financial year;\n\n(e) service types, and the duration of services, delivered to each individual;\n\n(f) individual care and services plans;\n\n(g) progress in embedding a wellness and reablement approach to service delivery;\n\n(h) individual service agreements;\n\n(i) a summary of the activities undertaken to prevent disease outbreaks;\n\n(j) the number of individuals who are waiting to access funded aged care services for the financial year and the reason for the waitlist.\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that the registered provider must keep and retain: \n\n(a) the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider under subsection 264(2) of the Act within a particular financial year; \n\n(b) any individual fees and contributions collected over the financial year; \n\n(c) expenditure for the delivery of funded aged care services by the provider under the funding agreement; \n\n(d) any surplus and uncommitted funds from the previous financial year; \n\n(e) service types, and the duration of services, delivered to each individual; \n\n(f) individual care and services plans; \n\n(g) progress in embedding a wellness and reablement approach to service delivery; \n\n(h) individual service agreements;  \n\n(i) a summary of the activities undertaken to prevent disease outbreaks; \n\n(j) the number of individuals who are waiting to access funded aged care services for the financial year and the reason for the waitlist. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 309,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div K, s154-605",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subdivision applies to a registered provider delivering funded aged care services under the MPSP.",
          "summaryHTML": "This subdivision applies to a registered provider delivering funded aged care services under the MPSP.",
          "extract": "This Subdivision applies to a registered provider delivering funded aged services under the MPSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 310,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div K, s154-610(1)-(2)",
          "section": "Requirements for records",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This section outlines the kinds of records that the registered provider must keep and retain, including:\n- the amount of subsidy received to deliver funded aged care services at each approved residential care homes\n- any individual fees or contributions paid by individuals accessing funded aged care services in or from each residential care home\n- expenditure for the delivery of funded aged care services at each approved residential care home for the financial year\n- service types delivered in a financial year\n- the number of individuals who have accessed, or are waiting to access, funded services in or from the residential care home for the financial year\n- demographic information about each individual who has accessed or waiting to access services for the financial year\n- activities taken to prevent disease outbreaks\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "This section outlines the kinds of records that the registered provider must keep and retain, including:\n- the amount of subsidy received to deliver funded aged care services at each approved residential care homes\n- any individual fees or contributions paid by individuals accessing funded aged care services in or from each residential care home\n- expenditure for the delivery of funded aged care services at each approved residential care home for the financial year\n- service types delivered in a financial year\n- the number of individuals who have accessed, or are waiting to access, funded services in or from the residential care home for the financial year\n- demographic information about each individual who has accessed or waiting to access services for the financial year\n- activities taken to prevent disease outbreaks\n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that the registered provider must keep and retain: \n\n(a) records of the amount of subsidy received under Division 5 of Part 2 of Chapter 4 of the Act to deliver funded aged care services at each approved residential care home; \n\n(b) records of any individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services, in or from, each approved residential care home; \n\n(c) records of expenditure by the provider for the delivery of funded aged care services at each approved residential care home for the financial year; \n\n(d) records of the service types delivered for the financial year; \n\n(e) records of the number of individuals who have accessed funded aged care services, or are waiting to access services, in, or from, the approved residential care home for the financial year, including: \n\n(i) whether the individual had an access approval when they commenced accessing services; and \n\n(ii) the service types the individual accessed, including the services where specified in the individual’s access approval; and \n\n(iii) the individual’s classification type for a service group; and \n\n(iv) when the individual commenced and ceased accessing services; and \n\n(v) the reason the individual ceased accessing services; \n\n(f) records of the demographic information about each individual who have accessed funded aged care services, or are waiting to access services for the financial year, including: \n\n(i) the name of the individual; and \n\n(ii) the gender of the individual; and \n\n(iii) the date of birth of the individual; and \n\n(iv) whether the individual is an Aboriginal or Torres Strait Islander person; and \n\n(v) whether the individual has dementia or dementia symptoms; \n\n(f) records of a summary of the activities undertaken to prevent disease outbreaks. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 311,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div L, s154-650",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "summaryHTML": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "extract": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 312,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div L, s154-665(1)-(2)",
          "section": "Requirements for records",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This section outlines the kinds of records that a registered provider delivering funded aged care services under the TCP must keep and retain: \n\n(a) records of claims for payment of subsidy made by the provider under section 260 of the Act; \n\n(b) records of the amount of subsidy the Commonwealth has paid to the provider for the financial year; \n\n(c) records of any individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services for the financial year; \n\n(d) records of expenditure by the provider for the delivery of funded aged care services for the financial year; \n\n(e) records of any System Governor approved unspent funds from previous financial years. \n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "summaryHTML": "This section outlines the kinds of records that a registered provider delivering funded aged care services under the TCP must keep and retain: \n\n(a) records of claims for payment of subsidy made by the provider under section 260 of the Act; \n\n(b) records of the amount of subsidy the Commonwealth has paid to the provider for the financial year; \n\n(c) records of any individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services for the financial year; \n\n(d) records of expenditure by the provider for the delivery of funded aged care services for the financial year; \n\n(e) records of any System Governor approved unspent funds from previous financial years. \n\nA registered provider must keep these prescribed records in written or electronic form for seven years from the date they are made or received.",
          "extract": "(1) Each of the following kinds of records are prescribed kinds of records that the registered provider must keep and retain: \n\n(a) records of claims for payment of subsidy made by the provider under section 260 of the Act; \n\n(b) records of the amount of subsidy the Commonwealth has paid to the provider for the financial year; \n\n(c) records of any individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services for the financial year; \n\n(d) records of expenditure by the provider for the delivery of funded aged care services for the financial year; \n\n(e) records of any System Governor approved unspent funds from previous financial years. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section in written or electronic form for 7 years starting on the day the record is made or received. \n\nNote: A registered provider may be required to comply with other Commonwealth, State or Territory laws in relation to the retention of records.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 299,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div M, s154-700(1)-(3)",
          "section": "Records about independent non-executive members of a governing body",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Records about independent non-executive members of a governing body. \n\nIf, because of paragraph 157(2)(a) of the Act and section 157-5 of the rules, a registered provider is required to ensure that a majority of the members of its governing body are independent non-executive members. \n\nRegistered providers must keep and retain records of the names of the members of its governing body and which of those members are independent non-executive members. \n\nIt is a requirement that a registered provider keep the records prescribed under this section for seven years starting on the day the record is made. \n\nIf a record relates to a specific governing body member, registered providers must retain it for seven years after the member's engagement ends.",
          "summaryHTML": "<i>Records about independent non-executive members of a governing body. </i>\n\nIf, because of paragraph 157(2)(a) of the Act and section 157-5 of the rules, a registered provider is required to ensure that a majority of the members of its governing body are independent non-executive members. \n\nRegistered providers must keep and retain records of the names of the members of its governing body and which of those members are independent non-executive members. \n\nIt is a requirement that a registered provider keep the records prescribed under this section for seven years starting on the day the record is made. \n\nIf a record relates to a specific governing body member, registered providers must retain it for seven years after the member's engagement ends.",
          "extract": "(1) If, because of paragraph 157(2)(a) of the Act and section 157-5 of this instrument, a registered provider is required to ensure that a majority of the members of its governing body are independent non-executive members, the registered provider must keep and retain records of:\n\n(a) the names of the members of its governing body; and\n\n(b) which of those members are independent non-executive members.\n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made. \n\n(3) Despite subsection (2), if a record prescribed under subsection (1) relates to a specific member of the governing body, the registered provider must keep the record for a period of 7 years following the end of that member’s engagement with the governing body.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 300,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div M, s154-705(1)-(3)",
          "section": "Records about members of a governing body with clinical care \nprovision experience",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Records about members of a governing body with clinical care provision experience\n\nIf, because of paragraph 157(2)(b) of the Act and section 157-10 of the rules, a registered provider is required to ensure that at least one member of its governing body has experience in the provision of clinical care.\n\nRegistered providers must keep and retain records of the names of the members of its governing body who have experience in the provision of clinical care and details of those members experience. \n\nIt is a requirement that a registered provider keep the records prescribed under this section for seven years starting on the day the record is made.\n\nIf a record relates to a specific governing body member, registered providers must retain it for seven years after the member's engagement ends.",
          "summaryHTML": "<i>Records about members of a governing body with clinical care provision experience</i>\n\nIf, because of paragraph 157(2)(b) of the Act and section 157-10 of the rules, a registered provider is required to ensure that at least one member of its governing body has experience in the provision of clinical care.\n\nRegistered providers must keep and retain records of the names of the members of its governing body who have experience in the provision of clinical care and details of those members experience. \n\nIt is a requirement that a registered provider keep the records prescribed under this section for seven years starting on the day the record is made.\n\nIf a record relates to a specific governing body member, registered providers must retain it for seven years after the member's engagement ends.",
          "extract": "(1) If, because of paragraph 157(2)(b) of the Act and section 157-10 of this instrument, a registered provider is required to ensure that at least one member of its governing body has experience in the provision of clinical care, the registered provider must keep and retain records of:\n\n(a) the names of the members of its governing body who have experience in the provision of clinical care; and\n\n(b) the details of those members’ experience.\n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made. \n\n(3) Despite subsection (2), if a record prescribed under subsection (1) relates to a specific member of the governing body, the registered provider must keep the record for a period of 7 years following the end of that member’s engagement with the governing body.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 301,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div N, s154-800(1)-(3)",
          "section": "Records about the quality care advisory body",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Records about the quality care advisory body\n\nIf, because of paragraph 158(2)(a) of the Act and section 158-5 of the rules, a registered provider is required to establish, and continue in existence, a quality care advisory body. The registered provider must keep and retain record of the names of the members of the quality care advisory body including appointment details,  records of how the quality care advisory body satisfies the requirements of section 158-15 of the rules, a copy of the minutes of any meeting held and the date, a copy of each written report given to the governing body, records of any feedback given to the governing body, a copy of any written advice given to the quality care advisory body by the governing body . \n\nIt is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.\n\nIf a record relates to a specific governing body member, registered providers must retain it for 7 years after the member's engagement ends.",
          "summaryHTML": "<i>Records about the quality care advisory body</i>\n\nIf, because of paragraph 158(2)(a) of the Act and section 158-5 of the rules, a registered provider is required to establish, and continue in existence, a quality care advisory body. The registered provider must keep and retain record of the names of the members of the quality care advisory body including appointment details,  records of how the quality care advisory body satisfies the requirements of section 158-15 of the rules, a copy of the minutes of any meeting held and the date, a copy of each written report given to the governing body, records of any feedback given to the governing body, a copy of any written advice given to the quality care advisory body by the governing body . \n\nIt is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.\n\nIf a record relates to a specific governing body member, registered providers must retain it for 7 years after the member's engagement ends.",
          "extract": "(1) If, because of paragraph 158(2)(a) of the Act and section 158-5 of this instrument, a registered provider is required to establish, and continue in existence, a quality care advisory body, the registered provider must keep and retain the following:\n\n(a) records of the names of the members of the quality care advisory body and details of:\n\n(i) the date each member was appointed to the quality care advisory body; and\n\n(ii) the date (if any) a member resigned from the quality care advisory body;\n\n(b) records of how the quality care advisory body satisfies the requirements of section 158-15 of this instrument (requirements for reports of quality care advisory bodies);\n\n(c) a copy of the minutes of any meeting held by the quality care advisory body and the date on which the meeting was held;\n\n(d) a copy of each written report given to the governing body of the provider by the quality care advisory body under subparagraph 158(2)(a)(ii) of the Act;\n\n(e) records of any feedback given to the governing body of the provider by the quality care advisory body under subparagraph 158(2)(a)(iii) of the Act;\n\n(f) a copy of any written advice given to the quality care advisory body by the governing body of the provider under subparagraph 158(2)(b)(ii) of the Act advising how the governing body has considered the report and feedback mentioned in paragraphs (d) and (e) of this subsection.\n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made. \n\nRetention of records\n\n(3) Despite subsection (2), if a record prescribed under subsection (1) relates to a specific member of the quality care advisory body, the registered provider must keep the record for a period of 7 years following the end of that member’s engagement with the quality care advisory body.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 302,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div N, s154-805(1)-(3)",
          "section": "Records about the quality care advisory body",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Records about the consumer advisory body\n\nIf, because of paragraph 158(4)(a) of the Act and section 158-20 of the rules, a registered provider is required to offer the opportunity to establish one or more consumer advisory bodies, the registered provider must keep and retain a copy of each written offer made to individuals to whom the provider delivers funded aged care services and the supporters of those individuals giving them the opportunity to establish a consumer advisory body and records of the date on which each offer was given to those individuals and \nsupporters.\n\nIf one or more consumer advisory bodies are established, the registered provider must also keep and retain a copy of the minutes of each meeting, records of any feedback given to the governing body and a copy of any written advice given to the consumer advisory body.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "summaryHTML": "<i>Records about the consumer advisory body</i>\n\nIf, because of paragraph 158(4)(a) of the Act and section 158-20 of the rules, a registered provider is required to offer the opportunity to establish one or more consumer advisory bodies, the registered provider must keep and retain a copy of each written offer made to individuals to whom the provider delivers funded aged care services and the supporters of those individuals giving them the opportunity to establish a consumer advisory body and records of the date on which each offer was given to those individuals and \nsupporters.\n\nIf one or more consumer advisory bodies are established, the registered provider must also keep and retain a copy of the minutes of each meeting, records of any feedback given to the governing body and a copy of any written advice given to the consumer advisory body.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "extract": "(1) If, because of paragraph 158(4)(a) of the Act and section 158-20 of this instrument, a registered provider is required to offer the opportunity to establish one or more consumer advisory bodies, the registered provider must keep and retain the following:\n\n(a) a copy of each written offer made to individuals to whom the provider delivers funded aged care services and the supporters of those individuals giving them the opportunity to establish a consumer advisory body;\n\n(b) records of the date on which each offer was given to those individuals and supporters.\n\n(2) If one or more consumer advisory bodies are established, the registered provider must also keep and retain the following in relation to each body:\n\n(a) a copy of the minutes of each meeting of the consumer advisory body;\n\n(b) records of any feedback given to the governing body of the provider by the consumer advisory body;\n\n(c) a copy of any written advice given to the consumer advisory body by the governing body under subparagraph 158(4)(b)(ii) of the Act advising how the governing body has considered any such feedback.\n\n(3) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 303,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-900(1)",
          "section": "Records of responsible persons",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Records of responsible persons\n\nA registered provider must keep, and keep up-to-date, a record for each responsible person of the provider that includes the following information and documents:\n\n(a) the person’s full name, date of birth and address\n\n(b) a record of the person’s police certificate;\n\n(c) a record of the person’s statutory declaration;\n\n(d) a record of the person’s NDIS clearance decision.\n\nRefer to section 152-15 or 152-16 for more information about workforce and aged care worker requirements.",
          "summaryHTML": "<i>Records of responsible persons</i>\n\nA registered provider must keep, and keep up-to-date, a record for each responsible person of the provider that includes the following information and documents:\n\n(a) the person’s full name, date of birth and address\n\n(b) a record of the person’s police certificate;\n\n(c) a record of the person’s statutory declaration;\n\n(d) a record of the person’s NDIS clearance decision.\n\nRefer to section 152-15 or 152-16 for more information about workforce and aged care worker requirements.",
          "extract": "(1) A registered provider must keep, and keep up-to-date, a record for each responsible person of the provider that includes the following information and documents:\n\n(a) the person’s full name, date of birth and address;\n\n(b) if paragraph 152-15(1)(a) or 152-16(1)(a) applies to the person—a record of the person’s police certificate; \n\n(c) if paragraph 152-15(1)(b) or 152-16(1)(b) applies to the person—a record of the person’s statutory declaration; \n\n(d) if paragraph 152-15(1)(c) or 152-16(1)(c) applies to the person—a record of the person’s NDIS clearance decision.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 304,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-900(2)-(3)",
          "section": "Records of responsible persons",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "The registered provider must also keep a record of the name of the person who ensured the responsible person has a police certificate, statutory declaration or NDIS clearance decision, and the date this occurred.\n\nThis subsection applies if the responsible person’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section.",
          "summaryHTML": "The registered provider must also keep a record of the name of the person who ensured the responsible person has a police certificate, statutory declaration or NDIS clearance decision, and the date this occurred.\n\nThis subsection applies if the responsible person’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section.",
          "extract": "(2) Subject to subsection (3), the registered provider must also keep a record of: \n\n(a) the name of the person who ensured that the responsible person has a police certificate, statutory declaration or NDIS clearance decision; and \n\n(b) the date the person did so. \n\n(3) Subsection (2) applies if the responsible person’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 305,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-905(1)",
          "section": "Records of aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Records of aged care workers\n\nA registered provider must keep, and keep up-to-date, a record for each aged care worker of the provider that includes the following information and documents:\n\n(a) the worker’s full name, date of birth and address;\n\n(b) how the provider has ensured that the worker has appropriate qualifications, skills or experience to provide the funded aged care services that the registered provider delivers to individuals and is given opportunities to develop their capability to provide those services\n\n(c) a record of the worker’s police certificate;\n\n(d) a record of the worker’s statutory declaration;\n\n(e) a record of the worker’s NDIS clearance decision.\n\nRefer to sections 152-20, 152-21 or 152-35 for more information about workforce and aged care worker requirements.",
          "summaryHTML": "<i>Records of aged care workers</i>\n\nA registered provider must keep, and keep up-to-date, a record for each aged care worker of the provider that includes the following information and documents:\n\n(a) the worker’s full name, date of birth and address;\n\n(b) how the provider has ensured that the worker has appropriate qualifications, skills or experience to provide the funded aged care services that the registered provider delivers to individuals and is given opportunities to develop their capability to provide those services\n\n(c) a record of the worker’s police certificate;\n\n(d) a record of the worker’s statutory declaration;\n\n(e) a record of the worker’s NDIS clearance decision.\n\nRefer to sections 152-20, 152-21 or 152-35 for more information about workforce and aged care worker requirements.",
          "extract": "(1) A registered provider must keep, and keep up-to-date, a record for each aged care worker of the provider that includes the following information and documents:\n\n(a) the worker’s full name, date of birth and address;\n\n(b) how the provider has ensured that the worker: \n\n(i) has appropriate qualifications, skills or experience to provide the funded aged care services that the registered provider delivers to individuals (see section 152-35 of this instrument); and \n\n(ii) is given opportunities to develop their capability to provide those services (see paragraph 152(d) of the Act); \n\n(c) if paragraph 152-20(1)(a) or 152-21(1)(a) of this instrument applies to the worker—a record of the worker’s police certificate; \n\n(d) if paragraph 152-20(1)(b) or 152-21(1)(b) of this instrument applies to the worker—a record of the worker’s statutory declaration; \n\n(e) if paragraph 152-20(1)(c) or 152-21(1)(c) of this instrument applies to the worker—a record of the worker’s NDIS clearance decision.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 306,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-905(2)-(3)",
          "section": "Records of aged care workers",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "The registered provider must also keep a record of the name of the person who ensured the worker has a police certificate, statutory declaration or NDIS clearance decision, and the date this occurred.\n\nThis subsection applies if the responsible person’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section",
          "summaryHTML": "The registered provider must also keep a record of the name of the person who ensured the worker has a police certificate, statutory declaration or NDIS clearance decision, and the date this occurred.\n\nThis subsection applies if the responsible person’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section",
          "extract": "(2) Subject to subsection (3), the registered provider must also keep a record of: \n\n(a) the name of the person who ensured that the worker has a police certificate, statutory declaration or NDIS clearance decision; and \n\n(b) the date the person did so. \n\n(3) Subsection (2) applies if the worker’s police certificate, statutory declaration or NDIS clearance is received by the registered provider on or after the commencement of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 307,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-910",
          "section": "How long records required by sections 154-900 and 154-905 to be kept",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "A registered provider must keep records required by sections 154-900 or 154-905 for seven years from the date they are first made or last updated, whichever is later.",
          "summaryHTML": "A registered provider must keep records required by sections 154-900 or 154-905 for seven years from the date they are first made or last updated, whichever is later.",
          "extract": "A registered provider must keep a record required by section 154-1110 or 154-1120 for 7 years starting on the later of the following: \n\n(a) the day the record is first made; \n\n(b) the day the latest update to the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 308,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div P, s154-915(1)-(2)",
          "section": "Copies of records relating to allegations of misconduct",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "complaints"
          ],
          "summary": "Copies of records relating to allegations of misconduct \n\nThis requirement applies if a registered provider has a copy of records relating to allegations of misconduct against a responsible person or aged care worker of the provider or any action taken, including an investigation, in response to an allegation.\n\nThe provider must keep the copy for seven years starting on the first day the provider has the copy.",
          "summaryHTML": "<i>Copies of records relating to allegations of misconduct </i>\n\nThis requirement applies if a registered provider has a copy of records relating to allegations of misconduct against a responsible person or aged care worker of the provider or any action taken, including an investigation, in response to an allegation.\n\nThe provider must keep the copy for seven years starting on the first day the provider has the copy.",
          "extract": "(1) This section applies if a registered provider has a copy of a record relating to:\n\n(a) an allegation of misconduct against a responsible person or aged care worker of the provider; or\n\n(b) any action taken, including any investigation, in response to such an allegation.\n\n(2) The provider must keep the copy for 7 years starting on the first day the provider has the copy.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 314,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div Q, s154-1000(1)-(2)",
          "section": "Requirement to keep and retain records relating to continuity of funded aged care services",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must keep retain records relating to continuity of funded aged care services, or copies of such records, for an individual to whom the provider is delivering funded aged care services. Including:\n\n(a) any assessment and classification records of the individual that are not provided to the System Governor in electronic form;\n\n(b) the service agreement between the provider and the individual;\n\n(c) the care and services plan for the individual;\n\n(d) the medical records, progress notes and other clinical records of the individual;\n\n(e) where the provider is delivering funded aged care services to the individual through the service group residential care, the accounts of the individual, including:\n\n(i) the entry, if any, in the refundable deposit register of the provider that relates to the individual; and\n\n(ii) amounts, if any, of daily accommodation payments, daily accommodation contributions or accommodation charge paid by the individual; and\n\n(iii) entry and leave arrangements for the individual; and\n\n(iv) the accommodation agreement between the provider and the individual; and\n\n(f) where the provider is delivering funded aged care services to the individual through the service groups home support, assistive technology or home modifications, the accounts of the individual, including any notices provided to the individual in accordance with section 149-45;\n\n(g) applicability of any fee reduction supplements to the individual under sections 197-5, 231-15 or 231-20;\n\n(h) the name and contact details of any supporter registered in relation to the individual;\n\n(i) measurements, assessments and information about the individual obtained in accordance with sections 154-110, 166-110 and 166-112 of the rules;\n\n(j) monthly statements prepared in accordance with section 155-40 of the rules.\n\nIt is a requirement that a registered provider keep a record made under this section for seven years starting on the day the record is made.",
          "summaryHTML": "A registered provider must keep retain records relating to continuity of funded aged care services, or copies of such records, for an individual to whom the provider is delivering funded aged care services. Including:\n\n(a) any assessment and classification records of the individual that are not provided to the System Governor in electronic form;\n\n(b) the service agreement between the provider and the individual;\n\n(c) the care and services plan for the individual;\n\n(d) the medical records, progress notes and other clinical records of the individual;\n\n(e) where the provider is delivering funded aged care services to the individual through the service group residential care, the accounts of the individual, including:\n\n(i) the entry, if any, in the refundable deposit register of the provider that relates to the individual; and\n\n(ii) amounts, if any, of daily accommodation payments, daily accommodation contributions or accommodation charge paid by the individual; and\n\n(iii) entry and leave arrangements for the individual; and\n\n(iv) the accommodation agreement between the provider and the individual; and\n\n(f) where the provider is delivering funded aged care services to the individual through the service groups home support, assistive technology or home modifications, the accounts of the individual, including any notices provided to the individual in accordance with section 149-45;\n\n(g) applicability of any fee reduction supplements to the individual under sections 197-5, 231-15 or 231-20;\n\n(h) the name and contact details of any supporter registered in relation to the individual;\n\n(i) measurements, assessments and information about the individual obtained in accordance with sections 154-110, 166-110 and 166-112 of the rules;\n\n(j) monthly statements prepared in accordance with section 155-40 of the rules.\n\nIt is a requirement that a registered provider keep a record made under this section for seven years starting on the day the record is made.",
          "extract": "(1) A registered provider must keep the following kinds of records, or copies of such records, for an individual to whom the provider is delivering funded aged care services: \n\n(a) any assessment and classification records of the individual that are not provided to the System Governor in electronic form; \n\n(b) the service agreement between the provider and the individual; \n\n(c) the care and services plan for the individual; \n\n(d) the medical records, progress notes and other clinical records of the individual; \n\n(e) where the provider is delivering funded aged care services to the individual through the service group residential care, the accounts of the individual, including:  (i) the entry, if any, in the refundable deposit register of the provider that relates to the individual; and \n\n(ii) amounts, if any, of daily accommodation payments, daily accommodation contributions or accommodation charge paid by the individual; and \n\n(iii) entry and leave arrangements for the individual; and \n\n(iv) the accommodation agreement between the provider and the individual; and \n\n(f) where the provider is delivering funded aged care services to the individual through the service groups home support, assistive technology or home modifications, the accounts of the individual, including any notices provided to the individual in accordance with section 149-45; \n\n(g) applicability of any fee reduction supplements to the individual under sections 197-5, 231-15 or 231-20; \n\n(h) the name and contact details of any supporter registered in relation to the individual; \n\n(i) measurements, assessments and information about the individual obtained in accordance with sections 154-110, 166-110 and 166-112 of this instrument; \n\n(j) monthly statements prepared in accordance with section 155-40 of this instrument. \n\n(2) It is a requirement that a registered provider keep a record made under this section for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 315,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div R, s154-1100(1)-(2)",
          "section": "Requirement to keep and retain records about service delivery branches",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to keep and retain records about service delivery branches\n\nA registered provider must keep records of their compliance with reporting requirements under Subdivision M, of Division 3 of Part 2 of Chapter 5, including records under sections 166-910, 166-915, 166-920, 166-925, and 166-930.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made",
          "summaryHTML": "<i>Requirement to keep and retain records about service delivery branches</i>\n\nA registered provider must keep records of their compliance with reporting requirements under Subdivision M, of Division 3 of Part 2 of Chapter 5, including records under sections 166-910, 166-915, 166-920, 166-925, and 166-930.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made",
          "extract": "(1) A registered provider must keep records of their compliance with the reporting requirements under Subdivision N of Division 3 of Part 2 of Chapter 5, including records of the following: \n\n(a) any reports given under section 166-910; \n\n(b) any reports given under section 166-915; \n\n(c) any reports given under section 166-920; \n\n(d) any reports given under section 166-925; \n\n(e) any reports given under section 166-930. \n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 318,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div S, s154-1200(1)-(2)",
          "section": "Application of this Subdivision",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This subdivision (claims for subsidy) applies to all registered providers, unless they only deliver funded aged care services under one of the following specialist aged care programs; CHSP, MPSP, or NATSIFACP.",
          "summaryHTML": "This subdivision (claims for subsidy) applies to all registered providers, unless they only deliver funded aged care services under one of the following specialist aged care programs; CHSP, MPSP, or NATSIFACP.",
          "extract": "(1) This Subdivision applies to a registered provider registered in any registration category.\n\n(2) Despite subsection (1), this Subdivision does not apply to a registered provider only delivering funded aged care services under one of the following specialist aged care programs:\n\n(a) CHSP;\n\n(b) MPSP;\n\n(c) NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 319,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div S, s154-1205(1)-(3)",
          "section": "Requirement to keep and retain records which enable claims for payment of subsidy to be verified",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to keep and retain records which enable claims for payment of subsidy to be verified\n\n(1) A kind of record that a registered provider must keep and retain under paragraph 154(a) of the Act is any record that enables claims for payments of subsidy to be properly verified.\n\n(2) Without limiting subsection (1), a kind of record that enables claims for payments of subsidy to be properly verified includes the following: service agreements with an individual, medical records, progress notes and other clinical records for the individual, invoices for delivery of services to an individual, and staff attendance records.\n\nIt is a requirement that a registered provider keep a record prescribed under subsection (1) for seven years starting on the day the record is made.",
          "summaryHTML": "<i>Requirement to keep and retain records which enable claims for payment of subsidy to be verified</i>\n\n(1) A kind of record that a registered provider must keep and retain under paragraph 154(a) of the Act is any record that enables claims for payments of subsidy to be properly verified.\n\n(2) Without limiting subsection (1), a kind of record that enables claims for payments of subsidy to be properly verified includes the following: service agreements with an individual, medical records, progress notes and other clinical records for the individual, invoices for delivery of services to an individual, and staff attendance records.\n\nIt is a requirement that a registered provider keep a record prescribed under subsection (1) for seven years starting on the day the record is made.",
          "extract": "(1) A kind of record that a registered provider must keep and retain under paragraph 154(a) of the Act is any record that enables claims for payments of subsidy to be properly verified.\n\n(2) Without limiting subsection (1), a kind of record that enables claims for payments of subsidy to be properly verified includes the following:\n\n(a) the service agreement between the registered provider and the individual to whom the provider is delivering funded aged care services;\n\n(b) the medical records, progress notes and other clinical records of the individual to whom the provider is delivering funded aged care services;\n\n(c) invoices for the delivery of funded aged care services to an individual;\n\n(d) attendance records for an aged care worker of the provider.\n\n(3) It is a requirement that a registered provider keep a record prescribed under subsection (1) for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        },
        {
          "id": 320,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 1, Sub Div T, s154-1300(1)-(2)",
          "section": "Requirement to keep and retain records relating to compliance",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Personal information and record keeping",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to keep and retain records relating to compliance\n\nA kind of record that a registered provider must keep and retain under section 154 of the Act is any record that enables proper assessments to be made of whether a provider has complied, or is complying, with its obligations under Chapter 3 of the Act.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made.",
          "summaryHTML": "<i>Requirement to keep and retain records relating to compliance</i>\n\nA kind of record that a registered provider must keep and retain under section 154 of the Act is any record that enables proper assessments to be made of whether a provider has complied, or is complying, with its obligations under Chapter 3 of the Act.\n\nIt is a requirement that a registered provider keep a record prescribed under this section for seven years starting on the day the record is made.",
          "extract": "(1) A kind of record that a registered provider must keep and retain under section 154 of the Act is any record that enables proper assessments to be made of whether a provider has complied, or is complying, with its obligations under Chapter 3 of the Act.\n\n(2) It is a requirement that a registered provider keep a record prescribed under this section for 7 years starting on the day the record is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s154"
        }
      ]
    },
    {
      "id": 21,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s155(1)",
      "section": "Provision of information to individual",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Provision of information to individuals",
      "topic": [
        "agreements",
        "reporting"
      ],
      "summary": "Registered providers must provide and explain records and information prescribed by the rules to individuals seeking to access funded aged care services.",
      "summaryHTML": "Registered providers must provide and explain records and information prescribed by the rules to individuals seeking to access funded aged care services.",
      "extract": "(1) It is a condition of registration that a registered provider must provide and explain records and information of a kind prescribed by the rules to individuals accessing, or seeking to access, funded aged care services, in accordance with any requirements prescribed by the rules. \n\nNote: Information or documents may also be required to be given to a supporter of an individual: see section 29.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631490",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 321,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-15(1)-(3)",
          "section": "Information to be provided and explained—Statement of Rights",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided and explained—Statement of Rights\n\nRegistered providers must give individuals accessing or seeking aged care services both information about their rights and a copy of the Statement of Rights, assist the individual to understand the information and the Statement of Rights, and do so before or when the registered provider commences delivery of funded aged care services.\n\nNote: The registered provider must retain records relating to the Statement of Rights given under paragraph (1)(b) (see section 154-2).",
          "summaryHTML": "<i>Information to be provided and explained—Statement of Rights</i>\n\nRegistered providers must give individuals accessing or seeking aged care services both information about their rights and a copy of the Statement of Rights, assist the individual to understand the information and the Statement of Rights, and do so before or when the registered provider commences delivery of funded aged care services.\n\nNote: The registered provider must retain records relating to the Statement of Rights given under paragraph (1)(b) (see section 154-2).",
          "extract": "(1) For the purposes of subsection 155(1) of the Act, a registered provider must provide an individual accessing or seeking to access funded aged care services the following:\n\n(a) information about the individual’s rights under the Statement of Rights set out in section 23 of the Act, in relation to the funded aged care services the individual accesses;\n\n(b) a copy of the Statement of Rights.\n\nNote: The registered provider must retain records relating to the Statement of Rights given under paragraph (1)(b) (see section 154-2). \n\n(2) A registered provider must assist the individual to understand the information and the Statement of Rights given under subsection (1).\n\n(3) A registered provider must comply with subsections (1) and (2) before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 322,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-20(1)-(2)",
          "section": "Information to be provided—information to assist individuals to choose funded aged care services that best meet their needs",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—information to assist individuals to choose funded aged care services that best meet their needs\n\nThis section applies to a registered provider registered in Category 1 - home and community services; Category 2 - assistive technology and home modifications; Category 3 - advisory and support services; Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and registration category subscription trial. \n\nA registered provider must provide such information as is reasonably necessary to assist an individual to choose, in accordance with the individual’s access approval, the funded aged care services that best meet the individual’s goals and assessed needs and preferences within the limits of the resources available.",
          "summaryHTML": "<i>Information to be provided—information to assist individuals to choose funded aged care services that best meet their needs</i>\n\nThis section applies to a registered provider registered in Category 1 - home and community services; Category 2 - assistive technology and home modifications; Category 3 - advisory and support services; Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and registration category subscription trial. \n\nA registered provider must provide such information as is reasonably necessary to assist an individual to choose, in accordance with the individual’s access approval, the funded aged care services that best meet the individual’s goals and assessed needs and preferences within the limits of the resources available.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.\n\n(2) A registered provider must provide such information as is reasonably necessary to assist an individual to choose, in accordance with the individual’s access approval, the funded aged care services that best meet the individual’s goals and assessed needs and preferences within the limits of the resources available.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 323,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-25",
          "section": "Information to be provided—clear and understandable invoices",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—clear and understandable invoices\n\nRegistered providers must provide an individual with invoices that are easy to read and clearly understandable.",
          "summaryHTML": "<i>Information to be provided—clear and understandable invoices</i>\n\nRegistered providers must provide an individual with invoices that are easy to read and clearly understandable.",
          "extract": "For the purposes of subsection 155(1) of the Act, a registered provider must provide an individual with invoices that are clear and in a format that is understandable.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 324,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(1)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "reporting"
          ],
          "summary": "Information about a registered provider’s management and use of refundable deposits\n\nThis rule applies to registered providers registered in Category 6 - residential care, that receives or has received payment of a refundable deposit, accommodation bond, or entry contribution from an individual, wholly or partly as a lump sum as prescribed under section 150A-3 of the rules.",
          "summaryHTML": "<i>Information about a registered provider’s management and use of refundable deposits\n</i>\nThis rule applies to registered providers registered in Category 6 - residential care, that receives or has received payment of a refundable deposit, accommodation bond, or entry contribution from an individual, wholly or partly as a lump sum as prescribed under section 150A-3 of the rules.",
          "extract": "(1) This section applies to a registered provider if the registered provider is prescribed under section 150A-3 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 325,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(2)-(3)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "reporting"
          ],
          "summary": "Notification by registered provider\n\nWithin 7 days after an accommodation agreement is entered into between a provider registered in Category 6 - residential care, the registered provider must notify the individual in writing that they will give the individual, upon request, with a range of financial, compliance, investment, and individual deposit information within 7 days. \n\nFor more detailed information refer to subsections Ch 4, Part 7, Div 2, section 155-30(2)(a)-(h) of the rules.\n\nA registered provider that is not required to prepare annual financial reports under the Corporations Act 2001 is not required to comply with paragraph (2)(g) of this section.",
          "summaryHTML": "<i>Notification by registered provider</i>\n\nWithin 7 days after an accommodation agreement is entered into between a provider registered in Category 6 - residential care, the registered provider must notify the individual in writing that they will give the individual, upon request, with a range of financial, compliance, investment, and individual deposit information within 7 days. \n\nFor more detailed information refer to subsections Ch 4, Part 7, Div 2, section 155-30(2)(a)-(h) of the rules.\n\nA registered provider that is not required to prepare annual financial reports under the Corporations Act 2001 is not required to comply with paragraph (2)(g) of this section.",
          "extract": "Notification by registered provider\n\n(2) Within 7 days after an accommodation agreement is entered into between a registered provider and an individual, the registered provider must notify the individual, in writing, that the registered provider will give the individual, within 7 days of a request by the individual, the following information and documents: \n \n(a) a summary of the permitted uses for which refundable deposits and accommodation bonds have been used by the registered provider during the previous financial year; \n\n(b) if, during the 2 years prior to the request, the registered provider has given the System Governor an aged care financial report for the registered provider that included a permitted uses reconciliation—a copy of the permitted uses reconciliation included in the most recent such report;   (c) information about whether the registered provider has, during the previous financial year, complied with: \n\n(i) section 310 of the Act; and \n\n(ii) the Financial and Prudential Standards; \n\n(d) information about: \n\n(i) the number (if any) of refundable deposit balances or accommodation bond balances that, in the previous financial year, were not refunded in accordance with section 311 of the Act or section 287-102 of this instrument+E330; and \n\n(ii) the number (if any) of entry contribution balances that, in the previous financial year, were not refunded in accordance with a formal agreement; \n\n(e) if the registered provider is required to implement and maintain a written investment management strategy under the Financial and Prudential Standards—the registered provider’s investment objectives as recorded in the registered provider’s investment management strategy; \n\n(f) a copy of the audit opinion referred to in paragraph 166-380(g) of this instrument for the previous financial year; \n\n(g) a copy of either: \n\n(i) the most recent statement of the audited accounts in relation to the registered provider; or \n\n(ii) if the registered provider is operated as part of a broader organisation—the most recent statement of the audited accounts of the organisation’s aged care component; \n\n(h) a copy of the refundable deposit register entry that relates to the individual, as at the time of the request. \n\n(3) A registered provider that is not required to prepare annual financial reports under Part 2M.3 of Chapter 2M of the Corporations Act 2001 is not required to comply with paragraph (2)(g) of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 326,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(4)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A copy of the refundable deposit register entry that relates to the individual must be provided to the individual or another person in the following circumstances:\n\n(a) the individual, or their legal representative or estate (if deceased), when the individual ceases to access funded services through the provider's approved residential care home\n\n(b) the individual, when they move to another approved residential care home of another registered provider.",
          "summaryHTML": "A copy of the refundable deposit register entry that relates to the individual must be provided to the individual or another person in the following circumstances:\n\n(a) the individual, or their legal representative or estate (if deceased), when the individual ceases to access funded services through the provider's approved residential care home\n\n(b) the individual, when they move to another approved residential care home of another registered provider.",
          "extract": "Disclosure of refundable deposit register entry relating to an individual \n(4) A copy of the refundable deposit register entry that relates to the individual must be provided to the individual or another person in the following circumstances: \n\n(a) when the individual ceases to access funded aged care services through the registered provider’s approved residential care home, the record must be provided to the individual, or if the individual has died, the individual’s legal representative or estate; \n\n(b) when the individual moves to another approved residential care home of another registered provider, the record must be provided to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 327,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(5)-(6)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Disclosure on request\n\nA registered provider must provide the information or documents referred to in subsection (2) or (4) within 7 days of receiving a request from an individual accessing funded aged care services in their approved residential care home.\n\nSubsection (5) applies to any individual accessing funded aged care services in an approved residential care home, regardless of whether they have an accommodation agreement with the provider or have paid a refundable deposit, accommodation bond, or entry contribution.\n\nIf an individual requests the summary of permitted uses for refundable deposits and accommodation bonds from the previous financial year, and the registered provider has already given the  System Governor an aged care financial report including a permitted uses reconciliation for the previous financial year, the provider may meet the requirement by giving the individual a copy of that permitted uses reconciliation.",
          "summaryHTML": "<i>Disclosure on request\n</i>\nA registered provider must provide the information or documents referred to in subsection (2) or (4) within 7 days of receiving a request from an individual accessing funded aged care services in their approved residential care home.\n\nSubsection (5) applies to any individual accessing funded aged care services in an approved residential care home, regardless of whether they have an accommodation agreement with the provider or have paid a refundable deposit, accommodation bond, or entry contribution.\n\nIf an individual requests the summary of permitted uses for refundable deposits and accommodation bonds from the previous financial year, and the registered provider has already given the  System Governor an aged care financial report including a permitted uses reconciliation for the previous financial year, the provider may meet the requirement by giving the individual a copy of that permitted uses reconciliation.",
          "extract": "Disclosure on request\n\n(5) If an individual requests the registered provider of an approved residential care home in which the individual is accessing funded aged care services to give the individual the information and documents referred to in subsection (2) or (4), the registered provider must give the individual the information and documents requested within 7 days after receiving the request. \n\n(6) Subsection (5) applies in relation to an individual who is accessing funded aged care services in an approved residential care home: \n\n(a) whether or not the individual entered into an accommodation agreement with the registered provider of the approved residential care home; and \n\n(b) whether or not the individual has paid a refundable deposit; an accommodation bond or an entry contribution to that registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 583,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(7)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Disclosure on request\n\nIf at the request of an individual, a provider is required under subsection (5) of this section to give a summary of the permitted uses for which refundable deposits and accommodation bonds have been used during the previous financial year, and the provider has given the System Governor an aged care financial report for the previous financial year, which included a permitted uses reconciliation, the provider may satisfy the requirement to give the individual the summary by giving the individual a copy of that permitted uses reconciliation.",
          "summaryHTML": "<i>Disclosure on request</i>\n\nIf at the request of an individual, a provider is required under subsection (5) of this section to give a summary of the permitted uses for which refundable deposits and accommodation bonds have been used during the previous financial year, and the provider has given the System Governor an aged care financial report for the previous financial year, which included a permitted uses reconciliation, the provider may satisfy the requirement to give the individual the summary by giving the individual a copy of that permitted uses reconciliation.",
          "extract": "(7)\tIf:\n\t(a)\tas a result of a request by an individual, a registered provider is required under subsection (5) to give the individual the summary referred to in paragraph (2)(a); and\n\t(b)\tthe registered provider has given the System Governor an aged care financial report for the registered provider for the previous financial year, and that report included a permitted uses reconciliation;\nthe registered provider may satisfy the requirement to give the individual the summary by giving the individual a copy of that permitted uses reconciliation.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 328,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-30(8)",
          "section": "Information to be provided—information about a registered provider’s management and use of refundable deposits",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Disclosure after end of financial year for registered provider\n\nWithin 4 months after the end of each financial year, the registered provider must give each individual who has paid a refundable deposit, accommodation bond or entry contribution:\n\n(a) a copy of the refundable deposit record as at the end of the financial year and\n\n(b) a written statement that the provider will provide within 7 days, upon request, the information and documents referred to in subsection (2) of this rule.",
          "summaryHTML": "<i>Disclosure after end of financial year for registered provider</i>\n\nWithin 4 months after the end of each financial year, the registered provider must give each individual who has paid a refundable deposit, accommodation bond or entry contribution:\n\n(a) a copy of the refundable deposit record as at the end of the financial year and\n\n(b) a written statement that the provider will provide within 7 days, upon request, the information and documents referred to in subsection (2) of this rule.",
          "extract": "Disclosure after end of financial year for registered provider\n\n(8) Within 4 months after the end of each financial year for a registered provider, the registered provider must give each individual who has paid a refundable deposit, an accommodation bond or an entry contribution to the registered provider for entry to the approved residential care home operated by the registered provider:\n\n(a) a copy of the refundable deposit record that relates to the individual as at the end of the financial year; and\n\n(b) a written statement that the registered provider will provide, within 7 days of a request by the individual, the information and documents referred to in subsection (2).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 329,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-35(1)-(2)",
          "section": "Information to be provided—to prospective individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—to prospective individuals\n\nThis rule applies to Category 6 - residential care providers who have received, or currently receive, a refundable deposit, accommodation bond, or entry contribution from an individual, wholly or partly as a lump sum (per section 150A-3 of the rules).\n\nWithin 7 days of a request, registered providers must give a prospective individual the information and documents referred to in paragraphs section 155-30(2)(a) to (g) of the rules.",
          "summaryHTML": "<i>Information to be provided—to prospective individuals</i>\n\nThis rule applies to Category 6 - residential care providers who have received, or currently receive, a refundable deposit, accommodation bond, or entry contribution from an individual, wholly or partly as a lump sum (per section 150A-3 of the rules).\n\nWithin 7 days of a request, registered providers must give a prospective individual the information and documents referred to in paragraphs section 155-30(2)(a) to (g) of the rules.",
          "extract": "(1) This section applies to a registered provider if the registered provider is prescribed under section 150A-3 of this instrument. \n\n(2) Within 7 days of a request from a prospective individual, a registered provider must give the prospective individual the information and documents referred to in paragraphs 155-30(2)(a) to (g).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 330,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-36(1)-(2)",
          "section": "Information to be provided—statement of audited accounts",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—statement of audited accounts\n\nWhere section 155-30 does not apply, if requested, Category 6 - residential care providers must still provide individuals within 7 days, with a copy of the most recent statement of the audited accounts or the most recent audited general purpose financial report  within 7 days of request.\n\nRegistered providers are not required to comply with this requirement under section 155-36(1), if they are not required to prepare annual financial reports under the Corporations Act or general purpose financial reports under section 166-345 of the rules.",
          "summaryHTML": "<i>Information to be provided—statement of audited accounts</i>\n\nWhere section 155-30 does not apply, if requested, Category 6 - residential care providers must still provide individuals within 7 days, with a copy of the most recent statement of the audited accounts or the most recent audited general purpose financial report  within 7 days of request.\n\nRegistered providers are not required to comply with this requirement under section 155-36(1), if they are not required to prepare annual financial reports under the Corporations Act or general purpose financial reports under section 166-345 of the rules.",
          "extract": "(1) Subject to subsection (2), if section 155-30 of this instrument does not apply to the registered provider that is registered in the provider registration category residential care, the provider must, if asked by an individual to whom the provider is delivering funded aged care services, give the individual, within 7 days of the request, a copy of either: \n\n(a) the most recent statement of the audited accounts in relation to the registered provider; or \n\n(b) if the registered provider is operated as part of a broader organisation—the most recent statement of the audited accounts of the organisation’s aged care component; or \n\n(c) the most recent audited general purpose financial report prepared under Subdivision E of Division 3 of Part 2 of Chapter 5 of this instrument. \n\n(2) Despite subsection (1) of this section, a registered provider is not required to comply with this requirement if the registered provider:\n\n(a) is not required to prepare annual financial reports under Part 2M.3 of the Chapter 2M of the Corporations Act 2001; and\n\n(b) is not required to prepare a general purpose financial report under section 166-345 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 331,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(1)-(3)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Monthly Statements\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers registered in subscription trial.\n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program\n\nRegistered providers delivering funded services through a service delivery branch in a calendar month must give individuals a written statement relating to the services delivered in that calendar month no later than the last day of the following month.",
          "summaryHTML": "<i>Monthly Statements</i>\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers registered in subscription trial.\n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program\n\nRegistered providers delivering funded services through a service delivery branch in a calendar month must give individuals a written statement relating to the services delivered in that calendar month no later than the last day of the following month.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.\n\n(2) The requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\n(3) A registered provider that delivers funded aged care services to an individual through a service delivery branch in a calendar month must give the individual a written statement relating to the services delivered in that calendar month no later than the last day of the following month.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 332,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(4)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Monthly statement for an individual accessing care through the service group home support\n\nMonthly statements must set out subsidies, opening and closing balances, supplements, rollover credits, and an itemised breakdown of all services, costs, contributions, and subsidies for the calendar month, including adjustments, variations, refunds, and services provided by associated providers. Additional details are required for specific service types, classification types, and pathways, including units or hours delivered, contribution rates, and prices.\n\nFor more information that needs to be included in monthly statements, refer to section 155-40 (4)(a) to (m) of the rules.",
          "summaryHTML": "<i>Monthly statement for an individual accessing care through the service group home support</i>\n\nMonthly statements must set out subsidies, opening and closing balances, supplements, rollover credits, and an itemised breakdown of all services, costs, contributions, and subsidies for the calendar month, including adjustments, variations, refunds, and services provided by associated providers. Additional details are required for specific service types, classification types, and pathways, including units or hours delivered, contribution rates, and prices.\n\nFor more information that needs to be included in monthly statements, refer to section 155-40 (4)(a) to (m) of the rules.",
          "extract": "Monthly statement for an individual accessing care through the service group home support \n\n(4) The monthly statement must contain the following:  \n\n(a) the amount of person-centred subsidy for the individual for the quarter in their ongoing home support account or the amount of person-centred subsidy for the individual for the episode in their short-term home support account; \n\n(b) the amount of person-centred subsidy that was available for the individual in their ongoing or short-term home support account at the beginning of the calendar month; \n\n(c) the amount of person-centred subsidy for the individual remaining in their ongoing or short term home support account at the end of the calendar month; \n\n(d) the name and amount of the primary-centred supplements (if any) for the individual in their ongoing home support account for the quarter and the name and amount of the primary-centred supplements (if any) for the individual in their short-term home support account for the episode;  \n\n(e) rollover credits received in respect of the quarter;    (g) an itemised list of: \n\n(i) each episode of services or items delivered to the individual during the calendar month; and \n\n(ii) any adjustments, variations or refunds from previous calendar months, including the service name and delivery date if relating to a service; \n\n(iii) any adjustments, variations or refunds from previous calendar months, including the service name and delivery date if relating to individual contribution amounts. \n\n(h) for each service or item delivered under the classification type ongoing or the classification type short-term: \n\n(i) the name of the service or item as described in the service list under section 8-5 of this instrument; and \n\n(ii) the price or cost that the registered provider charged the individual in respect of the calendar month; and \n \n(iii) the date on which the service or item was delivered in respect of the calendar month; and \n\n(iv) the contribution amount for the individual in respect of each service or item delivered in the calendar month; and \n\n(v) the total amount of contribution paid by the individual for the calendar month; and \n\n(vi) the amount of subsidy claimed by the registered provider in respect of each service or item delivered in the calendar month; and \n\n(vii) the number of units or hours delivered in respect of the calendar month; and \n\n(viii) where services or items were delivered by an associated provider of the registered provider, the name of that associated provider; \n\n(i) for each service delivered under the classification type ongoing: \n\n(i) identify the individual contribution rate, which must be provided each time there is a change to the contribution rate arising from a new determination made under section 314 of the Act; and \n\n(ii) the corresponding amount for which the individual is responsible to contribute for delivery of that service. \n\n(j) for individuals with the classification type ongoing, information relating to the total number of units or hours delivered for the service type care management delivered in the relevant calendar month; \n\n(k) for individuals with the classification level SAH end-of-life pathway for the classification type short-term, information relating to: \n\n(i) the total number of units or hours delivered for the service type care management; and \n\n(ii) the price and cost of the service and amount of subsidy claimed by the provider in respect of that service; \n\n(l) for individuals with the classification level SAH restorative care pathway for the classification type short-term, information relating to: \n\n(i) the total number of units or hours delivered for the service type restorative care management; and \n\n(ii) the price and cost of the service and amount of subsidy claim by the provider in respect of that service; \n\n(m) for each service taken to be delivered in accordance with subsection 11A(2) of the Act: \n\n(i) the name of the service as provided in the list referred to in subsection 8(1) of the Act; and \n\n(ii) the amount that the registered provider charged the individual for the service; and \n\n(iii) the date on which the service was taken to be delivered; and \n\n(iv) if the registered provider charged an individual contribution for the service, the individual contribution rate used to work out the individual contribution; and \n\n(v) the amount of subsidy claimed by the registered provider for the service.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 333,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(5)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Monthly statement for an individual accessing care through the service groups assistive technology or home modifications\n\nMonthly statements must outline the individual’s person-centred subsidy, opening and closing balances for assistive technology or home modifications accounts (including committed funds and any amounts no longer available), account period end dates, supplements, and additional approved amounts. They must include an itemised list of all items, modifications, services, costs, contributions, subsidies, suppliers, and delivery dates for the month, as well as any adjustments, refunds, or commitments not yet delivered, with full pricing and funding breakdowns.\n\nFor more information on what needs to be included in monthly statements, refer to section 155-40 (5)(a) to (n) of the rules.",
          "summaryHTML": "<i>Monthly statement for an individual accessing care through the service groups assistive technology or home modifications</i>\n\nMonthly statements must outline the individual’s person-centred subsidy, opening and closing balances for assistive technology or home modifications accounts (including committed funds and any amounts no longer available), account period end dates, supplements, and additional approved amounts. They must include an itemised list of all items, modifications, services, costs, contributions, subsidies, suppliers, and delivery dates for the month, as well as any adjustments, refunds, or commitments not yet delivered, with full pricing and funding breakdowns.\n\nFor more information on what needs to be included in monthly statements, refer to section 155-40 (5)(a) to (n) of the rules.",
          "extract": "Monthly statement for an individual accessing care through the service groups assistive technology or home modifications \n\n(5) The monthly statement must contain the following: \n\n(a) the amount of person-centred subsidy for the individual for the account period; \n\n(b) the available balance of the individual’s notional assistive technology or home modifications account (if any) at the beginning of the calendar month; \n\n(c) the available balance of the individual’s notional assistive technology account or home modifications account at the end of the calendar month; \n\n(d) the available balance of the individual’s notional assistive technology account or notional home modifications account after taking into account any committed funds; \n\n(e) any amount of the available balance that is no longer available to the individual due to the ceasing of the individual’s notional assistive technology account or notional home modifications account in respect of the calendar month; \n\n(f) the end date of the account period for the individual’s notional assistive technology account or notional home modifications account in the following calendar month; \n\n(g) the name and amount of primary person-centred supplements (if any) for the individual for the account period; \n\n(h) any additional approved amounts as specified in the determination made under subsection 211-20(5) of this instrument;: \n\n(i) an itemised list of: \n\n(i) assistive technology or home modification items and services (if any), including administration or coordination, delivered to the individual during the calendar month; and \n\n(ii) any adjustments, variations or refunds from previous calendar months; \n\n(j) for each item or service delivered: \n\n(i) the name of the item or service; and \n\n(ii) the price that the registered provider charged the individual for the item or service in respect of the calendar month; and  \n\n(iii) the date on which the item or service was delivered in respect of the calendar month; and \n\n(iv) the amount of contribution (if any) paid by the individual in respect of each item or service delivered in the calendar month; and \n\n(v) the total amount of contribution paid by the individual for the calendar month; and \n\n(vi) the amount of subsidy claimed by the registered provider in respect of each service or item delivered in the calendar month; and \n\n(vii) the rate and number of item units or service hours delivered in respect of the calendar month; and \n\n(viii) if the service or item was delivered by an associated provider of the registered provider or by a third party, that fact;; \n\n(k) any commitments to assistive technology or home modifications made during the calendar month, including those items, modifications or related services which are agreed to with the individual, but which have not yet been delivered within the calendar month; \n\n(l) for each item or service committed to but not yet delivered: \n\n(i) the name and price for each item or service agreed to; and \n\n(ii) the amount of contribution in respect of each item or service that remains to be paid; and \n\n(iii) the total amount of committed funds, including a breakdown of the total amount of subsidy to be claimed and the total amount of contribution to be paid; \n\n(m) any assistive technology or home modification items charged through the assistive technology or home modifications account or through unspent Commonwealth portion; \n\n(n) for each service taken to be delivered in accordance with subsection 11A(2) of the Act: \n\n(i) the name of the service as provided in the service list under section 8-5 of this instrument; and \n\n(ii) the amount that the registered provider charged the individual for the service; and \n\n(iii) the date on which service was taken to be delivered; and \n\n(iv) if the registered provider charged an individual contribution for the service, the individual contribution rate used to work out the individual contribution; and \n\n(v) the amount of subsidy claimed by the registered provider for the service.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 334,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(6)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Unspent portions and notional home care accounts\n\nMonthly statements must contain the available balance for an individual's notional home care account or unspent Commonwealth portion or unspent care recipient portion at the beginning and end of the calendar month.",
          "summaryHTML": "<i>Unspent portions and notional home care accounts</i>\n\nMonthly statements must contain the available balance for an individual's notional home care account or unspent Commonwealth portion or unspent care recipient portion at the beginning and end of the calendar month.",
          "extract": "Unspent portions and notional home care accounts \n\n(6) If an individual has a notional home care account; or the registered provider holds an unspent Commonwealth portion or an unspent care recipient portion for the individual, the monthly statement must contain the following: \n\n(a) the available balance of the individual’s notional home care account at the beginning and end of the calendar month; \n\n(b) the available balance of the individual’s unspent Commonwealth portion at the beginning and end of the calendar month; \n\n (c) the amount of the individual’s unspent care recipient portion at the beginning and end of the calendar month.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 335,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(7)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Monthly statement for established account types\n\nThe monthly statement must only contain information regarding the notional accounts created for the individual.",
          "summaryHTML": "<i>Monthly statement for established account types\n</i>\nThe monthly statement must only contain information regarding the notional accounts created for the individual.",
          "extract": "Monthly statement for established account types \n(7) The monthly statement must only contain information regarding the notional accounts established for the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 336,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(8)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Monthly statement for a period in which no services are delivered\n\nIf no service or item was delivered by registered provider to the individual during the calendar month, a statement must still be provided no later than the last day of the following calendar month.",
          "summaryHTML": "<i>Monthly statement for a period in which no services are delivered</i>\n\nIf no service or item was delivered by registered provider to the individual during the calendar month, a statement must still be provided no later than the last day of the following calendar month.",
          "extract": "Monthly statement for a period in which no services are delivered \n\n(8) If no service or item was delivered by registered provider to the individual during the calendar month, a statement must still be provided no later than the last day of the following calendar month.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 337,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(9)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "When statement must be given\n\nThe monthly statement must be sent by the end of the following month.",
          "summaryHTML": "<i>When statement must be given</i>\n\nThe monthly statement must be sent by the end of the following month.",
          "extract": "When statement must be given\n\n(9) A registered provider must give the statement to the individual no later than the last day of the following calendar month.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 338,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-40(10)",
          "section": "Information to be provided—monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Informing the individual of, and helping the individual to understand, statement\n\nA registered provider must inform the individual of and help the individual to understand the monthly statement.",
          "summaryHTML": "<i>Informing the individual of, and helping the individual to understand, statement</i>\n\nA registered provider must inform the individual of and help the individual to understand the monthly statement.",
          "extract": "Informing the individual of, and helping the individual to understand, statement\n\n(10) A registered provider must inform the individual of and help the individual to understand the monthly statement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 339,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-41",
          "section": "Information to be provided with monthly statement—subscription services",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Registered providers delivering services under the registration category subscription trial must provider a monthly statement to an individual, relating to the funded aged care services delivered to that individual in the month for each subscription services delivered.\n \nThe statement must include infomation on each day that the individual accessed the service, the number of hours on that day the individual accessed the service and whether the subscription service was delivered by an associated provider of the registered provider. It must also include the total number of hours that the individual accessed the service for the month.\nThis statement must be given to the individual at the same time they receive other monthly statements, as prescribed under subsection 155-40(3).",
          "summaryHTML": "Registered providers delivering services under the registration category subscription trial must provider a monthly statement to an individual, relating to the funded aged care services delivered to that individual in the month for each subscription services delivered.\n \nThe statement must include infomation on each day that the individual accessed the service, the number of hours on that day the individual accessed the service and whether the subscription service was delivered by an associated provider of the registered provider. It must also include the total number of hours that the individual accessed the service for the month.\nThis statement must be given to the individual at the same time they receive other monthly statements, as prescribed under subsection 155-40(3).",
          "extract": "(1) This section applies to a registered provider in respect of a calendar month if:\n\n(a) the provider is registered in the provider registration category subscription trial; and\n\n(b) the provider is required under subsection 155 40(3) to give an individual a written statement relating to the funded aged care services delivered to the individual by the provider in the month; and\n\n(c) the services included a subscription service.\n\n(2) The registered provider must give the individual a statement, for each subscription service delivered to the individual in the month, of the use that the individual made of the service in the month, including the following:\n\n(a) each day that the individual accessed the service made available to the individual by the subscription service;\n\n(b) for each day referred to in paragraph (a):\n\n(i) the number of hours on the day that the individual accessed the service made available to the individual by the subscription service; and\n\n(ii) whether the service made available to the individual by the subscription service was delivered by an associated provider of the registered provider;\n\n(c) for the month—the total number of hours that the individual accessed the service made available to the individual by the subscription service.\n\n(3) The registered provider must give the statement under subsection (2) at the same time that the provider gives the statement under subsection 155-40(3).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": false,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": false,
                "tsil": true,
                "hcgr": true,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 340,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-45(1)-(3)",
          "section": "Information to be given—final monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Final monthly statements\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\nIf a registered provider ceases to deliver funded aged care services to the individual, the registered provider must give the individual or their supporter, after the final claim is made for the individual, a final monthly statement.",
          "summaryHTML": "<i>Final monthly statements\n</i>\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\nIf a registered provider ceases to deliver funded aged care services to the individual, the registered provider must give the individual or their supporter, after the final claim is made for the individual, a final monthly statement.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.\n\n(2) The requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\n(3) If a registered provider ceases to deliver funded aged care services to the individual, the registered provider must give the individual or their supporter, after the final claim is made for the individual, a final monthly statement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 341,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-45(4)",
          "section": "Information to be given—final monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "The final monthly statement must be prepared in accordance with subsection 155-40(4) or (5) of the rules.",
          "summaryHTML": "The final monthly statement must be prepared in accordance with subsection 155-40(4) or (5) of the rules.",
          "extract": "(4) The final monthly statement must be prepared in accordance with subsection 155-40(4) or (5).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 342,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-45(6)",
          "section": "Information to be given—final monthly statement",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must give the final monthly statement to the individual or their supporter no later than the last day of the calendar month after the last claim is made.",
          "summaryHTML": "A registered provider must give the final monthly statement to the individual or their supporter no later than the last day of the calendar month after the last claim is made.",
          "extract": "(6) A registered provider must give the final monthly statement to the individual or their supporter no later than the last day of the calendar month after the last claim is made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 343,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(1)-(3)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Individualised budget\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\nA registered provider that delivers funded aged care services to an individual through one or more of the service groups home support, assistive technology and home modifications must give the individual a written individualised budget.",
          "summaryHTML": "<i>Individualised budget</i>\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program.\n\nA registered provider that delivers funded aged care services to an individual through one or more of the service groups home support, assistive technology and home modifications must give the individual a written individualised budget.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.\n\n(2) The requirements of this section do not apply in respect of the delivery of funded aged care services under a specialist aged care program. \n\n(3) A registered provider that delivers funded aged care services to an individual through one or more of the service groups home support, assistive technology and home modifications must give the individual a written individualised budget.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 344,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(4)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "An individualised budget must be prepared in partnership with the individual, cover an agreed period, and reflect their preferences, goals, assessed needs, available resources, and chosen funded aged care services. It must include an itemised budget aligned to the care and services plan, detailing contribution rates, costs, subsidies, and specific breakdowns for assistive technology and home modifications, including descriptions, costs, and related administrative or coordination expenses.\n\nFor more information on what needs to be included in individualised budget, refer to section 155-50(4)(a) to (g) of the rules.",
          "summaryHTML": "An individualised budget must be prepared in partnership with the individual, cover an agreed period, and reflect their preferences, goals, assessed needs, available resources, and chosen funded aged care services. It must include an itemised budget aligned to the care and services plan, detailing contribution rates, costs, subsidies, and specific breakdowns for assistive technology and home modifications, including descriptions, costs, and related administrative or coordination expenses.\n\nFor more information on what needs to be included in individualised budget, refer to section 155-50(4)(a) to (g) of the rules.",
          "extract": "(4) The individualised budget for the individual must: \n\n(a) be prepared in partnership with the individual; and \n\n(b) cover a period agreed with the individual (the budget period); and \n\n(c) be prepared having regard to the individual’s preferences, goals and assessed needs, the resources available and the funded aged care services selected by the individual for the budget period; and \n\n(d) set out an itemised budget for the funded aged care services to be delivered to the individual in the budget period, as set out in the individual’s care and services plan, including, for each service to be delivered to the individual on a day: \n\n(i) if an individual contribution rate determination for the individual is in effect—the individual contribution rate for the service for the individual; and \n\n(ii) if an individual contribution rate determination for the individual is not in effect—the maximum individual contribution rate that could apply to the service for the individual (when determined for each means testing category for the individual under section 314 of the Act); and \n\n(iii) if known—the cost for the delivery of the service; and \n\n(iv) if known—the amount that will be the individual contribution for the delivery of the service to the individual on the day; and \n\n(v) if known—the amount of subsidy for which the provider will be eligible for the delivery of the service to the individual on the day; and \n\n(e) for the service group assistive technology, the itemised budget must also specify the following (if known): \n\n(i) the description and cost for assistive technology products and equipment; \n\n(ii) the description and cost for assistive technology product and equipment repair or maintenance; \n\n(iii) the prescription cost (if applicable) for assistive technology; \n\n(iv) the description and cost of wraparound activities for assistive technology; \n\n(v) administrative costs charged by the registered provider for assistive technology; and \n\n(f) for the service group home modifications, the itemised budget must also specify the following: \n\n(i) the description and cost of home modification supplies and services; \n\n(ii) the prescription cost (if applicable) for home modifications; \n\n(iii) the description and cost of wraparound activities for home modifications; \n\n(iv) coordination costs charged by the registered provider for home modifications; and \n\n(g) if known—set out the amount of subsidy payable to the registered provider for the individual in respect of the period agreed between the individual and the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 345,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(5)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must give the individualised budget to the individual as soon as practicable after the registered provider has all the necessary information to complete it.",
          "summaryHTML": "A registered provider must give the individualised budget to the individual as soon as practicable after the registered provider has all the necessary information to complete it.",
          "extract": "(5) A registered provider must give the individualised budget to the individual as soon as practicable after the registered provider has all the necessary information to complete it.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 346,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(6)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must review and revise the individual's budget if there are any proposed changes to the funded aged care services being provided, there is a change to the costs for delivering those services, the individual contribution rate for the individual changes, or the individual requests the registered provider to do so.",
          "summaryHTML": "A registered provider must review and revise the individual's budget if there are any proposed changes to the funded aged care services being provided, there is a change to the costs for delivering those services, the individual contribution rate for the individual changes, or the individual requests the registered provider to do so.",
          "extract": "(6) A registered provider must review and, if necessary, revise the individualised budget for the individual if: \n\n(a) a change to the funded aged care services mentioned in paragraph (4)(d) is proposed; or \n\n(b) there is a change to the costs for delivering those services; or \n\n(c) the individual contribution rate for the individual changes; or \n\n(d) the individual requests the registered provider to do so.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 347,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(7)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "If a registered provider updates an individual’s budget, they must give the individual the revised version (either as soon as practicable after obtaining all necessary information), for changes to services, costs, or contribution rate, or within 14 days of a request from the individual.",
          "summaryHTML": "If a registered provider updates an individual’s budget, they must give the individual the revised version (either as soon as practicable after obtaining all necessary information), for changes to services, costs, or contribution rate, or within 14 days of a request from the individual.",
          "extract": "(7) If a registered provider reviews and revises the individualised budget for an individual, the registered provider must give the individual a copy of the revised individualised budget: \n\n(a) if the review and revision was for a reason referred to in paragraph (6)(a), (b) or (c)—as soon as practicable after the registered provider has all the necessary information to complete it; or \n\n(b) if the review and revision was in response to a request referred to in paragraph (6)(d)—within 14 days of the request being made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 348,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-50(8)",
          "section": "Information to be provided—individualised budget",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "The registered provider must inform the individual of, and help the individual to understand, the individualised budget for the individual.",
          "summaryHTML": "The registered provider must inform the individual of, and help the individual to understand, the individualised budget for the individual.",
          "extract": "(8) The registered provider must inform the individual of, and help the individual to understand, the individualised budget for the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 349,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-55(1)-(3)",
          "section": "Information to be provided—general information for individuals accessing any funded aged care services",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must give an individual accessing or seeking to access funded services, information about giving complaints and feedback under section 165-20 of the rules, explain the protection of person information under section 168 of the Act, and provide a copy of the Aged Care Code of Conduct.\n\nA registered provider must assist the individual to understand this information and comply with these requirements  before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "summaryHTML": "A registered provider must give an individual accessing or seeking to access funded services, information about giving complaints and feedback under section 165-20 of the rules, explain the protection of person information under section 168 of the Act, and provide a copy of the Aged Care Code of Conduct.\n\nA registered provider must assist the individual to understand this information and comply with these requirements  before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "extract": "(1) For the purposes of subsection 155(1) of the Act, a registered provider must give an individual accessing, or seeking to access, funded aged care services the following: \n\n(a) a copy of the document mentioned in paragraph 165-20(1)(f) of this instrument, relating to giving complaints and feedback;\n\n(b) an explanation of the effect of section 168 of the Act (which deals with the protection of personal information);\n\n(c) a copy of the Aged Care Code of Conduct.\n\n(2) A registered provider must assist the individual to understand the information given under subsection (1) of this section.\n\n(3) A registered provider must comply with subsections (1) and (2) before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 350,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-60(1)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in a home or community setting",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "General information for individuals accessing funded aged care services in a home or community setting\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial.",
          "summaryHTML": "<i>General information for individuals accessing funded aged care services in a home or community setting\n</i>\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 351,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-60(2)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in a home or community setting",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must give an individual accessing, or seeking to access, funded aged care services in a home or community setting information about means testing, service cessation rules, care planning, and monthly statements as required under aged care legislation.\n\nFor more information refer to Ch 4, Part 7, Div 2, section 155-60(2)(a) to (e) of the rules.",
          "summaryHTML": "A registered provider must give an individual accessing, or seeking to access, funded aged care services in a home or community setting information about means testing, service cessation rules, care planning, and monthly statements as required under aged care legislation.\n\nFor more information refer to Ch 4, Part 7, Div 2, section 155-60(2)(a) to (e) of the rules.",
          "extract": "(2) For the purposes of subsection 155(1) of the Act, a registered provider must give an individual accessing, or seeking to access, funded aged care services in a home or community setting the following:\n\n(a) an explanation of the effect of Division 1 of Part 5 of Chapter 4 of the Act and Division 1 of Part 2 of Chapter 10 of this instrument (which deals with means testing in a home or community setting);\n\n(b) information about the circumstances in which the provider may cease delivery of funded aged care services to the individual as specified in subsection 149-35(2) of this instrument, including an explanation of the effect of section 149-40 (which deals with notice requirements applicable to the provider);\n\n(c) an explanation of the effect of subsection 148-80(1) of this instrument (which deals with the development of a care and services plan for the individual);\n\n(d) information that the provider will give the individual a monthly statement in accordance with sections 155-40 and 155-45 of this instrument;\n\n(e) for individuals accessing funded aged care services through the service group home support, other than under a specialist aged care program, a copy of the most recent version of the Support at Home Service List published by the Department.\n\nNote: The Support at Home Service List could in 2026 be viewed on the Department’s website (https://www.health.gov.au).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 352,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-60(3)-(4)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in a home or community setting",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must provide the information required under subsection (2) and assist the individual to understand the information before or when commencing service delivery.",
          "summaryHTML": "A registered provider must provide the information required under subsection (2) and assist the individual to understand the information before or when commencing service delivery.",
          "extract": "(3) A registered provider must assist the individual to understand the information given under subsection (2) of this section.\n\n(4) A registered provider must comply with subsections (2) and (3) before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 353,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-60(5)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in a home or community setting",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Registered providers delivering services funded under a specialist aged care program are not required to provide information on means testing or monthly statements as described under section 155-60(5), subsections (2)(a) and (2)(d).",
          "summaryHTML": "Registered providers delivering services funded under a specialist aged care program are not required to provide information on means testing or monthly statements as described under section 155-60(5), subsections (2)(a) and (2)(d).",
          "extract": "(5) Despite subsection (2) of this section, the requirements of paragraphs (2)(a) and (2)(d) of this section do not apply in respect of the delivery of funded aged care services delivered under any specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 354,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-65(1)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—general information for individuals accessing funded aged care services in an approved residential care home\n\nThis section applies to registered providers in registration Category 6 - residential care.",
          "summaryHTML": "<i>Information to be provided—general information for individuals accessing funded aged care services in an approved residential care home</i>\n\nThis section applies to registered providers in registration Category 6 - residential care.",
          "extract": "(1) This section applies to a registered provider registered in the provider registration category residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 355,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-65(2)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must give an individual accessing or seeking to access funded services in an approved residential home: \n\n(a) information about the circumstances in which they may be asked to leave, as specified in s 149-60(1) and\n\n(b) information about any policies or protocols for the home that are relevant to the individual.",
          "summaryHTML": "A registered provider must give an individual accessing or seeking to access funded services in an approved residential home: \n\n(a) information about the circumstances in which they may be asked to leave, as specified in s 149-60(1) and\n\n(b) information about any policies or protocols for the home that are relevant to the individual.",
          "extract": "(2) For the purposes of subsection 155(1) of the Act, a registered provider must give an individual accessing or seeking to access funded aged care services in an approved residential care home the following:\n\n(a) information about the circumstances in which the individual may be asked to leave the approved residential care home as specified in subsection 149-60(1) of this instrument, including an explanation of the effect of section 149-65 (which deals with notice requirements applicable to the provider);\n\n(b) information about any policies or protocols of the approved residential care home that are relevant to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 356,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-65(3)-(4)",
          "section": "Information to be provided—general information for individuals accessing funded aged care services in an approved residential care home",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must provide the required information and assist the individual to understand it before or when commencing service delivery in a home or community setting.",
          "summaryHTML": "A registered provider must provide the required information and assist the individual to understand it before or when commencing service delivery in a home or community setting.",
          "extract": "(3) A registered provider must assist the individual to understand the information given under subsection (2) of this section.\n\n(4) A registered provider must comply with subsections (2) and (3) before, or when, the registered provider commences delivery of funded aged care services to that individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 357,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-70(1)-(2)",
          "section": "Information to be provided—information about the financial position of a registered provider registered in a provider registration category other than residential care",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Information to be provided—information about the financial position of a registered provider registered in a provider registration category other than residential care\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThis section does not apply to registered providers which are government entities.",
          "summaryHTML": "<i>Information to be provided—information about the financial position of a registered provider registered in a provider registration category other than residential care</i>\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThis requirement is also prescribed for providers in registration category subscription trial. \n\nThis section does not apply to registered providers which are government entities.",
          "extract": "(1) Subject to subsection (2), this section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care;\n\n(f) subscription trial.\n\n(2) This section does not apply to registered providers of services in the registration categories listed in subsection (1) which are government entities.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 358,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-70(3)",
          "section": "Information to be provided—information about the financial position of a registered provider registered in a provider registration category other than residential care",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Before or when a registered provider starts delivering funded aged care services, they must inform the individual in writing that they will provide a clear and simple presentation of financial and other specified documents within 7 days if the individual requests them. This includes an overview of the provider's financial position and a copy of the latest audited financial accounts of the service branch, or the accounts of the organisation's aged care component, if the service delivery branch is operated as part of a broader organisation.",
          "summaryHTML": "Before or when a registered provider starts delivering funded aged care services, they must inform the individual in writing that they will provide a clear and simple presentation of financial and other specified documents within 7 days if the individual requests them. This includes an overview of the provider's financial position and a copy of the latest audited financial accounts of the service branch, or the accounts of the organisation's aged care component, if the service delivery branch is operated as part of a broader organisation.",
          "extract": "(3) For the purposes of subsection 155(1) of the Act, before or when, a registered provider starts delivering funded aged care services to an individual, the registered provider must notify the individual, in writing, that the registered provider will give the individual, within 7 days of a request by the individual, the following information and documents:\n\n(a) a clear and simple presentation of the financial position of the registered provider;\n\n(b) a copy of the most recent statement of the audited accounts of the service delivery branch or, if the service delivery branch is operated as part of a broader organisation, the most recent statement of the audited accounts of the organisation’s aged care component (that includes the service delivery branch).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 359,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-70(4)-(5)",
          "section": "Information to be provided—information about the financial position of a registered provider registered in a provider registration category other than residential care",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "The registered provider must give the individual the information and documents requested within 7 days after receiving the request.\n\nIf a registered provider is not required to prepare annual financial reports under Part 2M.3 of Chapter 2M of the Corporations Act 2001, then they are not required to provide the information listed in paragraph (3)(b).",
          "summaryHTML": "The registered provider must give the individual the information and documents requested within 7 days after receiving the request.\n\nIf a registered provider is not required to prepare annual financial reports under Part 2M.3 of Chapter 2M of <i>the Corporations Act 2001</i>, then they are not required to provide the information listed in paragraph (3)(b).",
          "extract": "(4) If an individual requests the registered provider to give the individual the information and documents referred to in subsection (3), the registered provider must give the individual the information and documents requested within 7 days after receiving the request. \n\n(5) A registered provider that is not required to prepare annual financial reports under Part 2M.3 of Chapter 2M of the Corporations Act 2001 is not required to comply with paragraph (3)(b) of this section.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 360,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-80(1)",
          "section": "Information to be provided-pricing information (by way of publication)",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Pricing information (by way of publication)\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "summaryHTML": "<i>Pricing information (by way of publication)</i>\n\nThis section applies to registered providers registered in any of the following:\n\nCategory 1 - home and community services,\nCategory 2 - assistive technology and home modifications,\nCategory 3 - advisory and support services,\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "extract": "(1) This section applies to a registered provider registered in any of the following provider registration categories:\n\n(a) home and community services;\n\n(b) assistive technology and home modifications;\n\n(c) advisory and support services;\n\n(d) personal and care support in the home or community;\n\n(e) nursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 361,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-80(2)-(7)",
          "section": "Information to be provided -pricing information (by way of publication)",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Service group home support\n\nA registered provider delivering funded services through the service group home support must publish on their website the most common price they charge for each service, for the service types listed in subsections (2)(a)-(e). The exception is where a provider does not deliver a particular service and has not done so for 12 months. This requirement does not apply to a registered provider delivering funded services under a specialist aged care program.\n\nThe website must be kept up to date where the most common price changes. Subsection (4) explains the meaning of most common price.\n\nThis pricing information must specify the most common price for service delivery during standard business hours, on weekdays outside standard business hours and on Saturdays, Sundays and public holidays.",
          "summaryHTML": "<i>Service group home support\n</i>\nA registered provider delivering funded services through the service group home support must publish on their website the most common price they charge for each service, for the service types listed in subsections (2)(a)-(e). The exception is where a provider does not deliver a particular service and has not done so for 12 months. This requirement does not apply to a registered provider delivering funded services under a specialist aged care program.\n\nThe website must be kept up to date where the most common price changes. Subsection (4) explains the meaning of most common price.\n\nThis pricing information must specify the most common price for service delivery during standard business hours, on weekdays outside standard business hours and on Saturdays, Sundays and public holidays.",
          "extract": "Service group home support\n\n(2) A registered provider delivering funded aged care services through the service group home support must publish on the registered provider’s website the most common price that the registered provider charges individuals for each service in the following service types:\n\n(a) allied health and therapy;\n\n(b) care management;\n\n(c) domestic assistance;\n\n(d) home maintenance and repairs;\n\n(e) home or community general respite;\n\n(f) meals;\n\n(g) nursing care;\n\n(h) personal care;\n\n(i) restorative care management;\n\n(j) social support and community engagement;\n\n(k) therapeutic service for independent living;\n\n(l) transport.\n\n(3) The pricing information published for the purposes of subsection (2) of this section must:\n\n(a) specify the most common price for delivery of the service during standard business hours; and \n\n(b) specify the most common price for delivery of the service on weekdays outside standard business hours; and \n\n(c) specify the most common price for delivery of the service on Saturdays; and \n\n(d) specify the most common price for delivery of the service on Sundays; and \n\n(e) specify the most common price for delivery of the service on public holidays. \n\n(4) In this section:\n\nmost common price means the price for a service that the registered provider has most frequently charged during the previous 2 calendar months, calculated at the end of the following:\n\n(a) August;\n\n(b) October;\n\n(c) December;\n\n(d) February;\n\n(e) April;\n\n(f) June.\n\n(5) A registered provider must update the pricing information on the registered provider’s website for a service where the most common price for the service changes, within 30 days of the end of the calculation period mentioned in subsection (4).\n\n(6) A registered provider is not required to publish a price for a service under subsection (2) if the registered provider is not currently delivering the service and has not delivered the service in the last 12 months.\n\n(7) The requirements of this section do not apply to a registered provider in respect of the delivery of funded aged care services under a specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 362,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-80(8)-(9)",
          "section": "Information to be provided -pricing information (by way of publication)",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Service group assistive technology\n\nA registered provider in Category 2 - assistive technology and home modifications, delivering funded services through the service group assistive technology, must publish on their website whether they charge a provider administration fee for the provision of funded aged care and if so, the amount this fee represents as a percentage of the price for service provision.\n\nA registered provider must update the pricing information on its website where the information published changes, within 30 days of the change.",
          "summaryHTML": "<i>Service group assistive technology</i>\n\nA registered provider in Category 2 - assistive technology and home modifications, delivering funded services through the service group assistive technology, must publish on their website whether they charge a provider administration fee for the provision of funded aged care and if so, the amount this fee represents as a percentage of the price for service provision.\n\nA registered provider must update the pricing information on its website where the information published changes, within 30 days of the change.",
          "extract": "Service group assistive technology\n\n(8) A registered provider registered in the provider registration category assistive technology and home modifications delivering funded aged care services through the service group assistive technology must publish on the registered provider’s website:\n\n(a) whether the registered provider charges a provider administration fee for the provision of funded aged care services; and\n\n(b) if the registered provider charges a provider administration fee, the amount of the provider administration fee as a percentage of the price for the provision of services.\n\n(9) A registered provider must update the pricing information on the registered provider's website where the information published under subsection (8) changes, within 30 days of the change.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        },
        {
          "id": 363,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-80(10)-(11)",
          "section": "Information to be provided -pricing information (by way of publication)",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Service group home modifications\n\nA registered provider in Category 2 - assistive technology and home modifications, delivering funded services through the service group home modifications, must publish on their website whether they charge a provider coordination fee  for the provision of funded aged care and if so, the amount this fee represents as a percentage of the price for service provision.\n\nA registered provider must update the pricing information on its website where the information published changes, within 30 days of the change.",
          "summaryHTML": "<i>Service group home modifications</i>\n\nA registered provider in Category 2 - assistive technology and home modifications, delivering funded services through the service group home modifications, must publish on their website whether they charge a provider coordination fee  for the provision of funded aged care and if so, the amount this fee represents as a percentage of the price for service provision.\n\nA registered provider must update the pricing information on its website where the information published changes, within 30 days of the change.",
          "extract": "Service group home modifications\n\n(10) A registered provider registered in the provider registration category assistive technology and home modifications delivering funded aged care services through the service group home modifications must publish on the registered provider’s website:\n\n(a) whether the registered provider charges a provider coordination fee for the provision of funded aged care; and\n\n(b) if the registered provider charges a provider coordination fee, the amount of the provider coordination fee as a percentage of the price for the provision of services.\n\n(11) A registered provider must update the pricing information on its website where the information published under subsection (10) of this section changes, within 30 days of the change.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(1)"
        }
      ]
    },
    {
      "id": 22,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s155(2)",
      "section": "Provision of information to individual",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Provision of information to individuals",
      "topic": [
        "agreements",
        "unspecified"
      ],
      "summary": "Registered providers of a kind must allow and facilitate individuals receiving care from that provider to access records and information about the individual, in accordance with the rules.",
      "summaryHTML": "Registered providers of a kind must allow and facilitate individuals receiving care from that provider to access records and information about the individual, in accordance with the rules.",
      "extract": "(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) allow and facilitate access by an individual to whom the registered provider delivers funded aged care services to records and information (including personal information) held by the registered provider about the individual; and \n\n(b) do so in accordance with any requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631490",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": true,
          "subcategories": {
            "ep": true,
            "ha": true
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 364,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 2, s155-85(1)-(2)",
          "section": "Requirements for allowing and facilitating access to information held about an individual",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Provision of information to individuals",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Requirements for allowing and facilitating access to information held about an individual\n\nFor the purposes of s 155(2) of the Act, a registered provider that is not an APP entity according to the Privacy Act 1988, a State or Territory, or a body established for a public purpose under a State or Territory law (other than a local government authority) is prescribed.\n\nThe provider must comply with Australian Privacy Principle 12, as if it were an organisation for the purposes of the Privacy Act, when facilitating access by an individual to records and information held by the provider about the individual.\n\nNote: A registered provider that is an APP entity remains subject to the Privacy Act 1988, including APP 12.",
          "summaryHTML": "<i>Requirements for allowing and facilitating access to information held about an individual\n</i>\nFor the purposes of s 155(2) of the Act, a registered provider that is not an APP entity according to the<i> Privacy Act 1988</i>, a State or Territory, or a body established for a public purpose under a State or Territory law (other than a local government authority) is prescribed.\n\nThe provider must comply with Australian Privacy Principle 12, as if it were an organisation for the purposes of the<i> Privacy Act</i>, when facilitating access by an individual to records and information held by the provider about the individual.\n\nNote: A registered provider that is an APP entity remains subject to the<i> Privacy Act 1988</i>, including APP 12.",
          "extract": "(1) For the purposes of subsection 155(2) of the Act, a registered provider that is not any of the following is prescribed:\n\n(a) an APP entity within the meaning of the Privacy Act 1988;\n\n(b) a State or Territory;\n\n(c) a body established for a public purpose by or under a law of the State or Territory (other than a local government authority).\n\n(2) For the purposes of paragraph 155(2)(b) of the Act, it is a requirement when a registered provider is allowing and facilitating access by an individual to whom the registered provider delivers funded aged care services to records and information (including personal information) held by the registered provider about the individual, that the registered provider must comply with Australian Privacy Principle 12 as set out in Schedule 1 of the Privacy Act 1988, as if it were an organisation for the purposes of that Act. \n\nNote: A registered provider that is an APP entity remains subject to the Privacy Act 1988, including APP 12.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s155(2)"
        }
      ]
    },
    {
      "id": 23,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s156(1)",
      "section": "Access by supporters and independent aged care advocates etc.",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Access by supporters and independent aged care advocates etc.",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "All registered providers must allow and facilitate access to an individual receiving aged care services including a supporter of the individual, a qualified person providing legal advice to the individual, an independent aged care advocate, or a visitor to the individual, in accordance with any requirements prescribed by the rules.",
      "summaryHTML": "All registered providers must allow and facilitate access to an individual receiving aged care services including a supporter of the individual, a qualified person providing legal advice to the individual, an independent aged care advocate, or a visitor to the individual, in accordance with any requirements prescribed by the rules.",
      "extract": "Access to individuals\n\n(1) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) allow and facilitate access by the following persons to an individual to whom the provider delivers funded aged care services: \n\n(i) a supporter of the individual; \n\n(ii) a relevantly qualified person providing legal advice or another legal service to the individual; \n\n(iii)\tan independent aged care advocate; \n\n(iv) an aged care volunteer visitor; and \n\n(b) do so in accordance with any requirements prescribed by the rules. \n\nNote: For example, the rules might prescribe a requirement for a provider delivering services in a residential care home to allow a supporter of an individual access (whether physically, by video link or other means) to the individual at any time.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631491",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 365,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-5(1)",
          "section": "Access to individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 156(1) all registered providers are prescribed.",
          "summaryHTML": "For section 156(1) all registered providers are prescribed.",
          "extract": "For the purposes of subsection 156(1) of the Act, every kind of registered provider is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(1)"
        },
        {
          "id": 366,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-5(2)",
          "section": "Access to individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Supporters\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by a supporter of an individual to whom the provider delivers funded aged care services to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "summaryHTML": "<i>Supporters\n</i>\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by a supporter of an individual to whom the provider delivers funded aged care services to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "extract": "Supporters\n\n(2) For the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by a supporter of an individual to whom the provider delivers funded aged care services to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(1)"
        },
        {
          "id": 367,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-5(3)",
          "section": "Access to individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Legal advisors\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) to an individual to whom the provider delivers funded aged care services by a relevantly qualified person providing legal advice or another legal service to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "summaryHTML": "<i>Legal advisors</i>\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) to an individual to whom the provider delivers funded aged care services by a relevantly qualified person providing legal advice or another legal service to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "extract": "Legal advisors etc.\n\n(3) For the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) to an individual to whom the provider delivers funded aged care services by a relevantly qualified person providing legal advice or another legal service to the individual at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(1)"
        },
        {
          "id": 368,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-5(4)",
          "section": "Access to individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Independent aged care advocates\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an independent aged care advocate to an individual to whom the provider delivers funded aged care services:\n\n(a) at any time requested, or consented to, by the individual; or\n\n(b) if the individual is unable to request or consent to the access—at any time.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "summaryHTML": "<i>Independent aged care advocates</i>\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an independent aged care advocate to an individual to whom the provider delivers funded aged care services:\n\n(a) at any time requested, or consented to, by the individual; or\n\n(b) if the individual is unable to request or consent to the access—at any time.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "extract": "Independent aged care advocates\n\n(4) For the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an independent aged care advocate to an individual to whom the provider delivers funded aged care services:\n\n(a) unless paragraph (b) applies—at any time requested, or consented to, by the individual; or\n\n(b) if the individual is unable to request or consent to the access—at any time.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(1)"
        },
        {
          "id": 369,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-5(5)",
          "section": "Access to individuals",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Aged care volunteer visitor\n\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an aged care volunteer visitor to an individual to whom the provider delivers funded aged care services at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "summaryHTML": "<i>Aged care volunteer visitor\n</i>\nFor the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an aged care volunteer visitor to an individual to whom the provider delivers funded aged care services at any time requested, or consented to, by the individual.\n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "extract": "Aged care volunteer visitor\n\n(5) For the purposes of subsection 156(1) of the Act, it is a requirement that a registered provider must allow and facilitate access (whether physically, by visual link or other reasonable means requested by the individual) by an aged care volunteer visitor to an individual to whom the provider delivers funded aged care services at any time requested, or consented to, by the individual. \n\nNote: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(1)"
        }
      ]
    },
    {
      "id": 24,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s156(2)",
      "section": "Access by supporters and independent aged care advocates etc.",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Access by supporters and independent aged care advocates etc.",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers of a kind must allow and facilitate independent aged care advocates to access a setting in which the provider delivers funded aged care services, in accordance with any requirements prescribed by the rules.",
      "summaryHTML": "Registered providers of a kind must allow and facilitate independent aged care advocates to access a setting in which the provider delivers funded aged care services, in accordance with any requirements prescribed by the rules.",
      "extract": "Access to settings\n\n(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) allow and facilitate access by independent aged care advocates to a setting in which the provider delivers funded aged care services; and \n\n(b) do so in accordance with any requirements prescribed by the rules. \n\nNote: For example, the rules might prescribe a requirement for a registered provider delivering funded aged care services in a residential care home to allow independent aged care advocates access to the home to educate individuals accessing funded aged care services in the home about their rights and the availability of their advocacy services.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631491",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 370,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-10(1)",
          "section": "Access to settings",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Access to settings\n\nFor the purposes of subsection 156(2) of the Act all registered providers are prescribed.\n\nIt is a prescribed requirement that, if a registered provider delivers funded aged care services to an individual in a setting; and the individual requests, or consents to, access by an independent aged care advocate; and the purpose of the access by the advocate is to provide information and education to the individual; the registered provider must allow and facilitate the access to the individual, and any other individual who requests or consents to the access, in the setting.\n\nNote 1: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.\n\nNote 2: See also subsections 156(6) and (7) of the Act, which relate to access to settings.",
          "summaryHTML": "<i>Access to settings</i>\n\nFor the purposes of subsection 156(2) of the Act all registered providers are prescribed.\n\nIt is a prescribed requirement that, if a registered provider delivers funded aged care services to an individual in a setting; and the individual requests, or consents to, access by an independent aged care advocate; and the purpose of the access by the advocate is to provide information and education to the individual; the registered provider must allow and facilitate the access to the individual, and any other individual who requests or consents to the access, in the setting.\n\nNote 1: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.\n\nNote 2: See also subsections 156(6) and (7) of the Act, which relate to access to settings.",
          "extract": "(1) For the purposes of subsection 156(2) of the Act:\n\n(a) every kind of registered provider is prescribed; and\n\n(b) it is a prescribed requirement that, if: \n\n(i) a registered provider delivers funded aged care services to an individual in a setting; and \n\n(ii) the individual requests, or consents to, access by an independent aged care advocate; and \n\n(iii) the purpose of the access by the advocate is to provide information and education to the individual; \nthe registered provider must allow and facilitate the access to the individual, and any other individual who requests or consents to the access, in the setting.\n\nNote 1: See also subsection 156(4) of the Act, which relates to providers delivering services to an individual in a home or community setting, and access requirements only applying in relation to times during which those services are being delivered.\n\nNote 2: See also subsections 156(6) and (7) of the Act, which relate to access to settings.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(2)"
        },
        {
          "id": 371,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 7, Div 3, s156-10(2)",
          "section": "Access to settings",
          "requirement": "Conditions of Registration",
          "subdivision": "Information and access",
          "sublevel": "Access by supporters and independent aged care advocates etc.",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Without limiting paragraph (1)(b), a setting may include the following:\n\n(a) a residential care home;\n\n(b) a home or community setting.",
          "summaryHTML": "Without limiting paragraph (1)(b), a setting may include the following:\n\n(a) a residential care home;\n\n(b) a home or community setting.",
          "extract": "(2) Without limiting paragraph (1)(b), a setting may include the following:\n\n(a) a residential care home;\n\n(b) a home or community setting.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s156(2)"
        }
      ]
    },
    {
      "id": 25,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s156(3)",
      "section": "Access by supporters and independent aged care advocates etc.",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Access by supporters and independent aged care advocates etc.",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Registered providers must allow and facilitate independent aged care advocates to access records and information held by the provider about an individual who is receiving care by the provider, if the individual has the right to access the records and information and consents to the advocate accessing them to provide advocacy. The provider must do this in accordance with section 168 of the Act and the rules. \n\nIf the registered provider delivers services to an individual in a home or community setting, section 156(1)(a) and section 156(2)(a) only applies in relation to the times during which the provider delivers those services. \n\nThe rules may prescribe different requirements for different kinds of registered providers or settings, without limiting section 156(1)(b), 156(2)(b), or 156(3)(b).",
      "summaryHTML": "Registered providers must allow and facilitate independent aged care advocates to access records and information held by the provider about an individual who is receiving care by the provider, if the individual has the right to access the records and information and consents to the advocate accessing them to provide advocacy. The provider must do this in accordance with section 168 of the Act and the rules. \n\nIf the registered provider delivers services to an individual in a home or community setting, section 156(1)(a) and section 156(2)(a) only applies in relation to the times during which the provider delivers those services. \n\nThe rules may prescribe different requirements for different kinds of registered providers or settings, without limiting section 156(1)(b), 156(2)(b), or 156(3)(b).",
      "extract": "Access to records\n\n(3) It is a condition of registration that a registered provider must: \n\n(a) allow and facilitate access by an independent aged care advocate to records and information (including personal information) held by the registered provider about an individual to whom: \n\n(i) the registered provider delivers funded aged care services; and \n\n(ii) the independent aged care advocate provides advocacy; if the individual has the right to access the records and information and consents to the independent aged care advocate being given access to the records and information; and \n\n(b) do so in accordance with the requirements in section 168 and any requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631491",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 26,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s156(4)",
      "section": "Access by supporters and independent aged care advocates etc.",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Access by supporters and independent aged care advocates etc.",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The requirement to allow and facilitate access to an individual or their home/community setting applies only during the times when the provider is delivering services.",
      "summaryHTML": "The requirement to allow and facilitate access to an individual or their home/community setting applies only during the times when the provider is delivering services.",
      "extract": "Additional matters\n\n(4) For the purposes of paragraphs (1)(a) and (2)(a), if the services are delivered to an individual in a home or community setting, the requirement to allow and facilitate access to the individual or setting (as applicable) only applies in relation to the times during which the provider delivers those services. \n\nNote: For example, the rules might prescribe a requirement for a provider delivering services in a home or community setting to allow an independent aged care advocate to, with the consent of an individual, be present (whether physically, by video link or other means) when services are delivered to the individual.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631491",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 27,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div F, s156(5)",
      "section": "Access by supporters and independent aged care advocates etc.",
      "requirement": "Conditions of Registration",
      "subdivision": "Information and access",
      "sublevel": "Access by supporters and independent aged care advocates etc.",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules may establish varying requirements for different types of registered providers or for different kinds of settings.",
      "summaryHTML": "The rules may establish varying requirements for different types of registered providers or for different kinds of settings.",
      "extract": "(5) Without limiting paragraph (1)(b), (2)(b) or (3)(b), the rules may: \n\n(a) prescribe different requirements for different kinds of registered providers; or \n\n(b) different requirements for different kinds of settings.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631491",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 28,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s157(1)-(2)",
      "section": "Membership of governing bodies",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Membership of governing bodies",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "Registered providers of a kind must ensure that a majority of members of the provider's governing body are independent nonexecutive members and at least one member of the governing body has experience in the provision of clinical care.",
      "summaryHTML": "Registered providers of a kind must ensure that a majority of members of the provider's governing body are independent nonexecutive members and at least one member of the governing body has experience in the provision of clinical care.",
      "extract": "(1) Subsection (2) applies to a registered provider other than a registered provider that is:\n\n(a) a government entity; or\n\n(b) a local government authority.\n\n(2) Subject to subsections (3) and (4), it is a condition of registration that a registered provider must ensure that: \n\n(a) if the provider is a registered provider of a kind prescribed by the rules—a majority of the members of the governing body of the provider are independent nonexecutive members; and \n\n(b) if the provider is a registered provider of a kind prescribed by the rules—at least one member of the governing body of the provider has experience in the provision of clinical care.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631493",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 374,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 1, s157-5(1)-(2)",
          "section": "Kinds of provider to which the independent non-executive members requirement applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Membership of governing bodies",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "This rule is only relevant to subsection (a) of section 157(2).\n\nSection 157(2)(a), Kinds of provider to which the independent non-executive members requirement applies to providers that are in registration Category 5 - nursing and transition care and Category 6 - residential care, unless the provider is:\n- an Aboriginal Community Controlled Organisation\n- or the Co-operatives Act 2009 (WA) as a registered co-operative and has clauses in its rules to the effect that:\n\n(i) an objective or primary activity of the registered provider is delivering quality funded aged care services to individuals in accordance with the Aged Care Quality Standards; and\n\n(ii) distribution of assets to members upon winding-up are limited to the nominal value of the member’s contribution to the co-operative, provided that such a limitation complies with the legislation under which the co-operative is registered.",
          "summaryHTML": "This rule is only relevant to subsection (a) of section 157(2).\n\nSection 157(2)(a), <i>Kinds of provider to which the independent non-executive members requirement</i> applies to providers that are in registration Category 5 - nursing and transition care and Category 6 - residential care, unless the provider is:\n- an Aboriginal Community Controlled Organisation\n- or the Co-operatives Act 2009 (WA) as a registered co-operative and has clauses in its rules to the effect that:\n\n(i) an objective or primary activity of the registered provider is delivering quality funded aged care services to individuals in accordance with the Aged Care Quality Standards; and\n\n(ii) distribution of assets to members upon winding-up are limited to the nominal value of the member’s contribution to the co-operative, provided that such a limitation complies with the legislation under which the co-operative is registered.",
          "extract": "(1) For the purposes of paragraph 157(2)(a) of the Act, a registered provider registered in any of the following provider registration categories is prescribed, unless the provider is covered by subsection (2):\n\n(a) nursing and transition care;\n\n(b) residential care.\n\n(2) This subsection covers a registered provider that is:\n\n(a) a kind of body known as an Aboriginal Community Controlled Organisation; or\n\n(b) a body that is registered under the Co-operatives National Law or the Co-operatives Act 2009 (WA) as a registered co-operative and has clauses in its rules to the effect that:\n\n(i) an objective or primary activity of the registered provider is delivering quality funded aged care services to individuals in accordance with the Aged Care Quality Standards; and\n\n(ii) distribution of assets to members upon winding-up are limited to the nominal value of the member’s contribution to the co-operative, provided that such a limitation complies with the legislation under which the co-operative is registered.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s157(1)-(2)"
        },
        {
          "id": 372,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 1, s157-10",
          "section": "Kinds of provider to which the clinical care provision experience requirement applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Membership of governing bodies",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Kinds of provider to which the clinical care provision experience requirement applies\n\nFor the purposes of paragraph 157(2)(b) of the Act, a registered provider is prescribed if the provider:\n\n(a) is registered in any of the following provider registration categories:\n\n(i) nursing and transition care;\n\n(ii) residential care; and\n\n(b) is not a kind of body known as an Aboriginal Community Controlled Organisation.",
          "summaryHTML": "<i>Kinds of provider to which the clinical care provision experience requirement applies</i>\n\nFor the purposes of paragraph 157(2)(b) of the Act, a registered provider is prescribed if the provider:\n\n(a) is registered in any of the following provider registration categories:\n\n(i) nursing and transition care;\n\n(ii) residential care; and\n\n(b) is not a kind of body known as an Aboriginal Community Controlled Organisation.",
          "extract": "For the purposes of paragraph 157(2)(b) of the Act, a registered provider is prescribed if the provider:\n\n(a) is registered in any of the following provider registration categories:\n\n(i) nursing and transition care;\n\n(ii) residential care; and\n\n(b) is not a kind of body known as an Aboriginal Community Controlled Organisation.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s157(1)-(2)"
        }
      ]
    },
    {
      "id": 29,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s157(3)",
      "section": "Membership of governing bodies",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Membership of governing bodies",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "The requirements in Subsection (2) do not apply to a registered provider at a certain time if the governing body has fewer than 5 members and the provider serves fewer than 40 individuals receiving funded aged care services.",
      "summaryHTML": "The requirements in Subsection (2) do not apply to a registered provider at a certain time if the governing body has fewer than 5 members and the provider serves fewer than 40 individuals receiving funded aged care services.",
      "extract": "(3) Subsection (2) does not apply in relation to a registered provider at a particular time if both of the following apply at that time: \n\n(a) the governing body of the provider has fewer than 5 members; \n\n(b) the provider delivers funded aged care services to fewer than 40 individuals.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631493",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 30,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s157(4)",
      "section": "Membership of governing bodies",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Membership of governing bodies",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "The requirements in paragraph (2)(a) or (b) do not apply if there is a decision in place under section 159 stating that these requirements do not apply to that provider.",
      "summaryHTML": "The requirements in paragraph (2)(a) or (b) do not apply if there is a decision in place under section 159 stating that these requirements do not apply to that provider.",
      "extract": "(4) Paragraph (2)(a) or (b) does not apply in relation to a registered provider at a particular time if a determination under section 159 that the requirement set out in that paragraph does not apply in relation to the provider is in force at that time.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631493",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 31,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s157(5)",
      "section": "Membership of governing bodies",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Membership of governing bodies",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "Kinds of providers to which other governing body requirements apply\n\nRegistered providers of a kind must comply with any rules relating to membership of governing bodies. \n\nFor section 157(5) providers that are in Category 5 - nursing and transition care and Category 6 - residential care and are not a Aboriginal Community Controlled Organisation are prescribed.",
      "summaryHTML": "<i>Kinds of providers to which other governing body requirements apply\n</i>\nRegistered providers of a kind must comply with any rules relating to membership of governing bodies. \n\nFor section 157(5) providers that are in Category 5 - nursing and transition care and Category 6 - residential care and are not a Aboriginal Community Controlled Organisation are prescribed.",
      "extract": "(5) It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with any requirements relating to membership of governing bodies prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631493",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": false,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": false,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 373,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 1, s157-15",
          "section": "Kinds of providers to which other governing body requirements apply",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Membership of governing bodies",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "Kinds of providers to which other governing body requirements apply\n\nFor section 157(5) providers that are in registration Category 5 - nursing and transition care and Category 6 - residential care and are not a Aboriginal Community Controlled Organisation are prescribed.\n\nA registered provider must ensure that the members of its governing body complete governance training focused on cooperatives or include course material on cooperatives within six months of their appointment to the governing body.",
          "summaryHTML": "<i>Kinds of providers to which other governing body requirements apply\n</i>\nFor section 157(5) providers that are in registration Category 5 - nursing and transition care and Category 6 - residential care and are not a Aboriginal Community Controlled Organisation are prescribed.\n\nA registered provider must ensure that the members of its governing body complete governance training focused on cooperatives or include course material on cooperatives within six months of their appointment to the governing body.",
          "extract": "For the purposes of subsection 157(5) of the Act, a registered provider that is covered by paragraph 157-5(2)(b) of this instrument must ensure that the members of the provider’s governing body undertake training on governance focused on co-operatives or includes course material on co-operatives within 6 months of the member’s appointment as a member of the governing body.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": false,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": false,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s157(5)"
        }
      ]
    },
    {
      "id": 32,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s158(2)",
      "section": "Advisory body requirements",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Advisory body requirements",
      "topic": [
        "governance",
        "reporting"
      ],
      "summary": "Registered providers in registration Category 5 - nursing and transition care and Category 6 - residential care must establish and continue a body that complies with the membership requirements in the rules, provide the governing body a written report about the quality of the funded aged care services delivered at least once every 6 months, and is able to give feedback at any time to the governing body about the quality of the services. The registered provider must also require the governing body to consider such reports or feedback when making decisions regarding the quality of services provided, and to advise the quality care advisory board in writing of how the governing body considered such reports or feedback.",
      "summaryHTML": "Registered providers in registration Category 5 - nursing and transition care and Category 6 - residential care must establish and continue a body that complies with the membership requirements in the rules, provide the governing body a written report about the quality of the funded aged care services delivered at least once every 6 months, and is able to give feedback at any time to the governing body about the quality of the services. The registered provider must also require the governing body to consider such reports or feedback when making decisions regarding the quality of services provided, and to advise the quality care advisory board in writing of how the governing body considered such reports or feedback.",
      "extract": "(2) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) establish, and continue in existence, a body (the quality care advisory body) that: \n\n(i) complies with the requirements about membership prescribed by the rules; and \n\n(ii) is required, at least once every 6 months, to give the governing body of the provider a written report about the quality of the funded aged care services delivered by the provider in accordance with any requirements prescribed by the rules; and \n\n(iii) is able, at any time, to give feedback to the governing body of the provider about the quality of the funded aged care services delivered by the provider; and \n\n(b) require the governing body of the provider: \n\n(i) to consider such a report, or any such feedback, when making decisions in relation to the quality of the funded aged care services delivered by the provider; and \n\n(ii) to advise, in writing, the quality care advisory body how the governing body considered such a report or any such feedback.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631494",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 375,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 2, s158-5",
          "section": "Kinds of provider to which the quality care advisory body condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Advisory body requirements",
          "topic": [
            "governance",
            "reporting"
          ],
          "summary": "Kinds of provider to which the quality care advisory body condition applies\n\nFor the purposes of subsection 158(2) of the Act, registered providers in Category 5 - nursing and transition care and Category 6 - residential care are prescribed.",
          "summaryHTML": "<i>Kinds of provider to which the quality care advisory body condition applies</i>\n\nFor the purposes of subsection 158(2) of the Act, registered providers in Category 5 - nursing and transition care and Category 6 - residential care are prescribed.",
          "extract": "For the purposes of subsection 158(2) of the Act, a registered provider registered in any of the following provider registration categories is prescribed:\n\n(a) nursing and transition care;\n\n(b) residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s158(2)"
        },
        {
          "id": 376,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 2, s158-10",
          "section": "Requirements for membership of quality care advisory body",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Advisory body requirements",
          "topic": [
            "governance",
            "reporting"
          ],
          "summary": "Requirements for membership of quality care advisory body\n\nFor the purposes of subparagraph 158(2)(a)(i) of the Act, the requirements are that the membership of the quality care advisory body of a registered provider must include the following:\n\n(a) a responsible person of the registered provider who has appropriate experience in the delivery of funded aged care services;\n\n(b) if the registered provider is registered in the provider registration Category 6 - residential care—a person who is directly involved in the provider’s delivery of funded aged care services;\n\n(c) if the registered provider is registered in the provider registration Category 5 - nursing and transition care and delivers funded aged care services in the service type nursing care—a person who is directly involved in the delivery of those services;\n\n(d) a person who represents the interests of individuals to whom the provider delivers funded aged care services.\n\nNote: For paragraph (d), examples of such persons include the following:\n\n(a) an individual to whom the provider is delivering funded aged care services;\n\n(b) a member of a consumer advisory body (if established);\n\n(c) a member of an organised consumer advisory service.",
          "summaryHTML": "<i>Requirements for membership of quality care advisory body</i>\n\nFor the purposes of subparagraph 158(2)(a)(i) of the Act, the requirements are that the membership of the quality care advisory body of a registered provider must include the following:\n\n(a) a responsible person of the registered provider who has appropriate experience in the delivery of funded aged care services;\n\n(b) if the registered provider is registered in the provider registration Category 6 - residential care—a person who is directly involved in the provider’s delivery of funded aged care services;\n\n(c) if the registered provider is registered in the provider registration Category 5 - nursing and transition care and delivers funded aged care services in the service type nursing care—a person who is directly involved in the delivery of those services;\n\n(d) a person who represents the interests of individuals to whom the provider delivers funded aged care services.\n\nNote: For paragraph (d), examples of such persons include the following:\n\n(a) an individual to whom the provider is delivering funded aged care services;\n\n(b) a member of a consumer advisory body (if established);\n\n(c) a member of an organised consumer advisory service.",
          "extract": "For the purposes of subparagraph 158(2)(a)(i) of the Act, the requirements are that the membership of the quality care advisory body of a registered provider must include the following:\n\n(a) a responsible person of the registered provider who has appropriate experience in the delivery of funded aged care services;\n\n(b) if the registered provider is registered in the provider registration category residential care—a person who is directly involved in the provider’s delivery of funded aged care services;\n\n(c) if the registered provider is registered in the provider registration category nursing and transition care and delivers funded aged care services in the service type nursing care—a person who is directly involved in the delivery of those services;\n\n(d) a person who represents the interests of individuals to whom the provider delivers funded aged care services.\n\nNote: For paragraph (d), examples of such persons include the following:\n(a) an individual to whom the provider is delivering funded aged care services;\n(b) a member of a consumer advisory body (if established);\n(c) a member of an organised consumer advisory service.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s158(2)"
        },
        {
          "id": 377,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 2, s158-15",
          "section": "Requirements for reports of quality care advisory body",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Advisory body requirements",
          "topic": [
            "governance",
            "reporting"
          ],
          "summary": "Requirements for reports of quality care advisory body\n\nA registered provider must ensure that the quality care advisory body reports any concerns about the quality of funded aged care services in the period covered by the report. Taking into consideration the following:\n\n- feedback provided (if any) about the quality of funded aged care services delivered by the provider by individuals to whom the provider delivered funded aged care services, responsible persons and aged care workers of the provider\n\n- complaints received (if any) , and action taken by the provider to address the complaints\n\n- the use of regulatory mechanisms (if any) under Chapter 6 of the Act by the Commissioner\n\n- progress made in the report period in relation to the provider’s continuous improvement plan\n\n- the results of any audits performed by the Commissioner under section 110-38\n\n- staffing arrangement of the provider including the availability of allied health professionals or registered health practitioners and registered nurses during the reporting period and turnover of aged care workers\n\n- reportable incidents (if any) in connection with the delivery of funded aged care services to an individual by the provider and any action taken by the provider in response to the reportable incidents\n\n- if the provider delivers funded aged care services in an approved residential care home:\n\n- feedback received (if any) from individuals about the quality of food provided by the provider, changes in the quality of food and food preparation model used, menu assessments (if any) conducted by an accredited dietitian and information compiled or derived from a measurement or other assessment made by the provider in relation to the Quality Indicators in Subdivision B of Division 3 of Part 2 of Chapter 5 of the rules.",
          "summaryHTML": "<i>Requirements for reports of quality care advisory body</i>\n\nA registered provider must ensure that the quality care advisory body reports any concerns about the quality of funded aged care services in the period covered by the report. Taking into consideration the following:\n\n- feedback provided (if any) about the quality of funded aged care services delivered by the provider by individuals to whom the provider delivered funded aged care services, responsible persons and aged care workers of the provider\n\n- complaints received (if any) , and action taken by the provider to address the complaints\n\n- the use of regulatory mechanisms (if any) under Chapter 6 of the Act by the Commissioner\n\n- progress made in the report period in relation to the provider’s continuous improvement plan\n\n- the results of any audits performed by the Commissioner under section 110-38\n\n- staffing arrangement of the provider including the availability of allied health professionals or registered health practitioners and registered nurses during the reporting period and turnover of aged care workers\n\n- reportable incidents (if any) in connection with the delivery of funded aged care services to an individual by the provider and any action taken by the provider in response to the reportable incidents\n\n- if the provider delivers funded aged care services in an approved residential care home:\n\n- feedback received (if any) from individuals about the quality of food provided by the provider, changes in the quality of food and food preparation model used, menu assessments (if any) conducted by an accredited dietitian and information compiled or derived from a measurement or other assessment made by the provider in relation to the Quality Indicators in Subdivision B of Division 3 of Part 2 of Chapter 5 of the rules.",
          "extract": "For the purposes of subparagraph 158(2)(a)(ii) of the Act, the requirements for a written report given by the quality care advisory body of a registered provider to the governing body of the provider are that the report must include any concerns that the body has about the quality of funded aged care services delivered by the provider in the period covered by the report (the report period), taking into account the following:\n\n(a) feedback provided (if any) about the quality of funded aged care services delivered by the provider in the report period by:\n\n(i) individuals to whom the provider delivered funded aged care services; and\n\n(ii) responsible persons and aged care workers of the provider;\n\n(b) complaints received (if any) in the report period by the provider about the quality of funded aged care services delivered by the provider and action taken by the provider to address the complaints;\n\n(c) the use of regulatory mechanisms (if any) under Chapter 6 of the Act by the Commissioner in relation to the quality of funded aged care services delivered by the provider;\n\n(d) progress made in the report period in relation to the provider’s continuous improvement plan, particularly improvements made in the delivery of funded aged care services by the provider;\n\n(e) the results of any audits performed by the Commissioner under section 110-38; \n\n(f) staffing arrangements of the provider during the report period, including details of the following, as applicable:\n\n(i) the availability of allied health professionals or registered health practitioners; \n\n(ii) the availability of registered nurses;\n\n(iii) turnover of the aged care workers of the provider;\n\n(g) reportable incidents (if any) in connection with the delivery of funded aged care services to an individual by the provider that occurred in the report period and any action taken by the provider in response to the reportable incidents;\n\n(h) if the provider delivers funded aged care services in an approved residential care home:\n\n(i) feedback received (if any) in the report period from individuals to whom the provider delivers funded aged care services about the quality of food provided by the provider; and\n\n(ii) changes (if any) in the report period in the quality of food provided, and the food preparation model used, by the provider; and\n\n(iii) menu assessments (if any) conducted by an accredited practising dietitian in the report period in relation to food and nutrition provided by the provider; and\n\n(iv) information compiled or derived from a measurement or other assessment made by the provider in the report period in relation to the Quality Indicators in Subdivision B of Division 3 of Part 2 of Chapter 5 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s158(2)"
        }
      ]
    },
    {
      "id": 33,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s158(3)",
      "section": "Advisory body requirements",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Advisory body requirements",
      "topic": [
        "governance",
        "reporting"
      ],
      "summary": "If requested by the quality care advisory body, a registered provider must provide information about the quality of funded services delivered by the provider.",
      "summaryHTML": "If requested by the quality care advisory body, a registered provider must provide information about the quality of funded services delivered by the provider.",
      "extract": "(3) A registered provider must, if requested to do so by the quality care advisory body, give the body information about the quality of the funded aged care services delivered by the provider.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631494",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 34,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s158(4)",
      "section": "Advisory body requirements",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Advisory body requirements",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "Registered providers of a kind must offer individuals accessing services the opportunity to establish consumer advisory bodies and provide feedback to the governing body at least once every 12 months. Any feedback provided by these bodies must be considered by the governing body of the provider when making decisions relating to the services delivered and must advise the bodies in writing of how the feedback was considered.",
      "summaryHTML": "Registered providers of a kind must offer individuals accessing services the opportunity to establish consumer advisory bodies and provide feedback to the governing body at least once every 12 months. Any feedback provided by these bodies must be considered by the governing body of the provider when making decisions relating to the services delivered and must advise the bodies in writing of how the feedback was considered.",
      "extract": "(4) It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) offer, in writing, at least once every 12 months, individuals accessing funded aged care services and their supporters the opportunity to establish one or more bodies (the consumer advisory bodies) to give the governing body of the provider feedback about the quality of the funded aged care services delivered by the provider; and \n\n(b) if one or more consumer advisory bodies are established—require the governing body of the provider: \n\n(i) to consider any such feedback given by the body or bodies when making decisions in relation to the quality of the funded aged care services delivered by the provider; and \n\n(ii) to advise, in writing, the body or bodies how the governing body considered any such feedback.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631494",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": true,
        "otherUnico": true,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 378,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 8, Div 2, s158-20",
          "section": "Kinds of provider to which the consumer advisory bodies condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Governance",
          "sublevel": "Advisory body requirements",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "For the purposes of subsection 158(4) of the Act, registered providers in Category 5 - nursing and transition care and Category 6 - residential care are prescribed.",
          "summaryHTML": "For the purposes of subsection 158(4) of the Act, registered providers in Category 5 - nursing and transition care and Category 6 - residential care are prescribed.",
          "extract": "For the purposes of subsection 158(4) of the Act, a registered provider registered in any of the following provider registration categories is prescribed:\n\n(a) nursing and transition care;\n\n(b) residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s158(4)"
        }
      ]
    },
    {
      "id": 35,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s161(1)",
      "section": "Constitution of registered providers that are wholly-owned subsidiary corporations",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Constitution of registered providers that are wholly-owned subsidiary corporations",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "If a registered provider is an incorporated body corporate, has a constitution, is a wholly owned subsidiary of another body corporate, and the holding company is not a registered provider, then the constitution of the registered provider must not authorise a director of the provider to act in the best interests of the holding company.",
      "summaryHTML": "If a registered provider is an incorporated body corporate, has a constitution, is a wholly owned subsidiary of another body corporate, and the holding company is not a registered provider, then the constitution of the registered provider must not authorise a director of the provider to act in the best interests of the holding company.",
      "extract": "Corporations under the Corporations Act 2001 \n\n(1) If: \n\n(a) a registered provider is a body corporate that is incorporated, or taken to be incorporated, under the Corporations Act 2001; and \n\n(b) the provider has a constitution (within the meaning of that Act); and \n\n(c) the provider is a wholly owned subsidiary (within the meaning of that Act) of another body corporate (the holding company); and \n\n(d) the holding company is not a registered provider; it is a condition of registration that the registered provider must ensure that the constitution of the provider does not authorise a director of the provider to act in good faith in the best interests of the holding company.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631497",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": false,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": true,
          "subcategories": {
            "ep": true,
            "ha": true
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 36,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div G, s161(2)",
      "section": "Constitution of registered providers that are wholly-owned subsidiary corporations",
      "requirement": "Conditions of Registration",
      "subdivision": "Governance",
      "sublevel": "Constitution of registered providers that are wholly-owned subsidiary corporations",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "If a registered provider is an Aboriginal and Torres Strait Islander corporation, is a wholly owned subsidiary of another body corporate, and the holding company is not a registered provider, then the constitution of the registered provider must not authorise a director of the provider to act in the best interests of the holding company.",
      "summaryHTML": "If a registered provider is an Aboriginal and Torres Strait Islander corporation, is a wholly owned subsidiary of another body corporate, and the holding company is not a registered provider, then the constitution of the registered provider must not authorise a director of the provider to act in the best interests of the holding company.",
      "extract": "Aboriginal and Torres Strait Islander corporations \n\n(2) If: \n\n(a) a registered provider is an Aboriginal and Torres Strait Islander corporation (within the meaning of the Corporations (Aboriginal and Torres Strait Islander) Act 2006); and \n\n(b) the provider is a wholly owned subsidiary (within the meaning of that Act) of another body corporate (the holding company); and \n\n(c) the holding company is not a registered provider; it is a condition of registration that the registered provider must ensure that the constitution of the provider does not authorise a director of the provider to act in good faith in the best interests of the holding company.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631497",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": false,
        "bodyCorp": true,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": true,
          "subcategories": {
            "ep": true,
            "ha": true
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 37,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div H, s162",
      "section": "Restrictive practices",
      "requirement": "Conditions of Registration",
      "subdivision": "Restrictive practices",
      "sublevel": "Restrictive practices",
      "topic": [
        "agreements",
        "unspecified"
      ],
      "summary": "Registered providers in Category 6 - residential care must comply with the rules relating to the use of restrictive practices in relation to an individual receiving services from the provider.",
      "summaryHTML": "Registered providers in Category 6 - residential care must comply with the rules relating to the use of restrictive practices in relation to an individual receiving services from the provider.",
      "extract": "It is a condition of registration that a registered provider of a kind prescribed by the rules must comply with any requirements prescribed by the rules relating to the use of restrictive practices in relation to an individual to whom the provider is delivering funded aged care services.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631499",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": true,
        "chsp": false,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 379,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 1, s162-5",
          "section": "Kinds of provider to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 162 providers that are in registration Category 6 - residential care are prescribed.",
          "summaryHTML": "For section 162 providers that are in registration Category 6 - residential care are prescribed.",
          "extract": "For the purposes of section 162 of the Act, a registered provider registered in the provider registration category residential care is prescribed.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 380,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-15(1)",
          "section": "Requirements for the use of any restrictive practice",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "(1) The following requirements apply to the use of any restrictive practice in relation to an individual:\n\n(a) the restrictive practice is used only:\n\n(i) as a last resort to prevent harm to the individual or other persons; and\n\n(ii) after consideration of the likely impact of the use of the restrictive practice on the individual;\n\n(b) to the extent possible, best practice alternative strategies are used before the restrictive practice is used;\n\n(c) the alternative strategies that have been considered or used have been documented in the behaviour support plan for the individual;\n\n(d) the restrictive practice is used only to the extent that it is necessary and in proportion to the risk of harm to the individual or other persons;\n\n(e) the restrictive practice is used in the least restrictive form, and for the shortest time, necessary to prevent harm to the individual or other persons;\n\n(f) informed consent to the use of the restrictive practice, and how it is to be used (including its duration, frequency and intended outcome), has been given by:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give that consent—the restrictive practices substitute decision-maker for the restrictive practice;\n\n(g) the use of the restrictive practice is in accordance with the informed consent mentioned in paragraph (f);\n\n(h) the use of the restrictive practice complies with any provisions of the behaviour support plan for the individual that relate to the use of the restrictive practice;\n\n(i) the use of the restrictive practice complies with the Aged Care Quality Standards and the Aged Care Code of Conduct;\n\n(j) the use of the restrictive practice is not inconsistent with the Statement of Rights;\n\n(k) the use of the restrictive practice meets the requirements (if any) of the law of the State or Territory in which the restrictive practice is used.",
          "summaryHTML": "(1) The following requirements apply to the use of any restrictive practice in relation to an individual:\n\n(a) the restrictive practice is used only:\n\n(i) as a last resort to prevent harm to the individual or other persons; and\n\n(ii) after consideration of the likely impact of the use of the restrictive practice on the individual;\n\n(b) to the extent possible, best practice alternative strategies are used before the restrictive practice is used;\n\n(c) the alternative strategies that have been considered or used have been documented in the behaviour support plan for the individual;\n\n(d) the restrictive practice is used only to the extent that it is necessary and in proportion to the risk of harm to the individual or other persons;\n\n(e) the restrictive practice is used in the least restrictive form, and for the shortest time, necessary to prevent harm to the individual or other persons;\n\n(f) informed consent to the use of the restrictive practice, and how it is to be used (including its duration, frequency and intended outcome), has been given by:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give that consent—the restrictive practices substitute decision-maker for the restrictive practice;\n\n(g) the use of the restrictive practice is in accordance with the informed consent mentioned in paragraph (f);\n\n(h) the use of the restrictive practice complies with any provisions of the behaviour support plan for the individual that relate to the use of the restrictive practice;\n\n(i) the use of the restrictive practice complies with the Aged Care Quality Standards and the Aged Care Code of Conduct;\n\n(j) the use of the restrictive practice is not inconsistent with the Statement of Rights;\n\n(k) the use of the restrictive practice meets the requirements (if any) of the law of the State or Territory in which the restrictive practice is used.",
          "extract": "(1) The following requirements apply to the use of any restrictive practice in relation to an individual:\n\n(a) the restrictive practice is used only:\n\n(i) as a last resort to prevent harm to the individual or other persons; and\n\n(ii) after consideration of the likely impact of the use of the restrictive practice on the individual;\n\n(b) to the extent possible, best practice alternative strategies are used before the restrictive practice is used;\n\n(c) the alternative strategies that have been considered or used have been documented in the behaviour support plan for the individual;\n\n(d) the restrictive practice is used only to the extent that it is necessary and in proportion to the risk of harm to the individual or other persons;\n\n(e) the restrictive practice is used in the least restrictive form, and for the shortest time, necessary to prevent harm to the individual or other persons;\n\n(f) informed consent to the use of the restrictive practice, and how it is to be used (including its duration, frequency and intended outcome), has been given by:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give that consent—the restrictive practices substitute decision-maker for the restrictive practice;\n\n(g) the use of the restrictive practice is in accordance with the informed consent mentioned in paragraph (f);\n\n(h) the use of the restrictive practice complies with any provisions of the behaviour support plan for the individual that relate to the use of the restrictive practice;\n\n(i) the use of the restrictive practice complies with the Aged Care Quality Standards and the Aged Care Code of Conduct;\n\n(j) the use of the restrictive practice is not inconsistent with the Statement of Rights;\n\n(k) the use of the restrictive practice meets the requirements (if any) of the law of the State or Territory in which the restrictive practice is used.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 381,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-15(2)",
          "section": "Requirements for the use of any restrictive practice",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The specific requirements regarding restrictive practices outlined in 156-15 (1)(a), (b), (c), (f), (g) and (h) do not apply in emergency situations.",
          "summaryHTML": "The specific requirements regarding restrictive practices outlined in 156-15 (1)(a), (b), (c), (f), (g) and (h) do not apply in emergency situations.",
          "extract": "(2) However, the requirements set out in paragraphs (1)(a), (b), (c), (f), (g) and (h) do not apply to the use of a restrictive practice in relation to an individual if the use of the restrictive practice in relation to the individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 382,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-15(3)",
          "section": "Requirements for the use of any restrictive practice",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The allowance to use restrictive practices in emergencies is only valid as long as the emergency exists.",
          "summaryHTML": "The allowance to use restrictive practices in emergencies is only valid as long as the emergency exists.",
          "extract": "(3) Subsection (2) applies only while the emergency exists.\n\nNote: See section 162-35 for other responsibilities of registered providers that apply if the use of a restrictive practice in relation to an individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 383,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-20(1)",
          "section": "Additional requirements for the use of restrictive practices other than chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The following requirements apply to the use of a restrictive practice in relation to an individual that is not chemical restraint. An approved health practitioner who has day-to-day knowledge of the individual has assessed the individual as posing a risk of harm to the individual or any other person that the use of the restrictive practice is necessary. The assessments, a description of any engagement with persons other than the approved health practitioner in relation to the assessments, a description of any engagement with external support services (for example, dementia support specialists) in relation to the assessments must be documented in the behaviour support plan for the individual.",
          "summaryHTML": "The following requirements apply to the use of a restrictive practice in relation to an individual that is not chemical restraint. An approved health practitioner who has day-to-day knowledge of the individual has assessed the individual as posing a risk of harm to the individual or any other person that the use of the restrictive practice is necessary. The assessments, a description of any engagement with persons other than the approved health practitioner in relation to the assessments, a description of any engagement with external support services (for example, dementia support specialists) in relation to the assessments must be documented in the behaviour support plan for the individual.",
          "extract": "(1) The following requirements apply to the use of a restrictive practice in relation to an individual that is not chemical restraint:\n\n(a) an approved health practitioner who has day-to-day knowledge of the individual has:\n\n(i) assessed the individual as posing a risk of harm to the individual or any other person; and\n\n(ii) assessed that the use of the restrictive practice is necessary;\n\n(b) the following matters have been documented in the behaviour support plan for the individual:\n\n(i) the assessments;\n\n(ii) a description of any engagement with persons other than the approved health practitioner in relation to the assessments;\n\n(iii) a description of any engagement with external support services (for example, dementia support specialists) in relation to the assessments.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 384,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-20(2)",
          "section": "Additional requirements for the use of restrictive practices other than chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The requirement for having an approved health practitioner assess and document matters in the behaviour support plan does not apply in emergency situations.",
          "summaryHTML": "The requirement for having an approved health practitioner assess and document matters in the behaviour support plan does not apply in emergency situations.",
          "extract": "(2) However, the requirement set out in paragraph (1)(b) does not apply to the use of a restrictive practice in relation to an individual if the use of the restrictive practice in relation to the individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 385,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-20(3)",
          "section": "Additional requirements for the use of restrictive practices other than chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The exemption for emergency use of restrictive practices only applies while the emergency exists.",
          "summaryHTML": "The exemption for emergency use of restrictive practices only applies while the emergency exists.",
          "extract": "(3) Subsection (2) applies only while the emergency exists.\n\nNote: See section 162-35 for other responsibilities of registered providers that apply if the use of a restrictive practice in relation to an individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 386,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-25(1)",
          "section": "Additional requirements for the use of restrictive practices that are chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A provider must ensure that the use of chemical restraints is assessed and documented by a medical or nurse practitioner, including obtaining informed consent and following the prescription details.\n\nNote: Codes of appropriate professional practice for medical practitioners and nurse practitioners provide for the practitioners to obtain informed consent before prescribing medications. Those codes are approved under the National Law and are:\n(a) for medical practitioners—Good medical practice: a code of conduct for doctors in Australia (which in 2025 could be viewed on the website of the Medical Board of Australia (www.medicalboard.gov.au)); and\n(b) for nurse practitioners—Code of conduct for nurses (which in 2025 could be viewed on the website of the Nursing and Midwifery Board of Australia (www.nursingmidwiferyboard.gov.au)).",
          "summaryHTML": "A provider must ensure that the use of chemical restraints is assessed and documented by a medical or nurse practitioner, including obtaining informed consent and following the prescription details.\n\nNote: Codes of appropriate professional practice for medical practitioners and nurse practitioners provide for the practitioners to obtain informed consent before prescribing medications. Those codes are approved under the National Law and are:\n(a) for medical practitioners—Good medical practice: a code of conduct for doctors in Australia (which in 2025 could be viewed on the website of the Medical Board of Australia (www.medicalboard.gov.au)); and\n(b) for nurse practitioners—Code of conduct for nurses (which in 2025 could be viewed on the website of the Nursing and Midwifery Board of Australia (www.nursingmidwiferyboard.gov.au)).",
          "extract": "(1) The following requirements apply to the use of a restrictive practice in relation to an individual that is chemical restraint:\n\n(a) the registered provider is satisfied that a medical practitioner or nurse practitioner has:\n\n(i) assessed the individual as posing a risk of harm to the individual or any other person; and\n\n(ii) assessed that the use of the chemical restraint is necessary; and\n\n(iii) prescribed medication for the purpose of using the chemical restraint; and\n\n(iv) obtained informed consent to the prescribing of the medication for the purpose of using the chemical restraint;\n\n(b) the following matters have been documented in the behaviour support plan for the individual:\n\n(i) the assessments;\n\n(ii) the practitioner’s decision to use the chemical restraint;\n\n(iii) the individual’s behaviours that are relevant to the need for the chemical restraint;\n\n(iv) the reasons the chemical restraint is necessary;\n\n(v) the information (if any) provided by the registered provider to the practitioner that informed the decision to prescribe the medication for the purpose of using the chemical restraint; \n\n(vi) that the registered provider is satisfied that the practitioner obtained informed consent to the prescribing of the medication;\n\n(vii) the details of the prescription for the prescribed medication, including its name, dosage and when it may be used;\n\n(viii) a description of any engagement with persons other than the practitioner in relation to the use of the chemical restraint;\n\n(ix) a description of any engagement with external support services (for example, dementia support specialists) in relation to the assessments;\n\n(c) the use of the medication for the purpose of using the chemical restraint is in accordance with the prescription mentioned in subparagraph (b)(vii).\n\nNote: Codes of appropriate professional practice for medical practitioners and nurse practitioners provide for the practitioners to obtain informed consent before prescribing medications. Those codes are approved under the National Law and are:\n(a) for medical practitioners—Good medical practice: a code of conduct for doctors in Australia (which in 2025 could be viewed on the website of the Medical Board of Australia (www.medicalboard.gov.au)); and\n(b) for nurse practitioners—Code of conduct for nurses (which in 2025 could be viewed on the website of the Nursing and Midwifery Board of Australia (www.nursingmidwiferyboard.gov.au)).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 387,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-25(2)",
          "section": "Additional requirements for the use of restrictive practices that are chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The requirements for obtaining informed consent and documenting matters in the behaviour support plan do not apply in emergency situations.\n\nNote: See section 162-35 for other responsibilities of registered providers that apply if the use of a restrictive practice in relation to an individual is necessary in an emergency.",
          "summaryHTML": "The requirements for obtaining informed consent and documenting matters in the behaviour support plan do not apply in emergency situations.\n\nNote: See section 162-35 for other responsibilities of registered providers that apply if the use of a restrictive practice in relation to an individual is necessary in an emergency.",
          "extract": "(2) However, the requirements set out in subparagraph (1)(a)(iv) and paragraph (1)(b) do not apply to the use of a restrictive practice in relation to an individual if the use of the restrictive practice in relation to the individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 388,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-25(3)",
          "section": "Additional requirements for the use of restrictive practices that are chemical restraint",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The exception for obtaining informed consent and documenting matters in the behaviour support plan in emergencies is only valid as long as the emergency exists.",
          "summaryHTML": "The exception for obtaining informed consent and documenting matters in the behaviour support plan in emergencies is only valid as long as the emergency exists.",
          "extract": "(3) Subsection (2) applies only while the emergency exists.\n\nNote: See section 162-35 for other responsibilities of registered providers that apply if the use of a restrictive practice in relation to an individual is necessary in an emergency.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 389,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-30",
          "section": "Requirements while restrictive practice being used",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "If a restrictive practice is being used, the provider must continuously monitor the individual’s well-being and the necessity and effectiveness of the practice, make environmental adjustments to reduce its need, and, if it is chemical restraint, provide usage and effect information to the prescribing practitioner as described in 162-25(1)(a).\n\nThe provider must ensure that while the restrictive practice is being used:\n(a) the individual is monitored for the following:\n(i) signs of distress or harm;\n(ii) side effects and adverse events;\n(iii) changes in mood or behaviour;\n(iv) changes in well-being, including the individual’s ability to engage in activities that enhance quality of life and are meaningful and pleasurable;\n(v) changes in the individual’s ability to maintain independent function (to the extent possible);\n(vi) changes in the individual’s ability to engage in activities of daily living (to the extent possible).",
          "summaryHTML": "If a restrictive practice is being used, the provider must continuously monitor the individual’s well-being and the necessity and effectiveness of the practice, make environmental adjustments to reduce its need, and, if it is chemical restraint, provide usage and effect information to the prescribing practitioner as described in 162-25(1)(a).\n\nThe provider must ensure that while the restrictive practice is being used:\n(a) the individual is monitored for the following:\n(i) signs of distress or harm;\n(ii) side effects and adverse events;\n(iii) changes in mood or behaviour;\n(iv) changes in well-being, including the individual’s ability to engage in activities that enhance quality of life and are meaningful and pleasurable;\n(v) changes in the individual’s ability to maintain independent function (to the extent possible);\n(vi) changes in the individual’s ability to engage in activities of daily living (to the extent possible).",
          "extract": "If a registered provider uses a restrictive practice in relation to an individual, the registered provider must ensure that while the restrictive practice is being used: \n\n(a) the individual is monitored for the following: \n\n(i) signs of distress or harm; \n\n(ii) side effects and adverse events; \n\n(iii) changes in mood or behaviour; \n\n(iv) changes in well-being, including the individual’s ability to engage in activities that enhance quality of life and are meaningful and pleasurable; \n\n(v) changes in the individual’s ability to maintain independent function (to the extent possible); \n\n(vi) changes in the individual’s ability to engage in activities of daily living (to the extent possible); and \n\n(b) the necessity for the use of the restrictive practice is regularly monitored, reviewed and documented; and\n\n(c) the effectiveness of the use of the restrictive practice, and the effect of changes in the use of the restrictive practice, are monitored; and \n\n(d) to the extent possible, changes are made to the individual’s environment to reduce or remove the need for the use of the restrictive practice; and \n\n(e) if the restrictive practice is chemical restraint—information about the effects and use of the chemical restraint is provided to the medical practitioner or nurse practitioner who prescribed the medication for the purpose of using the chemical restraint as mentioned in paragraph 162-25(1)(a).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 390,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-35",
          "section": "Requirements following emergency use of restrictive practice",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "A provider must ensure that if a restrictive practice is used in an emergency, the restrictive practices substitute decision-maker is informed, and relevant details are documented in the behaviour support plan. If the restrictive practice is not chemical restraint - ensure that the assessments in 162-20(1)(a) are documented in the behaviour support plan for the individual and for restrictive practice that is chemical restraint ensure that the matters mentioned in 162-25(1)(b)(i) to (v) and (vii) to (ix) are documented.",
          "summaryHTML": "A provider must ensure that if a restrictive practice is used in an emergency, the restrictive practices substitute decision-maker is informed, and relevant details are documented in the behaviour support plan. If the restrictive practice is not chemical restraint - ensure that the assessments in 162-20(1)(a) are documented in the behaviour support plan for the individual and for restrictive practice that is chemical restraint ensure that the matters mentioned in 162-25(1)(b)(i) to (v) and (vii) to (ix) are documented.",
          "extract": "If a registered provider uses a restrictive practice in relation to an individual and the use of the restrictive practice in relation to the individual is necessary in an emergency, the registered provider must, as soon as practicable after the restrictive practice starts to be used:\n\n(a) if the individual lacked capacity to consent to the use of the restrictive practice—inform the restrictive practices substitute decision-maker for the restrictive practice about the use of the restrictive practice; and\n\n(b) ensure that the following matters are documented in the behaviour support plan for the individual:\n\n(i) the individual’s behaviours that were relevant to the need for the use of the restrictive practice;\n\n(ii) the alternative strategies that were considered or used (if any) before the use of the restrictive practice;\n\n(iii) the reasons the use of the restrictive practice was necessary;\n\n(iv) the care to be provided to the individual in relation to the individual’s behaviour;\n\n(v) if the restrictive practices substitute decision-maker for the restrictive practice was informed about the use of the restrictive practice under paragraph (a)—a record of the restrictive practices substitute decision-maker being so informed; and\n\n(c) if the restrictive practice is not chemical restraint—ensure that the assessments mentioned in paragraph 162-20(1)(a) are documented in the behaviour support plan for the individual; and\n\n(d) if the restrictive practice is chemical restraint—ensure that the matters mentioned in subparagraphs 162-25(1)(b)(i) to (v) and (vii) to (ix) are documented in the behaviour support plan for the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 391,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-40(1)",
          "section": "Requirements relating to nominations of restrictive practices nominees",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A provider must ensure that individuals are not subject to coercion or duress when making, varying, revoking, or agreeing to nominations related to restrictive practices.",
          "summaryHTML": "A provider must ensure that individuals are not subject to coercion or duress when making, varying, revoking, or agreeing to nominations related to restrictive practices.",
          "extract": "Preventing coercion and duress\n\n(1) A registered provider must take reasonable steps to ensure that:\n\n(a) an individual to whom the registered provider delivers funded aged care services is not subject to coercion or duress in making, varying or revoking a nomination under section 6-15; and\n\n(b) an individual nominated under section 6-15 (whether as an individual or as a member of a group) is not subject to coercion or duress in agreeing as mentioned in paragraph 6-15(2)(b) or (3)(b), or in withdrawing that agreement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 392,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-40(2)",
          "section": "Requirements relating to nominations of restrictive practices nominees",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A provider must assist individuals in notifying, providing a copy of the nomination, and seeking agreement when nominating someone under section 6-15.",
          "summaryHTML": "A provider must assist individuals in notifying, providing a copy of the nomination, and seeking agreement when nominating someone under section 6-15.",
          "extract": "Assisting care individuals\n\n(2) If an individual nominates an individual under section 6-15 (whether as an individual or as a member of a group), the registered provider delivering funded aged care services to the individual must assist the individual to:\n\n(a) notify the individual of the nomination; and\n\n(b) give the individual a copy of the nomination; and\n\n(c) seek the individual’s agreement as mentioned in paragraph 6-15(2)(b) or (3)(b).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 393,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 2, s162-40(3)",
          "section": "Requirements relating to nominations of restrictive practices nominees",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A provider must keep records of the nomination, the individual's agreement, and any withdrawal of that agreement when someone is nominated under section 6-15.",
          "summaryHTML": "A provider must keep records of the nomination, the individual's agreement, and any withdrawal of that agreement when someone is nominated under section 6-15.",
          "extract": "Keeping records\n\n(3) If an individual nominates an individual under section 6-15 (whether as an individual or as a member of a group), the registered provider delivering funded aged care services to the individual must keep a record of:\n\n(a) the nomination; and\n\n(b) whether the individual has agreed as mentioned in paragraph 6-15(2)(b) or (3)(b); and\n\n(c) if the individual has agreed as mentioned in paragraph 6-15(2)(b) or (3)(b)—whether the individual has withdrawn that agreement.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 394,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-45(1)",
          "section": "Requirement for behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The registered provider must ensure that a behaviour support plan is included in the care and services plan if they deliver funded aged care services and behaviour support is needed for the individual.",
          "summaryHTML": "The registered provider must ensure that a behaviour support plan is included in the care and services plan if they deliver funded aged care services and behaviour support is needed for the individual.",
          "extract": "(1) If: \n\n(a) a registered provider delivers funded aged care services to an individual; and\n\n(b) behaviour support is needed for the individual;\nthe registered provider must ensure that a behaviour support plan for the individual is included in the care and services plan for the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 395,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-45(2)",
          "section": "Requirement for behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "The registered provider must ensure that the behaviour support plan is prepared, reviewed, and revised according to legislation in Division 2 - Requirements relating to the use of restrictive practices and Division 3 - Requirements relating to behaviour support plan.",
          "summaryHTML": "The registered provider must ensure that the behaviour support plan is prepared, reviewed, and revised according to legislation in Division 2 - Requirements relating to the use of restrictive practices and Division 3 - Requirements relating to behaviour support plan.",
          "extract": "(2) The registered provider must ensure that the behaviour support plan:\n\n(a) is prepared, reviewed and revised in accordance with this Division; and\n\n(b) sets out the matters required by this Division and Division 2.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 396,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-45(3)",
          "section": "Requirement for behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "The registered provider must consider any previous assessments when preparing the behaviour support plan.",
          "summaryHTML": "The registered provider must consider any previous assessments when preparing the behaviour support plan.",
          "extract": "(3) In preparing the behaviour support plan, the registered provider must take into account any previous assessment relating to the individual that is available to the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 397,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-50",
          "section": "Requirements for behaviour support plans—alternative strategies for addressing behaviours of concern",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Requirements for behaviour support plans alternative strategies for addressing behaviours of concern\n\nThe behaviour support plan must include comprehensive information about the individual, assessments, details of concerning behaviours, alternative strategies, their effectiveness, and consultations regarding these strategies.",
          "summaryHTML": "<i>Requirements for behaviour support plans alternative strategies for addressing behaviours of concern</i>\n\nThe behaviour support plan must include comprehensive information about the individual, assessments, details of concerning behaviours, alternative strategies, their effectiveness, and consultations regarding these strategies.",
          "extract": "A behaviour support plan for an individual must set out the following matters:\n\n(a) information about the individual that helps the registered provider to understand the individual and the individual’s behaviour (such as information about the individual’s past experience and background);\n\n(b) any assessment of the individual that is relevant to understanding the individual’s behaviour;\n\n(c) information about behaviours of concern for which the individual may need support;\n\n(d) the following information about each occurrence of behaviours of concern for which the individual has needed support:\n\n(i) the date, time and duration of the occurrence;\n\n(ii) any adverse consequences for the individual or other persons;\n\n(iii) any related incidents;\n\n(iv) any warning signs for, or triggers or causes of, the occurrence (including trauma, injury, illness or unmet needs such as pain, boredom or loneliness);\n\n(e) alternative strategies for addressing the behaviours of concern that:\n\n(i) are best practice alternatives to the use of restrictive practices in relation to the individual; and\n\n(ii) take into account the individual’s preferences (including preferences in relation to care delivery) and matters that might be meaningful or of interest to the individual; and\n\n(iii) aim to improve the individual’s quality of life and engagement;\n\n(f) any alternative strategies that have been considered for use, or have been used, in relation to the individual;\n\n(g) for any alternative strategy that has been used in relation to the individual:\n\n(i) the effectiveness of the strategy in addressing the behaviours of concern; and\n\n(ii) records of the monitoring and evaluation of the strategies;\n\n(h) a description of the registered provider’s consultation about the use of alternative strategies in relation to the individual with the individual or a supporter of the individual (if any).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 398,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-55",
          "section": "Requirements for behaviour support plans—if use of restrictive practice assessed as necessary",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Requirements for behaviour support plans if use of restrictive practice assessed as necessary\n\nThe behaviour support plan must detail the individual's concerning behaviours, the restrictive practice usage, best practice alternative strategies, monitoring and review processes, informed consent procedures, and consultations with individuals or their decision-makers. Sections 162-20 and 162-25 also require other matters to be documented in the behaviour support plan.",
          "summaryHTML": "<i>Requirements for behaviour support plans if use of restrictive practice assessed as necessary</i>\n\nThe behaviour support plan must detail the individual's concerning behaviours, the restrictive practice usage, best practice alternative strategies, monitoring and review processes, informed consent procedures, and consultations with individuals or their decision-makers. Sections 162-20 and 162-25 also require other matters to be documented in the behaviour support plan.",
          "extract": "If the use of a restrictive practice in relation to an individual is assessed as necessary as mentioned in section 162-20 or 162-25, the behaviour support plan for the individual must set out the following matters:\n\n(a) the individual’s behaviours of concern that are relevant to the need for the use of the restrictive practice;\n\n(b) the restrictive practice and how it is to be used, including its duration, frequency and intended outcome;\n\n(c) the best practice alternative strategies that must be used (to the extent possible) before using the restrictive practice;\n\n(d) how the use of the restrictive practice is to be monitored, including how the monitoring will be escalated if required, taking into account the nature of the restrictive practice and any care needs that arise from the use of the restrictive practice;\n\n(e) how the use of the restrictive practice is to be reviewed, including consideration of the following:\n\n(i) the outcome of its use and whether the intended outcome was achieved;\n\n(ii) whether an alternative strategy could be used to address the individual’s behaviours of concern;\n\n(iii) whether a less restrictive form of the restrictive practice could be used to address the individual’s behaviours of concern;\n\n(iv) whether there is an ongoing need for its use;\n\n(v) if the restrictive practice is chemical restraint—whether the medication prescribed for the purpose of using the chemical restraint can or should be reduced or stopped;\n\n(f) if the individual lacks the capacity to give informed consent to the use of the restrictive practice:\n\n(i) whether subsection 6-20(1), or an item of the table in subsection 6-20(2), applies for the restrictive practice in relation to the individual, and why that subsection or item applies; and\n\n(ii) the name of the restrictive practices substitute decision-maker for the restrictive practice in relation to the individual;\n\n(g) a description of the registered provider’s consultation about the use of the restrictive practice with:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give informed consent to the use of the restrictive practice—the restrictive practices substitute decision-maker for the restrictive practice;\n\n(h) a record of the giving of informed consent to the use of the restrictive practice, and how it is to be used (including its duration, frequency and intended outcome), by:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give that consent—the restrictive practices substitute decision-maker for the restrictive practice.\n\nNote: Sections 162-20 and 162-25 also require other matters to be documented in the behaviour support plan.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 399,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-60",
          "section": "Requirements for behaviour support plans—if restrictive practice used",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Requirements for behaviour support plans if restrictive practice used. \n\nThe behaviour support plan must document the use of restrictive practices, including details of implementation, monitoring, review outcomes, involved personnel, and any engagement with external support services.",
          "summaryHTML": "<i>Requirements for behaviour support plans if restrictive practice used. \n</i>\nThe behaviour support plan must document the use of restrictive practices, including details of implementation, monitoring, review outcomes, involved personnel, and any engagement with external support services.",
          "extract": "If a restrictive practice is used in relation to an individual, the behaviour support plan for the individual must set out the following matters:\n\n(a) the restrictive practice and how it was used, including the following:\n\n(i) when it began to be used;\n\n(ii) the duration of each use;\n\n(iii) the frequency of its use;\n\n(iv) the outcome of its use and whether the intended outcome was achieved;\n\n(v) whether its use was in accordance with the informed consent set out under paragraph 162-55(h);\n\n(b) if, under the plan, the restrictive practice is to be used only on an as-needed basis in response to particular behaviour, or in particular circumstances:\n\n(i) the individual’s behaviours of concern that led to the use of the restrictive practice; and\n\n(ii) the actions (if any) taken leading up to the use of the restrictive practice, including any alternative strategies that were used before the restrictive practice was used;\n\n(c) the details of the persons involved in the use of the restrictive practice;\n\n(d) a description of any engagement with external support services (for example, dementia support specialists) in relation to the use of the restrictive practice;\n\n(e) details of the monitoring of the use of the restrictive practice as required by the plan;\n\n(f) the outcome of the review of the use of the restrictive practice as required by the plan.\n\nNote 1: For paragraphs (e) and (f), see paragraphs 162-55(d) and (e) for the requirements for a behaviour support plan for an individual to require monitoring and review of the use of a restrictive practice in relation to the individual.\n\nNote 2: If the use of a restrictive practice in relation to an individual is necessary in an emergency, other matters must also be documented in the behaviour support plan for the individual (see section 162-35).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 400,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-65",
          "section": "Requirements for behaviour support plans—if need for ongoing use of restrictive practice indicated",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "Requirements for behaviour support plans—if need for ongoing use of restrictive practice indicated\n\nThe behaviour support plan must outline the ongoing use of restrictive practices, including details on implementation, monitoring, review processes, consultations for informed consent, and documentation of consent from the individual or their decision-maker.",
          "summaryHTML": "<i>Requirements for behaviour support plans—if need for ongoing use of restrictive practice indicated\n</i>\nThe behaviour support plan must outline the ongoing use of restrictive practices, including details on implementation, monitoring, review processes, consultations for informed consent, and documentation of consent from the individual or their decision-maker.",
          "extract": "If a review of the use of a restrictive practice in relation to an individual (as required by the behaviour support plan for the individual) indicates a need for the ongoing use of the restrictive practice, the behaviour support plan for the individual must set out the following matters:\n\n(a) the restrictive practice and how it is to be used, including its duration, frequency and intended outcome;\n\n(b) how the ongoing use of the restrictive practice is to be monitored, including how the monitoring will be escalated if required, taking into account the nature of the restrictive practice and any care needs that arise from the use of the restrictive practice;\n\n(c) how the ongoing use of the restrictive practice is to be reviewed, including consideration of the following:\n\n(i) the outcome of the ongoing use of the restrictive practice and whether the intended outcome is being achieved;\n\n(ii) whether an alternative strategy could be used to address the individual’s behaviours of concern;\n\n(iii) whether a less restrictive form of the restrictive practice could be used to address the individual’s behaviours of concern;\n\n(iv) whether there continues to be need for the ongoing use of the restrictive practice;\n\n(v) if the restrictive practice is chemical restraint—whether the medication prescribed for the purpose of using the chemical restraint can or should be reduced or stopped;\n\n(d) a description of the registered provider’s consultation about the ongoing use of the restrictive practice, and how it is to be used (including its duration, frequency and intended outcome), with:\n\n(i) the individual; or\n\n(ii) if the individual lacks the capacity to give informed consent to the ongoing use of the restrictive practice—the restrictive practices substitute decision-maker for the restrictive practice;\n\n(e) a record of the giving of informed consent to the ongoing use of the restrictive practice by:\n\n(i) the individual; or\n\n(ii) if the individual lacks capacity to give that consent—the restrictive practices substitute decision-maker for the restrictive practice.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 401,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-70",
          "section": "Requirement to review and revise behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must review a behaviour support plan for an individual and make any necessary revision on a regular basis and as soon as practicable after any change in the individual’s circumstances.",
          "summaryHTML": "A registered provider must review a behaviour support plan for an individual and make any necessary revision on a regular basis and as soon as practicable after any change in the individual’s circumstances.",
          "extract": "A registered provider must review a behaviour support plan for an individual and make any necessary revisions:\n\n(a) on a regular basis; and\n\n(b) as soon as practicable after any change in the individual’s circumstances.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 402,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-75(1)",
          "section": "Requirement to consult on behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "A registered provider must consult the individual and their supporter (if any), decision-makers if the individual lacks capacity, and relevant health practitioners when preparing or revising a behaviour support plan.",
          "summaryHTML": "A registered provider must consult the individual and their supporter (if any), decision-makers if the individual lacks capacity, and relevant health practitioners when preparing or revising a behaviour support plan.",
          "extract": "(1) In preparing, reviewing or revising a behaviour support plan for an individual, a registered provider must consult the following:\n\n(a) if the individual has the capacity to be consulted—the individual and a supporter of the individual (if any);\n\n(b) if the individual lacks the capacity to be consulted—a person or body who, under the law of the State or Territory in which the individual accesses funded aged care services, can make decisions about that care;\n\n(c) health practitioners with expertise relevant to the individual’s behaviours of concern.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 403,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-75(2)",
          "section": "Requirement to consult on behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "When a restrictive practice is deemed necessary, the registered provider must consult the assessing approved health practitioner and, if applicable, the substitute decision-maker for the individual when preparing or revising the behaviour support plan.",
          "summaryHTML": "When a restrictive practice is deemed necessary, the registered provider must consult the assessing approved health practitioner and, if applicable, the substitute decision-maker for the individual when preparing or revising the behaviour support plan.",
          "extract": "(2) If the use of a restrictive practice in relation to the individual is assessed as necessary as mentioned in section 162-20 or 162-25, the registered provider must also consult the following in preparing, reviewing or revising the behaviour support plan:\n\n(a) the approved health practitioner who made the assessment;\n\n(b) if the individual lacks the capacity to be consulted—the restrictive practices substitute decision-maker for the restrictive practice.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        },
        {
          "id": 404,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 9, Div 3, s162-75(3)",
          "section": "Requirement to consult on behaviour support plans",
          "requirement": "Conditions of Registration",
          "subdivision": "Restrictive practices",
          "sublevel": "Restrictive practices",
          "topic": [
            "agreements",
            "unspecified"
          ],
          "summary": "When consulting the registered provider must provide the plan or revised plan, and any associated information, in an appropriately accessible format.",
          "summaryHTML": "When consulting the registered provider must provide the plan or revised plan, and any associated information, in an appropriately accessible format.",
          "extract": "(3) In consulting under this section, the registered provider must provide the plan or revised plan, and any associated information, in an appropriately accessible format.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s162"
        }
      ]
    },
    {
      "id": 38,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div I, s164",
      "section": "Incident management",
      "requirement": "Conditions of Registration",
      "subdivision": "Management of incidents and complaints",
      "sublevel": "Incident management",
      "topic": [
        "reporting",
        "workforce"
      ],
      "summary": "Registered providers in Category 1 - home and community services, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care must implement and maintain an incident management system, manage and take reasonable steps to prevent incidents, and not victimise or discriminate against anyone for reporting an incident.",
      "summaryHTML": "Registered providers in Category 1 - home and community services, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care and Category 6 - residential care must implement and maintain an incident management system, manage and take reasonable steps to prevent incidents, and not victimise or discriminate against anyone for reporting an incident.",
      "extract": "It is a condition of registration that a registered provider of a kind prescribed by the rules must: \n\n(a) implement and maintain an incident management system in accordance with any requirements prescribed by the rules; and \n\n(b) manage, and take reasonable steps to prevent, incidents in accordance with any requirements prescribed by the rules; and \n\n(c) not victimise or discriminate against anyone for reporting an incident.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631502",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": true,
        "tcp": true
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 129,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, s164-1",
          "section": "Kinds of provider to which the condition applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For section 164 registered providers in Category 1 - home and community services, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care, Category 6 - residential care are prescribed .\n\nProviders registered in registration category subscription trial are also prescribed.",
          "summaryHTML": "For section 164 registered providers in Category 1 - home and community services, Category 3 - advisory and support services, Category 4 - personal care and care support in the home or community, Category 5 - nursing and transition care, Category 6 - residential care are prescribed .\n\nProviders registered in registration category subscription trial are also prescribed.",
          "extract": "For the purposes of section 164 of the Act, a registered provider registered in any of the following provider registration categories is prescribed:\n\n(a) home and community services;\n\n(b) advisory and support services;\n\n(c) personal and care support in the home or community;\n\n(d) nursing and transition care;\n\n(e) residential care;\n\n(f) subscription trial.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 130,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div A, s164-10(1)",
          "section": "Incidents to which this Division applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This Division pertains to incidents occurring in the delivery of funded aged care services that have resulted in, or could reasonably result in, harm to individuals or others.",
          "summaryHTML": "This Division pertains to incidents occurring in the delivery of funded aged care services that have resulted in, or could reasonably result in, harm to individuals or others.",
          "extract": "(1) This Division applies to incidents that consist of acts, omissions, events or circumstances that:\n\n(a) occur, are alleged to have occurred, or are suspected of having occurred, in connection with the delivery of funded aged care services to an individual by a registered provider; and\n\n(b) either:\n\n(i) have caused harm to the individual or another person; or\n\n(ii) could reasonably have been expected to have caused harm to an individual or another person.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 131,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div A, s164-10(2)",
          "section": "Incidents to which this Division applies",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "This Division applies to incidents not covered by subsection 164-10(1) involving acts, omissions, events or circumstances that:\n\n(a) a registered provider becomes aware of in connection with the delivery of funded aged care services to an individual in a residential care home of the registered provider; and\n\n(b) have caused harm to the individual.",
          "summaryHTML": "This Division applies to incidents not covered by subsection 164-10(1) involving acts, omissions, events or circumstances that:\n\n(a) a registered provider becomes aware of in connection with the delivery of funded aged care services to an individual in a residential care home of the registered provider; and\n\n(b) have caused harm to the individual.",
          "extract": "(2) This Division also applies to incidents not covered by subsection (1) that consist of acts, omissions, events or circumstances that:\n\n(a) a registered provider becomes aware of in connection with the delivery of funded aged care services to an individual in a residential care home of the registered provider; and\n\n(b) have caused harm to the individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 132,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div B, s164-15",
          "section": "Requirements for system—objects",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The objects of a registered provider's incident management system must include enhancing the safety, health, well-being and quality of life of individuals; preventing incidents; facilitating open disclosure and the resolution of incidents between individuals and the provider; and promoting continuous improvement of the registered provider's incident management system and service delivery.",
          "summaryHTML": "The objects of a registered provider's incident management system must include enhancing the safety, health, well-being and quality of life of individuals; preventing incidents; facilitating open disclosure and the resolution of incidents between individuals and the provider; and promoting continuous improvement of the registered provider's incident management system and service delivery.",
          "extract": "The objects of a registered provider’s incident management system must include the following:\n\n(a) to promote the safety, health, well-being and quality of life of individuals to whom the provider delivers funded aged care services by:\n\n(i) detecting, addressing and remediating incidents; and\n\n(ii) preventing incidents; and\n\n(iii) ensuring the provider’s incident management system facilitates the open disclosure and resolution of incidents between individuals and the provider; and\n\n(b) to promote continuous improvement of:\n\n(i) the provider’s management and prevention of incidents; and\n\n(ii) the provider’s delivery of funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 133,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div B, s164-20",
          "section": "Requirements for system—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "General Requirements for an Incident Management System\n\nA registered provider's incident management system must have policies and procedures for incident identification; assessment; reporting; support for affected individuals; clarification of the roles and responsibilities of aged care workers and responsible persons in relation to incidents including reportable incidents; notification of reportable incidents; investigations; and remedial actions to ensure compliance with relevant regulations.",
          "summaryHTML": "<i>General Requirements for an Incident Management System</i>\n\nA registered provider's incident management system must have policies and procedures for incident identification; assessment; reporting; support for affected individuals; clarification of the roles and responsibilities of aged care workers and responsible persons in relation to incidents including reportable incidents; notification of reportable incidents; investigations; and remedial actions to ensure compliance with relevant regulations.",
          "extract": "A registered provider’s incident management system must:\n\n(a) be able to identify, record, assess, respond to and report on incidents; and\n\n(b) specify procedures for identifying, recording, assessing, responding to and reporting on incidents; and\n\n(c) require that appropriate support and assistance (including access to advocates and language services) is provided to persons affected by an incident to ensure their safety, health, well-being and quality of life; and\n\n(d) specify how persons affected by an incident will be appropriately involved in the management and resolution of the incident; and\n\n(e) specify the roles and responsibilities of aged care workers and responsible persons of the provider in managing and responding to incidents; and\n\n(f) specify the roles and responsibilities of aged care workers and responsible persons of the provider in notifying reportable incidents to the Commissioner; and\n\n(g) require an aged care worker of the provider who becomes aware of a reportable incident to notify one of the following of that fact as soon as possible:\n\n(i) a responsible person of the provider;\n\n(ii) a supervisor or manager of the aged care worker;\n\n(iii) a person specified for the purposes of paragraph (e) or (f); and\n\n(h) require reportable incidents to be reported to the Commissioner in accordance with Division 2 of Part 2 of Chapter 5 of this instrument; and \n\n(i) specify when an investigation by the provider is required to establish:\n\n(i) the causes of a particular incident; and\n\n(ii) the harm caused by the incident; and\n\n(iii) any operational issues that may have contributed to the incident occurring; and\n\n(j) specify the nature of investigations mentioned in paragraph (i); and\n\n(k) specify when remedial action is required and the nature of that action; and\n\n(l) set out procedures for ensuring that the requirements of sections 164-40 and 164-45 are complied with.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 134,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div B, s164-25(1)-(2)",
          "section": "Requirements for system—recording details of incidents",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements for System Recording of Details of Incidents, and Retention of Records\n\nAs a minimum, the incident management system must provide for detailed recording of each incident including descriptions, the harm caused, whether classifiable as a reportable incident, the timing of events, involved parties and their contact details, provider assessments, provider actions taken, consultations with affected parties, investigation details, and police report information if applicable. These details must be retained for 7 years after the date the record is made or received.",
          "summaryHTML": "<i>Requirements for System Recording of Details of Incidents, and Retention of Records</i>\n\nAs a minimum, the incident management system must provide for detailed recording of each incident including descriptions, the harm caused, whether classifiable as a reportable incident, the timing of events, involved parties and their contact details, provider assessments, provider actions taken, consultations with affected parties, investigation details, and police report information if applicable. These details must be retained for 7 years after the date the record is made or received.",
          "extract": "(1) A registered provider’s incident management system must require the following details, as a minimum, to be recorded in relation to each incident:\n\n(a) a description of the incident, including:\n\n(i) the harm that was caused, or that could reasonably have been expected to have been caused, to each person affected by the incident; and\n\n(ii) if known—the consequences of that harm;\n\n(b) whether the incident is a reportable incident;\n\n(c) if known—the time, date and place at which the incident occurred or was alleged or suspected to have occurred;\n\n(d) the time and date the incident was identified;\n\n(e) the names and contact details of the persons directly involved in the incident;\n\n(f) the names and contact details of any witnesses to the incident;\n\n(g) details of the assessments undertaken in accordance with subparagraph 164-40(1)(b)(i) and subsection 164-45(1);\n\n(h) the actions taken in response to the incident, including actions taken under sections 164-40 or 164-45;\n\n(i) any consultations undertaken with the persons affected by the incident;\n\n(j) whether persons affected by the incident have been provided with any reports or findings regarding the incident;\n\n(k) if an investigation is undertaken by the provider in relation to the incident—the details and outcomes of the investigation;\n\n(l) the name and contact details of the person recording the details of the incident;\n\n(m) if the incident has been reported to the police—the details included in that report.\n\n(2) A registered provider’s incident management system must require details recorded in relation to an incident to be retained for 7 years after the date the record was made or received, in accordance with section 154-3000 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 135,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div B, s164-30",
          "section": "Requirements for system—data collection and analysis",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Incident Systems Data Collection and Analysis\n\nThe incident management system must require collection of data for identifying incidents, addressing systemic issues, providing feedback and training to workers and responsible persons, reporting to the Commissioner, reporting to advisory bodies and improving service quality, along with regular data analysis to evaluate and enhance incident management practices.",
          "summaryHTML": "<i>Incident Systems Data Collection and Analysis</i>\n\nThe incident management system must require collection of data for identifying incidents, addressing systemic issues, providing feedback and training to workers and responsible persons, reporting to the Commissioner, reporting to advisory bodies and improving service quality, along with regular data analysis to evaluate and enhance incident management practices.",
          "extract": "A registered provider’s incident management system must:\n\n(a) require the collection of data relating to incidents that will enable the provider to:\n\n(i) identify occurrences, or alleged or suspected occurrences, of similar incidents; and\n\n(ii) identify and address systemic issues in the quality of funded aged care services delivered by the provider; and\n\n(iii) provide feedback and training to the provider’s aged care workers and responsible persons about managing and preventing incidents; and\n\n(iv) provide information to the Commissioner, if required or requested to do so by the Commissioner; and\n\n(v) provide information to the provider’s quality care advisory body (if any) and consumer advisory bodies (if any) to assist the body or bodies to prepare reports or feedback about the quality of the funded aged care services delivered by the provider; and\n\n(vi) continuously improve the provider’s management and prevention of incidents; and\n\n(b) require the regular analysis and review of data mentioned in paragraph (a) to assess:\n\n(i) the effectiveness of the provider’s management and prevention of incidents; and\n\n(ii) what, if any, actions could be taken to improve the provider’s management and prevention of incidents.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 136,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div B, s164-35(1)-(2)",
          "section": "Requirements for registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "reporting",
            "workforce"
          ],
          "summary": "Requirements for Registered Providers\n\nA registered provider must maintain and distribute documentation of their incident management system, ensure staff understand their roles, provide training, and make the information accessible to individuals to whom care is being delivered and their supporters, carers and advocates.\n\nA registered provider must ensure that incident management training for aged care workers and responsible persons is conducted at least annually and whenever there are changes in roles or the incident management system that impact their responsibilities.",
          "summaryHTML": "<i>Requirements for Registered Providers</i>\n\nA registered provider must maintain and distribute documentation of their incident management system, ensure staff understand their roles, provide training, and make the information accessible to individuals to whom care is being delivered and their supporters, carers and advocates.\n\nA registered provider must ensure that incident management training for aged care workers and responsible persons is conducted at least annually and whenever there are changes in roles or the incident management system that impact their responsibilities.",
          "extract": "(1) A registered provider must:\n\n(a) prepare and keep up to date documents detailing:\n\n(i) the provider’s incident management system, including the objects mentioned in section 164-15 and the requirements mentioned in sections 164-20 to 164-30; and\n\n(ii) the roles and responsibilities in the system of the provider’s aged care workers and responsible persons in identifying, managing and resolving incidents and in preventing incidents from occurring; and\n\n(b) give the documents to:\n\n(i) the provider’s aged care workers and responsible persons; and\n\n(ii) to the Commissioner, if required or requested to do so by the Commissioner; and\n\n(c) ensure that the provider’s aged care workers and responsible persons are aware of, and understand, their roles and responsibilities in the system; and\n\n(d) require the provider’s aged care workers and responsible persons to comply with the system; and\n\n(e) provide appropriate training to the provider’s aged care workers and responsible persons on how the system works, including:\n\n(i) how to recognise, respond to and report incidents; and\n\n(ii) their roles and responsibilities in the system; and\n\n(f) make the documents mentioned in paragraph (a) available, in an accessible form, to the following persons:\n\n(i) the individuals to whom the provider is delivering funded aged care services;\n\n(ii) supporters, family members, carers and advocates of the individuals to whom the provider is delivering funded aged care services, and any other person significant to those individuals; and\n\n(g) assist persons referred to in paragraph (f) to understand how the system works.\n\n(2) Without limiting paragraph (1)(e), a provider provides appropriate training to a person who is an aged care worker or responsible person of the provider if the training is provided:\n\n(a) at least annually; and\n\n(b) at the following times:\n\n(i) when the person becomes an aged care worker or responsible person of the provider;\n\n(ii) when there is a change to how the system works that affects the person’s roles and responsibilities in the system;\n\n(iii) when there is a change to the person’s role that affects the person’s roles and responsibilities in the system.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 137,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div C, s164-40(1)-(3)",
          "section": "Requirements for managing incidents",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements for Managing Incidents\n\nA registered provider must manage incidents by following their incident management system, assessing what assistance is required for the safety, health, well-being and quality of life of affected individuals, providing necessary support, and involving the relevant individuals and their supporters and advocates in the resolution process using open disclosure.\n\nA registered provider is required to notify the police of an incident within 24 hours if there are reasonable grounds to do so. If a registered provider discovers reasonable grounds to report an incident to the police after the incident, they must notify a police officer within 24 hours of that discovery.",
          "summaryHTML": "<i>Requirements for Managing Incidents</i>\n\nA registered provider must manage incidents by following their incident management system, assessing what assistance is required for the safety, health, well-being and quality of life of affected individuals, providing necessary support, and involving the relevant individuals and their supporters and advocates in the resolution process using open disclosure.\n\nA registered provider is required to notify the police of an incident within 24 hours if there are reasonable grounds to do so. If a registered provider discovers reasonable grounds to report an incident to the police after the incident, they must notify a police officer within 24 hours of that discovery.",
          "extract": "General\n\n(1) A registered provider must manage an incident:\n\n(a) in accordance with the provider’s incident management system; and\n\n(b) by doing the following:\n\n(i) assessing the support and assistance required to ensure the safety, health, well-being and quality of life of persons affected by the incident;\n\n(ii) providing that support and assistance to those persons;\n\n(iii) assessing how to appropriately involve each person affected by the incident, or a supporter or advocate of the person, in the management and resolution of the incident;\n\n(iv) involving each person or supporter or advocate in that way;\n\n(v) using an open disclosure process.\n\nNotifying police of incident where reasonable grounds to do so\n\n(2) If there are reasonable grounds to report the incident to police, the provider must notify a police officer of the incident within 24 hours of becoming aware of the incident.\n\n(3) If the provider later becomes aware of reasonable grounds to report the incident to police, the provider must notify a police officer of the incident within 24 hours of becoming aware of those grounds.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        },
        {
          "id": 138,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 1, Sub Div C, s164-45(1)-(3)",
          "section": "Requirements for improving management of incidents and taking reasonable steps to prevent incidents",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Incident management",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirements for improving management of incidents and prevention\n\nA registered provider must assess incidents considering whether the incident could have been prevented, necessary remedial actions, management effectiveness, potential improvements, and whether other parties should be informed. A registered provider is also required to inform the other parties identified during the incident assessment process. Further, they must implement necessary remedial actions identified during the incident assessment and any reasonable improvement actions.",
          "summaryHTML": "<i>Requirements for improving management of incidents and prevention</i>\n\nA registered provider must assess incidents considering whether the incident could have been prevented, necessary remedial actions, management effectiveness, potential improvements, and whether other parties should be informed. A registered provider is also required to inform the other parties identified during the incident assessment process. Further, they must implement necessary remedial actions identified during the incident assessment and any reasonable improvement actions.",
          "extract": "(1) The provider must assess the incident in relation to the following, taking into account the views of persons affected by the incident:\n\n(a) whether the incident could have been prevented;\n\n(b) what, if any, remedial action needs to be undertaken to prevent further similar incidents from occurring, or to minimise their harm;\n\n(c) how well the incident was managed and resolved;\n\n(d) what, if any, actions could be taken to improve the provider’s management and resolution of similar incidents;\n\n(e) whether other persons or bodies should be notified of the incident.\n\n(2) The provider must notify the persons and bodies determined under paragraph (1)(e).\n\n(3) The provider must:\n\n(a) take any actions determined under paragraph (1)(b); and\n\n(b) take any actions determined under paragraph (1)(d) of this section or subparagraph 164-30(b)(ii) that are reasonable in the circumstances.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s164"
        }
      ]
    },
    {
      "id": 39,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 1, Sub Div I, s165(1)-(2)",
      "section": "Complaints, feedback and whistleblowers",
      "requirement": "Conditions of Registration",
      "subdivision": "Management of incidents and complaints",
      "sublevel": "Complaints, feedback and whistleblowers",
      "topic": [
        "complaints",
        "workforce"
      ],
      "summary": "Registered providers must implement and maintain a complaints and feedback management system, manage complaints and feedback in accordance with that system, and not victimise or discriminate against anyone making a complaint or providing feedback. Providers must also implement and manage a whistleblower system, maintain a whistleblower policy and manage disclosures that qualify for protection under section 547. If a complaint or feedback is also a disclosure that qualifies for protection under section 547, providers must manage that disclosure in accordance with the rules. \n\nIf a disclosure qualifies for protection under section 547 and the discloser elects to have it managed as a complaint or feedback under section 165(1)(b), a provider must manage the disclosure in accordance with any requirements prescribed by the rules.",
      "summaryHTML": "Registered providers must implement and maintain a complaints and feedback management system, manage complaints and feedback in accordance with that system, and not victimise or discriminate against anyone making a complaint or providing feedback. Providers must also implement and manage a whistleblower system, maintain a whistleblower policy and manage disclosures that qualify for protection under section 547. If a complaint or feedback is also a disclosure that qualifies for protection under section 547, providers must manage that disclosure in accordance with the rules. \n\nIf a disclosure qualifies for protection under section 547 and the discloser elects to have it managed as a complaint or feedback under section 165(1)(b), a provider must manage the disclosure in accordance with any requirements prescribed by the rules.",
      "extract": "(1) It is a condition of registration that a registered provider: \n\n(a) implement and maintain a complaints and feedback management system in accordance with any requirements prescribed by the rules; and \n\n(b) manage complaints and feedback in accordance with that system and any other requirements prescribed by the rules; and \n\n(c) not victimise or discriminate against anyone for making a complaint or giving feedback; and \n\n(d) implement and maintain a whistleblower system, and maintain a whistleblower policy, in accordance with any requirements prescribed by the rules; and \n\n(e) manage disclosures that qualify for protection under section 547 (whistleblower protections) in accordance with any requirements prescribed by the rules; and \n\n(f) if a complaint or feedback is also a disclosure that qualifies for protection under section 547—manage that disclosure in accordance with any requirements prescribed by the rules.\n\n(2) Without limiting paragraph (1)(f), rules made for the purposes of that paragraph may provide that if a discloser (within the meaning of section 547) elects to have the disclosure managed as a complaint or feedback under paragraph (1)(b), the provider is required to manage the disclosure in accordance with that paragraph rather than paragraph (1)(e).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631503",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 139,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div B, s165-15(1)-(2)",
          "section": "Requirements for system—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "A registered provider's complaints and feedback management system must facilitate the effective handling of complaints and feedback, ensuring accessibility, confidentiality, support for individuals, procedural fairness, and compliance with legal requirements, while also promoting open disclosure and regular reviews of the system.\n\nFor more detailed information refer to section 165-15 Requirements for system - general, paragraphs (1)a-p.\n\nWithout limiting paragraph (1)(l), a disclosure is appropriate if the person about whom the information relates has consented to the disclosure.",
          "summaryHTML": "A registered provider's complaints and feedback management system must facilitate the effective handling of complaints and feedback, ensuring accessibility, confidentiality, support for individuals, procedural fairness, and compliance with legal requirements, while also promoting open disclosure and regular reviews of the system.\n\nFor more detailed information refer to section 165-15 Requirements for system - general, paragraphs (1)a-p.\n\nWithout limiting paragraph (1)(l), a disclosure is appropriate if the person about whom the information relates has consented to the disclosure.",
          "extract": "(1) A registered provider’s complaints and feedback management system must:\n\n(a) be able to:\n\n(i) receive, record, assess, acknowledge, respond to and report on complaints and feedback; and\n\n(ii) securely store information relating to complaints and feedback; and\n\n(b) enable any person to:\n\n(i) make a complaint or give feedback; and\n\n(ii) withdraw a complaint or feedback that the person has made or given; and\n\n(c) enable complaints to be made and withdrawn, and feedback to be given and withdrawn, orally and in writing; and\n\n(d) enable complaints to be made, and feedback to be given, anonymously; and\n\n(e) require that there are to be no costs charged by the provider for making, withdrawing or managing a complaint or giving, withdrawing or managing feedback; and\n\n(f) require that the process for making and resolving complaints and giving and responding to feedback is accessible to any person who wishes to make or give, or has made or given, a complaint or feedback; and\n\n(g) require that appropriate support and assistance (including access to advocates and language services) is provided to:\n\n(i) any person who wishes to make or give, or has made or given, a complaint or feedback; and\n\n(ii) each individual to whom the provider delivers funded aged care services who is directly affected by an issue raised in a complaint or feedback; and\n\n(h) require that the role of the independent aged care advocate is acknowledged and supported; and\n\n(i) enable cooperation with, and facilitate arrangements for, the independent aged care advocate to support the following persons in making a complaint, giving feedback, or otherwise in relation to a complaint made or feedback given:\n\n(i) individuals to whom the provider delivers funded aged care services;\n\n(ii) supporters of those individuals, and other persons supporting those individuals; and\n\n(j) require that, if a person who has made a complaint (other than anonymously), or an individual to whom the provider delivers funded aged care services who is directly affected by an issue raised in the complaint, wishes to be involved in the resolution of the complaint, the person or individual is:\n\n(i) involved in an appropriate way in the resolution of the complaint; and\n\n(ii) kept informed in an appropriate way of the progress and outcome of the complaint; and\n\n(k) require that there are no reprisals for a person who makes a complaint or gives feedback; and\n\n(l) require that information provided in a complaint or feedback is kept confidential and only disclosed if required by law or if the disclosure is otherwise appropriate in the circumstances; and\n\n(m) require that the provider must, in responding to a complaint or feedback, afford procedural fairness to:\n\n(i) the person who made the complaint or gave the feedback (other than anonymously); and\n\n(ii) the person (if any) against whom the complaint is made or who is the subject of the feedback; and\n\n(n) require that the provider practise open disclosure and prioritise restorative practices; and\n\n(o) ensure that any requirements for the referral or notification of complaints under Commonwealth, State or Territory laws (as applicable) are met; and\n\n(p) provide for the system to be reviewed as required, and at least annually, to ensure that it is meeting the requirements mentioned in paragraphs (a) to (o).\n\n(2) Without limiting paragraph (1)(l), a disclosure is appropriate if the person about whom the information relates has consented to the disclosure.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 140,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div B, s165-20(1)-(2)",
          "section": "Requirements for registered providers",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "workforce"
          ],
          "summary": "A registered provider must maintain comprehensive documentation of their complaints and feedback management system, provide staff training and ensure understanding and compliance, provide accessible information to individuals receiving aged care services and those that support them, diffuse understanding of the system, and regularly communicate (at least monthly) receptiveness to complaints and feedback and options to make them while reviewing the system annually.\n\nFor more detailed information refer to section 165-20 Requirements for registered providers, paragraphs (1)a-k.\n\nWithout limiting paragraph (1)(e), a registered provider must ensure that complaints management training for aged care workers and responsible persons is conducted when the person commences then at least annually and whenever there are changes in the system or the individual's role that impact their responsibilities.",
          "summaryHTML": "A registered provider must maintain comprehensive documentation of their complaints and feedback management system, provide staff training and ensure understanding and compliance, provide accessible information to individuals receiving aged care services and those that support them, diffuse understanding of the system, and regularly communicate (at least monthly) receptiveness to complaints and feedback and options to make them while reviewing the system annually.\n\nFor more detailed information refer to section 165-20 Requirements for registered providers, paragraphs (1)a-k.\n\nWithout limiting paragraph (1)(e), a registered provider must ensure that complaints management training for aged care workers and responsible persons is conducted when the person commences then at least annually and whenever there are changes in the system or the individual's role that impact their responsibilities.",
          "extract": "(1) A registered provider must:\n\n(a) prepare and keep up to date documents detailing:\n\n(i) the provider’s complaints and feedback management system, including the requirements mentioned in section 165-15; and\n\n(ii) the roles and responsibilities in the system of the provider’s aged care workers and responsible persons in relation to complaints and feedback; and\n\n(b) give the documents to the provider’s aged care workers and responsible persons; and\n\n(c) ensure that the provider’s aged care workers and responsible persons are aware of, and understand, their roles and responsibilities in the system; and\n\n(d) require the provider’s aged care workers and responsible persons to comply with the system; and\n\n(e) provide appropriate training to the provider’s aged care workers and responsible persons on how the system works, including:\n\n(i) how to handle personal information and data; and\n\n(ii) how to recognise and respond to complaints and feedback; and\n\n(iii) managing relationships and clearly communicating with persons making complaints or giving feedback; and\n\n(iv) when and how to escalate complaints and feedback in the system; and\n\n(v) their roles and responsibilities in the system; and\n\n(f) publish an accessible document that:\n\n(i) describes how a complaint can be made, or feedback can be given, to the provider; and\n\n(ii) describes what a person who makes a complaint or gives feedback to the provider can expect in relation to the provider’s management of the complaint or feedback; and\n\n(iii) includes information about how a complaint can be made, or feedback can be given, to the Complaints Commissioner; and\n\n(iv) explains that the provider will not victimise or discriminate against anyone for making a complaint or giving feedback to the provider or the Complaints Commissioner; and\n\n(v) includes information about how to contact an independent aged care advocate; and \n\n(g) give the document mentioned in paragraph (f) to the following:\n\n(i) individuals to whom the provider delivers funded aged care services;\n\n(ii) any other person who requests the document; and\n\n(h) if it is necessary, to enable a person to whom the document mentioned in paragraph (f) must be given under subparagraph (g)(i) to understand the document, to translate the document into another language or present the document in an alternative appropriate format—translate the document into that language, or present the document in that format, and give the translation or reformatted document to the person; and\n\n(i) help the persons mentioned in subparagraph (g)(i) to understand how the provider’s complaints and feedback management system works; and\n\n(j) communicate regularly, and at least monthly, to the persons mentioned in paragraph (b) and subparagraph (g)(i) that complaints and feedback are welcome; and\n\n(k) review the system as mentioned in paragraph 165-15(p).\n\n(2) Without limiting paragraph (1)(e), the provider provides appropriate training to a person who is an aged care worker or responsible person of the provider if the training is provided:\n\n(a) at regular intervals, which must be at least annually; and\n\n(b) at the following times:\n\n(i) when the person becomes an aged care worker or responsible person of the provider;\n\n(ii) when there is a change to how the system works that affects the person’s roles and responsibilities in the system;\n\n(iii) when there is a change to the person’s role that affects the person’s roles and responsibilities in the system.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 141,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div C, s165-25",
          "section": "Requirements for complaints management and resolution",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "If a provider received a complaint, the provider must:\n- manage the complaint in accordance with the provider’s complaints and feedback management system\n- resolve each issue raised in the complaint by taking appropriate action as soon as practical using an approach that is consistent with the Statement of Rights, appropriate in nature, person-centred and will contribute to continuous improvement\n- unless the complaint is made anonymously, inform relevant parties how to escalate to the Complaints Commissioner\n- take reasonable steps to inform relevant parties of outcomes of the complaint\n- take reasonable steps to provide relevant parties information about the availability of independent aged care advocates to assist with making a new complaint to the Complaints Commissioner.",
          "summaryHTML": "If a provider received a complaint, the provider must:\n- manage the complaint in accordance with the provider’s complaints and feedback management system\n- resolve each issue raised in the complaint by taking appropriate action as soon as practical using an approach that is consistent with the Statement of Rights, appropriate in nature, person-centred and will contribute to continuous improvement\n- unless the complaint is made anonymously, inform relevant parties how to escalate to the Complaints Commissioner\n- take reasonable steps to inform relevant parties of outcomes of the complaint\n- take reasonable steps to provide relevant parties information about the availability of independent aged care advocates to assist with making a new complaint to the Complaints Commissioner.",
          "extract": "If a registered provider receives a complaint, the provider must:\n\n(a) manage the complaint in accordance with the provider’s complaints and feedback management system; and\n\n(b) as soon as practicable after receiving the complaint, resolve each issue raised in the complaint by taking appropriate action in relation to the issue; and\n\n(c) in resolving each issue raised in the complaint, use a resolution approach that:\n\n(i) is consistent with the Statement of Rights; and \n\n(ii) is appropriate given the nature of the issue; and \n\n(iii) is centred around each individual to whom the provider delivers funded aged care services who is directly affected by the issue; and \n\n(iv) seeks to address the issue as raised in the complaint; and \n\n(v) will contribute to the continuous improvement of the provider’s delivery of funded aged care services; and \n\n(d) unless the complaint was made anonymously—take reasonable steps to notify the following persons of the outcome of the complaint, and the reasons for the outcome: \n\n(i) the person who made the complaint; \n\n(ii) if the complaint was made on behalf of an individual to whom the provider is delivering funded aged care services—the individual; and \n\n(e) unless the complaint was made anonymously—take reasonable steps to tell the following persons how the complaint (the initial complaint) can also be made to the Complaints Commissioner: \n\n(i) the person who made the complaint; \n\n(ii) if the complaint was made on behalf of an individual to whom the provider is delivering funded aged care services—the individual; and \n\n(f) take reasonable steps to tell any other person involved in the resolution of the initial complaint how the complaint can also be made to the Complaints Commissioner; and \n\n(g) take reasonable steps to tell the persons mentioned in paragraphs (d) and (e): \n\n(i) how a new complaint about the resolution of the initial complaint can be made to the Complaints Commissioner; \n\n(ii) information about the availability of independent aged care advocates to assist with making a new complaint to the Complaints Commissioner. \n\nNote: See section 29 of the Act for provisions relating to giving information and documents to supporters.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 142,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div C, s165-30(1)-(3)",
          "section": "Requirements for feedback management and resolution",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "A registered provider is required to handle feedback according to their established complaints and feedback management system.\n\nWhen addressing feedback, a registered provider must use a resolution approach that will contribute to continuous improvement and consult relevant parties, including the individual who provided the feedback and their supporters.\n\nThe provider must, unless the feedback was given anonymously, take reasonable steps to tell relevant parties how the feedback can also be given to the Complaints Commission. This includes how new feedback about the resolution of any issues realised by the initial feedback can be made or given to the Complaints Commissioner.",
          "summaryHTML": "A registered provider is required to handle feedback according to their established complaints and feedback management system.\n\nWhen addressing feedback, a registered provider must use a resolution approach that will contribute to continuous improvement and consult relevant parties, including the individual who provided the feedback and their supporters.\n\nThe provider must, unless the feedback was given anonymously, take reasonable steps to tell relevant parties how the feedback can also be given to the Complaints Commission. This includes how new feedback about the resolution of any issues realised by the initial feedback can be made or given to the Complaints Commissioner.",
          "extract": "(1) If a registered provider receives feedback, the provider must manage the feedback in accordance with the provider’s complaints and feedback management system.\n\n(2) In resolving any issues raised in the feedback, the provider must:\n\n(a) use a resolution approach that will contribute to the continuous improvement of the provider’s delivery of funded aged care services; and\n\n(b) unless the feedback was given anonymously—consult with:\n\n(i) the person who gave the feedback; and\n\n(ii) if the feedback was given on behalf of an individual to whom the provider is delivering funded aged care services—the individual; and\n\n(iii) if the person who gave the feedback is an individual to whom the provider is delivering funded aged care services and the individual has consented to the consultation—the individual’s supporter (if any); and\n\n(iv) if the feedback was given on behalf of an individual to whom the provider is delivering funded aged care services and the individual has consented to the consultation—the individual’s supporter (if any).\n\n(3) The provider must:\n\n(a) unless the feedback was given anonymously—take reasonable steps to tell the persons mentioned in paragraph (2)(b) how the feedback (the initial feedback) can also be given to the Complaints Commissioner; and\n\n(b) take reasonable steps to tell any other person involved in the resolution of any issue raised by the initial feedback how the feedback can also be given to the Complaints Commissioner; and\n\n(c) take reasonable steps to tell the persons mentioned in paragraph (2)(b) and paragraph (b) of this subsection how a complaint or new feedback about the resolution of any issue raised by the initial feedback can be made or given to the Complaints Commissioner.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 143,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div C, s165-35(1)-(2)",
          "section": "Other requirements relating to complaints and feedback",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "A registered provider must offer appropriate support and assistance to relevant parties involved in a complaint or feedback process, ensuring they have access to necessary resources. The provider must take reasonable steps to ensure that the relevant parties involved in the complaint or feedback is not adversely affected or suffers any detriment, victimisation or reprisal as a result of making the complaint or giving feedback.  \n\nA registered provider is required to use an open disclosure process for matters related to complaints or feedback.",
          "summaryHTML": "A registered provider must offer appropriate support and assistance to relevant parties involved in a complaint or feedback process, ensuring they have access to necessary resources. The provider must take reasonable steps to ensure that the relevant parties involved in the complaint or feedback is not adversely affected or suffers any detriment, victimisation or reprisal as a result of making the complaint or giving feedback.  \n\nA registered provider is required to use an open disclosure process for matters related to complaints or feedback.",
          "extract": "(1) If a registered provider receives a complaint or feedback, the provider must:\n\n(a) provide appropriate support and assistance (including access to advocates and language services), in relation to contacting the Complaints Commissioner, to the following persons:\n\n(i) the person who made the complaint or gave the feedback (other than anonymously);\n\n(ii) each individual to whom the provider delivers funded aged care services who is directly affected by an issue raised in the complaint or feedback; and\n\n(b) take reasonable steps to ensure that:\n\n(i) the person who made the complaint or gave the feedback, or on whose behalf the complaint was made or the feedback was given, is not adversely affected as a result of the making of the complaint or the giving of the feedback; and\n\n(ii) no individual to whom the provider delivers funded aged care services who is affected by an issue raised in the complaint or feedback suffers any detriment, victimisation or reprisal as a result of the making of the complaint or the giving of the feedback.\n\n(2) A registered provider must use an open disclosure process:\n\n(a) in relation to a matter that is the subject of a complaint or feedback; and\n\n(b) if things go wrong in managing a complaint or feedback or resolving an issue raised in a complaint or feedback.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 144,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div C, s165-35(3)-(4)",
          "section": "Other requirements relating to complaints and feedback",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Handling whistleblower disclosures as complaints or feedback\n\nAn individual who discloses information that qualifies for protection under section 547 of the Act (whistleblower protections) to a provider may elect to have the disclosure managed as a complaint or feedback under paragraph 165(1)(b) of the Act and this Division of the rules.\n\nIf an individual makes such an election, the provider must manage the disclosure as a complaint or feedback in accordance with this Subdivision rather than in accordance with Subdivision E.",
          "summaryHTML": "<i>Handling whistleblower disclosures as complaints or feedback\n</i>\nAn individual who discloses information that qualifies for protection under section 547 of the Act (whistleblower protections) to a provider may elect to have the disclosure managed as a complaint or feedback under paragraph 165(1)(b) of the Act and this Division of the rules.\n\nIf an individual makes such an election, the provider must manage the disclosure as a complaint or feedback in accordance with this Subdivision rather than in accordance with Subdivision E.",
          "extract": "Handling whistleblower disclosures as complaints or feedback\n\n(3) An individual who discloses information that qualifies for protection under section 547 of the Act (whistleblower protections) to a provider may elect to have the disclosure managed as a complaint or feedback under paragraph 165(1)(b) of the Act and this Division of this instrument.\n\n(4) If an individual makes an election under subsection (3), the provider must manage the disclosure as a complaint or feedback in accordance with this Subdivision rather than in accordance with Subdivision E.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 145,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div D, s165-45",
          "section": "Requirements for system—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Whistleblower Disclosures - general system requirements\n\nA registered provider's whistleblower system must support the whistleblower protections outlined in Part 5 of Chapter 7 of the Act, allow individuals to disclose information either orally, in writing or anonymously, to the provider, a responsible person or an aged care worker of the provider. The system must undergo annual reviews to ensure compliance with these requirements.",
          "summaryHTML": "<i>Whistleblower Disclosures - general system requirements</i>\n\nA registered provider's whistleblower system must support the whistleblower protections outlined in Part 5 of Chapter 7 of the Act, allow individuals to disclose information either orally, in writing or anonymously, to the provider, a responsible person or an aged care worker of the provider. The system must undergo annual reviews to ensure compliance with these requirements.",
          "extract": "A registered provider’s whistleblower system must:\n\n(a) support the operation of Part 5 of Chapter 7 of the Act (whistleblower protections); and\n\n(b) enable individuals to disclose information to the following:\n\n(i) the provider;\n\n(ii) a responsible person of the provider;\n\n(iii) an aged care worker of the provider; and\n\n(c) enable disclosures of information mentioned in paragraph (b) to be made:\n\n(i) orally and in writing; and\n\n(ii) anonymously; and\n\n(d) provide for the system to be reviewed as required, and at least annually, to ensure that it is meeting the requirements mentioned in paragraphs (a) to (c).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 146,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div D, s165-50(1)-(2)",
          "section": "Requirements for registered providers—general",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Whistleblower Disclosures - general registered provider requirements \n\nA registered provider must maintain comprehensive documentation of their whistleblower system, ensure staff training, understanding and compliance, promote a culture of receptiveness regarding protected disclosures including regular communication of the options to disclose, and conduct regular reviews of the system to ensure compliance and effectiveness.\n\nA registered provider must make sure that training for aged care workers and responsible persons is conducted at least annually and whenever there are changes in the system or the individual's role that impact their responsibilities.",
          "summaryHTML": "<i>Whistleblower Disclosures - general registered provider requirements</i> \n\nA registered provider must maintain comprehensive documentation of their whistleblower system, ensure staff training, understanding and compliance, promote a culture of receptiveness regarding protected disclosures including regular communication of the options to disclose, and conduct regular reviews of the system to ensure compliance and effectiveness.\n\nA registered provider must make sure that training for aged care workers and responsible persons is conducted at least annually and whenever there are changes in the system or the individual's role that impact their responsibilities.",
          "extract": "(1) A registered provider must:\n\n(a) prepare and keep up to date documents detailing:\n\n(i) the provider’s whistleblower system, including the requirements mentioned in section 165-45; and\n\n(ii) the roles and responsibilities in the system of the provider’s aged care workers and responsible persons; and\n\n(b) give the documents to the provider’s aged care workers and responsible persons; and\n\n(c) ensure that the provider’s aged care workers and responsible persons are aware of, and understand, their roles and responsibilities in the system; and\n\n(d) require the provider’s aged care workers and responsible persons to comply with the system; and\n\n(e) provide appropriate training to the provider’s aged care workers and responsible persons on how the system works, including:\n\n(i) how to handle personal information and data; and\n\n(ii) how to recognise and respond to disclosures that qualify for protection under section 547 of the Act; and\n\n(iii) managing relationships and communicating with disclosers; and\n\n(iv) when and how to escalate disclosures in the system; and\n\n(v) their roles and responsibilities in the system; and\n\n(vi) the penalties for contravening subsection 550(1) of the Act (confidentiality of identity of disclosers); and\n\n(f) communicate regularly, and at least monthly, to the provider’s aged care workers and responsible persons that disclosures that qualify for protection under section 547 of the Act are welcome; and\n\n(g) review the system as mentioned in paragraph 165-45(d).\n\n(2) Without limiting paragraph (1)(e), the provider provides appropriate training to a person who is an aged care worker or responsible person of the provider if the training is provided:\n\n(a) at regular intervals, which must be at least annually; and\n\n(b) at the following times:\n\n(i) when the person becomes an aged care worker or responsible person of the provider;\n\n(ii) when there is a change to how the system works that affects the person’s roles and responsibilities in the system;\n\n(iii) when there is a change to the person’s role that affects the person’s roles and responsibilities in the system.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 147,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div D, s165-55",
          "section": "Requirements for registered providers—whistleblower policy",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "Whistleblower policy - requirements for registered providers\n\nA registered provider must develop and maintain a comprehensive whistleblower policy reflecting all the relevant legal requirements, ensure the policy's accessibility, provide it to relevant individuals, support distribution and understanding of the policy, and regularly communicate (at least monthly) receptiveness to and options for protected disclosures.\n\nFor more detailed information refer to section 165-55 Requirements for registered providers - whistleblower policy, paragraphs a-g.",
          "summaryHTML": "<i>Whistleblower policy - requirements for registered providers</i>\n\nA registered provider must develop and maintain a comprehensive whistleblower policy reflecting all the relevant legal requirements, ensure the policy's accessibility, provide it to relevant individuals, support distribution and understanding of the policy, and regularly communicate (at least monthly) receptiveness to and options for protected disclosures.\n\nFor more detailed information refer to section 165-55 Requirements for registered providers - whistleblower policy, paragraphs a-g.",
          "extract": "A registered provider must:\n\n(a) prepare and keep up to date a whistleblower policy that sets out the following:\n\n(i) the effect of Part 5 of Chapter 7 of the Act;\n\n(ii) that individuals may disclose information to the provider or another person mentioned in section 547 of the Act, and how such disclosures may be made;\n\n(iii) how the provider will manage disclosures that qualify for protection under section 547 of the Act that are made to the provider or a responsible person or aged care worker of the provider;\n\n(iv) that individuals may also disclose information to the entities mentioned in subparagraphs 547(a)(i), (ii), (vi) and (vii) of the Act, and how such disclosures may be made;\n\n(v) how the provider will investigate disclosures;\n\n(vi) how the provider will comply with the requirements mentioned in paragraphs 165-60(c) and (d) of this instrument;\n\n(vii) how the provider will comply with the obligations in section 553 of the Act;\n\n(viii) what an individual who has made a disclosure that qualifies for protection under section 547 of the Act can do if they suspect that there has been a contravention of a provision of Part 5 of Chapter 7 of the Act; and\n\n(b) publish the policy in an accessible document; and\n\n(c) give the policy to the provider’s aged care workers and responsible persons; and\n\n(d) give the policy to the following:\n\n(i) individuals to whom the provider delivers funded aged care services;\n\n(ii) a person who requests the policy and is a supporter of an individual to whom the provider delivers funded aged care services;\n\n(iii) any other person who requests the policy; and\n\n(e) if it is necessary, to enable a person to whom the policy must be given under subparagraph (d)(i) or (ii) to understand the policy, to translate the policy into another language or present the policy in an alternative appropriate format—translate the policy into that language, or present the policy in that format, and give the translation or reformatted policy to the person; and\n\n(f) help the persons mentioned in subparagraphs (d)(i) and (ii) to understand how the whistleblower system works; and\n\n(g) communicate regularly, and at least monthly, to the persons mentioned in paragraph (c) and subparagraphs (d)(i) and (ii) that disclosures that qualify for protection under section 547 of the Act are welcome.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        },
        {
          "id": 148,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 4, Part 10, Div 2, Sub Div E, s165-60",
          "section": "Requirements for managing disclosures",
          "requirement": "Conditions of Registration",
          "subdivision": "Management of incidents and complaints",
          "sublevel": "Complaints, feedback and whistleblowers",
          "topic": [
            "complaints",
            "unspecified"
          ],
          "summary": "If an individual reports an issue that is protected under section 547 of the Act to a registered provider or an aged care worker of the provider, the provider must:\n- Handle the report according to their whistleblower policy and take appropriate action as soon as possible after receiving the report.\n- Provide support to the person who made the report and any other person or entity connected to the reporter who might face negative consequences because of the report.\n- Ensure that any staff member mentioned in the report is treated fairly.\n\nNote: There are penalties for retaliating against someone who makes a protected report, as outlined in section 551 of the Act.",
          "summaryHTML": "If an individual reports an issue that is protected under section 547 of the Act to a registered provider or an aged care worker of the provider, the provider must:\n- Handle the report according to their whistleblower policy and take appropriate action as soon as possible after receiving the report.\n- Provide support to the person who made the report and any other person or entity connected to the reporter who might face negative consequences because of the report.\n- Ensure that any staff member mentioned in the report is treated fairly.\n\nNote: There are penalties for retaliating against someone who makes a protected report, as outlined in section 551 of the Act.",
          "extract": "If an individual makes a disclosure that qualifies for protection under section 547 of the Act to a registered provider or a responsible person or aged care worker of the provider, the provider must: \n\n(a) manage the disclosure in accordance with the provider’s whistleblower system; and \n\n(b) as soon as practicable after the disclosure is made, take appropriate action in relation to the disclosure; and \n\n(c) support: \n\n(i) the individual (the first individual) who made the disclosure; and \n\n(ii) any other individual, or an entity, that employs or is otherwise associated with the first individual, and to which detriment might be caused, or a threat of detriment might be made, because of the disclosure; and \n\n(d) ensure fair treatment of any responsible person or aged care worker of the provider who is mentioned in the disclosure or to whom the disclosure relates. \n\nNote: See section 551 of the Act for civil penalties for victimisation relating to a disclosure that qualifies for protection under section 547 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s165(1)-(2)"
        }
      ]
    },
    {
      "id": 68,
      "source": "Aged Care and Other Legislation Amendment Bill 2025",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s165A (1)-(2).",
      "section": "Reports about reportable incidents",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reportable incidents",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "Requirement to report\n\n(1) A registered provider of a kind prescribed by the rules must, if the rules prescribe that reports relating to reportable incidents must be given to the Commissioner, report reportable incidents to the Commissioner in accordance with this section.\n\n(2) A report under subsection (1) must:\n\n(a) be in the approved report form; and\n\n(b) be prepared, and given, in accordance with any other requirements prescribed by the rules.\n\nNote: For approved report form, see section 166A.",
      "summaryHTML": "<i>Requirement to report</i>\n\n(1) A registered provider of a kind prescribed by the rules must, if the rules prescribe that reports relating to reportable incidents must be given to the Commissioner, report reportable incidents to the Commissioner in accordance with this section.\n\n(2) A report under subsection (1) must:\n\n(a) be in the approved report form; and\n\n(b) be prepared, and given, in accordance with any other requirements prescribed by the rules.\n\nNote: For approved report form, see section 166A.",
      "extract": "Requirement to report\n\n(1) A registered provider of a kind prescribed by the rules must, if the rules prescribe that reports relating to reportable incidents must be given to the Commissioner, report reportable incidents to the Commissioner in accordance with this section.\n\n(2) A report under subsection (1) must:\n\n(a) be in the approved report form; and\n\n(b) be prepared, and given, in accordance with any other requirements prescribed by the rules.\n\nNote: For approved report form, see section 166A.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631506",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 69,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s166(1)",
      "section": "Other reports by registered providers",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reporting",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "Registered providers prescribed by the rules must give reports, as required, to the appropriate authority such as the Commissioner, Complaints Commissioner, Inspector General of Aged Care, System Governor, or Pricing Authority.",
      "summaryHTML": "Registered providers prescribed by the rules must give reports, as required, to the appropriate authority such as the Commissioner, Complaints Commissioner, Inspector General of Aged Care, System Governor, or Pricing Authority.",
      "extract": "Requirement to report\n\n(1) A registered provider of a kind prescribed by the rules must, if the rules prescribe that a report must be given to one of the following persons, give a report to that person in accordance with this section:\n\n(a) the Commissioner;\n\n(b) the Complaints Commissioner;\n\n(c) the Inspector General of Aged Care;\n\n(d) the System Governor;\n\n(e) the Pricing Authority.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631507",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 419,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div A, s166-5",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For this subdivision providers in registration Category 6 - residential care are prescribed.",
          "summaryHTML": "For this subdivision providers in registration Category 6 - residential care are prescribed.",
          "extract": "This Subdivision applies to a registered provider registered in the provider registration category residential care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 420,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div A, s166-10(1)-(4)",
          "section": "Reports about service staff—influenza vaccinations",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Upon request from the Commissioner and/or the System Governor, a registered provider is required to provide a report detailing service staff numbers in an approved residential care home, and their reported influenza vaccination status as at the reporting day requested.\n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider is required to respond to a request within 7 days, or within a mutually agreed extended timeframe with the System Governor or the Commissioner.",
          "summaryHTML": "Upon request from the Commissioner and/or the System Governor, a registered provider is required to provide a report detailing service staff numbers in an approved residential care home, and their reported influenza vaccination status as at the reporting day requested.\n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider is required to respond to a request within 7 days, or within a mutually agreed extended timeframe with the System Governor or the Commissioner.",
          "extract": "(1) For the purposes of paragraph 166(1)(a) and (d) of the Act, this section prescribes that a registered provider must, on request by the System Governor or the Commissioner, give the System Governor or the Commissioner a report, in a form approved by the System Governor, that sets out the following information as at the reporting day specified in the request:\n\n(a) the total number of service staff in relation to the approved residential care home;\n\n(b) the number of those service staff who have informed the registered provider, whether voluntarily or as required under a law of a State or Territory, that they have received the annual seasonal influenza vaccination for the calendar year that includes the reporting day (whether or not under the registered provider’s influenza vaccination scheme (if any)).\n\n(2) The System Governor or the Commissioner may, at any time, request a registered provider to give to the System Governor or the Commissioner a report under subsection (1).\n\n(3) A request under subsection (2) must:\n\n(a) be in writing; and\n\n(b) specify a reporting day that is not more than 3 years before the request is made.\n\n(4) A registered provider must comply with a request under subsection (2) within 7 days after the request is made, or such longer period as is agreed, in writing, between the System Governor or the Commissioner and the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 421,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div A, s166-15(1)-(4)",
          "section": "Reports about service staff—COVID-19 vaccinations",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Upon request from the System Governor or the Commissioner, a registered provider is required to provide a report detailing service staff numbers in an approved residential care home and the number who have voluntarily reported receiving a COVID-19 vaccination. \n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider is required to respond to a request within 7 days, or within a mutually agreed extended timeframe with the System Governor or the Commissioner.",
          "summaryHTML": "Upon request from the System Governor or the Commissioner, a registered provider is required to provide a report detailing service staff numbers in an approved residential care home and the number who have voluntarily reported receiving a COVID-19 vaccination. \n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider is required to respond to a request within 7 days, or within a mutually agreed extended timeframe with the System Governor or the Commissioner.",
          "extract": "(1) For the purposes of paragraph 166(1)(a) and (d) of the Act, this section prescribes that a registered provider must, on request by the System Governor or the Commissioner, give the System Governor or the Commissioner a report, in a form approved by the System Governor, that sets out the following information as at the reporting day specified in the request:\n\n(a) the total number of service staff in relation to the approved residential care home;\n\n(b) the number of those service staff who have voluntarily informed the registered provider that they have, in the period specified in the request before the reporting day, received a COVID-19 vaccination.\n\n(2) The System Governor or the Commissioner may, at any time, request a registered provider to give to the System Governor or the Commissioner a report under subsection (1).\n\n(3) A request under subsection (2) must:\n\n(a) be in writing; and\n\n(b) specify a reporting day that is not more than 3 years before the request is made.\n\n(4) A registered provider must comply with a request under subsection (2) within 7 days after the request is made, or such longer period as is agreed, in writing, between the System Governor or the Commissioner and the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 422,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div A, s166-25(1)-(4)",
          "section": "Reports about individuals receiving residential care—COVID-19 vaccinations",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must, when requested, submit an approved report to the System Governor or Commissioner detailing the number of individuals in residential care and their COVID-19 vaccination status. \n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider must respond to a request within 7 days, or a longer agreed period, as specified by the System Governor or Commissioner.",
          "summaryHTML": "A registered provider must, when requested, submit an approved report to the System Governor or Commissioner detailing the number of individuals in residential care and their COVID-19 vaccination status. \n\nThis request may be given at any time, must be in writing and must specify a reporting day that is not more than 3 years before the request is made.\n\nA registered provider must respond to a request within 7 days, or a longer agreed period, as specified by the System Governor or Commissioner.",
          "extract": "(1) For the purposes of paragraph 166(1)(a) and (d) of the Act, this section prescribes that a registered provider must, on request by the System Governor or the Commissioner, give the System Governor or the Commissioner a report, in a form approved by the System Governor, that sets out the following information, as at the reporting day specified in the request:\n\n(a) the total number of individuals accessing funded aged care services in an approved residential care home;\n\n(b) the number of those individuals who have voluntarily informed the registered provider, in the period specified in the request before the reporting day, that they had received one or more COVID-19 vaccinations;\n\n(c) the number of individuals covered by paragraph (b) who have informed the registered provider that they had received only one COVID-19 vaccination; \n\n(d) the number of individuals covered by paragraph (b) who have informed the registered provider that they had received 2 COVID-19 vaccinations. \n\n(2) The System Governor or the Commissioner may, at any time, request a registered provider to give to the System Governor or the Commissioner a report under subsection (1).\n\n(3) A request under subsection (2) must:\n\n(a) be in writing; and\n\n(b) specify a reporting day that is not more than 3 years before the request is made.\n\n(4) A registered provider must comply with a request under subsection (2) within 7 days after the request is made, or such longer period as is agreed, in writing, between the System Governor or the Commissioner and the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 423,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-105(1)-(2)",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For this subdivision providers in registration Category 6 - residential care are prescribed. The requirements do not apply to a registered provider in respect of the delivery of funded aged care services under a specialist aged care program.",
          "summaryHTML": "For this subdivision providers in registration Category 6 - residential care are prescribed. The requirements do not apply to a registered provider in respect of the delivery of funded aged care services under a specialist aged care program.",
          "extract": "(1) Subject to subsection (2), this Subdivision applies to a registered provider registered in the provider registration category residential care.\n\n(2) The requirements of this Subdivision do not apply to a registered provider in respect of the delivery of funded aged care services under a specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 424,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-110(1)",
          "section": "Requirement to provide a quality indicators report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This rule is only relevant to section 166(1).\n\nRegistered providers must submit a quality indicators report to the System Governor for each reporting period.",
          "summaryHTML": "This rule is only relevant to section 166(1).\n\nRegistered providers must submit a quality indicators report to the System Governor for each reporting period.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, a registered provider must give a report (the quality indicators report) on the quality indicators provided in this Subdivision to the System Governor each reporting period.\n\nNote: For the reporting period for a quality indicators report, see section 166-115.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 425,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-110(2)",
          "section": "Requirement to provide a quality indicators report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This rule is only relevant to section 166(1).\n\nRegistered providers must report the exclusion of individuals from assessments when required, even if those individuals are not included in specific evaluations.",
          "summaryHTML": "This rule is only relevant to section 166(1).\n\nRegistered providers must report the exclusion of individuals from assessments when required, even if those individuals are not included in specific evaluations.",
          "extract": "(2) To avoid doubt, if any individuals are excluded for any reason under this Subdivision, a registered provider is required to include information about the exclusion of those individuals in the report where required. \n\nExample:  If an individual is absent from the approved residential care home throughout the reporting period, as referred to in paragraph 166-135(1)(b) of this instrument, the registered provider is not required to include that individual in an assessment for falls and falls resulting in major injury, as referred to in paragraph 166-135(1)(a), but must include information about the exclusion of the individual under paragraph 166-135(1)(b).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 426,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-112(1)",
          "section": "Requirements for the collection of information for quality indicators reports—measurements and assessments",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This rule is only relevant to paragraph (a) of section 166(4).\n\nA registered provider must measure or assess the quality of residential care, gather information from those measurements, and then provide that information to the System Governor for a quality indicator report.",
          "summaryHTML": "This rule is only relevant to paragraph (a) of section 166(4).\n\nA registered provider must measure or assess the quality of residential care, gather information from those measurements, and then provide that information to the System Governor for a quality indicator report.",
          "extract": "(1) For the purposes of paragraph 166(4)(a) of the Act, a registered provider must: \n\n(a) make measurements or other assessments relevant to indicating the quality of residential care; and \n\n(b) compile or otherwise derive information from those measurements and assessments mentioned in paragraph (a); and \n\n(c) give the information to the System Governor for the purposes of a quality indicator report.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 428,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B s166-120(1)-(3)",
          "section": "Quality indicator—pressure injuries",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—pressure injuries\n\nA quality indicators report must include information about pressure injuries, including the assessments, exclusions, and classifications of injuries based on specific stages and categories, as defined by the relevant classification system.\n\nRegistered providers must schedule a specific date each reporting period to assess pressure injuries for each resident, collect data during a single observation assessment around the same time, and conduct a complete assessment as part of the residents' regular personal care routine.\n\nRegistered providers must inform individuals about the planned assessment of their pressure injuries and obtain their consent before conducting the assessment.",
          "summaryHTML": "<i>Quality indicator—pressure injuries</i>\n\nA quality indicators report must include information about pressure injuries, including the assessments, exclusions, and classifications of injuries based on specific stages and categories, as defined by the relevant classification system.\n\nRegistered providers must schedule a specific date each reporting period to assess pressure injuries for each resident, collect data during a single observation assessment around the same time, and conduct a complete assessment as part of the residents' regular personal care routine.\n\nRegistered providers must inform individuals about the planned assessment of their pressure injuries and obtain their consent before conducting the assessment.",
          "extract": "(1) A quality indicators report must include the following information on pressure injuries and the number of individuals receiving funded aged care services that:\n\n(a) were assessed for pressure injuries;\n\n(b) were excluded because of withholding consent to undergo an observational assessment for pressure injuries throughout the reporting period;\n\n(c) were excluded because of an absence from accessing funded aged care services throughout the reporting period; \n\n(d) have one or more pressure injuries;\n\n(e) have one or more pressure injuries with each injury measured and reported against the following sub-categories: \n\n(i) Stage 1 Pressure Injury;\n\n(ii) Stage 2 Pressure Injury;\n\n(iii) Stage 3 Pressure Injury;\n\n(iv) Stage 4 Pressure Injury;\n\n(v) Unstageable Pressure Injury;\n\n(vi) Suspected Deep Tissue Pressure Injury;\n\n(f) have one or more pressure injuries acquired outside the approved residential care home during the reporting period;\n\n(g) have one or more pressure injuries acquired outside the approved residential care home during the reporting period with each injury measured and reported against the following sub-categories: \n\n(i) Stage 1 Pressure Injury; \n\n(ii) Stage 2 Pressure Injury; \n\n(iii) Stage 3 Pressure Injury; \n\n(iv) Stage 4 Pressure Injury; \n\n(v) Unstageable Pressure Injury; \n\n(vi) Suspected Deep Tissue Pressure Injury. \n\nNote: For paragraphs (e) and (g), the relevant sub-category of pressure injury is determined by reference to the ICD-10 Australian Modified Pressure Injury Classification System.\n\n(2) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must: \n\n(a) identify a date once every reporting period when assessment for pressure injuries is to be carried out for each individual residing at the approved residential care home; and \n\n(b) collect data relating to pressure injures for each individual during a single observation assessment at approximately the same time every reporting period; and \n\n(c) carry out assessment on or around the same time each reporting period and complete assessment as part of the individual’s routine personal care (such as bathing and toileting). \n\n(3) Registered providers, in assessing and reporting pressure injuries acquired by individuals, must inform the individual about the proposed assessment and must seek consent from the individual before the assessment takes place.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 429,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-125(1)-(4)",
          "section": "Quality indicator—restrictive practices",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—restrictive practices\n\nA quality indicators report must include information on restrictive practices, including information on the collection period, assessments conducted, exclusions due to absence, and the number of individuals subjected to such practices, along with specific conditions of use.\n\nInformation for this quality indicator is to be collected over 3-days during the reporting period. \n\nRegistered providers must also identify and document a collection date for each reporting period, make sure that this date is unexpected for the staff involved in the care, ensure that the collection period lasts three days (including the chosen date and the two days prior), and apply the same three-day collection period for all individuals receiving funded aged care services at the residential care home.\n\nRegistered providers must examine an individual's existing record during the three-day collection period to determine if the individual experienced any restrictive practices (excluding chemical restraint) at any time during that period.",
          "summaryHTML": "<i>Quality indicator—restrictive practices</i>\n\nA quality indicators report must include information on restrictive practices, including information on the collection period, assessments conducted, exclusions due to absence, and the number of individuals subjected to such practices, along with specific conditions of use.\n\nInformation for this quality indicator is to be collected over 3-days during the reporting period. \n\nRegistered providers must also identify and document a collection date for each reporting period, make sure that this date is unexpected for the staff involved in the care, ensure that the collection period lasts three days (including the chosen date and the two days prior), and apply the same three-day collection period for all individuals receiving funded aged care services at the residential care home.\n\nRegistered providers must examine an individual's existing record during the three-day collection period to determine if the individual experienced any restrictive practices (excluding chemical restraint) at any time during that period.",
          "extract": "(1) A quality indicators report must include the following information on restrictive practices: \n\n(a) the collection date in the reporting period; \n\n(b) the number of individuals whose records were assessed for the use of restrictive practices other than chemical restraint throughout the collection period; \n\n(c) the number of individuals excluded because of an absence from accessing funded aged care services throughout the collection period; \n\n(d) the number of individuals subjected to the use of restrictive practices other than chemical restraint throughout the collection period: \n\n(i) on any occasion; \n\n(ii) on any occasion only in a secured area. \n\nNote: See section 17-5 (Practices and interventions that are restrictive practices in relation to individuals). Restrictive practices covered by this section include environmental restraint, mechanical restraint, physical restraint and seclusion as defined in section 17-5. \n\n(2) For the purposes of subsection (1), a collection period for this quality indicator is a 3-day period during the reporting period.\n\n(3) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must; \n\n(a) identify and record a collection date which is to take place during each reporting period; and \n\n(b) ensure that the collection date is varied and unpredictable to staff directly involved in the care of an individual; and \n\n(c) ensure that the 3-day collection period consists of the selected collection date and the 2 days before that date; and \n\n(d) ensure that the 3-day collection period is the same for all individuals receiving funded aged care services at the approved residential care home. \n\n(4) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must review an individual’s existing record over the 3- day collection period and assess whether the individual was subject to the use of restrictive practices other than chemical restraint at any stage during the collection period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 430,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-130(1)-(3)",
          "section": "Quality indicator—unplanned weight loss",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—unplanned weight loss\n\nThe quality indicators report must include information on unplanned weight loss, including details which are categorised into significant unplanned weight loss and consecutive unplanned weight loss.\n\nThe quality indicators report must detail significant unplanned weight loss, including assessments made, exclusions due to consent or care status, issues with weight recording, and instances of individuals experiencing a significant weight decrease. \n\nRegistered providers must check each individual's previous weight from the care home's records, weigh them in the last month of the reporting period with consent, and ensure consistency in timing and clothing. They should then compare the current weight to the previous weight for those who consented and calculate any percentage weight loss.",
          "summaryHTML": "<i>Quality indicator—unplanned weight loss</i>\n\nThe quality indicators report must include information on unplanned weight loss, including details which are categorised into significant unplanned weight loss and consecutive unplanned weight loss.\n\nThe quality indicators report must detail significant unplanned weight loss, including assessments made, exclusions due to consent or care status, issues with weight recording, and instances of individuals experiencing a significant weight decrease. \n\nRegistered providers must check each individual's previous weight from the care home's records, weigh them in the last month of the reporting period with consent, and ensure consistency in timing and clothing. They should then compare the current weight to the previous weight for those who consented and calculate any percentage weight loss.",
          "extract": "(1) A quality indicators report must include information on unplanned weight loss, with information reported under the following categories:\n\n(a) significant unplanned weight loss;\n\n(b) consecutive unplanned weight loss.\n\n(2) For the purposes of paragraph (1)(a), a quality indicators report must include the following information on significant unplanned weight loss and the number of individuals accessing funded aged care services that: \n\n(a) were assessed for significant unplanned weight loss; \n\n(b) were excluded because of withholding consent to be weighed on the finishing weight collection date; \n\n(c) were excluded because of receiving end-of-life care; \n\n(d) were excluded because the previous or finishing weights were not recorded, including comments on why any such weights were not recorded; \n\n(e) experienced a 5% or higher decrease in weight between the finishing weight and the previous weight. \n\n(3) Registered providers, in preparing the quality indicators report for the purposes of paragraph (1)(a), must: \n\n(a) identify each individual’s previous weight using the approved residential care home’s weight records of individuals in the residential care home; and \n\n(b) collect and record the finishing weight for each individual residing at the approved residential care home in the final month of the current reporting period using a calibrated scale; and \n\n(c) seek the consent of the individuals concerned before making the assessment required and must record any refusal to provide consent by an individual being assessed for their finishing weight; and \n\n(d) weigh individuals at or around the same time each month and at around the same time of the day and ensure that the individual is wearing clothing of a similar weight; and \n\n(e) for each individual who provided their consent for the making of the assessment, compare their finishing weight from the current reporting period with their previous weight and calculate the percentage weight loss.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 431,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-130(4)-(5)",
          "section": "Quality indicator—unplanned weight loss",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—unplanned weight loss\n\nA registered provider's report must include details about consecutive unplanned weight loss among individuals using funded aged care services, specifically noting how many were assessed, how many excluded for refusing to be weighed, those receiving end-of-life care, or where weight records were missing, as well as those who experienced any weight decrease during the reporting period.\n\nRegistered providers must measure and record the weights of residents at an approved care home over three consecutive months, comparing starting, middle, and finishing weights to assess any unplanned weight loss, while ensuring consent is obtained and that measurements are taken consistently. If previous weights have been recorded for significant weight loss assessments, those can be used without re-measuring.",
          "summaryHTML": "<i>Quality indicator—unplanned weight loss</i>\n\nA registered provider's report must include details about consecutive unplanned weight loss among individuals using funded aged care services, specifically noting how many were assessed, how many excluded for refusing to be weighed, those receiving end-of-life care, or where weight records were missing, as well as those who experienced any weight decrease during the reporting period.\n\nRegistered providers must measure and record the weights of residents at an approved care home over three consecutive months, comparing starting, middle, and finishing weights to assess any unplanned weight loss, while ensuring consent is obtained and that measurements are taken consistently. If previous weights have been recorded for significant weight loss assessments, those can be used without re-measuring.",
          "extract": "(4) For the purposes of paragraph (1)(b), a quality indicators report must include the following information on consecutive unplanned weight loss and the number of individuals accessing funded aged care services that: \n\n(a) were assessed for consecutive unplanned weight loss; \n\n(b) were excluded because of withholding consent to be weighed on any weight collection date; \n\n(c) were excluded because of receiving end-of-life care; \n\n(d) were excluded because any of the required weights were not recorded, including comments on why any such weights were not recorded; \n\n(e) experienced any decrease in weight between the previous weight, starting weight, middle weight and finishing weight. \n\n(5) Registered providers, in preparing the quality indicators report for the purposes of paragraph (1)(b), must: \n\n(a) measure consecutive unplanned weight loss as the weight loss of any amount measured every month over 3 consecutive months of a reporting period, and the 3 monthly weights are compared against each other and against the finishing weight from the previous reporting period; and \n\n(b) use their approved residential care home’s weight records in identifying each individual’s previous weight; and \n\n(c) in the first month of the reporting period, collect and record the starting weight of each individual residing at the approved residential care home using a calibrated scale; and \n\n(d) in the second month of the reporting period collect and record the middle weight of each individual residing at the approved residential care home using a calibrated scale; and \n\n(e) in the third and final month of the reporting period collect and record the finishing weight of each individual at the approved residential care home using a calibrated scale; and \n\n(f) where previous weights and finishing weights may already have been collected and recorded for the individual as part of assessments and measurements made for significant unplanned weight loss, the previous weight and finishing weights recorded and collected can be used for assessing consecutive unplanned weight loss and do not need to be collected again; and  \n\n(g) seek the consent of the individuals concerned before making the assessment required and must record any refusal to provide consent by an individual being assessed for their finishing weight; and \n\n(h) weigh individuals at or around the same time each month and at around the same time of the day and ensure that the individual is wearing clothing of a similar weight; and \n\n(i) for each individual who provided their consent for the making of the assessment, compare their previous, starting, middle and finishing weight to determine whether there has been weight loss in every month over 3 consecutive months of a reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 432,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-135(1)-(2)",
          "section": "Quality indicator—falls and major injury",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—falls and major injury\n\nThe quality indicators report must provide information on individuals whose records were assessed for falls and major injuries, including those excluded because they were absent and not accessing funded aged care services. This report should also include those who experienced falls, and those whose falls resulted in major injuries, during the reporting period.\n\nWhen preparing a quality indicators report, registered providers must identify and record a date for collecting data, ensuring that this date falls within 21 days after the end of the reporting period.",
          "summaryHTML": "<i>Quality indicator—falls and major injury</i>\n\nThe quality indicators report must provide information on individuals whose records were assessed for falls and major injuries, including those excluded because they were absent and not accessing funded aged care services. This report should also include those who experienced falls, and those whose falls resulted in major injuries, during the reporting period.\n\nWhen preparing a quality indicators report, registered providers must identify and record a date for collecting data, ensuring that this date falls within 21 days after the end of the reporting period.",
          "extract": "(1) A quality indicators report must include the following information on falls and falls resulting in major injury, and the number of individuals accessing funded aged care services: \n\n(a) whose records were assessed for falls and falls resulting in major injury; \n\n(b) who were excluded because of an absence from accessing funded aged care services at the approved residential care home throughout the reporting period; \n\n(c) who experienced one or more falls at the approved residential care home during the reporting period; \n\n(d) who experienced one or more falls at the approved residential care home resulting in major injury during the reporting period. \n\n(2) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must: \n\n(a) identify and record a collection date for the reporting period; and \n\n(b) ensure that the collection date is in the 21 days after the end of the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 433,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-140(1)-(7)",
          "section": "Quality indicator—medication management",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—medication management\n\nThe quality indicators report must include information about medication management, including specific reporting on polypharmacy and antipsychotics.\n\nThe quality indicators report must also provide specific information on polypharmacy, including the collection date, assessments conducted, exclusions due to hospital admissions, and the number of individuals prescribed 9 or more medications based on their medication or administration records.\n\nThe quality indicators report must further include the collection date, the number of individuals assessed for antipsychotic medications, those excluded due to hospitalisation, and the number of individuals who received antipsychotic medications or were treated for psychosis, based on reviews of their medication charts or administration records on the collection date.\n\nThe collection date for polypharmacy can be any day within the reporting period, and data collection must consist of a single review of each individual's medication charts and administration records on that specific date. \n\nWhen preparing a quality indicators report on polypharmacy, registered providers must identify and record a collection date for the reporting period and use each individual's medication charts and administration records as of that date.\n\nFor the report on antipsychotics, the collection date is the last day of a 7-day period within the reporting period.\n\nWhen preparing a quality indicators report on antipsychotics, registered providers must also identify a collection date between the second week and the end of the reporting period, review all individuals' medication charts and administration records from that date and the six days prior, and ensure that the collection date varies between reporting periods. Additionally, the assessment must be conducted by staff who are not directly involved in the care of the individuals receiving funded aged care services.",
          "summaryHTML": "<i>Quality indicator—medication management</i>\n\nThe quality indicators report must include information about medication management, including specific reporting on polypharmacy and antipsychotics.\n\nThe quality indicators report must also provide specific information on polypharmacy, including the collection date, assessments conducted, exclusions due to hospital admissions, and the number of individuals prescribed 9 or more medications based on their medication or administration records.\n\nThe quality indicators report must further include the collection date, the number of individuals assessed for antipsychotic medications, those excluded due to hospitalisation, and the number of individuals who received antipsychotic medications or were treated for psychosis, based on reviews of their medication charts or administration records on the collection date.\n\nThe collection date for polypharmacy can be any day within the reporting period, and data collection must consist of a single review of each individual's medication charts and administration records on that specific date. \n\nWhen preparing a quality indicators report on polypharmacy, registered providers must identify and record a collection date for the reporting period and use each individual's medication charts and administration records as of that date.\n\nFor the report on antipsychotics, the collection date is the last day of a 7-day period within the reporting period.\n\nWhen preparing a quality indicators report on antipsychotics, registered providers must also identify a collection date between the second week and the end of the reporting period, review all individuals' medication charts and administration records from that date and the six days prior, and ensure that the collection date varies between reporting periods. Additionally, the assessment must be conducted by staff who are not directly involved in the care of the individuals receiving funded aged care services.",
          "extract": "(1) A quality indicators report must include information on medication management, with information reported under the following categories:\n\n(a) polypharmacy;\n\n(b) antipsychotics.\n\n(2) For the purposes of paragraph (1)(a), a quality indicators report must include the following information on polypharmacy:\n\n(a) the collection date in the reporting period;\n\n(b) the number of individuals assessed for polypharmacy;\n\n(c) the number of individuals excluded because they were admitted to hospital on the collection date;\n\n(d) the number of individuals prescribed 9 or more medications based on a review of any of the following taken on the collection date:\n\n(i) the individual’s medication chart;\n\n(ii) the individual’s administration record.\n\n(3) For the purposes of paragraph (1)(b), a quality indicators report must include the following information on antipsychotics:\n\n(a) the collection period and collection date in the reporting period;\n\n(b) the number of individuals assessed for antipsychotic medications;\n\n(c) the number of individuals excluded because they were admitted to hospital for at least 6 days prior to the collection date;\n\n(d) the number of individuals that received an antipsychotic medication based on a review of any of the following taken on the collection date:\n\n(i) the individual’s medication chart;\n\n(ii) the individual’s administration record;\n\n(e) the number of individuals that received an antipsychotic medication for a medically diagnosed condition of psychosis based on a review of any of the following taken on the collection date:\n\n(i) the individual’s medication chart;\n\n(ii) the individual’s administration record.\n\n(4) For the purposes of paragraph (2)(a), the collection date is any date during the reporting period and the collection of data must involve a single review of medication charts and administration records for each individual on a particular collection date during the reporting period. \n\n(5) Registered providers, in preparing a quality indicators report for the purposes of paragraph (1)(a), must: \n\n(a) identify and record a collection date for the reporting period; \n\n(b) use each individual’s medication charts and administration records as at the identified collection date. \n\n(6) For the purposes of paragraph (3)(a), the collection date is the final day in the collection period which for that subsection is a 7-day period during the reporting period. \n\n(7) Registered providers, in preparing a quality indicators report for the purposes of paragraph (1)(b), must: \n\n(a) identify a collection date during the reporting period which is between the second week and the end of the reporting period; \n\n(b) assess and review all individual’s medication charts and administration records during the assessment period which covers the collection date and the 6 days prior to that collection date; \n\n(c) ensure that the collection date is varied between reporting periods and must not be identified to, staff directly involved in the care of individuals accessing funded aged care services; \n\n(d) ensure the assessment and review is not conducted by staff directly involved in the care of individuals receiving funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 434,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-145(1)-(3)",
          "section": "Quality indicator—activities of daily living",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—activities of daily living\n\nA quality indicators report must include information about individuals receiving funded aged care services, specifically those assessed for daily living activities. The report must cover those excluded for receiving end-of-life care or those absent and so not accessing services during the reporting period, and those with no previous assessment recorded. It should also include individuals who scored zero in the previous period and those who experienced a decline in their total score by one or more points.\n\nFor the purposes of this reporting, registered providers must conduct a single assessment of each individual at roughly the same time during each reporting period and compare the results to the total score from the previous period to identify any decline in daily living activities.\n\nRegistered providers must use care records to find each individual's total score from the previous reporting period's daily living activities assessment. They should then conduct a new assessment using the prescribed tool and compare the current score with the previous one to check for a decline of one or more points.",
          "summaryHTML": "<i>Quality indicator—activities of daily living\n</i>\nA quality indicators report must include information about individuals receiving funded aged care services, specifically those assessed for daily living activities. The report must cover those excluded for receiving end-of-life care or those absent and so not accessing services during the reporting period, and those with no previous assessment recorded. It should also include individuals who scored zero in the previous period and those who experienced a decline in their total score by one or more points.\n\nFor the purposes of this reporting, registered providers must conduct a single assessment of each individual at roughly the same time during each reporting period and compare the results to the total score from the previous period to identify any decline in daily living activities.\n\nRegistered providers must use care records to find each individual's total score from the previous reporting period's daily living activities assessment. They should then conduct a new assessment using the prescribed tool and compare the current score with the previous one to check for a decline of one or more points.",
          "extract": "(1) A quality indicators report must include the following information on activities of daily living and the number of individuals receiving funded aged care services that: \n\n(a) were assessed for activities of daily living function; \n\n(b) were excluded because of receiving end-of-life care; \n\n(c) were excluded because of an absence from accessing funded aged care services throughout the entire reporting period; \n\n(d) were excluded because an assessment for activities of daily living function was not recorded for the previous reporting period, including comments on why any such previous assessment was not recorded; \n\n(e) were assessed for activities of daily living function and received a total score of zero in the previous reporting period; \n\n(f) were assessed for activities of daily living function and experienced a decline in the total score by one or more points. \n\n(2) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must ensure the collection of information involves a single assessment of each individual, completed around the same time every reporting period, comparing the information to the activities of daily living assessment total score in the previous reporting period to determine decline. \n\n(3) For the purposes of subsection (1), registered providers must: \n\n(a) identify each individual’s activities for daily living assessment total score from the previous reporting period using their approved residential care home’s care records; \n\n(b) conduct activities for daily living assessment for each individual by completing the Barthel Indexl; \n\n(c) compare the previous reporting period assessment total score with the current reporting period assessment total score in relation to an individual in order to determine if the individual experienced a decline of one or more points.\n\nNote: Without limiting this section, activities of daily living includes fundamental skills typically needed to manage basic physical needs in the following areas: \n\n(a) grooming and personal hygiene, such as oral care; \n\n(b) dressing; \n\n(c) toileting and continence; \n\n(d) ambulating and movement; \n\n(e) eating.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 435,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-150(1)-(3)",
          "section": "Quality indicator—incontinence care",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—incontinence care \n\nThe quality indicators report must include information on incontinence care, including assessments conducted, the prevalence of incontinence and related dermatitis, and exclusions due to absence or lack of incontinence.\n\nThey must also include information about those assessed for incontinence, those excluded for not accessing services, and those without incontinence who were excluded from the relevant Incontinence Associated Dermatitis assessment. Assessments must be conducted by appropriately trained staff, and escalation processes be in place.\n\nRegistered providers must conduct a single assessment for each individual as part of routine care at around the same time during each reporting period.",
          "summaryHTML": "<i>Quality indicator—incontinence care </i>\n\nThe quality indicators report must include information on incontinence care, including assessments conducted, the prevalence of incontinence and related dermatitis, and exclusions due to absence or lack of incontinence.\n\nThey must also include information about those assessed for incontinence, those excluded for not accessing services, and those without incontinence who were excluded from the relevant Incontinence Associated Dermatitis assessment. Assessments must be conducted by appropriately trained staff, and escalation processes be in place.\n\nRegistered providers must conduct a single assessment for each individual as part of routine care at around the same time during each reporting period.",
          "extract": "(1) A quality indicators report must include the following information on incontinence care and the number of individuals receiving funded aged care services that: \n\n(a) were assessed for incontinence care; \n\n(b) were excluded because of an absence from accessing funded aged care services throughout the reporting period; \n\n(c) were excluded from an Incontinence Associated Dermatitis assessment because they did not have incontinence; \n\n(d) have incontinence and Incontinence Associated Dermatitis measured and reported against the following Ghent Global Incontinence Associated Dermatitis Categorisation Tool sub-categories: \n\n(i) 1A: persistent redness without clinical signs of infection; \n\n(ii) 1B: persistent redness with clinical signs of infection; \n\n(iii) 2A: skin loss without clinical signs of infection; \n\n(iv) 2B: skin loss with clinical signs of infection; \n\n(e) have incontinence; \n\n(f) have incontinence and Incontinence Associated Dermatitis. \n\n(2) Registered providers, in preparing a quality indicators report for the purposes of subsection (1), must: \n\n(a) identify a date once every reporting period to assess each individual residing at the approved residential care home for incontinence as part of routine care and carry out that assessment on or around the same time each reporting period; and \n\n(b) ensure that the assessment of Incontinence Associated Dermatitis is conducted by staff who understand the Ghent Global Incontinence Associated Dermatitis Categorisation Tool and have the necessary skills and experience to do so accurately and safely; and \n\n(c) if personal care workers observe or identify signs of redness or skin loss during routine personal care, escalate to appropriately trained staff for further assessment; and \n\n(d) consult with a suitably qualified health practitioner if there is uncertainty about the presence or severity of Incontinence Associated Dermatitis. \n\n(3) For the purposes of subsection (1), registered providers must ensure that the collection of information involves a single assessment for each individual as part of routine care around the same time every reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 436,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-155(1)-(2)",
          "section": "Quality indicator—hospitalisation",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—hospitalisation\n\nA quality indicators report must include information about individuals receiving funded aged care services, specifically, those assessed for hospitalisation, those excluded for not accessing services, and those who had one or more visits to the emergency department or hospital admissions during the reporting period.\n\nWhen preparing a quality indicators report, registered providers must conduct a single review of each individual's care records for the entire reporting period and complete this review within 21 days after the reporting period ends.",
          "summaryHTML": "<i>Quality indicator—hospitalisation</i>\n\nA quality indicators report must include information about individuals receiving funded aged care services, specifically, those assessed for hospitalisation, those excluded for not accessing services, and those who had one or more visits to the emergency department or hospital admissions during the reporting period.\n\nWhen preparing a quality indicators report, registered providers must conduct a single review of each individual's care records for the entire reporting period and complete this review within 21 days after the reporting period ends.",
          "extract": "(1) A quality indicators report must include the following information on hospitalisation and the number of individuals receiving funded aged care services that: \n\n(a) were assessed for hospitalisation; \n\n(b) were excluded because of an absence from accessing funded aged care services throughout the reporting period; \n\n(c) had one or more emergency department presentations during the reporting period; \n\n(d) had one or more emergency department presentations or hospital admissions during the reporting period. \n\n(2) In preparing a quality indicators report for the purposes of subsection (1), registered providers must: \n\n(a) ensure that the collection of information involves a single review of the care records for each individual for the entire reporting period; \n\n(b) view the care records within 21 days after the end of the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 437,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-160(1)-(3)",
          "section": "Quality indicator—workforce",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—workforce\n\nThe quality indicators report must include information on workforce, including specific staff roles such as service managers, nurses, and personal care workers.\n\nReporting must provide detailed workforce information for each specified sub-category, including total staff hours worked, staff employed at the beginning of the reporting period who worked a minimum of 120 hours, and those who did not work for at least 60 consecutive days.\n\nRegistered providers must review the records within 21 days after the reporting period ends.",
          "summaryHTML": "<i>Quality indicator—workforce</i>\n\nThe quality indicators report must include information on workforce, including specific staff roles such as service managers, nurses, and personal care workers.\n\nReporting must provide detailed workforce information for each specified sub-category, including total staff hours worked, staff employed at the beginning of the reporting period who worked a minimum of 120 hours, and those who did not work for at least 60 consecutive days.\n\nRegistered providers must review the records within 21 days after the reporting period ends.",
          "extract": "(1) A quality indicators report must include information on the workforce of a registered provider, reported against the following sub-categories of staff delivering funded aged care services:\n\n(a) service managers;\n\n(b) nurse practitioners and registered nurses;\n\n(c) enrolled nurses;\n\n(d) personal care workers and nursing assistants.\n\n(2) A quality indicators report must include the following information reported against each sub-category specified in subsection (1):\n\n(a) the number of staff that have worked any number of hours in the previous reporting period;\n\n(b) the number of staff that:\n\n(i) were employed at the start of the reporting period; and\n\n(ii) have worked for at least 120 hours in the previous reporting period;\n\n(c) the number of staff that:\n\n(i) were employed at the start of the reporting period; and\n\n(ii) did not work for at least 60 consecutive days in the reporting period.\n\n(3) For the purposes of subsection (1), registered providers must review the records within 21 days after the end of the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 438,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-165(1)-(4)",
          "section": "Quality indicator—Consumer Experience Assessment",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—Consumer Experience Assessment\n\nA quality indicators report must include information about individuals' experiences gathered through a Consumer Experience Assessment, specifically noting those excluded or choosing not to complete the assessment. It should also detail how many individuals were offered the assessment through various methods, how many completed it, and their scores based on their responses.\n\nWhen preparing a quality indicators report, registered providers must use the Quality-of-Care Experience questions to collect information for the consumer experience assessment. \n\nRegistered providers must collect information from each individual at least once during each reporting period. \n\nWhen preparing a quality indicators report, registered providers must use the Quality-of-Care Experience questions to collect information for the consumer experience assessment.\n\nWhen preparing for this part of quality indicators report, registered providers must offer the QCE-ACC Self Complete Version for suitable individuals to fill out themselves, allow those with mild cognitive impairment to complete it independently, arrange interviewer assistance for those needing help, and set up proxy completion for individuals with moderate or severe cognitive impairment, all at around the same time during each reporting period.",
          "summaryHTML": "<i>Quality indicator—Consumer Experience Assessment\n</i>\nA quality indicators report must include information about individuals' experiences gathered through a Consumer Experience Assessment, specifically noting those excluded or choosing not to complete the assessment. It should also detail how many individuals were offered the assessment through various methods, how many completed it, and their scores based on their responses.\n\nWhen preparing a quality indicators report, registered providers must use the Quality-of-Care Experience questions to collect information for the consumer experience assessment. \n\nRegistered providers must collect information from each individual at least once during each reporting period. \n\nWhen preparing a quality indicators report, registered providers must use the Quality-of-Care Experience questions to collect information for the consumer experience assessment.\n\nWhen preparing for this part of quality indicators report, registered providers must offer the QCE-ACC Self Complete Version for suitable individuals to fill out themselves, allow those with mild cognitive impairment to complete it independently, arrange interviewer assistance for those needing help, and set up proxy completion for individuals with moderate or severe cognitive impairment, all at around the same time during each reporting period.",
          "extract": "(1) A quality indicators report must include the following information on an individual’s experience obtained through a Consumer Experience Assessment and the number of individuals accessing funded aged care services that: \n\n(a) were excluded because of an absence from accessing funded aged care services throughout the reporting period; \n\n(b) were excluded because of choosing not to complete the Consumer Experience Assessment in the reporting period; \n\n(c) were offered a Consumer Experience Assessment during the reporting period through any of the following means: \n\n(i) a self-completion assessment; \n\n(ii) an interviewer facilitated assessment; \n\n(iii) a proxy-completion; \n\n(d) undertook the Consumer Experience Assessment during the reporting period, the number of individuals who reported against the following sub-categories and the means of assessment mentioned in paragraph (a) for the individuals in each sub-category: \n\n(i) excellent: for individuals who score between 22 and 24; \n\n(ii) good: for individuals who score between 19 and 21; \n\n(iii) moderate: for individuals who score between 14 and 18; \n\n(iv) poor: for individuals who score between 8 and 13; \n\n(v) very poor: for individuals who score between 0 and 7;\n\n(2) In preparing a quality indicators report for the purposes of subsection (1), registered providers must ensure that the collection of information for consumer experience assessment uses the Quality-of-Care Experience questions. \n\n(3) In preparing a quality indicators report for the purposes of subsection (1), registered providers must collect information from each individual, once every reporting period. \n\n(4) In preparing a quality indicators report for the purposes of subsection (1), registered providers must: \n\n(a) in order to collect information, offer a copy of the QCE-ACC Self Complete Version document for self-completion by suitable individuals at the approved residential care home at around the same time every reporting period; and \n\n(b) allow an individual with no or mild cognitive impairment to self-complete the QCE-ACC Self Complete Version document; and \n\n(c) arrange interviewer facilitated completion for all individuals requiring assistance to complete the QCE-ACC document (such as where the individual requires support with reading the questions or writing their responses) at around the same time every reporting period using the QCE-ACC Interviewer Facilitated Version; and \n\n(d) if there is a person covered by subsection 28(2) of the Act in relation to the individual—arrange for a proxy‑completion by that person at around the same time every reporting period using the QCE‑ACC.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 439,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-170(1)-(4)",
          "section": "Quality indicator—Quality of Life Assessment",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—Quality of Life Assessment\n\nThe quality indicators report must include information from the Quality of Life Assessment, including how many individuals were offered and completed the assessment, their scores categorised by quality of life level, and any exclusions due to absence or opting out.\n\nRegistered providers must use the Quality of Life Questions to collect and assess information related to quality of life.\n\nRegistered providers must collect information from each individual at least once during each reporting period. \n\nWhen preparing a quality indicators report, registered providers must offer the QOL-ACC Self Complete Version for suitable individuals to fill out themselves, allow those with mild cognitive impairment to complete it independently, arrange for an interviewer to assist those needing help, and set up proxy completion for individuals with moderate or severe cognitive impairment, all at around the same time during each reporting period.",
          "summaryHTML": "<i>Quality indicator—Quality of Life Assessment\n</i>\nThe quality indicators report must include information from the Quality of Life Assessment, including how many individuals were offered and completed the assessment, their scores categorised by quality of life level, and any exclusions due to absence or opting out.\n\nRegistered providers must use the Quality of Life Questions to collect and assess information related to quality of life.\n\nRegistered providers must collect information from each individual at least once during each reporting period. \n\nWhen preparing a quality indicators report, registered providers must offer the QOL-ACC Self Complete Version for suitable individuals to fill out themselves, allow those with mild cognitive impairment to complete it independently, arrange for an interviewer to assist those needing help, and set up proxy completion for individuals with moderate or severe cognitive impairment, all at around the same time during each reporting period.",
          "extract": "(1) A quality indicators report must include the following information on an individual’s quality of life obtained through a Quality of Life Assessment and the number of individuals accessing funded aged care services that: \n\n(a) were offered a Quality of Life Assessment during the reporting period through any of the following means: \n\n(i) a self-completion assessment; \n\n(ii) an interviewer facilitated assessment; \n\n(iii) a proxy-completion; \n\n(b) were excluded because of an absence from receiving funded aged care services throughout the reporting period; \n\n(c) were excluded because of choosing not to complete the Quality of Life Assessment in the reporting period; \n\n(d) undertook the Quality of Life Assessment, the number of individuals who reported against the following sub-categories and the means of assessment mentioned in paragraph (a) for the individuals in each sub-category: \n\n(i) excellent: for individuals who score between 22 and 24; \n\n(ii) good: for individuals who score between 19 and 21; \n\n(iii) moderate: for individuals who score between 14 and 18; \n\n(iv) poor: for individuals who score between 8 and 13; \n\n(v) very poor: for individuals who score between 0 and 7. \n\n(2) For the purposes of subsection (1), registered providers must ensure that the collection and assessment of information relating to quality of life must use the Quality of Life Questions. \n\n(3) For the purposes of subsection (1), registered providers must collect information from each individual, once every reporting period. \n\n(4) In preparing a quality indicators report for the purposes of subsection (1), registered providers must: \n\n(a) in order to collect information, offer a copy of the QOL-ACC Self Complete Version document for self-completion by suitable individuals at the approved residential care home at around the same time every reporting period; and \n\n(b) allow an individual with no or mild cognitive impairment to self-complete the QOL-ACC Self Complete Version document; and \n\n(c) arrange interviewer facilitated completion for all individuals requiring assistance to complete the QOL-ACC document (such as where the individual requires support with reading the questions or writing their responses) at around the same time every reporting period using the QOL-ACC Interviewer Facilitated Version; and \n\n(d) if there is a person covered by subsection 28(2) of the Act in relation to the individual—arrange for a proxy‑completion by that person at around the same time every reporting period using the QOL‑ACC.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 440,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-175(1)-(5)",
          "section": "Quality indicator—allied health",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—allied health\n\nThe quality indicators report must include information on allied health services, including assessments, recommendations, care received, and exclusions due to absence, categorised by specific types of allied health professionals.\n\nA quality indicators report must include the total number of hours worked by allied health professionals, shown as minutes of care and services provided to individuals each day, and reported separately for hours worked by employees and hours worked by agency staff.\n\nFor the purposes of paragraphs (1)(c) and (d) and subsection (2), a registered provider must report on the hours worked by each type of allied health professional, including physiotherapists, occupational therapists, speech pathologists, podiatrists, dietitians, allied health assistants, and other allied health professional including art therapists, audiologists, exercise physiologists, music therapists, chiropractors, counsellors, osteopaths, psychologists and social workers.\n\nFurther, when preparing a quality indicators report, registered providers must review all individuals' care records for the entire reporting period to collect information on recommended funded aged care services in allied health and therapy. They should also only report once for each allied health discipline.",
          "summaryHTML": "<i>Quality indicator—allied health</i>\n\nThe quality indicators report must include information on allied health services, including assessments, recommendations, care received, and exclusions due to absence, categorised by specific types of allied health professionals.\n\nA quality indicators report must include the total number of hours worked by allied health professionals, shown as minutes of care and services provided to individuals each day, and reported separately for hours worked by employees and hours worked by agency staff.\n\nFor the purposes of paragraphs (1)(c) and (d) and subsection (2), a registered provider must report on the hours worked by each type of allied health professional, including physiotherapists, occupational therapists, speech pathologists, podiatrists, dietitians, allied health assistants, and other allied health professional including art therapists, audiologists, exercise physiologists, music therapists, chiropractors, counsellors, osteopaths, psychologists and social workers.\n\nFurther, when preparing a quality indicators report, registered providers must review all individuals' care records for the entire reporting period to collect information on recommended funded aged care services in allied health and therapy. They should also only report once for each allied health discipline.",
          "extract": "(1) A quality indicators report must include the following information on allied health: \n\n(a) the number of individuals accessing funded aged care services in the residential care home that were assessed for services delivered by an allied health professional during the reporting period; \n\n(b) the number of individuals who were excluded because of an absence from accessing funded aged care services throughout the reporting period; \n\n(c) the number of funded aged care services in the service type allied health and therapy that were recommended to be delivered by an allied health professional (including through a care and services plan under paragraph 148(e) of the Act), reported against the sub-categories set out in subsection (3); \n\n(d) the number of funded aged care services in the service type allied health and therapy that were recommended to be delivered by an allied health professional (including through a care and services plan under paragraph 148(e) of the Act) and which were received, reported against the sub-categories set out in subsection (3). \n\nNote: See section 148 of the Act (Delivery of funded aged care services).\n\n(2) A quality indicators report must include the number of allied health professional labour hours (represented as minutes of care and services delivered to individuals each day) and reported separately as: \n\n(a) allied health professional employee labour hours;  \n\n(b) allied health professional agency labour hours. \n\n(3) For the purposes of paragraphs (1)(c) and (d) and subsection (2), a registered provider must report against each of the following sub-categories of allied health professionals; \n\n(a) physiotherapist; \n\n(b) occupational therapist; \n\n(c) speech pathologist; \n\n(d) podiatrist; \n\n (e) dietitian; \n \n(f) allied health assistant; \n\n(g) other allied health professionals.\n\n(4) For the purposes of paragraph (3)(g) other allied health professionals include the following:\n\n(a) art therapists;\n\n(b) audiologists;\n\n(c) exercise physiologists;\n\n(d) music therapists;\n\n(e) chiropractors;\n\n(f) counsellors;\n\n(g) osteopaths;\n\n(h) psychologists;\n\n(i) social workers\n\n(5) In preparing a quality indicators report for the purposes of subsection (1), registered providers must: \n\n(a) collect information as to recommended funded aged care services in the service type allied health and therapy by undertaking a single review of all individual’s care records for the entire reporting period; and \n\n(b) only report once per allied health discipline.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 441,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-180(1)-(2)",
          "section": "Quality indicator—lifestyle officers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—lifestyle officers\n\nThe quality indicators report must include information on lifestyle officers, including total labour hours worked in care minutes by lifestyle officers and the total labour hours worked as agency staff by lifestyle officers. Lifestyle officers encompass diversional, recreation, and activities officers. \n\nFor the purposes of reporting on lifestyle officers, the quality indicators report must include the total number of occupied bed days for the provider during the reporting period.",
          "summaryHTML": "<i>Quality indicator—lifestyle officers</i>\n\nThe quality indicators report must include information on lifestyle officers, including total labour hours worked in care minutes by lifestyle officers and the total labour hours worked as agency staff by lifestyle officers. Lifestyle officers encompass diversional, recreation, and activities officers. \n\nFor the purposes of reporting on lifestyle officers, the quality indicators report must include the total number of occupied bed days for the provider during the reporting period.",
          "extract": "(1)\tA quality indicators report must include the following information on lifestyle officers delivering funded aged care services:\n\t(a)\tthe total labour hours worked in care minutes by lifestyle officers;\n\t(b)\tthe total labour hours worked as agency staff by lifestyle officers.\nNote:\tFor subsection (1), a lifestyle officer includes any of the following roles:\n(a)\tdiversional officer;\n(b)\trecreation officer;\n(c)\tactivities officer.\n\t(2)\tFor the purposes of a quality indicators report and the quality indicator on lifestyle officers, a registered provider must also provide information on the number of occupied bed days for a provider for the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 442,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-185(1)-(2)",
          "section": "Quality indicator—enrolled nursing",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Quality indicator—enrolled nursing\n\nThe quality indicators report must include information on enrolled nursing including the total number of care minutes (in hours) for enrolled nurses, registered nurses, and personal care workers/nursing assistants involved in delivering funded aged care services. \n\nIn preparing the report, refer to the Act definition of direct care staff member in section 7.",
          "summaryHTML": "<i>Quality indicator—enrolled nursing\n</i>\nThe quality indicators report must include information on enrolled nursing including the total number of care minutes (in hours) for enrolled nurses, registered nurses, and personal care workers/nursing assistants involved in delivering funded aged care services. \n\nIn preparing the report, refer to the Act definition of direct care staff member in section 7.",
          "extract": "(1) A quality indicators report must include the following information on enrolled nursing with respect to direct care staff members that deliver funded aged care services:\n\n(a) enrolled nursing total number of care minutes (in hours);\n\n(b) registered nursing total number of care minutes (in hours);\n\n(c) personal care workers and nursing assistants total number of care minutes (in hours).\n\n(2) For the purposes of subsection (1), direct care staff members covered under this section are those specified in paragraphs (a) to (d) of the definition of direct care staff member in section 7 under the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 443,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div C, s166-205(1)-(2)",
          "section": "Application of Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For this subdivision, providers in registration category 4 - personal care and care support in the home or community, category 5 - nursing and transition care and category 6 - residential care are prescribed.\n\nThis subdivision also applies to a registered provider registered in the registration category subscription trial if the provider is also registered in a provider registration category referred to above.\n\nThis subdivision applies to feedback received by a registered provider:\n(a) that is managed in accordance with section 165-30; and\n(b) that raises an issue referred to in subsection 165-30(2).",
          "summaryHTML": "For this subdivision, providers in registration category 4 - personal care and care support in the home or community, category 5 - nursing and transition care and category 6 - residential care are prescribed.\n\nThis subdivision also applies to a registered provider registered in the registration category subscription trial if the provider is also registered in a provider registration category referred to above.\n\nThis subdivision applies to feedback received by a registered provider:\n(a) that is managed in accordance with section 165-30; and\n(b) that raises an issue referred to in subsection 165-30(2).",
          "extract": "(1) This Subdivision applies to registered providers registered in one or more of the following provider registration categories:\n\n(a) personal and care support in the home or community;\n\n(b) nursing and transition care;\n\n(c) residential care.\n\n(1A) This Subdivision also applies to a registered provider registered in the provider registration category subscription trial if the provider is also registered in a provider registration category referred to in paragraph (1)(a) or (b).\n\n(2) This Subdivision applies to feedback received by a registered provider:\n(a) that is managed in accordance with section 165-30; and\n(b) that raises an issue referred to in subsection 165-30(2).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 444,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div C, s166-210(1)-(4)",
          "section": "Requirements for reporting information relating to complaints and feedback management",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirements for reporting information relating to complaints and feedback management\n\nA registered provider must submit a complaints and feedback management report to the Commissioner within 4 months after the reporting period ends.\n\nThe reporting period is 12 months beginning 1 July each year, or a 12 month period determined by the System Governor.\n\nThe report must be in an approved format, signed by the governing body, and include specific information about complaints and feedback management as required.\n\nDetailed information on complaints and feedback must be included as well as actions taken, effectiveness evaluations, resolution timelines, staff training, and analysis of complaint patterns.",
          "summaryHTML": "<i>Requirements for reporting information relating to complaints and feedback management</i>\n\nA registered provider must submit a complaints and feedback management report to the Commissioner within 4 months after the reporting period ends.\n\nThe reporting period is 12 months beginning 1 July each year, or a 12 month period determined by the System Governor.\n\nThe report must be in an approved format, signed by the governing body, and include specific information about complaints and feedback management as required.\n\nDetailed information on complaints and feedback must be included as well as actions taken, effectiveness evaluations, resolution timelines, staff training, and analysis of complaint patterns.",
          "extract": "(1) For the purposes of paragraph 166(1)(a) of the Act this section prescribes that a registered provider to whom this Subdivision applies must give a report about the management of complaints and feedback (the complaints and feedback management report) to the Commissioner within 4 months after the end of the reporting period for the registered provider.\n\n(2) The reporting period for a registered provider is:\n\n(a) the period of 12 months starting on 1 July of a year; or\n\n(b) another 12 month period that starts on the first day of a month of a year that is determined for the registered provider by the System Governor in accordance with the rules.\n\n(3) The report must:\n\n(a) be in the approved form; and\n\n(b) be signed by a governing body of the registered provider; and\n\n(c) include the information prescribed by subsection (4) of this section that is a summary of the management of complaints and feedback. \n\n(4) For the purposes of paragraph 166(1)(a) of the Act, the following information is prescribed:\n\n(a) information about complaints and feedback received, including the number of complaints and feedback and the nature of the complaints and feedback;\n\n(b) information about the action taken to resolve complaints or in response to feedback received, including any subsequent improvements made by the registered provider in relation to complaints and feedback;\n\n(c) information about an evaluation of the effectiveness of the actions taken and their related outcome in relation to each complaint and feedback;\n\n(d) information about the number of days taken to resolve each complaint and feedback;\n\n(e) information about the education and training that has been delivered to the staff of the registered provider in relation to each complaint and feedback;\n\n(f) an analysis of the patterns of, and underlying reasons for, complaints.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 445,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div D, s166-215(1)-(2)",
          "section": "Application of Subdivision to all registered providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For this Subdivision all registered providers are prescribed.\n\nIt applies to feedback received by a registered provider:\n(a) that is managed in accordance with section 165-30; and\n(b) that raises an issue referred to in subsection 165-30(2).",
          "summaryHTML": "For this Subdivision all registered providers are prescribed.\n\nIt applies to feedback received by a registered provider:\n(a) that is managed in accordance with section 165-30; and\n(b) that raises an issue referred to in subsection 165-30(2).",
          "extract": "(1)\tThis Subdivision applies to every kind of registered provider.\n\t(2)\tThis Division applies to feedback received by a registered provider:\n\t(a)\tthat is managed in accordance with section 165-30; and\n\t(b)\traises an issue as referred to in subsection 165-30(2).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 446,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div D, s166-220(1)-(5)",
          "section": "Requirements for reporting information on request relating to complaints and feedback management",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Complaints and feedback management report on request \n\nA registered provider must provide a complaints and feedback management report to the System Governor or Commissioner upon request.\n\nA registered provider must respond to a request for the complaints and feedback management report within 14 days or a longer timeframe specified in the request.\n\nThe report must be in an approved format, signed by the governing body, and include specific information as required by subsection (5).\n\nDetailed information on complaints and feedback must be included as well as actions taken, effectiveness evaluations, resolution timelines, staff training, and analysis of complaint patterns.",
          "summaryHTML": "<i>Complaints and feedback management report on request \n</i>\nA registered provider must provide a complaints and feedback management report to the System Governor or Commissioner upon request.\n\nA registered provider must respond to a request for the complaints and feedback management report within 14 days or a longer timeframe specified in the request.\n\nThe report must be in an approved format, signed by the governing body, and include specific information as required by subsection (5).\n\nDetailed information on complaints and feedback must be included as well as actions taken, effectiveness evaluations, resolution timelines, staff training, and analysis of complaint patterns.",
          "extract": "(1) For the purposes of paragraph 166(1)(a) and (d) of the Act this section prescribes that a registered provider to whom this Subdivision applies must on request by the System Governor or the Commissioner, give a report about the management of complaints and feedback (the complaints and feedback management report) to the System Governor and the Commissioner.\n\n(2) The System Governor or the Commissioner may, at any time, request a registered provider to give the System Governor and the Commissioner a report under subsection (1).\n\n(3) A registered provider must comply with a request under subsection (1) within 14 days after the request is made, or such longer period as specified in the request.\n\n(4) The report must:\n\n(a) be in the approved form;\n\n(b) be signed by a governing body of the registered provider; and\n\n(c) include the information prescribed by subsection (5) of this section.\n\n(5) For the purposes of paragraph 166(1)(a) and (d) of the Act, the following information is prescribed:\n\n(a) information about complaints and feedback received, including the number of complaints and feedback and the nature of the complaints and feedback;\n\n(b) information about the action taken to resolve complaints or in response to feedback received, including any subsequent improvements made by the registered provider in relation to complaints and feedback;\n\n(c) information about an evaluation of the effectiveness of the actions taken and their related outcome in relation to each complaint and feedback;\n\n(d) information about the number of days taken to resolve each complaint and feedback;\n\n(e) information about the education and training that has been delivered to the staff of the registered provider in relation to each complaint and feedback;\n\n(f) an analysis of the patterns of, and underlying reasons for, complaints.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 447,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-310(1)-(2)",
          "section": "Other requirements relating to complaints and feedback",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "All registered providers must submit an aged care financial report regarding financial and prudential matters to the System Governor for each reporting period. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) CHSP;\n\n(b) NATSIFACP;\n\n(c) TCP.\n\nFor the reporting period for an aged care financial report, see section 166-355.\n\nFor requirements relating to an annual prudential compliance statement, see section 166-360.",
          "summaryHTML": "All registered providers must submit an aged care financial report regarding financial and prudential matters to the System Governor for each reporting period. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) CHSP;\n\n(b) NATSIFACP;\n\n(c) TCP.\n\nFor the reporting period for an aged care financial report, see section 166-355.\n\nFor requirements relating to an annual prudential compliance statement, see section 166-360.",
          "extract": "Scope of this section\n\n(1) Subject to subsection (2), for the purposes of paragraph 166(1)(d) of the Act:\n\n(a) every kind of registered provider is prescribed; and\n\n(b) a registered provider must give a report about financial and prudential matters (the aged care financial report) to the System Governor each reporting period for the registered provider.\n\nNote: For the reporting period for an aged care financial report, see section 166-355 of this instrument.\n\n(2) The requirements of this section do not apply in respect of the delivery of funded aged care services under any of the following specialist aged care programs: \n\n(a) CHSP; \n\n(b) NATSIFACP; \n\n(c) TCP. \n\nNote: For requirements relating to an annual prudential compliance statement, see section 166-360 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": true,
            "rp": true
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 448,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-310(3)",
          "section": "Aged care financial report—general",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirements for an aged care financial report\n\nThe aged care financial report must: \n\n(a) be in the approved report form; and  \n\n(b) be signed by a member of the governing body of the registered provider; and \n\n(c) be given to the System Governor within 4 months after the end of each reporting period for the registered provider; and \n\n(d) if section 166-315 of the rules applies—include a financial support statement; and \n\n(e) if section 166-345 of the rules applies—include a general purpose financial report; and \n\n(f) if section 166-360 of the rules applies—include an annual prudential compliance statement. \n\nNote: The term governing body is defined in section 7 of the Act. The effect of this definition is that for registered providers who are not a body corporate with a board of directors (eg State and Territory governments), the Aged Care Financial Report can be signed by a person or group of persons responsible for the executive decisions of the registered provider.",
          "summaryHTML": "<i>Requirements for an aged care financial report\n</i>\nThe aged care financial report must: \n\n(a) be in the approved report form; and  \n\n(b) be signed by a member of the governing body of the registered provider; and \n\n(c) be given to the System Governor within 4 months after the end of each reporting period for the registered provider; and \n\n(d) if section 166-315 of the rules applies—include a financial support statement; and \n\n(e) if section 166-345 of the rules applies—include a general purpose financial report; and \n\n(f) if section 166-360 of the rules applies—include an annual prudential compliance statement. \n\nNote: The term governing body is defined in section 7 of the Act. The effect of this definition is that for registered providers who are not a body corporate with a board of directors (eg State and Territory governments), the Aged Care Financial Report can be signed by a person or group of persons responsible for the executive decisions of the registered provider.",
          "extract": "Requirements for an aged care financial report\n\n(3) The aged care financial report must: \n\n(a) be in the approved report form; and  \n\n(b) be signed by a member of the governing body of the registered provider; and \n\n(c) be given to the System Governor within 4 months after the end of each reporting period for the registered provider; and \n\n(d) if section 166-315 of this instrument applies—include a financial support statement; and \n\n(e) if section 166-345 of this instrument applies—include a general purpose financial report; and \n\n(f) if section 166-360 of this instrument applies—include an annual prudential compliance statement. \n\nNote: The term governing body is defined in section 7 of the Act. The effect of this definition is that for registered providers who are not a body corporate with a board of directors (eg State and Territory governments), the Aged Care Financial Report can be signed by a person or group of persons responsible for the executive decisions of the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": true,
            "dpo": true,
            "rp": true
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 449,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-310(5)",
          "section": "Aged care financial report—general",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Additional requirements if registered in provider registration category residential care\n\nRegistered providers in Category 6 - residential care must include additional information in their aged care financial report, including care minutes performance, amount of accommodation payments and accommodation contributions, refundable deposits and daily payments, accommodation bonds and charges, and details on building and refurbishment activities.",
          "summaryHTML": "<i>Additional requirements if registered in provider registration category residential care\n</i>\nRegistered providers in Category 6 - residential care must include additional information in their aged care financial report, including care minutes performance, amount of accommodation payments and accommodation contributions, refundable deposits and daily payments, accommodation bonds and charges, and details on building and refurbishment activities.",
          "extract": "Additional requirements if registered in provider registration category residential care\n\n(5) For a registered provider registered in the provider registration category residential care, in addition to the requirements in subsection (3), an aged care financial report must also include the following:\n\n(a) subject to section 166-335 of this instrument, a care minutes performance statement;\n\n(b) the amount of accommodation payments and accommodation contributions paid to the registered provider;\n\n(c) the amounts of those accommodation payments and accommodation contributions paid as refundable deposits and daily payments;\n\n(d) the amounts of accommodation bonds and accommodation charges paid to the registered provider;\n\n(e) the extent of building, upgrading, and refurbishment of residential care homes.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 450,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-310(6)-(7)",
          "section": "Aged care financial report—general",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirement to comply with a notice for further information\n\nA registered provider is required to respond to notices for further information related to the Aged Care Financial Report within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nTo comply with a notice a registered provider must submit the requested information in a format approved by the System Governor.",
          "summaryHTML": "<i>Requirement to comply with a notice for further information</i>\n\nA registered provider is required to respond to notices for further information related to the Aged Care Financial Report within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nTo comply with a notice a registered provider must submit the requested information in a format approved by the System Governor.",
          "extract": "Requirement to comply with a notice for further information\n\n(6) A registered provider must comply with a notice under subsection (8) within the period specified in the notice or, if no period is specified in the notice, within 28 days after the day when the notice is given.\n\n(7) A registered provider complies with a notice under subsection (8) only if the provider gives the information in a form (if any) approved by the System Governor for the purposes of that subsection.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 451,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-315(1)-(2)",
          "section": "Aged care financial report—provision of a financial support statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Aged care financial report—provision of a financial support statement\n\nSubject to subsection (2), for the purposes of paragraph 166(1)(a) of the Act, a registered provider is prescribed if the provider is registered in registration Category 6 - residential care, is part of or is financially reliant on a related corporate entity, is not a government entity or a local government authority and is required under section 166-310 of the rules to give the System Governor an aged care financial report for the provider for a reporting period.\n\nThis section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "summaryHTML": "<i>Aged care financial report—provision of a financial support statement</i>\n\nSubject to subsection (2), for the purposes of paragraph 166(1)(a) of the Act, a registered provider is prescribed if the provider is registered in registration Category 6 - residential care, is part of or is financially reliant on a related corporate entity, is not a government entity or a local government authority and is required under section 166-310 of the rules to give the System Governor an aged care financial report for the provider for a reporting period.\n\nThis section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "extract": "Scope of this section\n(1) Subject to subsection (2), for the purposes of paragraph 166(1)(d) of the Act, a registered provider is prescribed if the provider:\n(a) is registered in the provider registration category residential care; and\n(b) is part of or is financially reliant on a related corporate entity; and\n(c) is not a government entity or a local government authority; and\n(d) is required under section 166-310 of this instrument to give the System Governor an aged care financial report for the provider for a reporting period.\n(2) This section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": false,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 452,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-315(3)-(4)",
          "section": "Aged care financial report—provision of a financial support statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Financial support statement to be given with aged care financial report\n\nIn addition to the aged care financial report, the registered provider must submit a signed financial support statement to the System Governor within 4 months following the end of the reporting period.\n\nA registered provider is exempt from the requirements of subsection (3) if their aged care financial report includes an explanation for non-compliance regarding the financial support statement for that year.",
          "summaryHTML": "<i>Financial support statement to be given with aged care financial report</i>\n\nIn addition to the aged care financial report, the registered provider must submit a signed financial support statement to the System Governor within 4 months following the end of the reporting period.\n\nA registered provider is exempt from the requirements of subsection (3) if their aged care financial report includes an explanation for non-compliance regarding the financial support statement for that year.",
          "extract": "Financial support statement to be given with aged care financial report\n\n(3) If a registered provider is required to give the System Governor an aged care financial report for the provider for a reporting period, then the provider must, when giving the report to the System Governor, also give the System Governor a financial support statement for the provider signed within the period of 4 months starting on the day after the end of the reporting period.\n\n(4) However, subsection (3) does not apply to a registered provider in relation to a reporting period if the aged care financial report for the provider for the year includes an explanation of why the provider has not complied with subsection (3) in relation to that year.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": false,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 453,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-315(5)",
          "section": "Aged care financial report—provision of a financial support statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Financial support statement to be given on request\n\nThe System Governor may at any time, by notice in writing, require a registered provider to give the System Governor a financial support statement for the provider signed within the period for signing specified in the notice.\n\nNote: For who must sign a financial support statement, see subsection 166-320(4) of the rules.",
          "summaryHTML": "<i>Financial support statement to be given on request</i>\n\nThe System Governor may at any time, by notice in writing, require a registered provider to give the System Governor a financial support statement for the provider signed within the period for signing specified in the notice.\n\nNote: For who must sign a financial support statement, see subsection 166-320(4) of the rules.",
          "extract": "Financial support statement to be given on request\n\n(5) The System Governor may at any time, by notice in writing, require a registered provider to give the System Governor a financial support statement for the provider signed within the period for signing specified in the notice.\n\nNote:\tFor who must sign a financial support statement, see subsection 166 320(4) of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": false,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 454,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-315(6)-(7)",
          "section": "Aged care financial report—provision of a financial support statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Financial support statement to be given on request\n\nRegistered providers are required to respond to notices within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nA registered provider is exempt from the requirements of subsection (6) if they provide a written explanation to the System Governor regarding their inability to comply with the notice before the end of the specified compliance period.\n\nHowever, subsection (6) does not apply to a registered provider in relation to a notice under subsection (5) if at or before the end of the period within which the provider would (but for this subsection) be required to comply with the notice, the provider gives the System Governor a written explanation of why the provider is not able to comply with the notice.",
          "summaryHTML": "<i>Financial support statement to be given on request</i>\n\nRegistered providers are required to respond to notices within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nA registered provider is exempt from the requirements of subsection (6) if they provide a written explanation to the System Governor regarding their inability to comply with the notice before the end of the specified compliance period.\n\nHowever, subsection (6) does not apply to a registered provider in relation to a notice under subsection (5) if at or before the end of the period within which the provider would (but for this subsection) be required to comply with the notice, the provider gives the System Governor a written explanation of why the provider is not able to comply with the notice.",
          "extract": "(6) A registered provider must comply with a notice under subsection (5) within the period for complying specified in the notice or, if no such period is specified in the notice, within 28 days after the day when the notice is given.\n\n(7) However, subsection (6) does not apply to a registered provider in relation to a notice under subsection (5) if at or before the end of the period within which the provider would (but for this subsection) be required to comply with the notice, the provider gives the System Governor a written explanation of why the provider is not able to comply with the notice.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": false,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 455,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-315(8)-(9)",
          "section": "Aged care financial report—provision of a financial support statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "System Governor may request further information and documents\n\nThe System Governor may at any time, by notice in writing, require a registered provider to give the System Governor information about a matter, as specified in the notice, if the information is about a matter required under this section.\n\nRegistered providers are required to respond to notices under subsection (8) within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.",
          "summaryHTML": "<i>System Governor may request further information and documents</i>\n\nThe System Governor may at any time, by notice in writing, require a registered provider to give the System Governor information about a matter, as specified in the notice, if the information is about a matter required under this section.\n\nRegistered providers are required to respond to notices under subsection (8) within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.",
          "extract": "System Governor may request further information and documents\n(8) The System Governor may at any time, by notice in writing, require a registered provider to give the System Governor information about a matter, as specified in the notice, if the information is about a matter required under this section.\n\n(9) A registered provider must comply with a notice under subsection (8) within the period for complying specified in the notice or, if no such period is specified in the notice, within 28 days after the day when the notice is given.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": false,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 456,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-335(1)-(2)",
          "section": "Aged care financial report—care minutes performance statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Aged care financial report—care minutes performance statement\n\nThis section applies to a registered provider registered in the registration Category 6 - residential care; and is required under section 166-310 of the rules to give the System Governor an aged care financial report for the provider for a reporting period.\n\nThis section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "summaryHTML": "<i>Aged care financial report—care minutes performance statement\n</i>\nThis section applies to a registered provider registered in the registration Category 6 - residential care; and is required under section 166-310 of the rules to give the System Governor an aged care financial report for the provider for a reporting period.\n\nThis section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "extract": "Scope of this section\n\n(1) Subject to subsection (2), for the purposes of paragraph 166(1)(d) of the Act, a registered provider is prescribed if the provider:\n\n(a) is registered in the provider registration category residential care; and\n\n(b) is required under section 166-310 of this instrument to give the System Governor an aged care financial report for the provider for a reporting period.\n\n(1A) This section does not apply to registered providers that deliver funded aged care services under the MPSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 457,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-335(3)-(6)",
          "section": "Aged care financial report—care minutes performance statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Registered providers must submit a written care minutes performance statement that meets the criteria outlined in subsections (5), and (6) below.\n\n(4) A registered provider must, when giving the aged care financial report to the System Governor, also give the System Governor a care minutes performance statement for the provider in accordance with the requirements prescribed by subsection (5).\n\n(5) The care minutes performance statement must be a written document in an approved format, not contain false or misleading information, and include detailed data on the number of care minutes (in hours), the total expenses for care minutes for each reporting period quarter, a breakdown by types of nursing delivery of care minutes, reporting on 24/7 nursing coverage, and explanations for any variances across reporting periods, along with, subject to subsection (6), a signed audit report from an independent auditor.\n\n(6) The care minutes performance statement must be audited by a registered company auditor or an approved individual, following the ASAE 3000 standard for assurance engagements.",
          "summaryHTML": "Registered providers must submit a written care minutes performance statement that meets the criteria outlined in subsections (5), and (6) below.\n\n(4) A registered provider must, when giving the aged care financial report to the System Governor, also give the System Governor a care minutes performance statement for the provider in accordance with the requirements prescribed by subsection (5).\n\n(5) The care minutes performance statement must be a written document in an approved format, not contain false or misleading information, and include detailed data on the number of care minutes (in hours), the total expenses for care minutes for each reporting period quarter, a breakdown by types of nursing delivery of care minutes, reporting on 24/7 nursing coverage, and explanations for any variances across reporting periods, along with, subject to subsection (6), a signed audit report from an independent auditor.\n\n(6) The care minutes performance statement must be audited by a registered company auditor or an approved individual, following the ASAE 3000 standard for assurance engagements.",
          "extract": "(3) A registered provider of the kind prescribed under this section must provide a written statement that satisfies the requirements in subsections (4), (5) and (6) (a care minutes performance statement).\nCare minutes performance statement to be given with aged care financial report\n\n(4) A registered provider must, when giving the aged care financial report to the System Governor, also give the System Governor a care minutes performance statement for the provider in accordance with the requirements prescribed by subsection (5).\nRequirements for a care minutes performance statement\n\n(5) A care minutes performance statement for a reporting period for a registered provider must:\n(a) be in writing; and\n(b) be in a form approved by the System Governor; and\n(c) not contain false or misleading information; and\n(d) include the total number of care minutes (in hours) for each reporting period quarter as delivered by:\n(i) registered nurses; and\n(ii) enrolled nurses; and\n(iii) personal care workers and nursing assistants; and\n(e) include the total expenses for care minutes for each reporting period quarter as delivered by:\n(i) registered nurses; and\n(ii) enrolled nurses; and\n(iii) personal care workers and nursing assistants; and\n(f) include 24/7 registered nursing coverage across the reporting period by calendar month and expressed as a percentage; and\n(g) if there is a variance in the data submitted under paragraph (f) throughout the reporting period—the registered provider must include an explanation for the variance; and\n(h) if there is a variance between the care minutes reported in the care minutes performance statement and the care minutes reported in the previous quarterly financial reports—the registered provider must include an explanation for the variance; and\n(i) subject to subsection (6), include a signed audit report for the submitted care minutes performance statement by an independent auditor.\nAuditing of care minutes performance statement\n\t\n(6) A care minutes performance statement must be audited in accordance with the following requirements:\n(a) be audited by:\n(i) a registered company auditor within the meaning of the Corporations Act 2001; or\n(ii) a person approved by the System Governor under subsection \n\n(7);\n(b) be audited in accordance with the Assurance Engagements Other than Audits or Reviews of Historical Financial Information Standard (ASAE 3000).\nNote:\tFor the purposes of paragraph (b), the Assurance Engagements Other than Audits or Reviews of Historical Financial Information Standard (ASAE 3000) is published by the Australian Auditing and Assurance Standards Board.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 458,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-340(1)-(4)",
          "section": "Quarterly financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This section applies to every kind of registered providers. \n\nThe requirements of this section do not apply in respect to the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) CHSP;\n\n(b) TCP.\n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under the NATSIFACP where the registered provider is not registered in the provider registration Category 6 - residential care.\n\nA registered provider of the kind prescribed under this section must give a report about matters provided in subsection (5) (the quarterly financial report) to the System Governor for each quarter of a reporting period for the registered provider.\n\nNote: For the reporting period for a quarterly financial report, see section 166-355 of the rules.",
          "summaryHTML": "This section applies to every kind of registered providers. \n\nThe requirements of this section do not apply in respect to the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) CHSP;\n\n(b) TCP.\n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under the NATSIFACP where the registered provider is not registered in the provider registration Category 6 - residential care.\n\nA registered provider of the kind prescribed under this section must give a report about matters provided in subsection (5) (the quarterly financial report) to the System Governor for each quarter of a reporting period for the registered provider.\n\nNote: For the reporting period for a quarterly financial report, see section 166-355 of the rules.",
          "extract": "Scope of this section\n\n(1) Subject to subsections (2) and (3), for the purposes of paragraph 166(1)(d) of the Act, every kind of registered providers is prescribed. \n\n(2) The requirements of this section do not apply in respect to the delivery of funded aged care services under any of the following specialist aged care programs: \n\n(a) CHSP; \n\n(b) TCP. \n\n(3) The requirements of this section do not apply in respect of the delivery of funded aged care services under the NATSIFACP where the registered provider is not registered in the provider registration category residential care. \n\n(4) A registered provider of the kind prescribed under this section must give a report about matters provided in subsection (5) (the quarterly financial report) to the System Governor for each quarter of a reporting period for the registered provider.\n\nNote: For the reporting period for a quarterly financial report, see section 166-355 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 459,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-340(5)",
          "section": "Quarterly financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirements for a quarterly financial report\n\nThe quarterly financial report must be in the approved form and signed by a member of the provider’s governing body.",
          "summaryHTML": "<i>Requirements for a quarterly financial report</i>\n\nThe quarterly financial report must be in the approved form and signed by a member of the provider’s governing body.",
          "extract": "Requirements for a quarterly financial report\n\n(5) The quarterly financial report must: \n\n(a) be in the approved report form; and \n\n(b) be signed by a member of the governing body of the registered provider. \n\nNote: The term governing body is defined in section 7 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 460,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-340(7)",
          "section": "Quarterly financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Timeframes to give System Governor a quarterly financial report\n\nA registered provider must submit the quarterly financial reports to the System Governor within 45 days for the quarter ending December 31 and within 35 days for all other quarters.",
          "summaryHTML": "<i>Timeframes to give System Governor a quarterly financial report</i>\n\nA registered provider must submit the quarterly financial reports to the System Governor within 45 days for the quarter ending December 31 and within 35 days for all other quarters.",
          "extract": "Timeframes to give System Governor a quarterly financial report\n\n(7) The quarterly financial report for a quarter of a reporting period for the registered provider must be given to the System Governor:\n\n(a) for a quarter ending at the end of 31 December—within 45 days after the end of the quarter; and\n\n(b) for any other quarter—within 35 days after the end of the quarter.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 461,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-340(9)-(10)",
          "section": "Quarterly financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirement to comply with a notice for further information\n\nA registered provider must respond to notices for further information under subsection (11) within a specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice. \n\nTo comply with a notice under subsection (11) a registered provider must submit the requested information in a format approved by the System Governor.",
          "summaryHTML": "<i>Requirement to comply with a notice for further information</i>\n\nA registered provider must respond to notices for further information under subsection (11) within a specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice. \n\nTo comply with a notice under subsection (11) a registered provider must submit the requested information in a format approved by the System Governor.",
          "extract": "Requirement to comply with a notice for further information\n\n(9) A registered provider must comply with a notice under subsection (11) within the period specified in the notice or, if no period is specified in the notice, within 28 days after the day when the notice is given.\n\n(10) A registered provider complies with a notice under subsection (11) only if the provider gives the information in a form (if any) approved by the System Governor for the purposes of that subsection.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 462,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(1)-(3)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Aged care financial report—general purpose financial report\n\nThis section applies to registered providers registered in registration Category 6 - residential care.\n\nThe requirements of this section do not apply to a registered provider if the registered provider is a government entity or a local government authority or is delivering funded aged care services under a specialist aged care program.\n\nA registered provider of a kind prescribed under this section must give a report on matters provided in subsection (4) (the general purpose financial report) to the System Governor each reporting period for the registered provider.\n\nNote: For the reporting period for a general purpose financial report, see section 166-355 of the rules.",
          "summaryHTML": "<i>Aged care financial report—general purpose financial report</i>\n\nThis section applies to registered providers registered in registration Category 6 - residential care.\n\nThe requirements of this section do not apply to a registered provider if the registered provider is a government entity or a local government authority or is delivering funded aged care services under a specialist aged care program.\n\nA registered provider of a kind prescribed under this section must give a report on matters provided in subsection (4) (the general purpose financial report) to the System Governor each reporting period for the registered provider.\n\nNote: For the reporting period for a general purpose financial report, see section 166-355 of the rules.",
          "extract": "Scope of this section\n\n(1) Subject to subsection (2), for the purposes of paragraph 166(1)(d) of the Act, a registered provider is prescribed if the provider is registered in the provider registration category residential care.\n\n(2) The requirements of this section do not apply to a registered provider if the registered provider:\n\n(a) is a government entity or a local government authority; or\n\n(b) is delivering funded aged care services under a specialist aged care program. \n\n(3) A registered provider of a kind prescribed under this section must give a report on matters provided in subsection (4) (the general purpose financial report) to the System Governor each reporting period for the registered provider.\n\nNote: For the reporting period for a general purpose financial report, see section 166-355 of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 463,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(4)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirements for a general purpose financial report\n\nThe general purpose financial report must comply with specific accounting standards, provide an accurate representation of the financial status of the registered provider, and be submitted to the System Governor alongside the aged care financial report under section 166-310.",
          "summaryHTML": "<i>Requirements for a general purpose financial report</i>\n\nThe general purpose financial report must comply with specific accounting standards, provide an accurate representation of the financial status of the registered provider, and be submitted to the System Governor alongside the aged care financial report under section 166-310.",
          "extract": "Requirements for a general purpose financial report\n\n(4) The general purpose financial report must:\n\n(a) be a general purpose financial report within the meaning given by section 6 of the Statement of Accounting Concepts SAC 1; and\n\n(b) be in accordance with the Australian Accounting Standards in force at the time the report is prepared; and\n\n(c) give a true and fair view of the financial position and performance of the registered provider for the reporting period for each residential care home approved in relation to the registered provider; and\n\n(d) be written as if the registered provider were, so far as it provided those services, a distinct reporting entity within the meaning of the Statement of Accounting Concepts SAC 1; and\n\n(e) be given to the System Governor at the same time the registered provider gives an aged care financial report under section 166-310 of this instrument to the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 464,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(5)-(6)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirements for a general purpose financial report\n\nIf a general purpose financial report deals with a matter other than funded aged care services delivered through the service group residential care, the report must be prepared as if the funded aged care services delivered through the service group residential care it relates to were a reportable segment for the purposes of the Australian accounting standards related to segment reporting in force at the time the report is prepared.\n\nIf all the information about each residential care home approved in relation to the registered provider is included in the provider’s aged care financial report for the reporting period, none of that information need be included in the general purpose financial report for the reporting period.",
          "summaryHTML": "<i>Requirements for a general purpose financial report</i>\n\nIf a general purpose financial report deals with a matter other than funded aged care services delivered through the service group residential care, the report must be prepared as if the funded aged care services delivered through the service group residential care it relates to were a reportable segment for the purposes of the Australian accounting standards related to segment reporting in force at the time the report is prepared.\n\nIf all the information about each residential care home approved in relation to the registered provider is included in the provider’s aged care financial report for the reporting period, none of that information need be included in the general purpose financial report for the reporting period.",
          "extract": "Requirements for a general purpose financial report\n\n(5) If a general purpose financial report deals with a matter other than funded aged care services delivered through the service group residential care, the report must be prepared as if the funded aged care services delivered through the service group residential care it relates to were a reportable segment for the purposes of the Australian accounting standards related to segment reporting in force at the time the report is prepared.\n\n(6) Despite subsections (4) and (5), if all the information about each residential care home approved in relation to the registered provider is included in the provider’s aged care financial report for the reporting period, none of that information need be included in the general purpose financial report for the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 465,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(7)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must provide a copy of its most recently audited general purpose financial report to individuals accessing funded aged care services at the approved residential care home, an individual who has an access approval in effect for a residential care home, and their supporters.",
          "summaryHTML": "A registered provider must provide a copy of its most recently audited general purpose financial report to individuals accessing funded aged care services at the approved residential care home, an individual who has an access approval in effect for a residential care home, and their supporters.",
          "extract": "Requirements for a general purpose financial report\n\n(7) A registered provider must give a copy of its most recently audited general purpose financial report to each person who asks for a copy and is:\n\n(a) an individual accessing funded aged care services at the approved residential care home; or\n\n(b) an individual who has an access approval in effect for a residential care home and is considering accessing funded aged care services through the residential care home; or\n\n(c) a supporter of an individual to whom paragraph (a) or (b) applies.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 466,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(8)-(9)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirement to comply with a notice for further information\n\nA registered provider must respond to notices for further information under subsection (10) within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nTo comply with a notice under subsection (10) a registered provider must submit the requested information in a format approved by the System Governor.",
          "summaryHTML": "<i>Requirement to comply with a notice for further information</i>\n\nA registered provider must respond to notices for further information under subsection (10) within the specified timeframe or, if no timeframe is provided, within 28 days of receiving the notice.\n\nTo comply with a notice under subsection (10) a registered provider must submit the requested information in a format approved by the System Governor.",
          "extract": "Requirement to comply with a notice for further information\n\n(8) A registered provider must comply with a notice under subsection (10) within the period specified in the notice or, if no period is specified in the notice, within 28 days after the day when the notice is given.\n\n(9) A registered provider complies with a notice under subsection (10) only if the provider gives the information in a form (if any) approved by the System Governor for the purposes of that subsection.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 467,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-345(13)",
          "section": "Aged care financial report—general purpose financial report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Requirement to publish reports \n\nRegistered providers covered by this section must publish their general purpose financial report for the reporting period on their website, or any website if they do not have one. The report must be published no later than 5 months after the end of the reporting period and be available for a period of at least 3 years after publishing.",
          "summaryHTML": "<i>Requirement to publish reports \n</i>\nRegistered providers covered by this section must publish their general purpose financial report for the reporting period on their website, or any website if they do not have one. The report must be published no later than 5 months after the end of the reporting period and be available for a period of at least 3 years after publishing.",
          "extract": "Requirement to publish reports\n\n(13) A registered provider must ensure that a general purpose financial report for a reporting period is published, in a way that makes the report readily accessible to members of the public, on:\n\n(a) the registered provider’s website; or\n\n(b) if the registered provider does not have a website—another website;\n\nfor a period of at least 3 years starting no later than 5 months after the end of the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 468,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-350(1)",
          "section": "Aged care financial report—general purpose financial report audit requirements",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Aged care financial report—general purpose financial report audit requirements\n\nThe general purpose financial report must be audited by a qualified auditor and include their audit opinion and a compliance statement.",
          "summaryHTML": "<i>Aged care financial report—general purpose financial report audit requirements</i>\n\nThe general purpose financial report must be audited by a qualified auditor and include their audit opinion and a compliance statement.",
          "extract": "(1) A general purpose financial report must:\n\n(a) be audited by:\n\n(i) a registered company auditor within the meaning of the Corporations Act 2001; or\n\n(ii) a person approved by the System Governor under subsection (2);\n\n(b) include each of the following:\n\n(i) an audit opinion about the general purpose financial report from a registered company auditor or a person approved under subsection (2);\n\n(ii) a statement from the registered company auditor or the person approved under subsection (2) as to whether the report complies with paragraphs 166-345(4)(b) and (c) of this instrument.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 469,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-360(1)-(3)",
          "section": "Annual prudential compliance statement—general",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Aged care financial report—annual prudential compliance statement—general\n\nThis rule applies to Category 6 - residential care providers that receive lump sum payments from individuals, such as a refundable deposit, accommodation bond, or entry contribution.\n\nA registered provider must submit an annual prudential compliance statement to the System Governor that includes details on refundable deposits, accommodation bonds, entry contributions, other fees and statements.\n\nThe annual prudential compliance statement must be a written document in an approved format, include specific information and declarations and not contain any false or misleading information. It must be submitted with an aged care financial report if this is also a requirement. It must also be signed by an authorised responsible person and submitted within 4 months after the end of the reporting period for the registered provider.",
          "summaryHTML": "<i>Aged care financial report—annual prudential compliance statement—general</i>\n\nThis rule applies to Category 6 - residential care providers that receive lump sum payments from individuals, such as a refundable deposit, accommodation bond, or entry contribution.\n\nA registered provider must submit an annual prudential compliance statement to the System Governor that includes details on refundable deposits, accommodation bonds, entry contributions, other fees and statements.\n\nThe annual prudential compliance statement must be a written document in an approved format, include specific information and declarations and not contain any false or misleading information. It must be submitted with an aged care financial report if this is also a requirement. It must also be signed by an authorised responsible person and submitted within 4 months after the end of the reporting period for the registered provider.",
          "extract": "Scope of this section\n\n(1) For the purposes of paragraph 166(1)(d) of the Act, a registered provider is prescribed if the registered provider:\n\n(a) is registered in the provider registration category residential care; and\n\n(b) receives or has received payment of any of the following from an individual, wholly or partly as a lump sum:\n\n(i) a refundable deposit;\n\n(ii) an accommodation bond;\n\n(iii) an entry contribution. \n\n(2) A registered provider of the kind prescribed under this section must give the System Governor a statement (the annual prudential compliance statement) for a reporting period for the registered provider that includes the following:\n\n(a) if the lump sum is a refundable deposit—information about refundable deposits and refundable deposit balances referred to in section 166-365 of this instrument;\n\n(b) if the lump sum is an accommodation bond—information about the accommodation bond and accommodation bond balance referred to in section 166-365 of this instrument;\n\n(c) if the lump sum is an entry contribution—information about entry contributions referred to in section 166-365 of this instrument;\n\n(d) information about other fees referred to in section 166-375 of this instrument;\n\n(e) the statements and other information referred to in section 166-380 of this instrument.\n\nRequirements for an annual prudential compliance statement\n\n(3) An annual prudential compliance statement for a reporting period for a registered provider must:\n\n(a) be in writing; and\n\n(b) be in a form approved by the System Governor; and\n\n(c) further to subsection (2), include the information specified in that subsection; and\n\n(d) not contain false or misleading information; and\n\n(e) include a declaration that the registered provider has only charged the amount of refundable deposit the registered provider is permitted to charge; and\n\n(f) if the registered provider has not complied with paragraph (e), include the number of times the provider has not complied with this requirement and the reasons for the non-compliance; and\n\n(g) if the registered provider is required to prepare an aged care financial report for the reporting period—be included in the aged care financial report for the registered provider for the reporting period.\n\nNote: The annual prudential compliance statement must be supported by an independent audit (see section 166-385 of this instrument).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 470,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-365(2)",
          "section": "Annual prudential compliance statement—information about refundable deposits and accommodation bonds that must be included",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual prudential compliance statement—information about refundable deposits, accommodation bonds and entry contributions that must be included\n\nThe information that providers must include in their annual prudential compliance statement for a reporting period in relation to a refundable deposit, accommodation bond or entry contribution and their balances are outlined in subsections (2)(a)-(u) of the rules.",
          "summaryHTML": "<i>Annual prudential compliance statement—information about refundable deposits, accommodation bonds and entry contributions that must be included</i>\n\nThe information that providers must include in their annual prudential compliance statement for a reporting period in relation to a refundable deposit, accommodation bond or entry contribution and their balances are outlined in subsections (2)(a)-(u) of the rules.",
          "extract": "(2) The information about a refundable deposit, an accommodation bond or entry contribution, a refundable deposit balance or an accommodation bond balance or entry contribution balance that must be included in a registered provider’s annual prudential compliance statement for a reporting period is as follows:\n\n(a)\tthe total number of refundable deposit balances, or accommodation bond balances or entry contribution balances held by the registered provider as at the end of the reporting period;\n\n(b)\tthe total value of refundable deposit balances, or accommodation bond balances or entry contribution balances held by the registered provider as at the end of the reporting period;\n\n(c)\tthe total value of refundable deposits, accommodation bonds or entry contributions received by the registered provider during the reporting period;\n\n\t(d)\t the total amount deducted by the registered provider during the reporting period from refundable deposit balances, accommodation bond balances or entry contribution balances, including:\n\t(i)\t for refundable deposit balances or accommodation bond balances—any general deductions under section 307 of the Act or section 287-90 of this instrument; and\n\t(ii) \tfor refundable deposit balances only—any retention amounts deducted under section 308 of the Act by the registered provider during the reporting period from refundable deposit balances;\n\t(iii) \tfor accommodation bond balances only—any accommodation bond retention amounts deducted under section 287-95 of this instrument by the registered provider during the reporting period from accommodation bond balances;\n\n\t(e) \tthe total amount deducted by the registered provider during the reporting period from refundable deposits or accommodation bonds that were received during the year, including:\n\t(i) \tfor refundable deposit balances or accommodation bond balances—any general deductions under section 307 of the Act or section 287-90 of this instrument; and\n\t(ii) \tfor refundable deposit balances only—any retention amounts deducted under section 308 of the Act by the registered provider during the reporting period from refundable deposit balances received during the reporting period;\n\t(iii) \tfor accommodation bond balances only—any accommodation bond retention amounts deducted under section 287-95 of this instrument by the registered provider during the reporting period from accommodation bond balances;\n\n\t(f) \tany transfer of a refundable deposit made under section 312 of the Act, a transfer of an accommodation bond made under section 287-103 of this instrument, or transfer of entry contribution balances, including the amount, the date of transfer and the amount left on retention;\n\n\t(g)\t the total value of refundable deposit balances, accommodation bond balances and entry contribution balances refunded by the registered provider during the reporting period;\n\n\t(h) \tif, during the reporting period, refundable deposit balances or accommodation bond balances or entry contribution balances were not refunded in accordance with subsection 311(3) of the Act, subsection 287-102(2) of this instrument or section 287-160 of this instrument (other than a refundable deposit balance, or accommodation bond balance or entry contribution balance in relation to which the registered provider has made an agreement as referred to in section 311-20(3) of this instrument)—the following information:\n\n(i)\t\tthe total number of refundable deposit balances, accommodation bond balances or entry contribution balances that were not refunded in accordance with subsection 311(3) of the Act, subsection 287-102(2) of this instrument or section 287-160 of this instrument;\n(ii)\twhere entry contribution balances were not refunded in accordance with an applicable formal agreement with an individual—the number of entry contributions that were refunded under the formal agreement applying in respect of the relevant entry contribution balance;\n(iii)\tthe reason or reasons for the delay in refunding the refundable deposit balances, accommodation bond balances or entry contribution balances;\n\t(iv) \tin respect of each reason provided—the total number of instances of delay attributable to the reason;\n\t\n(i) \tif, for the whole or a part of the reporting period, the registered provider was not permitted to charge a refundable deposit or accommodation bond for entry by an individual to any aged care service that the registered provider is responsible for operating:\n\t(i)\t the period or periods during which the registered provider was not permitted to charge a refundable deposit or accommodation bond; and\n\t(ii)\t the funded aged care service in respect of which each period specified applies;\n\t(j) \tthe use of refundable deposits and accommodation bonds by the registered provider during the reporting period;\n\t(k)\t whether any use of refundable deposits, accommodation bonds by the registered provider during the reporting period was not permitted under section 310 of the Act or section 287-101 of this instrument;\n\t(l)\t the total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on capital expenditure for which use of a refundable deposit or an accommodation bond was permitted under section 310 of the Act or section 287-101 of this instrument;\n\t(m) \tthe total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on investment in financial products for which use of a refundable deposit or an accommodation bond was permitted under section 310 of the Act or section 287-101 of this instrument;\n\t(n) \tthe total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on loans for which use of a refundable deposit or an accommodation bond was permitted under section 310 of the Act or section 287-101 of this instrument;\n\t(o)\t the total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on repaying debt accrued for the purposes of:\n\t(i)\t capital expenditure of the kind described in paragraph (l); or\n\t(ii) \trefunding refundable deposit balances, accommodation bond balances or entry contribution balances;\n\t(p) \tthe total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on repaying debt that accrued before 1 October 2011 if the debt was accrued for the purpose of delivering funded aged care services to individuals;\n\t(q) \tthe total amount expended by the registered provider (whether or not obtained from refundable deposits or accommodation bonds) during the reporting period on each of the uses of refundable deposits or accommodation bonds permitted under section 310 of the Act or section 287 101 of this instrument;\n\t(r) \tthe amount that has been returned to the registered provider during the reporting period from the sale, disposal or redemption of financial products covered by subsection 310(3) of the Act, or subsection 287-101(4) of this instrument, that the registered provider invested in after 1 October 2011, whether or not the investment was obtained from refundable deposits or accommodation bonds;\n\t(s) \tfor each accommodation agreement entered for a room priced above the maximum accommodation payment amount, whether the provider ensured they were permitted to charge the price, including having a current approval from the Pricing Authority at the time the individual agreed to the payment of the higher room price;\n\t(t)\t where there is a decrease or reduction in the payable amount from each resident’s daily accommodation contribution and refundable contribution held, information that the provider refunded the overpaid amount within 28 days of becoming aware of the reduced amount payable or paid by the individual;\n\t(u) \tinformation regarding the overpayment of accommodation payments or contributions during prior reporting period that the provider has become aware of during the reporting period.\nNote:\tParagraph (h) does not apply to a registered provider that has transferred their refundable deposit balance to another registered provider under section 312 of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 471,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-375",
          "section": "Annual prudential compliance statement—information about other fees that must be included",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual prudential compliance statement—information about other fees that must be included\n\nThe information about other fees that must be included in a registered provider’s annual prudential compliance statement for a reporting period includes the fees (if any) other than individual contributions, accommodation payments and accommodation contributions that the registered provider charged to individuals during the reporting period, the total value of each such fee charged by the registered provider during the reporting period,  what each such fee purports to cover, and for individuals accessing ongoing funded aged care services, whether the provider has conducted, in accordance with subsection 284-11(4) of the rules, an annual review of each individual’s higher everyday living agreement during the reporting period.",
          "summaryHTML": "<i>Annual prudential compliance statement—information about other fees that must be included</i>\n\nThe information about other fees that must be included in a registered provider’s annual prudential compliance statement for a reporting period includes the fees (if any) other than individual contributions, accommodation payments and accommodation contributions that the registered provider charged to individuals during the reporting period, the total value of each such fee charged by the registered provider during the reporting period,  what each such fee purports to cover, and for individuals accessing ongoing funded aged care services, whether the provider has conducted, in accordance with subsection 284-11(4) of the rules, an annual review of each individual’s higher everyday living agreement during the reporting period.",
          "extract": "The information about other fees that must be included in a registered provider’s annual prudential compliance statement for a reporting period is as follows:\n\n(a) the fees (if any) other than individual contributions, accommodation payments and accommodation contributions that the registered provider charged to individuals during the reporting period;\n\n(b) the total value of each such fee charged by the registered provider during the reporting period;\n\n(c) what each such fee purports to cover;\n\n(d) for individuals accessing ongoing funded aged care services, whether the provider has conducted, in accordance with subsection 284 11(4) of this instrument, an annual review of each individual’s higher everyday living agreement during the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 472,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-380",
          "section": "Annual prudential compliance statement—Financial and Prudential Standards",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual prudential compliance statement—Financial and Prudential Standards\n\nThe annual prudential compliance statement must also include compliance statements regarding financial standard, refundable accommodation deposit register, reasons for non-compliance, liquidity management details, and an independent audit opinion on compliance. \n\nNote: The annual prudential compliance statement must be supported by an independent audit (see section 166-385 of the rules).\n\nFor more detail on the information required as prescribed for this section, refer to section 166-380 of the rules.",
          "summaryHTML": "<i>Annual prudential compliance statement—Financial and Prudential Standards</i>\n\nThe annual prudential compliance statement must also include compliance statements regarding financial standard, refundable accommodation deposit register, reasons for non-compliance, liquidity management details, and an independent audit opinion on compliance. \n\nNote: The annual prudential compliance statement must be supported by an independent audit (see section 166-385 of the rules).\n\nFor more detail on the information required as prescribed for this section, refer to section 166-380 of the rules.",
          "extract": "The statements and other information that must be included in a registered provider’s annual prudential compliance statement for a reporting period are as follows:\n\n(a) a statement about whether the registered provider has, during the reporting period, complied with the following:\n\n(i) the Financial and Prudential Standards;\n\n(ii) section 287-20 of this instrument and subsection 293(1), subsections 311(1) and (2), and section 313 of the Act;\n\n(iii) Division 3 of Part 4 of Chapter 4 of the Act;\n\n(iv) subsection 310(1) of the Act;\n\n(b) if the registered provider has not complied with any of the Standards in the Financial and Prudential Standards—a statement about why the registered provider has not complied with the Standard;\n\n(ba) if the registered provider is of a kind prescribed by section 150A 3 of this instrument:\n\n(i) a statement about whether the registered provider has, during the reporting period, complied with the condition under section 150A of the Act; and\n\n(ii) if the provider has not complied with the condition—a statement about why the registered provider has not complied with the condition;\n\n(c) if the registered provider is required to, but has not complied with, paragraph 166‑310(3)(c) or section 155‑30, 155‑35, 155‑36, 166‑365, 166‑375 or 166‑385 of this instrument—the following information: \n\n(i) the total number of occasions on which the registered provider did not comply; \n\n(ii) the reason or reasons for the registered provider’s failure to comply; \n\n(iii) in respect of each reason provided—the total number of occasions of non‑compliance attributable to the reason; \n\n(d) the amount set out in the registered provider’s liquidity management strategy, at the end of the reporting period, as the registered provider’s minimum liquidity amount for the end of the most recent quarter;\n\n(e) the date on which the registered provider’s liquidity management strategy was last reviewed and assessed;\n\n(ea) the date on which the registered provider’s investment management strategy was last reviewed and assessed;\n\n(f) the date on which the registered provider’s financial and prudential management system was last reviewed and assessed; \n\n(g) an audit opinion, provided by the person who provides the independent audit referred to in section 166 385 of this instrument, on whether the registered provider has complied with the following in the reporting period:\n\t(i)\tthe Financial and Prudential Standards;\n\t(ii)\tthe condition under section 150A of the Act;\n\t(iii)\tsections 155-30 and 155-35 of this instrument;+E476\n\t(iv)\tsections 166-360 to 166-385 of this instrument.\n\nNote: The annual prudential compliance statement must be supported by an independent audit (see section 166-385 of this instrument).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 473,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div E, s166-385(1)",
          "section": "Annual prudential compliance statement—audit requirements",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual prudential compliance statement—audit requirements\n\nThe annual prudential compliance statement must be independently audited by either a registered company auditor or an individual approved by the System Governor.",
          "summaryHTML": "<i>Annual prudential compliance statement—audit requirements</i>\n\nThe annual prudential compliance statement must be independently audited by either a registered company auditor or an individual approved by the System Governor.",
          "extract": "(1) An annual prudential compliance statement must be supported by an independent audit provided by:\n\n(a) a registered company auditor within the meaning of the Corporations Act 2001; or\n\n(b) a person approved by the System Governor under subsection (2).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 474,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-600",
          "section": "Application of Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Subdivision F applies to a provider delivering funded services under CHSP, registered in one or more of the following categories:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "summaryHTML": "Subdivision F applies to a provider delivering funded services under CHSP, registered in one or more of the following categories:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "extract": "This Subdivision applies to a registered provider of a kind who is registered in one or more of the following provider registration categories:\n(a) home and community services;\n(b) assistive technology and home modifications;\n(c) advisory and support services;\n(d) personal and care support in the home or community;\n (e) nursing and transition care;\nand delivers funded aged care services under the CHSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 475,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-605(1)-(4)",
          "section": "Annual financial declaration statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual financial declaration statement\n\nA registered provider to whom Subdivision F applies, must give the System Governor an annual financial declaration statement each financial year. The annual financial declaration for a financial year must be provided by 31 August of that year and in a report form approved by the System Governor. It must include the information detailed in subsections 166-605 (4)(a)-(e).",
          "summaryHTML": "<i>Annual financial declaration statement</i>\n\nA registered provider to whom Subdivision F applies, must give the System Governor an annual financial declaration statement each financial year. The annual financial declaration for a financial year must be provided by 31 August of that year and in a report form approved by the System Governor. It must include the information detailed in subsections 166-605 (4)(a)-(e).",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give the System Governor a statement (the annual financial declaration statement) each financial year for the registered provider.\n\n(2) The annual financial declaration statement for a financial year for the registered provider must be given to the System Governor by 31 August of that year.\n\n(3) The annual financial declaration statement must be in a report form approved by the System Governor.\n\n(4) The annual financial declaration statement must include the following information for the financial year:\n\n(a) certification that all financial assistance granted by the System Governor was spent for the purposes specified in the grant agreement;\n\n(b) the amount of financial assistance the System Governor has granted the registered provider under the grant agreement, excluding GST;\n\n(c) the registered provider’s expenditure for the delivery of funded aged care services, excluding GST;\n\n(d) any surplus and uncommitted funds in the financial year;\n\n(e) any surplus and uncommitted funds from the previous financial year.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 476,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-605(5)-(7)",
          "section": "Annual financial declaration statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Statement of compliance to be given with annual financial declaration statement\n\nIf, under subsection (1), a registered provider is required to give an annual financial declaration statement for the financial year, they must also give the System Governor a statement of compliance that the financial assistance granted under the grant agreement was only spent on individuals with an assessment approval for funded services in one or more service groups for the individuals and the classification types for service groups under section 65 of the Act.\n\nThe annual financial declaration statement must be certified by the provider's governing body and must not include information about the provider's own funds or funds from another aged care program.",
          "summaryHTML": "<i>Statement of compliance to be given with annual financial declaration statement</i>\n\nIf, under subsection (1), a registered provider is required to give an annual financial declaration statement for the financial year, they must also give the System Governor a statement of compliance that the financial assistance granted under the grant agreement was only spent on individuals with an assessment approval for funded services in one or more service groups for the individuals and the classification types for service groups under section 65 of the Act.\n\nThe annual financial declaration statement must be certified by the provider's governing body and must not include information about the provider's own funds or funds from another aged care program.",
          "extract": "Statement of compliance to be given with annual financial declaration statement\n\n(5) If a registered provider is required under subsection (1) to give the System Governor an annual financial declaration statement for the financial year, then the provider must, when giving the report to the System Governor, also give the System Governor a statement of compliance that the financial assistance granted under the grant agreement was only spent on individuals with an assessment approval for funded aged care services in one or more service groups for the individuals and the classification types for the service groups under section 65 of the Act.\n\n(6) The annual financial declaration statement must be certified by the registered provider’s governing body.\n\n(7) For the purposes of subsection (1), the annual financial declaration statement must not include information about the registered provider’s:\n\n(a) own funds; or\n(b) funds from another aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 477,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-610(1)-(4)",
          "section": "Monthly performance report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Monthly performance report\n\nA registered provider to whom subdivision F applies, must give the System Governor a report about activity and performance data matters each month (the monthly performance report).\n\nThe monthly performance report must be in a report form approved by the System Governor and given to the System Governor within 14 days after the end of the month. It must include details listed in subsections (3)(a)-(b).",
          "summaryHTML": "<i>Monthly performance report</i>\n\nA registered provider to whom subdivision F applies, must give the System Governor a report about activity and performance data matters each month (the monthly performance report).\n\nThe monthly performance report must be in a report form approved by the System Governor and given to the System Governor within 14 days after the end of the month. It must include details listed in subsections (3)(a)-(b).",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give the System Governor a report about activity and performance data matters (the monthly performance report) each month.\n\n(2) The monthly performance report must be in an approved report form approved by the System Governor.\n\n(3) Without limiting subsection (2), the monthly performance report must include:\n\n(a) client level data and service delivery information for all activities described in Item B of the grant agreement, including:\n(i) the output measure as per the service type; and\n(ii) the My Aged Care ID for each individual; and\n(b) any individual fees or contributions paid to the registered provider under Part 3 of Chapter 4 of the Act.\n\n(4) The monthly performance report for a registered provider must be given to the System Governor within 14 days after the end of the month.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 478,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-615(1)-(4)",
          "section": "Annual wellness and reablement report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual wellness and reablement report\n\nA registered provider to whom subdivision F applies must give the System Governor a report about their progress embedding wellness and reablement into service delivery. The System Governor may request such a report at any time and the provider must comply with the request within 28 days, in a report form approved by the System Governor.",
          "summaryHTML": "<i>Annual wellness and reablement report</i>\n\nA registered provider to whom subdivision F applies must give the System Governor a report about their progress embedding wellness and reablement into service delivery. The System Governor may request such a report at any time and the provider must comply with the request within 28 days, in a report form approved by the System Governor.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give the System Governor a report about the registered provider’s progress in embedding wellness and reablement in its service delivery (the annual wellness and reablement report).\n\n(2) The System Governor may, at any time, request a registered provider to give the System Governor a report under subsection (1).\n\n(3) A registered provider must comply with a request under subsection (1) within 28 days after the request is made.\n\n(4) The report must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 479,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-620(1)-(4)",
          "section": "Compliance report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Compliance report\n\nA registered provider to whom subdivision F applies, must give the System Governor a report about any matters related to their management of a grant agreement under section 264 of the Act (the compliance report).\n\nThe System Governor may request such a report at any time and the report must be provided, in an approved form, within 14 days after the request is made.",
          "summaryHTML": "<i>Compliance report</i>\n\nA registered provider to whom subdivision F applies, must give the System Governor a report about any matters related to their management of a grant agreement under section 264 of the Act (the compliance report).\n\nThe System Governor may request such a report at any time and the report must be provided, in an approved form, within 14 days after the request is made.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give the System Governor a report about any matters related to the registered provider’s management of a grant agreement under section 264 of the Act (the compliance report).\n\n(2) The System Governor may, at any time, request a registered provider to give the System Governor a report under subsection (1).\n\n(3) The compliance report for a registered provider must be given to the System Governor within 14 days after the request is made.\n\n(4) The report must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 480,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-625(1)-(4)",
          "section": "Service delivery report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Service delivery report\n\nA registered provider to whom subdivision F applies must, on request by the System Governor, give a report about service delivery (the service delivery report).\n\nThe System Governor may request such a report at any time. The provider must comply within 21 days after the request is made, or a longer period as specified in the request, and it must be in a report form approved by the System Governor.",
          "summaryHTML": "<i>Service delivery report</i>\n\nA registered provider to whom subdivision F applies must, on request by the System Governor, give a report about service delivery (the service delivery report).\n\nThe System Governor may request such a report at any time. The provider must comply within 21 days after the request is made, or a longer period as specified in the request, and it must be in a report form approved by the System Governor.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must, on request by the System Governor, give a report about service delivery (the service delivery report).\n\n(2) The System Governor may, at any time, request a registered provider to give the System Governor a report under subsection (1).\n\n(3) A registered provider must comply with a request under subsection (1) within 21 days after the request is made, or such longer period as specified in the request.\n\n(4) The report must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 481,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-627(1)-(11)",
          "section": "Exemption process for certain reports",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Exemption process for certain reports\n\nFor the purposes of s 166(4)(b) of the Act, this section prescribes the exemption process for submission of the following:\n(a) annual financial declaration statement\n(b) monthly performance report\n(c) compliance report\n(d) annual wellness and reablement report\n\nA registered provider may apply to the System Governor for an exemption from the above reports, if affected by extenuating circumstances.\n\nMore detail on the exemption process and requirements can be found in subsections (3) to (11).",
          "summaryHTML": "<i>Exemption process for certain reports</i>\n\nFor the purposes of s 166(4)(b) of the Act, this section prescribes the exemption process for submission of the following:\n(a) annual financial declaration statement\n(b) monthly performance report\n(c) compliance report\n(d) annual wellness and reablement report\n\nA registered provider may apply to the System Governor for an exemption from the above reports, if affected by extenuating circumstances.\n\nMore detail on the exemption process and requirements can be found in subsections (3) to (11).",
          "extract": "(1) For the purposes of paragraph 166(4)(b) of the Act, this section prescribes the exemption process in relation to the submission of the following: \n\n(a) annual financial declaration statement; \n\n(b) monthly performance report; \n\n(c) compliance report; \n\n(d) annual wellness and reablement report; \n\n(2) A registered provider may apply to the System Governor for an exemption from subsections 166-605(1), 166-610(1), 166-615(1) or 166-620(1), if the provider is affected by extenuating circumstances. \n\n(3) The application: \n\n(a) may be in a form approved by the System Governor; and \n\n(b) must be made to the System Governor at least 14 days before the due date for the report listed in subsection (1). \n\n(4) The System Governor must decide to grant or refuse an exemption within:  \n\n(a) if the registered provider is given a notice under subsection (5) and gives the System Governor the further information or documents requested within the 14-day period, or such longer period specified in the notice—14 days after receiving the further information or documents; or \n\n(b) if the registered provider is given a notice under subsection (5) but does not give the System Governor the further information or documents requested within the 14-day period, or such longer period specified in the notice—14 days after the end of that period; or \n\n(c) otherwise—14 days after receiving the request. \n\n(5) If the System Governor receives an application under subsection (2) from a registered provider, the System Governor may, by notice in writing given to the provider, request further information or documents specified in the notice for the purposes of considering the application. \n\n(6) If the registered provider does not provide the requested information or documents within 14 days after the day when the notice is given, or within such longer period specified in the notice, the application is taken to have been withdrawn. The notice must contain a statement setting out the effect of this subsection. \n\n(7) If the System Governor receives an application under subsection (2) from a registered provider for an exemption under subsections 166-605(1), 166-610(1), 166-615(1) or 166-620(1), the System Governor may grant the exemption only if the System Governor is satisfied that the provider is affected by extenuating circumstances. \n\n(8) If the System Governor decides to grant an exemption, the System Governor must decide the period for which the exemption is to be in force. \n\n(9) The period may: \n\n(a) be for the financial year; or \n\n(b) be a duration no longer than 12 months. \n\n(10) If the System Governor grants an exemption from subsections 166-605(1), 166-610(1), 166-615(1) or 166-620(1), to a registered provider, the System Governor must give the provider notice in writing of the decision that: \n\n(a) states an exemption has been granted; and \n\n(b) states the period for which the exemption is in force; and \n\n(c) the reasons for the decision. \n\n(11) If the System Governor refuses to grant an exemption from subsections 166-605(1), 166-610(1), 166-615(1) or 166-620(1), to a registered provider, the System Governor must give the provider notice in writing of the decision that: \n\n(a) states an exemption has not been granted; and \n\n(b) states the due date for the report; and\n\n(c) the reasons for the decision.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 482,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div F, s166-628(1)-(5)",
          "section": "Child safety compliance statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Child safety compliance statement\n\nA registered provider to whom subdivision G applies, must give the System Governor a report each year on matters outlined in subsection (3) of this rule the child safety compliance statement.\n\nThis statement must be given by 31 March each year, in an approved form, and include the information outlined in subsection (3).\n\nIf the provider has not complied with the Child Safety supplementary term in their grant agreement, they must provide a description of their non-compliance, including reasons.",
          "summaryHTML": "<i>Child safety compliance statement</i>\n\nA registered provider to whom subdivision G applies, must give the System Governor a report each year on matters outlined in subsection (3) of this rule the child safety compliance statement.\n\nThis statement must be given by 31 March each year, in an approved form, and include the information outlined in subsection (3).\n\nIf the provider has not complied with the Child Safety supplementary term in their grant agreement, they must provide a description of their non-compliance, including reasons.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report on matters provided for in subsection (3) (the child safety compliance statement) to the System Governor each year. \n\n(2) The child safety compliance statement for the registered provider must be given to the System Governor by 31 March each year. \n\n(3) The child safety compliance statement must include the following information:  \n\n(a) a declaration that the registered provider has delivered grant activities consistent with the Child Safety supplementary term in the registered provider’s grant agreement; \n\n(b) the activity name; \n\n(c) the activity ID; \n\n(d) the statement type in relation to the incidental contract term in the grant agreement; \n\n(e) the reporting start date; \n\n(f) the reporting end date. \n\n(4) If the registered provider has not complied with the Child Safety supplementary term in the registered provider’s grant agreement, the registered provider must provide a description of the non-compliance and set out the reasons for the non-compliance in the child safety compliance statement. \n\n(5) The child safety compliance statement must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 483,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div G, s166-630",
          "section": "Application of Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Subdivision G applies to a provider delivering funded services under NATSIFACP, registered in one or more of the following categories:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care and/or\nCategory 6 - residential care.",
          "summaryHTML": "Subdivision G applies to a provider delivering funded services under NATSIFACP, registered in one or more of the following categories:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care and/or\nCategory 6 - residential care.",
          "extract": "This Subdivision applies to a registered provider of a kind who is registered in one or more of the following provider registration categories:\n\n(a) home and community services;\n(b) assistive technology and home modifications;\n(c) personal and care support in the home or community;\n(d) nursing and transition care;\n(e) residential care;\n(f) advisory and support services;\nand delivers funded aged care services under the NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 484,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div G, s166-635(1)-(5)",
          "section": "Annual financial declaration statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Annual financial declaration statement\n\nA registered provider to whom subdivision G applies must give the System Governor an annual financial declaration statement each financial year.\n\nThe annual financial declaration statement must be in an approved report form and given annually or at such other time as agreed between the System Governor and the provider. It must include the detail outlined in subsection (4) of this section and be signed by a member of the provider's governing body.",
          "summaryHTML": "<i>Annual financial declaration statement</i>\n\nA registered provider to whom subdivision G applies must give the System Governor an annual financial declaration statement each financial year.\n\nThe annual financial declaration statement must be in an approved report form and given annually or at such other time as agreed between the System Governor and the provider. It must include the detail outlined in subsection (4) of this section and be signed by a member of the provider's governing body.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give the System Governor a statement (the annual financial declaration statement) each financial year for the registered provider.\n\t(2)\tThe annual financial declaration statement for a financial year for the registered provider must be given to the System Governor:\n\t(a)\tannually; or\n\t(b)\tat such other time as agreed between the System Governor and the registered provider.\n\t(3)\tThe annual financial declaration statement must be in a report form approved by the System Governor.\n\t(4)\tThe annual financial declaration statement must include the following information for the financial year:\n\t(a)\tcertification that the provider, in relation to the use of financial assistance granted by the System Governor under subsection 264(2) of the Act, complied with the statutory funding condition under subsection 267(1) of that Act;\n\t(b)\tthe amount of financial assistance the System Governor, on behalf of the Commonwealth, granted the registered provider;\n\t(c)\tthe amount of expenditure for the delivery of funded aged care services by the provider;\n\t(d)\tthe amount, if any, of unspent grant funding in the financial year;\n\t(e)\tany unspent funds approved by the System Governor from previous financial year.\nNote:\tIt is a statutory funding condition that the financial assistance granted to a registered provider is used only for the purpose of delivering funded aged care services to individuals in the circumstances mentioned in subsection 267(1) of the Act.\n\t(5)\tThe annual financial declaration statement must be signed by a member of the registered provider’s governing body.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 485,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div G, s166-640(1)-(4)",
          "section": "Audited income and expenditure report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Audited income and expenditure report\n\nA registered provider to whom subdivision G applies must give an audited income and expenditure report about financial matters to the System Governor each financial year.\n\nThe audited income and expenditure report must be prepared by a registered company auditor within the meaning of the Corporations Act 2001 or a member of the Institute of Public Accountants or the Institute of Chartered Accountants in Australia.\n\nIf a provider is required to provide an audited income and expenditure report under this section, they must also give the System Governor an audited income and expenditure statement, in accordance with the information outlined under subsection (4) of this section.",
          "summaryHTML": "<i>Audited income and expenditure report</i>\n\nA registered provider to whom subdivision G applies must give an audited income and expenditure report about financial matters to the System Governor each financial year.\n\nThe audited income and expenditure report must be prepared by a registered company auditor within the meaning of the Corporations Act 2001 or a member of the Institute of Public Accountants or the Institute of Chartered Accountants in Australia.\n\nIf a provider is required to provide an audited income and expenditure report under this section, they must also give the System Governor an audited income and expenditure statement, in accordance with the information outlined under subsection (4) of this section.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report about financial matters (the audited income and expenditure report) to the System Governor each financial year for the registered provider.\n\t(2)\tThe audited income and expenditure report must be prepared by:\n\t(a)\ta registered company auditor within the meaning of the Corporations Act 2001; or\n\t(b)\ta member of:\n\t\t(i) the Institute of Public Accountants; or\n\t\t(ii) the Institute of Chartered Accountants in Australia.\nAudited income and expenditure statement to be given with audited income and expenditure report\n\t(3)\tIf a registered provider is required under this section to give the System Governor an audited income and expenditure report for the financial year, then the provider must, when giving the report to the System Governor, also give the System Governor an audited income and expenditure statement.\n\t(4)\tThe audited income and expenditure statement must:\n\t(a)\tbe in accordance with the Australian accounting standards in force at the time the report is prepared; and\n\t(b)\tbe based on proper accounts and records of the registered provider; and\n\t(c)\tverify that the provider, in relation to the use of financial assistance granted by the System Governor under subsection 264(2) of the Act, complied with the statutory funding condition under subsection 267(1) of that Act; and\n\t(d)\tinclude other matters as specified in the funding agreement; and\n\t(e)\tinclude the audit opinion; and\n\t(f)\tinclude the amount of financial assistance the System Governor, on behalf of the Commonwealth, has granted the registered provider under subsection 264(2) of the Act for the financial year; and\n\t(g)\tinclude the amount of individual fees and contributions paid to the provider by individuals for the financial year; and\n\t(h)\tinclude salary expenditure; and\n\t(i)\tinclude rent or lease expenditure; and\n\t(j)\tinclude outbreak management expenditure; and\n\t(k)\tinclude vehicle lease and maintenance cost; and\n\t(l)\tinclude other expenditure; and\n\t(m)\tinclude total expenditure.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 486,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div G, s166-645(1)-(3)",
          "section": "Service activity report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Service activity report\n\nA registered provider to whom subdivision G applies must submit a service activity report about their progress in providing funded services in accordance with the grant agreement to the System Governor every 6 months.\n\nThe service activity report must be given in accordance with the timeframes outlined in subsection (2) and include the information listed in subsection (3) of this section.",
          "summaryHTML": "<i>Service activity report</i>\n\nA registered provider to whom subdivision G applies must submit a service activity report about their progress in providing funded services in accordance with the grant agreement to the System Governor every 6 months.\n\nThe service activity report must be given in accordance with the timeframes outlined in subsection (2) and include the information listed in subsection (3) of this section.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report about the registered provider’s progress in providing funded aged care services in accordance with the grant agreement (the service activity report) to the System Governor every 6 months.\n\t(2)\tThe service activity report must be given to the System Governor:\n\t(a)\ton 27 January for the 6 month period ending on 31 December; and\n\t(b)\ton 27 July for the 6 month period ending on 30 June.\n\t(3)\tThe service activity report must:\n\t(a)\tbe in a report form approved by the System Governor; and\n\t(b)\tinclude information about labour worked hours data for registered nurses, enrolled nurses, personal care workers and allied health professionals for the reporting period; and\n\t(c)\tinclude information about labour cost for registered nurses, enrolled nurses, personal care workers and allied health professionals for the reporting period; and\n\t(d)\tinclude information about the number of occupied beds for the reporting period; and\n\t(e)\tinclude de identified profiles of each aged care worker of the provider; and\n\t(f)\tinclude the number of individuals accessing funded aged care services by service type; and\n\t(g)\tinclude the number and type of health profession visits during the reporting period; and\n\t(h)\tinclude the number and type of traditional or cultural events individuals accessing funded aged care services were supported to engage in during the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 487,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div G, s166-646(1)-(5)",
          "section": "Child safety compliance statement",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Child safety compliance statement\n\nA registered provider to whom subdivision G applies, must give the System Governor a report each year on matters outlined in subsection (3) of this rule (the child safety compliance statement).\n\nThis statement must be given by 31 March each year, in an approved form, and include the information outlined in subsection (3) of this section.\n\nIf the provider has not complied with the Child Safety supplementary term in their grant agreement, they must provide a description of their non-compliance, including reasons.",
          "summaryHTML": "<i>Child safety compliance statement</i>\n\nA registered provider to whom subdivision G applies, must give the System Governor a report each year on matters outlined in subsection (3) of this rule (the child safety compliance statement).\n\nThis statement must be given by 31 March each year, in an approved form, and include the information outlined in subsection (3) of this section.\n\nIf the provider has not complied with the Child Safety supplementary term in their grant agreement, they must provide a description of their non-compliance, including reasons.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report on matters provided for in subsection (3) (child safety compliance statement) to the System Governor each year.\n\t(2)\tThe child safety compliance statement for the registered provider must be given to the System Governor by 31 March each year.\n\t(3)\tThe child safety compliance statement must include the following information:\n\t(a)\ta declaration that the registered provider has delivered grant activities consistent with the Child Safety supplementary term in the registered provider’s grant agreement;\n\t(b)\tthe activity name;\n\t(c)\tthe activity ID;\n\t(d)\tthe statement type in relation to the incidental contract term in the grant agreement;\n\t(e)\tthe reporting start date;\n\t(f)\tthe reporting end date.\n\t(4)\tIf the registered provider has not complied with the Child Safety supplementary term in the registered provider’s grant agreement, the registered provider must provide a description of the non compliance and set out the reasons for the non compliance in the child safety compliance statement.\n\t(5)\tThe child safety compliance statement must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 494,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-720",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Subdivision H prescribes the requirements for providers delivering aged care services under MPSP.",
          "summaryHTML": "Subdivision H prescribes the requirements for providers delivering aged care services under MPSP.",
          "extract": "This Subdivision applies to a registered provider delivering funded aged care services under the MPSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 495,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-725(1)-(3)",
          "section": "Annual activity report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of subsection 166(1)(d) of the Act, this section prescribes that providers that each financial year, a provider that delivers services under MPSP must submit an annual activity report to the System Governor.\n\nThe registered provider must provide this annual report to the System Governor by 31 July each year, unless another time has been agreed to by the System Governor and the provider. \n\nThe report must be in a report form approved by the System Governor.",
          "summaryHTML": "For the purposes of subsection 166(1)(d) of the Act, this section prescribes that providers that each financial year, a provider that delivers services under MPSP must submit an annual activity report to the System Governor.\n\nThe registered provider must provide this annual report to the System Governor by 31 July each year, unless another time has been agreed to by the System Governor and the provider. \n\nThe report must be in a report form approved by the System Governor.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report on matters provided for in subsection (4) (the annual activity report) to the System Governor each financial year.\n\n(2) The annual activity report for a financial year for the provider must be given to the System Governor:\n\n(a) by 31 July each year; or\n\n(b) at such other time as agreed between the System Governor and the registered provider.\n\n(3) The annual activity report must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 496,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-725(4)",
          "section": "Annual activity report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The information that must be included in the annual activity report for the financial year is as follows: \n\n(a) the number of individuals who have accessed funded aged care services in, or from, the approved residential care home; \n\n(b) the number of individuals who commenced accessing funded aged care services without an access approval and were later approved through the alternative entry pathway under subsection 71(2) of the Act; \n\n(c) the number of individuals waiting to access such funded aged care services; \n\n(d) any fees or contributions charged to individuals who accessed funded aged care services delivered in, or from, an approved residential care home; \n\n(e) the service types delivered; \n\n(f) the activities undertaken by the residential care home to prevent and manage disease outbreaks.",
          "summaryHTML": "The information that must be included in the annual activity report for the financial year is as follows: \n\n(a) the number of individuals who have accessed funded aged care services in, or from, the approved residential care home; \n\n(b) the number of individuals who commenced accessing funded aged care services without an access approval and were later approved through the alternative entry pathway under subsection 71(2) of the Act; \n\n(c) the number of individuals waiting to access such funded aged care services; \n\n(d) any fees or contributions charged to individuals who accessed funded aged care services delivered in, or from, an approved residential care home; \n\n(e) the service types delivered; \n\n(f) the activities undertaken by the residential care home to prevent and manage disease outbreaks.",
          "extract": "(4)\tThe information that must be included in the annual activity report for the financial year is as follows:\n\t(a)\tthe number of individuals who have accessed funded aged care services in, or from, the approved residential care home;\n\t(b)\tthe number of individuals who commenced accessing funded aged care services without an access approval and were later approved through the alternative entry pathway under subsection 71(2) of the Act;\n\t(c)\tthe number of individuals waiting to access such funded aged care services;\n\t(d)\tany fees or contributions charged to individuals who accessed funded aged care services delivered in, or from, an approved residential care home;\n\t(e)\tthe service types delivered;\n\t(f)\tthe activities undertaken by the residential care home to prevent and manage disease outbreaks.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 497,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-725(5)",
          "section": "Annual activity report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must provide the information prescribed in subsection (4) in respect of each residential care home operated by the registered provider.",
          "summaryHTML": "A registered provider must provide the information prescribed in subsection (4) in respect of each residential care home operated by the registered provider.",
          "extract": "(5) A registered provider must provide the information prescribed in subsection (4) in respect of each residential care home operated by the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 498,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-730(1)-(3)",
          "section": "Annual statement of financial compliance and income and expenditure",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that providers that deliver funded aged care services under MPSP must provide an annual report of financial compliance and income and expenditure to the System Governor each financial year.\n\nThis report must be given to the System Governor by 31 October each year, unless another time has been agreed to between the System Governor and the provider and must be in a report form approved by the System Governor.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that providers that deliver funded aged care services under MPSP must provide an annual report of financial compliance and income and expenditure to the System Governor each financial year.\n\nThis report must be given to the System Governor by 31 October each year, unless another time has been agreed to between the System Governor and the provider and must be in a report form approved by the System Governor.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report on matters provided for in subsection (4) (the annual statement of financial compliance and income and expenditure) to the System Governor each financial year.\n\t(2)\tThe annual statement of financial compliance and income and expenditure must be given to the System Governor:\n\t(a)\tby 31 October each year; or\n\t(b)\tat such other time as agreed between the System Governor and the registered provider.\n\t(3)\tThe annual statement of financial compliance and income and expenditure must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 499,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-730(4)",
          "section": "Annual statement of financial compliance and income expenditure",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The information that must be included in the annual statement of financial compliance and income and expenditure for the financial year is as follows: \n\n(a) amount of subsidy received under Division 5 of Part 2 of Chapter 4 of the Act to deliver funded aged care services at each approved residential care home; \n\n(b) individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services at each approved residential care home; \n\n(c) the amount of expenditure on each of the following: \n\n(i) salaries or wages of aged care workers and responsible persons;  (ii) any labour costs in addition to salaries in wages such as superannuation benefits, leave loadings, payroll tax, workers compensation and other liability insurance, cost of subsidised services to employees and training costs; \n\n(iii) non-salary related other expenditure; \n\n(iv) capital expenditure; \n\n(v) disease outbreak management activities.",
          "summaryHTML": "The information that must be included in the annual statement of financial compliance and income and expenditure for the financial year is as follows: \n\n(a) amount of subsidy received under Division 5 of Part 2 of Chapter 4 of the Act to deliver funded aged care services at each approved residential care home; \n\n(b) individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services at each approved residential care home; \n\n(c) the amount of expenditure on each of the following: \n\n(i) salaries or wages of aged care workers and responsible persons;  (ii) any labour costs in addition to salaries in wages such as superannuation benefits, leave loadings, payroll tax, workers compensation and other liability insurance, cost of subsidised services to employees and training costs; \n\n(iii) non-salary related other expenditure; \n\n(iv) capital expenditure; \n\n(v) disease outbreak management activities.",
          "extract": "(4) The information that must be included in the annual statement of financial compliance and income and expenditure for the financial year is as follows: \n\n(a) amount of subsidy received under Division 5 of Part 2 of Chapter 4 of the Act to deliver funded aged care services at each approved residential care home; \n\n(b) individual fees or contributions paid to the provider under Part 3 of Chapter 4 of the Act by individuals accessing funded aged care services at each approved residential care home; \n\n(c) the amount of expenditure on each of the following: \n\n(i) salaries or wages of aged care workers and responsible persons;  (ii) any labour costs in addition to salaries in wages such as superannuation benefits, leave loadings, payroll tax, workers compensation and other liability insurance, cost of subsidised services to employees and training costs; \n\n(iii) non-salary related other expenditure; \n\n(iv) capital expenditure; \n\n(v) disease outbreak management activities.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 500,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-735(1)-(3)",
          "section": "Service demographics report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that providers that deliver funded aged care services under MPSP must provide a service demographics report to the System Governor each financial year.\n\nThis report must be given to the System Governor by 31 July each year, unless another time has been agreed to between the System Governor and the provider, and must be in a report form approved by the System Governor.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that providers that deliver funded aged care services under MPSP must provide a service demographics report to the System Governor each financial year.\n\nThis report must be given to the System Governor by 31 July each year, unless another time has been agreed to between the System Governor and the provider, and must be in a report form approved by the System Governor.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a registered provider to whom this Subdivision applies must give a report on matters provided for in subsections (4) and (5) (service demographics report) to the System Governor each financial year.\n\n(2) The service demographics report must be given to the System Governor:\n\n(a) by 31 July each year; or\n\n(b) at such other time as agreed between the System Governor and the registered provider.\n\n(3) The service demographics report must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 501,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-735(4)",
          "section": "Service demographics report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The service demographics report must include a list of individuals who accessed funded aged care services delivered by the registered provider for the financial year.",
          "summaryHTML": "The service demographics report must include a list of individuals who accessed funded aged care services delivered by the registered provider for the financial year.",
          "extract": "(4) The service demographics report must include a list of individuals who accessed funded aged care services delivered by the registered provider for the financial year.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 502,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-735(5)",
          "section": "Service demographics report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The report must detail, for each individual, the services received, service group classification, key demographic data, access approval status, service start and end dates, and reasons for ceasing services.\n\nFor further detail on the information to be included in this report, see section 166-735(5)(a) to (g) of the rules.",
          "summaryHTML": "The report must detail, for each individual, the services received, service group classification, key demographic data, access approval status, service start and end dates, and reasons for ceasing services.\n\nFor further detail on the information to be included in this report, see section 166-735(5)(a) to (g) of the rules.",
          "extract": "(5) A report prepared for the purposes of subsection (1) of this section must also include the following information: \n\n(a) for each individual who accessed funded aged care service delivered by the provider, the service types, including the services where specified in the individual’s access approval, delivered; \n\n(b) the classification type for the service group for each individual; \n\n(c) demographic information where requested in the report form approved by the System Governor, including: \n\n(i) the name of the individual; and \n\n(ii) the gender of the individual; and \n\n(iii) the date of birth of the individual; and \n\n(iv) whether the individual is an Aboriginal or Torres Strait Islander Person; and \n\n(v) whether the individual has been diagnosed with dementia or has suspected dementia symptoms; \n\n(d) whether the individual had an access approval when they commenced accessing services; \n\n(e) the date on which the individual commenced accessing funded aged care services; \n\n(f) the date on which the individual ceased accessing funded aged care services; \n\n(g) the reason for ceasing any funded aged care services.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 503,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div H, s166-735(6)",
          "section": "Service demographics report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must give the System Governor a service demographics report for each approved residential care home operated by the registered provider.",
          "summaryHTML": "A registered provider must give the System Governor a service demographics report for each approved residential care home operated by the registered provider.",
          "extract": "(6) A registered provider must give the System Governor a service demographics report for each approved residential care home operated by the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 504,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div J, s166-740",
          "section": "Application of Subdivision to certain registered providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "summaryHTML": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "extract": "This Subdivision applies to a registered provider delivering funded aged care services under the TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 505,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div J, s166-745(1)-(3)",
          "section": "Annual accountability report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a provider that delivers funded aged care services under TCP must give an annual accountability report to the System Governor each financial year. \n\nThis report must be given to the System Governor annually, or at a time agreed to by the System Governor and the provider. \n\nThis report must be in a form approved by the System Governor.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a provider that delivers funded aged care services under TCP must give an annual accountability report to the System Governor each financial year. \n\nThis report must be given to the System Governor annually, or at a time agreed to by the System Governor and the provider. \n\nThis report must be in a form approved by the System Governor.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, this section prescribes that a provider to whom this Subdivision applies must give a report on matters provided for in subsection (4) (annual accountability report) to the System Governor each financial year.\n\n(2) The annual accountability report for a financial year for the provider must be given to the System Governor:\n\n(a) annually; or\n\n(b) at such other time as agreed between the System Governor and the registered provider.\n\n(3) The annual accountability must be in a report form approved by the System Governor.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 506,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div J, s166-745(4)-(5)",
          "section": "Annual accountability report",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The annual accountability report for the financial year must include detailed financial information, such as all sources of income (like subsidies, fees, and donations), total income and expenditures (including salaries and operational costs), care activities, surplus analysis, feedback received, and confirmation that the report's information is accurate. \n\nFor further detail on the additional information required as prescribed for the annual accountability report see section 166-745(4)(a) to (q) of the rules.\n\nThe reporting period is the period specified for a service activity report under section 166(645).",
          "summaryHTML": "The annual accountability report for the financial year must include detailed financial information, such as all sources of income (like subsidies, fees, and donations), total income and expenditures (including salaries and operational costs), care activities, surplus analysis, feedback received, and confirmation that the report's information is accurate. \n\nFor further detail on the additional information required as prescribed for the annual accountability report see section 166-745(4)(a) to (q) of the rules.\n\nThe reporting period is the period specified for a service activity report under section 166(645).",
          "extract": "(4)\tThe annual accountability report for the financial year must include the following information for the provider:\n \t(a)\tany subsidy received under section 249 of the Act;\n\t(b)\tany income derived from any individual fees and contributions under Part 3 or Chapter 4 of the Act;\n\t(c)\tState or Territory direct funding;\n\t(d)\tState or Territory in kind contributions;\n\t(e)\tother income including;\n\t(i)\tdonations; and\n\t(ii)\tinterest; and\n\t(iii)\texpenditure recoveries and reimbursements; and\n\t(iv)\tclient fees; and\n\t(v)\tany other income not specified in subparagraph (i) and (ii) of this paragraph or paragraph (a) to (d) of this subsection;\n\t(f)\ttotal income;\n\t(g)\tsalary expenditure;\n\t(h)\tnon salary expenditure including:\n\t(i)\toffice costs; and\n\t(ii)\toperating costs; and\n\t(iii)\tservice agreements; and\n\t(iv)\tconsumables and equipment for client use; and\n\t(v)\ttravel; and\n\t(vi)\tcapital costs;\n\t(i)\tother expenditure including:\n\t(i)\tasset related expenses including depreciation; and\n\t(ii)\tany other expenditure not specified in subparagraph (i) of this paragraph or paragraph (g) and (h) of this subsection;\n\n(5) The reporting period for the provider is the period specified for a service activity report under section 166-645.\n\t(j)\ttotal expenditure;\n\t(k)\tTCP activity for the financial year including;\n\t(i)\ttotal clients; and\n\t(ii)\ttotal care days; and\n\t(iii)\ttotal residential care days; and\n\t(iv)\ttotal home based care days;\n\t(l)\tsurplus analysis and itemisation of surplus by income source including;\n\t(i)\tCommonwealth government; and\n\t(ii)\tState government; and\n\t(iii)\tTerritory government; and\n\t(iv)\tclient contributions; and\n\t(v)\tany income specified in paragraph (e) of this subsection;\n\t(m)\tthe Commonwealth surplus expressed as a number of care days;\n\t(n)\tany explanatory notes or commentary on the following;\n\t(i)\tincome;\n\t(ii)\texpenditure;\n\t(iii)\tactivity for the financial year;\n\t(iv)\tsurplus analysis;\n\t(v)\tadditional activity;\n\t(o)\tfeedback, complaints and improvements including;\n\t(i)\tthe most common kinds of positive feedback; and\n\t(ii)\tthe most common kinds of complaints; and\n\t(iii)\timprovements made by the provider;\n\t(p)\tinformation in respect of whether the Fair Work Commission wage increase component of the Commonwealth subsidy has been passed on to any eligible workers;\n\t(q)\tcertification that the information provided in the report is true and correct.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 488,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-800(1)-(2)",
          "section": "Application of this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This subdivision prescribes requirements for governing bodies. \n\nThis subdivision applies to all providers registered in Category 5 - nursing and transition care and Category 6 - residential care. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) MPSP;\n\n(b) NATSIFACP.",
          "summaryHTML": "This subdivision prescribes requirements for governing bodies. \n\nThis subdivision applies to all providers registered in Category 5 - nursing and transition care and Category 6 - residential care. \n\nThe requirements of this section do not apply in respect of the delivery of funded aged care services under any of the following specialist aged care programs:\n\n(a) MPSP;\n\n(b) NATSIFACP.",
          "extract": "(1) Subject to subsection (2), this Subdivision applies to registered providers registered in one or more of the following provider registration categories: \n\n(a) nursing and transition care; \n\n(b) residential care. \n\n(2) This Subdivision does not apply to the delivery of funded aged care services provided under any of the following specialist aged care programs: \n\n(a) MPSP; \n\n(b) NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 489,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-805(1)-(3)",
          "section": "Governing bodies must prepare and provide statements",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, governing bodies must prepare and provide statements to the System Governor within 4 months after the end of the reporting period. \n\nThe reporting period is 12 months from 1 July each year, or another 12-month period starting on a date determined by the System Governor under the rules.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, governing bodies must prepare and provide statements to the System Governor within 4 months after the end of the reporting period. \n\nThe reporting period is 12 months from 1 July each year, or another 12-month period starting on a date determined by the System Governor under the rules.",
          "extract": "(1) Subject to subsection (2), for the purposes of paragraph 166(1)(d) of the Act, it is prescribed that a registered provider to whom this Subdivision applies must give a report of a kind referred to in this section to the System Governor within 4 months after the end of the reporting period. \n\n(2) This section does not apply to registered providers that deliver funded aged care services under the MPSP. \n\n(3) The reporting period for a registered provider to whom this Subdivision applies is: \n\n(a) the period of 12 months starting on 1 July of a year; or \n\n(b) another 12 month period that starts on the first day of a month of a year that is determined for the registered provider by the System Governor in accordance with the rules.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 490,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-805(4)-(5)",
          "section": "Governing bodies must prepare and provide statements",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The report must be in an approved form, signed by a governing body member on behalf of all members, include specific information such as the governing body's assessment of compliance with the Act, details of any non-compliance, reasons for it, and actions taken or planned to address the issues, and any additional required statements or information required by the approved form.\n\nThe report must include the governing body's assessment of compliance with the Act, details of any non-compliance, reasons for it, and actions taken or planned to address the issues.\n\nFor further detail on the additional information required as prescribed for this report, refer to section 166-705(5) of the rules.",
          "summaryHTML": "The report must be in an approved form, signed by a governing body member on behalf of all members, include specific information such as the governing body's assessment of compliance with the Act, details of any non-compliance, reasons for it, and actions taken or planned to address the issues, and any additional required statements or information required by the approved form.\n\nThe report must include the governing body's assessment of compliance with the Act, details of any non-compliance, reasons for it, and actions taken or planned to address the issues.\n\nFor further detail on the additional information required as prescribed for this report, refer to section 166-705(5) of the rules.",
          "extract": "(4) The report must: \n\n(a) be in the approved form; and \n\n(b) be signed by a member of the provider’s governing body on behalf of all members of the governing body; and \n\n(c) include the information prescribed by subsection (5) of this section; and \n\n(d) include any other statements or information required by the approved form. \n\n(5) The following information is prescribed: \n\n(a) whether the governing body of the provider believes that the provider has complied with the conditions, obligations and requirements of the provider under the Act; \n\n(b) if the governing body of the provider believes that the provider has failed to comply with one or more conditions, obligations or requirements of the provider under the Act—the details of: \n\n(i) each condition, obligation or requirement that the governing body believes that the provider has failed to comply with; and \n\n(ii) the reasons why the provider has failed to comply with the condition, obligation or requirement; and \n\n(iii) the actions that the provider has taken, has started to take or will take to rectify the non-compliance. \n\nExample: For subparagraph (b)(iii), under Chapter 6 of the Act a registered provider may: \n\n(a) give an enforceable undertaking about remedying non-compliance (see Part 8 of Chapter 6 of the Act); or \n\n(b) agree to certain matters if revocation of registration is being considered (see section 133 of the Act).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 491,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-810(1)",
          "section": "Requirements for certain registered providers to give information relating to reporting periods",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, a registered provider (to which this subdivision applies) must give the following additional information from the applicable reporting period regarding feedback and complaints, quality improvements, diversity and inclusion initiatives, governing body demographics, and compliance during the reporting period to the System Governor. \n\nFor further detail on the additional information required as prescribed in this section, refer to section 166-810(1)(a) to (h) of the rules.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, a registered provider (to which this subdivision applies) must give the following additional information from the applicable reporting period regarding feedback and complaints, quality improvements, diversity and inclusion initiatives, governing body demographics, and compliance during the reporting period to the System Governor. \n\nFor further detail on the additional information required as prescribed in this section, refer to section 166-810(1)(a) to (h) of the rules.",
          "extract": "(1)\tFor the purposes of paragraph 166(1)(d) of the Act, it is prescribed that a registered provider to whom this Subdivision applies must give the following additional information:\n\t(a)\tinformation about the kind of feedback and complaints received by the registered provider in the reporting period;\n\t(b)\tinformation about improvements made by the registered provider in the reporting period in relation to quality of care;\n\t(c)\tinformation about initiatives that the registered provider has implemented in the reporting period to support a diverse and inclusive environment for individuals accessing funded aged care services and aged care workers;\n\t(d)\tinformation about the representation of different demographic groups in the membership of the governing body of the provider (but, for any group, only if a member of the governing body who is a member of that group consents to that information being provided);\n\t(e)\tinformation on whether the registered provider was, in the reporting period, a government entity or a local government authority;\n\t(f)\tfor registered providers that are not government entities or local government authorities, whether the registered provider is a registered provider of a kind prescribed by the rules for the purposes of subsection 157(2) of the Act;\n\t(g)\tfor registered providers that are subject to the requirements of subsection 157(2) of the Act, whether the registered provider has complied during the reporting period with the requirements of subsection 157(2);\n\t(h)\twhether subsection 157(3) or (4) of the Act applied to the registered provider during the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": true,
            "mps": false,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 492,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-810(2)",
          "section": "Requirements for certain registered providers to give information relating to reporting periods",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider registered in the registration category 5 - nursing and transition care must provide the information prescribed in subsections (1)(a) to (c) in respect of each service delivery branch operated by the registered provider.",
          "summaryHTML": "A registered provider registered in the registration category 5 - nursing and transition care must provide the information prescribed in subsections (1)(a) to (c) in respect of each service delivery branch operated by the registered provider.",
          "extract": "(2) A registered provider registered in the registration category nursing and transition care must provide the information prescribed in subsections (1)(a) to (c) in respect of each service delivery branch operated by the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 493,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div K, s166-810(3)",
          "section": "Requirements for certain registered providers to give information relating to reporting periods",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider registered in the registration category 6 - residential care must provide the information prescribed in subsections (1)(a) to (c) in respect of each residential care home operated by the registered provider.",
          "summaryHTML": "A registered provider registered in the registration category 6 - residential care must provide the information prescribed in subsections (1)(a) to (c) in respect of each residential care home operated by the registered provider.",
          "extract": "(3) A registered provider registered in the registration category residential care must provide the information prescribed in subsections (1)(a) to (c) in respect of each residential care home operated by the registered provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 507,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div L, s166-850(1)-(2)",
          "section": "Application of this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Subdivision L prescribes the requirements for providers registered in category 6 - residential care, except if they only deliver aged care services under a specialist aged care program.",
          "summaryHTML": "Subdivision L prescribes the requirements for providers registered in category 6 - residential care, except if they only deliver aged care services under a specialist aged care program.",
          "extract": "(1)\tSubject to subsection (2), this Subdivision applies to a registered provider registered in the provider registration category residential care.\n\t(2)\tThe requirements of this Subdivision do not apply to a registered provider only delivering funded aged care services under a specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 508,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div L, s166-855(1)-(2)",
          "section": "Reporting requirements relating to registered nurses",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of subsection 166(1)(d) of the Act, a registered provider must give the System Governor a report about the obligation in subsection 175(1) of the Act in relation to each approved residential care home of the provider within 7 days after the end of each calendar month, or within a longer period specified by the System Governor by notice in writing given to the provider.\n\nA provider is not required to give the above report for an approved residential care home if during that calendar month, the provider did not deliver funded aged care services to any individuals. \n\nNote: section 175(1) of the Act prescribes the requirement that at least one registered nurse is on site and on duty at all times at an approved residential care home.",
          "summaryHTML": "For the purposes of subsection 166(1)(d) of the Act, a registered provider must give the System Governor a report about the obligation in subsection 175(1) of the Act in relation to each approved residential care home of the provider within 7 days after the end of each calendar month, or within a longer period specified by the System Governor by notice in writing given to the provider.\n\nA provider is not required to give the above report for an approved residential care home if during that calendar month, the provider did not deliver funded aged care services to any individuals. \n\nNote: section 175(1) of the Act prescribes the requirement that at least one registered nurse is on site and on duty at all times at an approved residential care home.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, a registered provider must give the System Governor a report about the obligation in subsection 175(1) of the Act in relation to each approved residential care home of the provider within 7 days after the end of each calendar month, or within a longer period specified by the System Governor by notice in writing given to the provider.\n\n(2) A registered provider is not required to provide a report under subsection (1) of this section in relation to an approved residential care home for a calendar month if, during that calendar month, the registered provider did not deliver funded aged care services to at least one individual in the home.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 509,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div L, s166-855(3)",
          "section": "Reporting requirements relating to registered nurses",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "To avoid doubt, it is a requirement that a registered provider provide a report under subsection (1) of this section in relation to an approved residential care home regardless of whether the registered provider has been granted an exemption under paragraph 175(2)(a) of the Act from the obligation in subsection 175(1) of the Act in relation to that home.",
          "summaryHTML": "To avoid doubt, it is a requirement that a registered provider provide a report under subsection (1) of this section in relation to an approved residential care home regardless of whether the registered provider has been granted an exemption under paragraph 175(2)(a) of the Act from the obligation in subsection 175(1) of the Act in relation to that home.",
          "extract": "(3) To avoid doubt, it is a requirement that a registered provider provide a report under subsection (1) of this section in relation to an approved residential care home regardless of whether the registered provider has been granted an exemption under paragraph 175(2)(a) of the Act from the obligation in subsection 175(1) of the Act in relation to that home.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 510,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div L, s166-855(4)",
          "section": "Reporting requirements relating to registered nurses",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The monthly report must be in a form approved by the System Governor and specify in relation to each approved residential care home, whether a registered nurse was on duty at all times. If not, it must outline each period of 30 minutes or more that a registered nurse was not on site or on duty, reasons, and any alternative clinical arrangements made.\n\nFor further detail on the additional information required as prescribed for the monthly report, refer section 166-855(4) of the rules.",
          "summaryHTML": "The monthly report must be in a form approved by the System Governor and specify in relation to each approved residential care home, whether a registered nurse was on duty at all times. If not, it must outline each period of 30 minutes or more that a registered nurse was not on site or on duty, reasons, and any alternative clinical arrangements made.\n\nFor further detail on the additional information required as prescribed for the monthly report, refer section 166-855(4) of the rules.",
          "extract": "(4)\tThe report must:\n\t(a)\tbe in a form approved, in writing, by the System Governor; and\n\t(b)\tspecify in relation to each approved residential care home, whether a registered nurse was on site and on duty at all times for each day during the calendar month on which at least one individual received funded aged care services in the home; and\n\t(c)\tif a registered nurse was not on site and on duty at all times on any such day—specify the following information:\n\t(i)\teach period of 30 minutes or more that a registered nurse was not on site and on duty at the home;\n\t(ii)\tfor each such period, the reasons why a registered nurse was not on site or on duty (or both) during that period;\n\t(iii)\tfor each such period, the alternative arrangements that were made for the period to ensure the clinical needs of the individuals in the home were met, or a statement that no alternative arrangements were made.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 518,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-900",
          "section": "Status of service delivery branches",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1) of the Act, subdivision M prescribes the requirements in relation to the status of service delivery branches. This Subdivision applies to a provider registered in one or more of the following provider registration categories: \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "summaryHTML": "For the purposes of paragraph 166(1) of the Act, subdivision M prescribes the requirements in relation to the status of service delivery branches. This Subdivision applies to a provider registered in one or more of the following provider registration categories: \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.",
          "extract": "This Subdivision applies to a registered provider registered in one or more of the following categories:\n\t(a)\thome and community services;\n\t(b)\tassistive technology and home modifications;\n\t(c)\tadvisory and support services;\n\t(d)\tpersonal and care support in the home or community;\n\t(e)\tnursing and transition care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 519,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-905",
          "section": "Reporting requirements relating to service delivery branches",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of subsection 166(1)(d) of the Act, this Subdivision prescribes the reports a registered provider must give to the System Governor in relation to a service delivery branch of the provider and the requirements relating to those reports.",
          "summaryHTML": "For the purposes of subsection 166(1)(d) of the Act, this Subdivision prescribes the reports a registered provider must give to the System Governor in relation to a service delivery branch of the provider and the requirements relating to those reports.",
          "extract": "For the purposes of paragraph 166(1)(d) of the Act, this Subdivision prescribes: \n\n(a) the reports a registered provider must give to the System Governor in relation to a service delivery branch of the provider; and \n\n(b) the requirements relating to those reports.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 520,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-910(1)",
          "section": "Report for opening of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if the provider intends to begin delivering funded aged care services through a service delivery branch. The provider cannot have previously delivered any funded aged care services through this service delivery branch, or the provider needs to have previously given a report to the System Governor in relation to closure of the service delivery branch. \n\nFor further detail on the additional information required as prescribed in this section refer to section 166-910(1) in the rules.",
          "summaryHTML": "A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if the provider intends to begin delivering funded aged care services through a service delivery branch. The provider cannot have previously delivered any funded aged care services through this service delivery branch, or the provider needs to have previously given a report to the System Governor in relation to closure of the service delivery branch. \n\nFor further detail on the additional information required as prescribed in this section refer to section 166-910(1) in the rules.",
          "extract": "(1) A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if: \n\n(a) the provider intends to begin delivering funded aged care services through a service delivery branch; and  \n\n(b) either: \n\n(i) the provider has not previously delivered any funded aged care services through this service delivery branch; or \n\n(ii) the provider has previously given a report to the System Governor in accordance with section 166-925 in relation to closure of the service delivery branch. \n\nNote: A separate notification must be given to the System Governor to establish a service delivery branch account for the service delivery branch: see subsection 203(1) of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 521,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-910(2)",
          "section": "Report for opening of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The report must include the name of the service delivery branch, the date the provider proposes to begin delivering funded aged care services through the service delivery branch, and the address and contact details for the service delivery branch.",
          "summaryHTML": "The report must include the name of the service delivery branch, the date the provider proposes to begin delivering funded aged care services through the service delivery branch, and the address and contact details for the service delivery branch.",
          "extract": "Information to be included in the report \n\n(2) The report must include the following information: \n\n(a) the name of the service delivery branch; \n\n(b) the date the provider proposes to begin delivering funded aged care services through the service delivery branch; \n\n(c) the address of the service delivery branch; \n\n(d) the contact details for the service delivery branch.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 522,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-910(3)",
          "section": "Report for opening of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The report must be given no later than the day the provider begins delivering funded aged care services through the service delivery branch.",
          "summaryHTML": "The report must be given no later than the day the provider begins delivering funded aged care services through the service delivery branch.",
          "extract": "(3) The report must be given no later than the day the provider begins delivering funded aged care services through the service delivery branch.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 523,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-915(1)",
          "section": "Report for change to a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must submit a report in an approved form to the System Governor if there has been a change to any information relating to the service delivery branch that was included in the previous report given to the System Governor in accordance with section 166-910.",
          "summaryHTML": "A registered provider must submit a report in an approved form to the System Governor if there has been a change to any information relating to the service delivery branch that was included in the previous report given to the System Governor in accordance with section 166-910.",
          "extract": "(1) A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if: \n\n(a) the provider has given a report to the System Governor in accordance with section 166-910 for a service delivery branch of the provider; and \n\n(b) there has been a change to any information relating to the service delivery branch that was included in the report given to the System Governor in accordance with section 166-910.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 524,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-915(2)-(3)",
          "section": "Report for change to a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The report must include the name of the service delivery branch and any updated information about the branch that was in the previous report submitted under section 166-910.\n\nThe report must be submitted within 28 days after the change mentioned in paragraph (1)(b) has taken place.",
          "summaryHTML": "The report must include the name of the service delivery branch and any updated information about the branch that was in the previous report submitted under section 166-910.\n\nThe report must be submitted within 28 days after the change mentioned in paragraph (1)(b) has taken place.",
          "extract": "Information to be included in the report \n\n(2) The report must include the following: \n\n(a) the name of the service delivery branch; \n\n(b) any updated information relating to the service delivery branch that was included in the report given under section 166-910. \n\nWhen report must be given\n \n(3) The report must be given within 28 days after the day the change in paragraph (1)(b) has occurred.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 525,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-920(1)",
          "section": "Report for merger of service delivery branches",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider must submit a report in an approved form to the System Governor if they have previously given a report to the System Governor in accordance with section 166-910 for 2 or more service delivery branches of the provider and the provider intends to merge 2 or more of these service delivery branches into a single service delivery branch of the provider.",
          "summaryHTML": "A registered provider must submit a report in an approved form to the System Governor if they have previously given a report to the System Governor in accordance with section 166-910 for 2 or more service delivery branches of the provider and the provider intends to merge 2 or more of these service delivery branches into a single service delivery branch of the provider.",
          "extract": "(1) A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if: \n\n(a) the provider has given a report to the System Governor in accordance with section 166-910 for 2 or more service delivery branches of the provider; and \n\n(b) the provider intends to merge 2 or more of these service delivery branches into a single service delivery branch of the provider.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 526,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-920(2)",
          "section": "Report for merging of service delivery branches",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Information to be included in the report\n\nThe report must include the names of the service delivery branches being merged, specifying which branch will continue to provide funded aged care services and which will be closed, the proposed merger date, and details about whether individuals receiving services have been notified of the merger and if the System Governor and Commissioner have been informed about the closures for those individuals.\n\nFor further detail on the additional information required as prescribed in this section refer to section 166-920(2) of the rules.",
          "summaryHTML": "<i>Information to be included in the report</i>\n\nThe report must include the names of the service delivery branches being merged, specifying which branch will continue to provide funded aged care services and which will be closed, the proposed merger date, and details about whether individuals receiving services have been notified of the merger and if the System Governor and Commissioner have been informed about the closures for those individuals.\n\nFor further detail on the additional information required as prescribed in this section refer to section 166-920(2) of the rules.",
          "extract": "Information to be included in the report \n\n(2) The report must include the following information: \n\n(a) the names of the service delivery branches that the provider proposes to merge, specifying; \n\n(i) the name of the service delivery branch through which the provider proposes to continue delivering funded aged care services; and \n\n(ii) the name of each service delivery branch the provider intends to close; \n\n(b) the date the provider proposes to merge the service delivery branches;  \n\n(c) in relation to the individuals (if any) accessing funded aged care services through the service delivery branches that the provider proposes to merge: \n\n(i) whether the provider has notified the individuals of the proposed merge; and \n\n(ii) whether the provider has given a cessation notification to the System Governor and the Commissioner for each individual accessing funded aged care services through each service delivery branch mentioned in subparagraph (a)(ii).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 511,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-920(3)",
          "section": "Report for merging of service delivery branches",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "When report must be given\n\nThe report must be given at least 90 days, or such smaller number of days as is agreed in writing between the System Governor and the registered provider, before the date of the proposed merger.",
          "summaryHTML": "<i>When report must be given</i>\n\nThe report must be given at least 90 days, or such smaller number of days as is agreed in writing between the System Governor and the registered provider, before the date of the proposed merger.",
          "extract": "When report must be given\n\t(3)\tThe report must be given at least 90 days, or such smaller number of days as is agreed in writing between the System Governor and the registered provider, before the date of the proposed merger.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 512,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-925(1)-(2)",
          "section": "Report for closure of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Registered providers must submit a report to the System Governor in an approved form if they he provider has given a report to the System Governor in accordance with section 166-910 for a service delivery branch of the provider and  the provider intends to close the service delivery branch.\n\nA registered provider does not have to give a report in accordance with this section if the provider intends to merge the service delivery branch with one or more other service delivery branches of the provider and a report under section 166-920 has been given in relation to the service delivery branch.",
          "summaryHTML": "Registered providers must submit a report to the System Governor in an approved form if they he provider has given a report to the System Governor in accordance with section 166-910 for a service delivery branch of the provider and  the provider intends to close the service delivery branch.\n\nA registered provider does not have to give a report in accordance with this section if the provider intends to merge the service delivery branch with one or more other service delivery branches of the provider and a report under section 166-920 has been given in relation to the service delivery branch.",
          "extract": "(1) A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if:\n\n(a) the provider has given a report to the System Governor in accordance with section 166-910 for a service delivery branch of the provider; and\n\n(b) the provider intends to close the service delivery branch.\n\n(2) Despite subsection (1), a registered provider does not have to give a report in accordance with this section in relation to a service delivery branch if:\n\n(a) the provider intends to merge the service delivery branch with one or more other service delivery branches of the provider; and\n\n(b) a report under section 166-920 has been given in relation to the service delivery branch.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 513,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-925(3)",
          "section": "Report for closure of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Information to be included in the report\n\nThe report regarding the closure of a service delivery branch must include the branch's name, the proposed closure date, and information about notifications provided to individuals accessing services through that branch, including whether cessation notifications have been issued.\n\nFor further details on what information is to be included in the report, please see subsection (3) of this rule.",
          "summaryHTML": "<i>Information to be included in the report</i>\n\nThe report regarding the closure of a service delivery branch must include the branch's name, the proposed closure date, and information about notifications provided to individuals accessing services through that branch, including whether cessation notifications have been issued.\n\nFor further details on what information is to be included in the report, please see subsection (3) of this rule.",
          "extract": "Information to be included in the report\n\t(3)\tThe report must include the following information:\n\t(a)\tthe name of the service delivery branch;\n\t(b)\tthe date the provider proposes to close the service delivery branch;\n\t(c)\tin relation to the individuals (if any) accessing funded aged care services through the service delivery branch:\n\t(i)\twhether the provider has notified the individuals of the proposed closure; and\n\t(ii)\twhether the provider has given a cessation notification to the System Governor and the Commissioner for each individual.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 514,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-925(4)",
          "section": "Report for closure of a service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "When report must be given\n\nThe report must be given at least 28 days before the date of the proposed closure.",
          "summaryHTML": "<i>When report must be given</i>\n\nThe report must be given at least 28 days before the date of the proposed closure.",
          "extract": "When report must be given\n\n(4) The report must be given at least 28 days before the date of the proposed closure.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 515,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-930(1)",
          "section": "Report if provider no longer intends to open, merge or close service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Registered providers are required to submit a report to the System Governor in an approved form if they have given a report (the original report) to the System Governor in accordance with sections 166-910, 166-920, or 166-925 and decide not to proceed with the opening, merging, or closure previously outlined in an original report submitted.",
          "summaryHTML": "Registered providers are required to submit a report to the System Governor in an approved form if they have given a report (the original report) to the System Governor in accordance with sections 166-910, 166-920, or 166-925 and decide not to proceed with the opening, merging, or closure previously outlined in an original report submitted.",
          "extract": "(1) A registered provider must give a report, in an approved form, to the System Governor in accordance with this section if:\n\n(a) the provider has given a report (the original report) to the System Governor in accordance with sections 166-910, 166-920, or 166-925; and\n\n(b) the provider no longer intends to proceed with the opening, merging, or closure described in the original report.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 516,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-930(2)",
          "section": "Report if provider no longer intends to open, merge or close service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Information to be included in the report\n\nThe report must detail the original report's content, including the service delivery branches involved, the nature of the action (opening, merging, or closure), the proposed date, a statement of non-intent to proceed, and the reasons for this decision.\n\nFor further detail on the additional information required as prescribed in this section refer to section 166-930(2) of the rules.",
          "summaryHTML": "<i>Information to be included in the report\n</i>\nThe report must detail the original report's content, including the service delivery branches involved, the nature of the action (opening, merging, or closure), the proposed date, a statement of non-intent to proceed, and the reasons for this decision.\n\nFor further detail on the additional information required as prescribed in this section refer to section 166-930(2) of the rules.",
          "extract": "Information to be included in the report\n\n(2) The report must include the following:\n\n(a) a description of the original report, including:\n\n(i) the name of each service delivery branch included in the original report;\n\n(ii) whether the original report was in relation to an opening, merging, or closure;\n\n(iii) the proposed date of the opening, merging, or closure that was included in the original report;\n\n(b) a statement that the provider no longer intends to proceed with the opening, merging, or closure described in the original report;\n\n(c) the reason why the provider no longer intends to proceed with the opening, merging, or closure described in the original report.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 517,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div M, s166-930(3)",
          "section": "Report if provider no longer intends to open, merge or close service delivery branch",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "When report must be given\n\nThe report must be given no later than the proposed date of the opening, merging, or closure that was included in the original report and for a merger—28 days before the proposed date of the merger.",
          "summaryHTML": "<i>When report must be given\n\n</i>The report must be given no later than the proposed date of the opening, merging, or closure that was included in the original report and for a merger—28 days before the proposed date of the merger.",
          "extract": "When report must be given\n\t(3)\tThe report must be given no later than: \n\t(a)\tfor an opening or closure—the proposed date of the opening or closure; and\n\t(b)\tfor a merger—28 days before the proposed date of the merger.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 527,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div N, s166-1000(1)-(2)",
          "section": "Application of this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Subdivision N prescribes requirements for providers regarding pricing information.  This Subdivision applies to a  provider registered in one or more of the following provider registration categories: \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThe requirements of this Subdivision do not apply to funded aged care services delivered under any specialist aged care program.",
          "summaryHTML": "Subdivision N prescribes requirements for providers regarding pricing information.  This Subdivision applies to a  provider registered in one or more of the following provider registration categories: \n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community and/or\nCategory 5 - nursing and transition care.\n\nThe requirements of this Subdivision do not apply to funded aged care services delivered under any specialist aged care program.",
          "extract": "(1)\tSubject to subsection (2), this Subdivision applies to a registered provider registered in one or more of the following provider registration categories:\n\t(a)\thome and community services;\n\t(b)\tassistive technology and home modifications;\n\t(c)\tadvisory and support services;\n\t(d)\tpersonal and care support in the home or community;\n\t(e)\tnursing and transition care.\n\t(2)\tThe requirements of this Subdivision do not apply in respect of the delivery of funded aged care services delivered under any specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 528,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div N, s166-1005(1)",
          "section": "Pricing information",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "For the purposes of paragraph 166(1)(d) of the Act, a registered provider must give a report about the information specified in subsection (3) to the System Governor for each reporting period within 30 days of the end of the relevant reporting period and do so in the approved form.",
          "summaryHTML": "For the purposes of paragraph 166(1)(d) of the Act, a registered provider must give a report about the information specified in subsection (3) to the System Governor for each reporting period within 30 days of the end of the relevant reporting period and do so in the approved form.",
          "extract": "(1) For the purposes of paragraph 166(1)(d) of the Act, a registered provider must: \n\n(a) give a report about the information specified in subsection (3) to the System Governor for each reporting period; and \n\n(b) do so within 30 days of the end of the relevant reporting period; and  \n\n(c) do so in the approved form.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 529,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div N, s166-1005(3)",
          "section": "Pricing information",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The information that must be included in a report given in accordance with subsection (1) is the most frequently charged price during standard business hours for the relevant reporting period that the provider charges individuals for each service in the following service types: \n\n(a) allied health and therapy; \n\n(b) care management; \n\n(c) domestic assistance; \n\n(d) home maintenance and repairs; \n\n(e) home or community general respite; \n\n(f) meals; \n\n(g) nursing care; \n\n(h) personal care; \n\n(i) restorative care management; \n\n(j) social support and community engagement; \n\n(k) therapeutic service for independent living; \n\n(l) transport.",
          "summaryHTML": "The information that must be included in a report given in accordance with subsection (1) is the most frequently charged price during standard business hours for the relevant reporting period that the provider charges individuals for each service in the following service types: \n\n(a) allied health and therapy; \n\n(b) care management; \n\n(c) domestic assistance; \n\n(d) home maintenance and repairs; \n\n(e) home or community general respite; \n\n(f) meals; \n\n(g) nursing care; \n\n(h) personal care; \n\n(i) restorative care management; \n\n(j) social support and community engagement; \n\n(k) therapeutic service for independent living; \n\n(l) transport.",
          "extract": "(3) The information that must be included in a report given in accordance with subsection (1) is the most frequently charged price during standard business hours for the relevant reporting period that the provider charges individuals for each service in the following service types: \n\n(a) allied health and therapy; \n\n(b) care management; \n\n(c) domestic assistance; \n\n(d) home maintenance and repairs; \n\n(e) home or community general respite; \n\n(f) meals; \n\n(g) nursing care; \n\n(h) personal care; \n\n(i) restorative care management; \n\n(j) social support and community engagement; \n\n(k) therapeutic service for independent living; \n\n(l) transport.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        },
        {
          "id": 530,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div N, s166-1005(4)",
          "section": "Pricing information",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider is not required to report on a price for a service in accordance with subsection (1) if they are not currently delivering the service and have not delivered the service in the last 12 months or if the service is delivered under a specialist aged care program.",
          "summaryHTML": "A registered provider is not required to report on a price for a service in accordance with subsection (1) if they are not currently delivering the service and have not delivered the service in the last 12 months or if the service is delivered under a specialist aged care program.",
          "extract": "(4) A registered provider is not required to report on a price for a service in accordance with subsection (1) if:  \n\n(a) the registered provider is not currently delivering the service and has not delivered the service in the last 12 months; or \n\n(b) the service is delivered under a specialist aged care program.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": true,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(1)"
        }
      ]
    },
    {
      "id": 70,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s166(2)",
      "section": "Other reports by registered providers",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reporting",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "A report under subsection (1) must include any prescribed information, use the approved form where required, and comply with all other requirements set out in the rules.",
      "summaryHTML": "A report under subsection (1) must include any prescribed information, use the approved form where required, and comply with all other requirements set out in the rules.",
      "extract": "Requirement to report\n\n(2) A report under subsection (1) must:\n\n(a) if the rules prescribe information that must be included in the report:\n\n(i) include that information; and\n\n(ii) be in the approved report form (if any); and\n\n(b) if paragraph (a) does not apply—be in the approved report form; and\n\n(c) in any case—be prepared, and given, in accordance with any other requirements prescribed by the rules.\n\nNote: For approved report form, see section 166A.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631507",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 71,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s166(3)",
      "section": "Other reports by registered providers",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reporting",
      "topic": [
        "reporting",
        "complaints"
      ],
      "summary": "The rules may require reports to cover a wide range of information, including complaints and feedback, workforce and governance details, and compliance with nursing service requirements. They may also prescribe reporting on service delivery locations, recipient groups, how services are provided, and specified financial and prudential matters.",
      "summaryHTML": "The rules may require reports to cover a wide range of information, including complaints and feedback, workforce and governance details, and compliance with nursing service requirements. They may also prescribe reporting on service delivery locations, recipient groups, how services are provided, and specified financial and prudential matters.",
      "extract": "Prescribed information\n\n(3) Without limiting paragraph (2)(a), the rules may prescribe information relating to any of the following:\n\n(a) complaints and feedback received by a registered provider;\n\n(b) the workforce, and governance, of a registered provider;\n\n(c) compliance by a registered provider with requirements relating to nursing services;\n\n(d) locations at which funded aged care services are delivered by a registered provider;\n\n(e) specified groups of individuals to whom a registered provider is delivering funded aged care services;\n\n(f) how specified funded aged care services are delivered;\n\n(g) specified financial and prudential matters.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631507",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 72,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s166(4)",
      "section": "Other reports by registered providers",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reporting",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "The rules may set requirements for how prescribed information is collected or generated, including specific measurements or assessments. They may also prescribe reporting periods, timeframes for submitting reports, and exemptions determined by the System Governor.",
      "summaryHTML": "The rules may set requirements for how prescribed information is collected or generated, including specific measurements or assessments. They may also prescribe reporting periods, timeframes for submitting reports, and exemptions determined by the System Governor.",
      "extract": "Prescribed requirements relating to preparing and giving reports\n\n(4) Without limiting paragraph (2)(c), the rules may prescribe requirements relating to either of the following:\n\n(a) the collection or generation of information prescribed for the purposes of paragraph (2)(a) (including requirements relating to making particular measurements or assessments in connection with that collection or generation);\n\n(b) reporting periods and the timeframes within which a report must be given in relation to those reporting periods (including by providing that a prescribed reporting period or timeframe is subject to an exemption determined by the System Governor in accordance with the rules).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631507",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": true,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 427,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 2, Div 3, Sub Div B, s166-115",
          "section": "Timeframes for reporting under this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Reporting",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "The reporting period for quality indicators report is quarterly (3 months), starting at the beginning of the financial year, and registered providers must submit these reports to the System Governor within 21 days after the end of each reporting period.",
          "summaryHTML": "The reporting period for quality indicators report is quarterly (3 months), starting at the beginning of the financial year, and registered providers must submit these reports to the System Governor within 21 days after the end of each reporting period.",
          "extract": "For the purposes of subsection 166(4) of the Act:\n\n(a) the reporting period for a quality indicators report given to the System Governor under this Subdivision is a quarter, being a period of 3 months, beginning at the start of a financial year; and\n\n(b) a registered provider must give a quality indicators report to the System Governor within 21 days after the end of the reporting period.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s166(4)"
        }
      ]
    },
    {
      "id": 73,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s166(5)",
      "section": "Other reports by registered providers",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Reporting",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "If required by the rules, a registered provider must publish their report in line with the prescribed requirements.",
      "summaryHTML": "If required by the rules, a registered provider must publish their report in line with the prescribed requirements.",
      "extract": "Requirement to publish reports\n\n(5) If the rules prescribe that a report given by a registered provider under subsection (1) must be published, the registered provider must publish the report in accordance with any requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631507",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 40,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s167(1)",
      "section": "Change in circumstances",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Change in circumstances",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "A registered provider of a kind must give notice to the Commissioner of any change of a kind in accordance with the rules.",
      "summaryHTML": "A registered provider of a kind must give notice to the Commissioner of any change of a kind in accordance with the rules.",
      "extract": "(1) A registered provider of a kind prescribed by the rules must give notice to the Commissioner of any change of a kind prescribed by the rules in accordance with any requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631509",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 531,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 1, s167-10",
          "section": "Notifying the Commissioner—kinds of registered providers and changes",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This rule contains a table that prescribes the kinds of registered providers and kinds of changes in respect of which those registered providers must give notice to the Commissioner under subsection 167(1) of the Act. \n\nEach kind of change, listed as an item in the table, has its own section in this Part.",
          "summaryHTML": "This rule contains a table that prescribes the kinds of registered providers and kinds of changes in respect of which those registered providers must give notice to the Commissioner under subsection 167(1) of the Act. \n\nEach kind of change, listed as an item in the table, has its own section in this Part.",
          "extract": "The following table prescribes the kinds of registered providers and kinds of changes that those providers must give notice to the Commissioner under subsection 167(1) of the Act.\n\nSee table in s167-10 of the rules for further information.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(1)"
        }
      ]
    },
    {
      "id": 41,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s167(2)",
      "section": "Change in circumstances",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Change in circumstances",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "If required by the rules, a registered provider of a kind must give notice to the System Governor of any circumstantial changes in accordance with the rules.",
      "summaryHTML": "If required by the rules, a registered provider of a kind must give notice to the System Governor of any circumstantial changes in accordance with the rules.",
      "extract": "(2) If circumstances prescribed by the rules apply, a notice under subsection (1) must also be given to the System Governor.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631509",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 532,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 1, s167-15",
          "section": "Notifying the System Governor—circumstances",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "This rule outlines when a notice of a change in circumstances, that is required to be given to the Commissioner, must also be given to the System Governor. \n\nA notice is also required to be given to the System Governor for changes to organisation arrangements (to the extent that the circumstances relate to entering into administration), financial and prudential matters, liquidity and approved residential care homes.\n\nRefer to sections 167-35, 167-60, 167-65 and 167-70 for further details.\n\nRefer to the table outlined in section 167-10: Kinds of registered providers and changes for detailed information.",
          "summaryHTML": "This rule outlines when a notice of a change in circumstances, that is required to be given to the Commissioner, must also be given to the System Governor. \n\nA notice is also required to be given to the System Governor for changes to organisation arrangements (to the extent that the circumstances relate to entering into administration), financial and prudential matters, liquidity and approved residential care homes.\n\nRefer to sections 167-35, 167-60, 167-65 and 167-70 for further details.\n\nRefer to the table outlined in section 167-10: Kinds of registered providers and changes for detailed information.",
          "extract": "For the purposes of subsection 167(2) of the Act, the circumstances in which a notice must also be given to the System Governor under that subsection are the circumstances in which a notice must be given to the Commissioner under subsection 167(1) of the Act relating to the following:\n\n(a) the circumstances prescribed by item 4, of the table in section 167-10, to the extent that the circumstances relate to entering into administration;\n\n(b) the circumstances prescribed by item 9 of the table in section 167-10 (relating to financial and prudential matters);\n\n(c) the circumstances prescribed by item 10 of the table in section 167-10 (relating to liquidity);\n\n(d) the circumstances prescribed by item 11 of the table in section 167-10 (relating to approved residential care homes).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(2)"
        }
      ]
    },
    {
      "id": 42,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s167(3)",
      "section": "Change in circumstances",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Change in circumstances",
      "topic": [
        "reporting",
        "governance"
      ],
      "summary": "The rules can require a registered provider to notify relevant authorities about any significant changes, including those that affect the suitability of a provider,  changes in circumstances, responsible persons, governance arrangements, the scale of services, types of services offered, approved residential home cares, and certain financial matters. This ensures that any factors impacting the provider's ability to deliver care are communicated promptly.",
      "summaryHTML": "The rules can require a registered provider to notify relevant authorities about any significant changes, including those that affect the suitability of a provider,  changes in circumstances, responsible persons, governance arrangements, the scale of services, types of services offered, approved residential home cares, and certain financial matters. This ensures that any factors impacting the provider's ability to deliver care are communicated promptly.",
      "extract": "(3) Without limiting subsection (1), the rules may prescribe that a registered provider must give notice of a change in relation to the following: \n\n(a) a change of circumstances or an event that materially affects the provider’s suitability to be a registered provider taking into account the matters referred to in paragraph 109(1)(b) (which deals with suitability of registered providers); \n\n(b) a change of circumstances that relates to a suitability matter in relation to a responsible person of the provider; \n\n(c) a change in the responsible persons of the provider; \n\n(d) a significant change in the organisation or governance arrangements of the provider; \n\n(e) a significant change in the scale of the provider in relation to the funded aged care services delivered by the provider; \n\n(f) a change in the service types delivered by the provider; \n\n(g) specified changes relating to the associated providers of the provider; \n\n(h) specified changes to an approved residential care home; \n\n(i) specified financial and prudential matters. \n\nNote: See section 13 for the definition of suitability matter.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631509",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 43,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s167(4)",
      "section": "Change in circumstances",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Change in circumstances",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "If a registered provider of a kind is required to give notice of a change in circumstance in accordance with the rules, it must be given within 14 days of the provider becoming aware of the change, be in an approved form, and include any information prescribed by the rules.",
      "summaryHTML": "If a registered provider of a kind is required to give notice of a change in circumstance in accordance with the rules, it must be given within 14 days of the provider becoming aware of the change, be in an approved form, and include any information prescribed by the rules.",
      "extract": "(4) A notice under subsection (1) or (2) must: \n\n(a) be given within 14 days after the registered provider becomes aware of the change in circumstances; and \n\n(b) be in an approved form; and \n\n(c) include any information prescribed by the rules in relation to a change of circumstances or event of a kind prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631509",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 533,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-20(1)-(2)",
          "section": "Suitability of a registered provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that every kind of registered provider must notify the Commissioner of any change in circumstances for a registered provider that materially affects, or may materially affect, the provider’s suitability to be a registered provider, taking into account the matters referred to in paragraph 109(1)(b) of the Act (which deals with suitability of registered providers). \n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the date on which a responsible person for the provider first became aware of the change of circumstances that materially affects the provider’s suitability to be a registered provider, how the provider became aware of the change of circumstances and details about the change of circumstances.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "summaryHTML": "These rules provide that every kind of registered provider must notify the Commissioner of any change in circumstances for a registered provider that materially affects, or may materially affect, the provider’s suitability to be a registered provider, taking into account the matters referred to in paragraph 109(1)(b) of the Act (which deals with suitability of registered providers). \n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the date on which a responsible person for the provider first became aware of the change of circumstances that materially affects the provider’s suitability to be a registered provider, how the provider became aware of the change of circumstances and details about the change of circumstances.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "extract": "(1) The change prescribed in item 1 of the table in section 167-10 is any change in circumstances for a registered provider that materially affects, or may materially affect, the provider’s suitability to be a registered provider, taking into account the matters referred to in paragraph 109(1)(b) of the Act (which deals with suitability of registered providers).\n\nNote: See section 167-10, which relates to notifying the Commissioner.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) the date on which a responsible person for the provider first became aware of the change of circumstances that materially affects the provider’s suitability to be a registered provider; and\n\n(b) how the provider became aware of the change of circumstances; and\n\n(c) details about the change of circumstances.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 534,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-25(1)-(2)",
          "section": "Suitability of a responsible person of a registered provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that every kind of registered provider must notify the Commissioner of any change in circumstances relating to a responsible person of a registered provider that materially affects, or could materially affect, the responsible person’s suitability to be a responsible person of the provider, having regard to the matters referred to in subsection 13(1) of the Act (which deals with suitability matters in relation to an individual). \n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the name of the responsible person, the date and how the provider  became aware of the change in circumstances, details of the change of circumstances, whether, after considering those matters, the provider is reasonably satisfied that the responsible person continues to be suitable to be a responsible person of the provider and what, if any, action the provider has taken, or proposes to take, in relation to the responsible person.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "summaryHTML": "These rules provide that every kind of registered provider must notify the Commissioner of any change in circumstances relating to a responsible person of a registered provider that materially affects, or could materially affect, the responsible person’s suitability to be a responsible person of the provider, having regard to the matters referred to in subsection 13(1) of the Act (which deals with suitability matters in relation to an individual). \n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the name of the responsible person, the date and how the provider  became aware of the change in circumstances, details of the change of circumstances, whether, after considering those matters, the provider is reasonably satisfied that the responsible person continues to be suitable to be a responsible person of the provider and what, if any, action the provider has taken, or proposes to take, in relation to the responsible person.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "extract": "(1) The change prescribed in item 2 of the table in section 167-10 is any change in circumstances relating to a responsible person of a registered provider that materially affects, or could materially affect, the responsible person’s suitability to be a responsible person of the provider, having regard to the matters referred to in subsection 13(1) of the Act (which deals with suitability matters in relation to an individual).\n\nNote: See section 167-10, which relates to notifying the Commissioner.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) the name of the responsible person; and\n\n(b) the date the provider first became aware of the change in circumstances; and\n\n(c) how the provider became aware of the change in circumstances; and\n\n(d) details of the change of circumstances; and\n\n(e) whether, after considering those matters, the provider is reasonably satisfied that the responsible person continues to be suitable to be a responsible person of the provider; and\n\n(f) what, if any, action the provider has taken, or proposes to take, in relation to the responsible person.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 535,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-30(1)-(2)",
          "section": "Change of responsible persons of a registered provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that every kind of registered provider must notify the Commissioner of any change of responsible persons of a registered provider, including an individual becoming a responsible person of the provider or ceasing to be a responsible person. \n\nThe information that must be included in a notice given in relation to a change to which this section includes:\n\n(a) for a change relating to an individual becoming a responsible person of the provider:\n\n(i) the name and contact details of the individual; and\n\n(ii) a description of the individual’s responsibilities in their capacity as a responsible person of the provider; and\n\n(iii) a statement to the effect that related to the suitability matters as referred to in subsection 13(1) of the Act, and that the provider is satisfied that the individual is suitable to be involved in the delivery of funded aged care services; \n\n(b) for a change relating to an individual ceasing to be a responsible person of the provider:\n\n(i) the name of the individual ceasing to be a responsible person; and\n\n(ii) the reason that the individual has ceased to be a responsible person of the provider; and\n\n(iii) the name and contact details of another individual (if any) who is carrying out, or will carry out, the responsibilities of the individual ceasing to be a responsible person.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "summaryHTML": "These rules provide that every kind of registered provider must notify the Commissioner of any change of responsible persons of a registered provider, including an individual becoming a responsible person of the provider or ceasing to be a responsible person. \n\nThe information that must be included in a notice given in relation to a change to which this section includes:\n\n(a) for a change relating to an individual becoming a responsible person of the provider:\n\n(i) the name and contact details of the individual; and\n\n(ii) a description of the individual’s responsibilities in their capacity as a responsible person of the provider; and\n\n(iii) a statement to the effect that related to the suitability matters as referred to in subsection 13(1) of the Act, and that the provider is satisfied that the individual is suitable to be involved in the delivery of funded aged care services; \n\n(b) for a change relating to an individual ceasing to be a responsible person of the provider:\n\n(i) the name of the individual ceasing to be a responsible person; and\n\n(ii) the reason that the individual has ceased to be a responsible person of the provider; and\n\n(iii) the name and contact details of another individual (if any) who is carrying out, or will carry out, the responsibilities of the individual ceasing to be a responsible person.\n\nNote: See section 167-10, which relates to notifying the Commissioner.",
          "extract": "(1) The change prescribed in item 3 of the table in section 167-10 is any change of responsible persons of a registered provider, including:\n\n(a) an individual becoming a responsible person of the provider; and\n\n(b) an individual ceasing to be a responsible person of the provider.\n\nNote: See section 167-10, which relates to notifying the Commissioner.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) For a change relating to an individual becoming a responsible person of the provider:\n\n(i) the name and contact details of the individual; and\n\n(ii) a description of the individual’s responsibilities in their capacity as a responsible person of the provider; and\n\n(iii) a statement to the effect that the provider has had regard to the suitability matters in relation to the individual, as referred to in subsection 13(1) of the Act, and that the provider is satisfied that the individual is suitable to be involved in the delivery of funded aged care services; and\n\n(b) For a change relating to an individual ceasing to be a responsible person of the provider:\n\n(i) the name of the individual ceasing to be a responsible person; and\n\n(ii) the reason that the individual has ceased to be a responsible person of the provider; and\n\n(iii) the name and contact details of another individual (if any) who is carrying out, or will carry out, the responsibilities of the individual ceasing to be a responsible person.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 536,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-35(1)-(3)",
          "section": "Organisation arrangements of a registered provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that a registered provider must notify the Commissioner of the following changes to the organisation arrangements of a registered provider. The information that must be included in the notice is set out in subsection 167-35(3).\n\n(a) If the provider is not a government entity - any significant change to the provider's legal and business structure. Includes a restructure of the organisation or a sale, acquisition, or merger relating to the provider. \n\n(b) For any registered provider (including a government entity) - the entering into of an agreement by the provider with another entity in which the other entity agrees to deliver services that support the management or governance function of the provider. (The circumstances referred to in this paragraph do not include the entering into of an agreement for the delivery of funded aged care services. See 167-35(2)). \n\n(c) For any registered provider (including a government entity) - any significant change to an agreement (including the cessation of a such an agreement) by the provider with another entity in which the other entity agrees to deliver services that support the management or governance of the provider.  \n\n(d) If the provider is not a government entity - any of the following events:\n\n(i) the provider enters into administration;\n\n(ii) the provider appoints a restructuring practitioner (within the meaning of the Corporations  Act 2001);\n\n(iii) an insolvency event (within the meaning of the Aged Care (Accommodation Payment Security) Act 2006) occurs in relation to the provider.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner.\n\nNote 2: See section 167-15, which relates to notifying the System Governor of matters relating to entering administration.",
          "summaryHTML": "These rules provide that a registered provider must notify the Commissioner of the following changes to the organisation arrangements of a registered provider. The information that must be included in the notice is set out in subsection 167-35(3).\n\n(a) If the provider is not a government entity - any significant change to the provider's legal and business structure. Includes a restructure of the organisation or a sale, acquisition, or merger relating to the provider. \n\n(b) For any registered provider (including a government entity) - the entering into of an agreement by the provider with another entity in which the other entity agrees to deliver services that support the management or governance function of the provider. (The circumstances referred to in this paragraph do not include the entering into of an agreement for the delivery of funded aged care services. See 167-35(2)). \n\n(c) For any registered provider (including a government entity) - any significant change to an agreement (including the cessation of a such an agreement) by the provider with another entity in which the other entity agrees to deliver services that support the management or governance of the provider.  \n\n(d) If the provider is not a government entity - any of the following events:\n\n(i) the provider enters into administration;\n\n(ii) the provider appoints a restructuring practitioner (within the meaning of the Corporations  Act 2001);\n\n(iii) an insolvency event (within the meaning of the Aged Care (Accommodation Payment Security) Act 2006) occurs in relation to the provider.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner.\n\nNote 2: See section 167-15, which relates to notifying the System Governor of matters relating to entering administration.",
          "extract": "(1) The change prescribed in item 4 of the table in section 167-10 is any change of the following kind to the organisation of a registered provider:\n\n(a) if the provider is not a government entity—any change to the provider’s legal and business structure, including any of the following:\n\n(i) a restructure of the organisation of the provider;\n\n(ii) a sale, acquisition, or merger relating to the provider;\n\n(b) for any registered provider (including a government entity)—the entering into of an agreement by the provider with another entity in which the other entity agrees to deliver services that support the management or governance function of the provider;\n\n(c) for any registered provider (including a government entity)—any significant change to an agreement (including the cessation of such an agreement) by the provider with another entity in which the other entity agrees to deliver services that support the management or governance of the provider;\n\n(d) if the provider is not a government entity—any of the following events:\n\n(i) the provider enters into administration;\n\n(ii) the provider appoints a restructuring practitioner (within the meaning of the Corporations Act 2001);\n\n(iii) an insolvency event (within the meaning of the Aged Care (Accommodation Payment Security) Act 2006) occurs in relation to the provider.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner.\n\nNote 2: See section 167-15, which relates to notifying the System Governor of matters relating to entering administration.\n\n(2) To avoid doubt, the circumstances referred to in paragraph (1)(b) relating to the provider entering into an agreement do not include the entering into of an agreement for the delivery of funded aged care services.\n\n(3) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) for a change to the provider’s legal or business structure—details about the change to the provider’s legal or business structure; and\n\n(b) for an event referred to in paragraph (1)(b) or (c) (which relate to agreements):\n\n(i) a detailed statement about the services that the other entity is to provide to the registered provider; and\n\n(ii) the nature and duration of the agreement; and\n\n(iii) if the notification is about the cessation of the agreement—the reason and date of cessation; and\n\n(c) for an event set out in paragraph (1)(d) of this section (which relates to administration, restructuring and insolvency):\n\n(i) the date on which the event occurred; and\n\n(ii) the type of administration (where applicable); and\n\n(iii) the name of the administrator or restructuring practitioner (where applicable).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 537,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-40(1)-(2)",
          "section": "Governance arrangements of a registered provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "governance"
          ],
          "summary": "Governance arrangements of a registered provider\n\nThese rules provide that a registered provider to whom section 157 of the Act applies (being a section about the membership of governing bodies) must notify the Commissioner of any change to the governance of a registered provider that would result in the registered provider no longer complying with subsection 157(2) of the Act. \n\nNote 1: See sections 157-5 and 157-10, which prescribe the kinds of registered providers to whom section 157 of the Act applies.\n\nNote 2: See section 167-10, which relates to notifying the Commissioner\n\nFor the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) a statement that the provider no longer complies with a condition of registration set out in paragraph 157(2)(a) or (b) of the Act (whichever is relevant to the provider); and\n\n(b) the names of incoming and outgoing members in relation to the non-compliance; and\n\n(c) information on steps being taken to return to compliance, including whether an application under subsection 159(1) of the Act (which relates to determinations that certain conditions relating to the governing body of a registered provider do not apply) has been submitted, or will be submitted.",
          "summaryHTML": "<i>Governance arrangements of a registered provider</i>\n\nThese rules provide that a registered provider to whom section 157 of the Act applies (being a section about the membership of governing bodies) must notify the Commissioner of any change to the governance of a registered provider that would result in the registered provider no longer complying with subsection 157(2) of the Act. \n\nNote 1: See sections 157-5 and 157-10, which prescribe the kinds of registered providers to whom section 157 of the Act applies.\n\nNote 2: See section 167-10, which relates to notifying the Commissioner\n\nFor the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) a statement that the provider no longer complies with a condition of registration set out in paragraph 157(2)(a) or (b) of the Act (whichever is relevant to the provider); and\n\n(b) the names of incoming and outgoing members in relation to the non-compliance; and\n\n(c) information on steps being taken to return to compliance, including whether an application under subsection 159(1) of the Act (which relates to determinations that certain conditions relating to the governing body of a registered provider do not apply) has been submitted, or will be submitted.",
          "extract": "(1) The change prescribed in item 5 of the table in section 167-10 is any change to the governance of a registered provider that would result in the registered provider no longer complying with subsection 157(2) of the Act.\n\nNote 1: See sections 157-5 and 157-10, which prescribe the kinds of registered providers to whom section 157 of the Act applies.\n\nNote 2: See section 167-10, which relates to notifying the Commissioner.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) a statement that the provider no longer complies with a condition of registration set out in paragraph 157(2)(a) or (b) of the Act (whichever is relevant to the provider); and\n\n(b) the names of incoming and outgoing members in relation to the non-compliance; and\n\n(c) information on steps being taken to return to compliance, including whether an application under subsection 159(1) of the Act (which relates to determinations that certain conditions relating to the governing body of a registered provider do not apply) has been submitted, or will be submitted.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 538,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-45(1)-(2)",
          "section": "Change relating to the scale of operations of a provider",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that every kind of registered provider must notify the Commissioner of the changes listed below relating to the scale of operations of the provider. \n\n(a) For a registered provider other than a provider registered in category 6 (residential care) - a change to the local government area in which the provider delivers a funded aged care service.\n\n(b) For a registered provider (including a provider registered in category 6 (residential care) - a significant increase or decrease in the number of aged care workers of the provider that materially affects the provider’s ability to deliver funded aged care services.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes details of the change, the aged care funded services that will be, or are likely to be, affected by the change, any other anticipated effects of the change, the reason for the change, and any actions that the provider has taken or will take to manage the effect on services, or other anticipated effects.\n\nNote: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "summaryHTML": "These rules provide that every kind of registered provider must notify the Commissioner of the changes listed below relating to the scale of operations of the provider. \n\n(a) For a registered provider other than a provider registered in category 6 (residential care) - a change to the local government area in which the provider delivers a funded aged care service.\n\n(b) For a registered provider (including a provider registered in category 6 (residential care) - a significant increase or decrease in the number of aged care workers of the provider that materially affects the provider’s ability to deliver funded aged care services.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes details of the change, the aged care funded services that will be, or are likely to be, affected by the change, any other anticipated effects of the change, the reason for the change, and any actions that the provider has taken or will take to manage the effect on services, or other anticipated effects.\n\nNote: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "extract": "(1) The change prescribed in item 6 of the table in section 167-10 is any of the following changes:\n\n(a) for a registered provider other than a registered provider registered in the provider registration category residential care—a change to the local government area in which the provider delivers a funded aged care service;\n\n(b) for a registered provider (including a registered provider registered in the provider registration category residential care)—a significant increase or decrease in the number of aged care workers of the provider that materially affects the provider’s ability to deliver funded aged care services.\n\nNote: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) details of the change; and\n\n(b) the aged care funded services that will be, or are likely to be, affected by the change; and\n\n(c) any other anticipated effects of the change; and\n\n(d) the reason for the change; and\n\n(e) any actions that the provider has taken or will take to manage the effect on services, or other anticipated effects.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 539,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-50(1)-(2)",
          "section": "Changes relating to intended service types",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "A registered provider in the following categories must notify the Commissioner of any change relating to the provider's intended service types:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the relevant service type and the date on which the provider expects the change to take effect.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.\n\nNote 2: See Division 4 of Part 4 of Chapter 4 of the rules for provisions relating to starting and ceasing the provision of funded aged care services to a particular individual and continuity of those services.",
          "summaryHTML": "A registered provider in the following categories must notify the Commissioner of any change relating to the provider's intended service types:\n\nCategory 1 - home and community services\nCategory 2 - assistive technology and home modifications\nCategory 3 - advisory and support services\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the relevant service type and the date on which the provider expects the change to take effect.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.\n\nNote 2: See Division 4 of Part 4 of Chapter 4 of the rules for provisions relating to starting and ceasing the provision of funded aged care services to a particular individual and continuity of those services.",
          "extract": "(1) The change prescribed in item 7 of the table in section 167-10 is any change relating to a registered provider’s intended service types.\n\nNote 1: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.\n\nNote 2: See Division 4 of Part 4 of Chapter 4 of this instrument for provisions relating to starting and ceasing the provision of funded aged care services to a particular individual and continuity of those services.\n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) the relevant service type; and\n\n(b) the date on which the provider expects the change to take effect.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": false,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 540,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-55(1)-(3)",
          "section": "Changes relating to arrangements with associated providers",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that a registered provider in the following categories must notify the Commissioner of changes relating to arrangements with associated providers:\n\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care.\nCategory 6 - residential care\n\nProviders registered in registration category subscription trial and also deliver the service types subscription allied health and therapy, subscription home or community general respite, subscription personal care, subscription therapeutic services for independent living, and subscription nursing care are also prescribed. \n\nThe changes prescribed are any of the following:\n(a) The commencement of a new arrangement between the registered provider and an associated provider for the delivery of funded aged care services by the associated provider on behalf of the registered provider.\n\n(b) The variation or extension of an existing such arrangement between the registered provider and an associated provider. \n\n(c) The cessation of an existing such arrangement between the registered provider and an associated provider.\n\nThe requirement above does not apply to an arrangement with an associated provider for:\n\n(a) the supply of labour under a labour hire arrangement; or\n\n(b) the delivery of services that support the management or governance function of the registered provider\n\nFor information to be included in a notice given in relation to this section, please see section 167-55(3) of the rules.",
          "summaryHTML": "These rules provide that a registered provider in the following categories must notify the Commissioner of changes relating to arrangements with associated providers:\n\nCategory 4 - personal care and care support in the home or community \nCategory 5 - nursing and transition care.\nCategory 6 - residential care\n\nProviders registered in registration category subscription trial and also deliver the service types subscription allied health and therapy, subscription home or community general respite, subscription personal care, subscription therapeutic services for independent living, and subscription nursing care are also prescribed. \n\nThe changes prescribed are any of the following:\n(a) The commencement of a new arrangement between the registered provider and an associated provider for the delivery of funded aged care services by the associated provider on behalf of the registered provider.\n\n(b) The variation or extension of an existing such arrangement between the registered provider and an associated provider. \n\n(c) The cessation of an existing such arrangement between the registered provider and an associated provider.\n\nThe requirement above does not apply to an arrangement with an associated provider for:\n\n(a) the supply of labour under a labour hire arrangement; or\n\n(b) the delivery of services that support the management or governance function of the registered provider\n\nFor information to be included in a notice given in relation to this section, please see section 167-55(3) of the rules.",
          "extract": "(1) Subject to subsections (2) and (2A), for the purposes of items 8 and 8A of the table in section 167-10, the changes are the following:\n\n(a) the commencement of a new arrangement between the registered provider and an associated provider for the delivery of funded aged care services by the associated provider on behalf of the registered provider;\n\n(b) the variation or extension of an existing such arrangement between the registered provider and an associated provider;\n\n(c) the cessation of an existing such arrangement between the registered provider and an associated provider.\n\nNote: See section 167-10, which relates to notifying the Commissioner.\n\n(2) Subsection (1) does not apply to circumstances where the registered provider has entered into an arrangement with an associated provider for:\n\n(a) the supply of labour under a labour hire arrangement; or\n\n(b) the delivery of services that support the management or governance function of the registered provider.\n\n(2A) Subsection (1) applies only to arrangements for the delivery of the following services:\n\n(a) services in service types that can be delivered under any of the following provider registration categories:\n\n(i) residential care;\n\n(ii) personal and care support in the home or community;\n\n(iii) nursing and transition care;\n\n(b) services in the following service types:\n\n(i) subscription allied health and therapy;\n\n(ii) subscription home or community general respite;\n\n(iii) subscription personal care;\n\n(iv) subscription therapeutic services for independent living;\n\n(v) subscription nursing care.\n\n(3) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) in all circumstances—information about the associated provider, including:\n\n(i) the associated provider’s business name; and\n\n(ii) the associated provider’s ABN; and\n\n(iii) the associated provider’s ACN (if any); and\n\n(iv) the associated provider’s business location;\n\n(b) in circumstances relating to the delivery of funded aged care services in a residential care home—information about the residential care home, including:\n\n(i) the name of the residential care home; and\n\n(ii) the address of the residential care home;\n\n(c) in circumstances relating to the commencement of a new arrangement:\n\n(i) details of the services to be delivered under the new arrangement; and\n\n(ii) the reasons for the new arrangement; and\n\n(iii) the time period for the new arrangement (including the commencement date and expiry date of the arrangement);\n\n(d) in circumstances relating to the variation or extension of an arrangement:\n\n(i) details of the variation or extension, including any new commencement dates or expiry dates for the arrangement; and\n\n(ii) the reason for the variation or extension;\n\n(e) in circumstances relating to the cessation of an arrangement:\n\n(i) the date on which the arrangement ceased or will cease; and\n\n(ii) the reason for the cessation.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 541,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-60(1)-(3)",
          "section": "Changes relating to financial and prudential matters",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that every kind of registered provider, except government entities, must notify the Commissioner and the System Governor of a change relating to financial and prudential matters (except a change relating to liquidity which is dealt with in section 167-10 (item 10) and section 167-65 of these rules).\n\nThe change prescribed is any change to a registered provider's capacity  to deliver funded aged care services that the provider is registered to deliver, including the following:\n\n(a) the inability to pay the entitlements of the provider’s aged care workers;\n\n(b) any change that materially affects an existing or anticipated revenue source;\n\n(c) any instance in which the provider is unable to pay the provider’s debts as and when those debts become due and payable.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes details about the change, the impact that the provider expects the change to have on the provider’s ability to deliver funded aged care services and details about any mitigating strategies the provider has attempted, or will attempt, to manage this impact.\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "summaryHTML": "These rules provide that every kind of registered provider, except government entities, must notify the Commissioner and the System Governor of a change relating to financial and prudential matters (except a change relating to liquidity which is dealt with in section 167-10 (item 10) and section 167-65 of these rules).\n\nThe change prescribed is any change to a registered provider's capacity  to deliver funded aged care services that the provider is registered to deliver, including the following:\n\n(a) the inability to pay the entitlements of the provider’s aged care workers;\n\n(b) any change that materially affects an existing or anticipated revenue source;\n\n(c) any instance in which the provider is unable to pay the provider’s debts as and when those debts become due and payable.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes details about the change, the impact that the provider expects the change to have on the provider’s ability to deliver funded aged care services and details about any mitigating strategies the provider has attempted, or will attempt, to manage this impact.\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "extract": "(1) The change prescribed in item 9 of the table in section 167-10 is any change to a registered provider’s capacity to deliver funded aged care services that the provider is registered to deliver, including:\n\n(a) the inability to pay the entitlements of the provider’s aged care workers;\n\n(b) any change that materially affects an existing or anticipated revenue source;\n\n(c) any instance in which the provider is unable to pay the provider’s debts as and when those debts become due and payable.\n\nNote: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.\n\n(2) Subsection (1) does not apply to circumstances set out in section 167-65 (which relates to liquidity).\n\n(3) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) details about the change; and\n\n(b) the impact that the provider expects that the change to have on the provider’s ability to deliver funded aged care services; and\n\n(c) details about any mitigating strategies the provider has attempted, or will attempt, to manage this impact.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": true,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 542,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-65(1)-(2)",
          "section": "Changes relating to liquidity",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that a registered provider that:\n\n(a) is registered in Category 6 - residential care; and\n\n(b) is not a government entity or a local government authority; and\n\n(c) is not delivering aged care services through the specialist aged care program NATSIFACP\nmust notify the Commissioner and the System Governor about any change relating to liquidity.\n\nThe change prescribed is any circumstance where the registered provider is not maintaining, or is at risk of not maintaining, the provider’s default minimum liquidity amount for a quarter or evaluated minimum liquidity amount for a quarter.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the provider’s current and expected liquidity for the relevant quarter, the reason for the reduction, or expected reduction in liquidity, the provider’s Liquidity Management Strategy and the provider’s plan to increase liquidity to a level that is sufficient for the purposes set out in subsection (1).\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "summaryHTML": "These rules provide that a registered provider that:\n\n(a) is registered in Category 6 - residential care; and\n\n(b) is not a government entity or a local government authority; and\n\n(c) is not delivering aged care services through the specialist aged care program NATSIFACP\nmust notify the Commissioner and the System Governor about any change relating to liquidity.\n\nThe change prescribed is any circumstance where the registered provider is not maintaining, or is at risk of not maintaining, the provider’s default minimum liquidity amount for a quarter or evaluated minimum liquidity amount for a quarter.\n\nThe information that must be included in a notice given in relation to a change to which this section applies includes the provider’s current and expected liquidity for the relevant quarter, the reason for the reduction, or expected reduction in liquidity, the provider’s Liquidity Management Strategy and the provider’s plan to increase liquidity to a level that is sufficient for the purposes set out in subsection (1).\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "extract": "(1) The change prescribed in item 10 of the table in section 167-10 is any circumstance where the registered provider is not maintaining, or is at risk of not maintaining, the provider’s default minimum liquidity amount for a quarter or evaluated minimum liquidity amount for a quarter. \n\nNote: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor. \n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) the provider’s current and expected liquidity for the relevant quarter; and\n\n(b) the reason for the reduction, or expected reduction in liquidity; and\n\n(c) the provider’s Liquidity Management Strategy; and\n\n(d) the provider’s plan to increase liquidity to a level that is sufficient for the purposes set out in subsection (1).\n\nNote: The standards in relation to financial and prudential matters are set out in the Financial and Prudential Standards made by the Commissioner under subsection 376(1) of the Act.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": false,
            "partnerships": true,
            "otherUnico": true,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        },
        {
          "id": 543,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 3, Div 2, s167-70(1)-(2)",
          "section": "Changes relating to approved residential care homes",
          "requirement": "Obligations",
          "subdivision": "Reporting, notifications and information",
          "sublevel": "Change in circumstances",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "These rules provide that a registered provider registered in Category 6 - residential care must notify the Commissioner and the System Governor of changes relating to approved residential care homes. \n\nThe changes prescribed are any of the following:\n\n(a) A change that may affect whether the approved residential care home of the provider continues to meet the definition of residential care home in the Act.\n\n(b) A change to a building or the premises that comprise the approved residential care home that presents a risk to the delivery of quality and safe residential care.\n\n(c) A planned construction or renovation activity relating to the approved residential care home that the provider reasonably expects will affect the delivery of funded aged care services at the residential care home.\n\n(d) An unplanned event relating to the approved residential care home that the provider reasonably expects will cause sustained disruption to the delivery of funded aged care services at the residential care home.\n\n(e) A change in the ownership of the premises at which the residential care home is located or a change to any agreement between the owner of the premises and the registered provider to use the premises as a residential care home.\n\n(f) For any provider other than a provider referred to in paragraph (g)—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home that the provider expects will continue for a continuous period of at least 3 months, except where the approved residential care home only delivers funded aged care services under a specialist aged care program.\n\n(g) For a registered provider in the 2023 MM category known as MM 6 or MM 7—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home for any period of time, except where the approved residential care home only delivers funded aged care services under a specialist aged care program.\n\n(h) A change in circumstances that causes beds that were unavailable as referred to in paragraph (1)(f) or (g) to become available.\n\nRegistered providers must include detailed information about the residential care home, any specifics about any change affecting bed availability and details of the change in ownership. when notifying the Commissioner of relevant changes. For more detailed information refer to subsection 167-70(2) (a) to (e).\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "summaryHTML": "These rules provide that a registered provider registered in Category 6 - residential care must notify the Commissioner and the System Governor of changes relating to approved residential care homes. \n\nThe changes prescribed are any of the following:\n\n(a) A change that may affect whether the approved residential care home of the provider continues to meet the definition of residential care home in the Act.\n\n(b) A change to a building or the premises that comprise the approved residential care home that presents a risk to the delivery of quality and safe residential care.\n\n(c) A planned construction or renovation activity relating to the approved residential care home that the provider reasonably expects will affect the delivery of funded aged care services at the residential care home.\n\n(d) An unplanned event relating to the approved residential care home that the provider reasonably expects will cause sustained disruption to the delivery of funded aged care services at the residential care home.\n\n(e) A change in the ownership of the premises at which the residential care home is located or a change to any agreement between the owner of the premises and the registered provider to use the premises as a residential care home.\n\n(f) For any provider other than a provider referred to in paragraph (g)—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home that the provider expects will continue for a continuous period of at least 3 months, except where the approved residential care home only delivers funded aged care services under a specialist aged care program.\n\n(g) For a registered provider in the 2023 MM category known as MM 6 or MM 7—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home for any period of time, except where the approved residential care home only delivers funded aged care services under a specialist aged care program.\n\n(h) A change in circumstances that causes beds that were unavailable as referred to in paragraph (1)(f) or (g) to become available.\n\nRegistered providers must include detailed information about the residential care home, any specifics about any change affecting bed availability and details of the change in ownership. when notifying the Commissioner of relevant changes. For more detailed information refer to subsection 167-70(2) (a) to (e).\n\nSee section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor.",
          "extract": "(1) The change prescribed in item 11 of the table in section 167-10 is any of the following changes relating to an approved residential care home of a registered provider:\n\n(a) a change that may affect whether the approved residential care home of the provider continues to meet the definition of residential care home in the Act;\n\n(b) a change to a building or the premises that comprise the approved residential care home that presents a risk to the delivery of quality and safe residential care;\n\n(c) a planned construction or renovation activity relating to the approved residential care home that the provider reasonably expects will affect the delivery of funded aged care services at the residential care home;\n\n(d) an unplanned event relating to the approved residential care home that the provider reasonably expects will cause sustained disruption to the delivery of funded aged care services at the residential care home; \n\n(e) a change in the ownership of the premises at which the residential care home is located or a change to any agreement between the owner of the premises and the registered provider to use the premises as a residential care home; \n\n(f) for any provider other than a provider referred to in paragraph (g)—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home that the provider expects will continue for a continuous period of at least 3 months, except where the approved residential care home only delivers funded aged care services under a specialist aged care program;  \n\n(g) for a registered provider in the 2023 MM category known as MM 6 or MM 7—a reduction in the availability of the total number of beds covered by the approval of the approved residential care home for any period of time, except where the approved residential care home only delivers funded aged care services under a specialist aged care program; \n\n(h) a change in circumstances that causes beds that were unavailable as referred to in paragraph (1)(f) or (g) to become available. \n\nNote 1: See section 167-10, which relates to notifying the Commissioner, and section 167-15, which relates to notifying the System Governor. \n\nNote 2: See section 136 of the Act, which relates to varying the approval of a residential care home of a registered provider. \n\n(2) For the purposes of paragraph 167(4)(c) of the Act, the information that must be included in a notice given in relation to a change to which this section applies is:\n\n(a) the name of the approved residential care home; and\n\n(b) the street address of the residential care home; and\n\n(c) a description of the change of circumstances; and\n\n(d) for circumstances referred to in paragraph (1)(f) or (g):\n\n(i) the number of beds in respect of which the registered provider is, or will be, unable to provide residential care; and\n\n(ii) the period during which the registered provider is, or will be, unable to provide residential care for those beds; and\n\n(iii) the reason for the change to the availability of beds; and \n\n(e) details of the change in ownership, and in circumstances where the registered provider is not the owner of the premises used for the provision of services and there is a change in ownership, the information must include the date and details of the type of agreement under which permission to use the premises is given.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": true
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s167(4)"
        }
      ]
    },
    {
      "id": 44,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div A, s168(1)-(2)",
      "section": "Protection of personal information",
      "requirement": "Obligations",
      "subdivision": "Reporting, notifications and information",
      "sublevel": "Protection of personal information",
      "topic": [
        "agreements",
        "unspecified"
      ],
      "summary": "A registered provider must ensure that the personal information of an individual receiving care is protected. The personal information can only be used to support the delivery of services if it was given by or on behalf of the individual to the provider. Except with the consent of the individual, the personal information must not be disclosed to any person unless it is to support the delivery of services to the individual by the provider or an associated provider, for the purpose that the information was given, or for compliance with this Act. The personal information must be protected by security safeguards reasonable in the circumstances against the loss or misuse of the information. \n\nThis does not prevent personal information being given to a court, or to a tribunal, authority or person having the power to require the production of documents or the answering of questions, in accordance with a requirement of that court, tribunal, authority or person.",
      "summaryHTML": "A registered provider must ensure that the personal information of an individual receiving care is protected. The personal information can only be used to support the delivery of services if it was given by or on behalf of the individual to the provider. Except with the consent of the individual, the personal information must not be disclosed to any person unless it is to support the delivery of services to the individual by the provider or an associated provider, for the purpose that the information was given, or for compliance with this Act. The personal information must be protected by security safeguards reasonable in the circumstances against the loss or misuse of the information. \n\nThis does not prevent personal information being given to a court, or to a tribunal, authority or person having the power to require the production of documents or the answering of questions, in accordance with a requirement of that court, tribunal, authority or person.",
      "extract": "(1) A registered provider must ensure the protection of personal information, relating to an individual to whom the registered provider delivers funded aged care services, including as follows: \n\n(a) the personal information must not be used other than: \n\n(i) for a purpose connected with the delivery of a funded aged care service to the individual by the registered provider; or \n\n(ii) for a purpose for which the personal information was given by or on behalf of the individual to the registered provider; \n\n(b) except with the consent of the individual, the personal information must not be disclosed to any other person other than: \n\n(i) for a purpose connected with the delivery of a funded aged care service to the individual by the registered provider; or \n\n(ii) for a purpose connected with the delivery of a funded aged care service to the individual by an associated provider of the registered provider or another registered provider; or \n\n(iii) for a purpose for which the personal information was given by or on behalf of the individual; or \n\n(iv) for the purpose of complying with an obligation under this Act; \n\n(c) the personal information must be protected by security safeguards that it is reasonable in the circumstances to take against the loss or misuse of the information. \n\n(2) This section does not prevent personal information being given to a court, or to a tribunal, authority or person having the power to require the production of documents or the answering of questions, in accordance with a requirement of that court, tribunal, authority or person.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631510",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 45,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div B, s169(1)",
      "section": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "requirement": "Obligations",
      "subdivision": "Suitability of responsible persons",
      "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "A responsible person of all registered providers (except a provider that is a sole trader) must notify the provider in writing, including details of the change.",
      "summaryHTML": "A responsible person of all registered providers (except a provider that is a sole trader) must notify the provider in writing, including details of the change.",
      "extract": "(1) If: \n\n(a) a person is one of the responsible persons of a registered provider of a kind prescribed by the rules; and \n\n(b) the person becomes aware of a change of circumstances that relates to a suitability matter in relation to the person; \nthe person must notify the provider of the change.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631512",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 544,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 4, s169-5",
          "section": "Kinds of registered provider to which the obligation applies",
          "requirement": "Obligations",
          "subdivision": "Suitability of responsible persons",
          "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "summaryHTML": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "extract": "For the purposes of paragraph 169(1)(a) of the Act, every kind of registered provider is prescribed except a provider that is a sole trader.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s169(1)"
        },
        {
          "id": 545,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 4, s169-5",
          "section": "Kinds of registered provider to which the obligation applies",
          "requirement": "Obligations",
          "subdivision": "Suitability of responsible persons",
          "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "summaryHTML": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "extract": "For the purposes of paragraph 169(1)(a) of the Act, every kind of registered provider is prescribed except a provider that is a sole trader.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s169(1)"
        }
      ]
    },
    {
      "id": 46,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div B, s169(1)",
      "section": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "requirement": "Obligations",
      "subdivision": "Suitability of responsible persons",
      "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A responsible person of all registered providers (except a provider that is a sole trader) must notify the provider in writing, including details of the change.",
      "summaryHTML": "A responsible person of all registered providers (except a provider that is a sole trader) must notify the provider in writing, including details of the change.",
      "extract": "(1) If: \n\n(a) a person is one of the responsible persons of a registered provider of a kind prescribed by the rules; and \n\n(b) the person becomes aware of a change of circumstances that relates to a suitability matter in relation to the person; \nthe person must notify the provider of the change.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631512",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": true
      },
      "type": "Hook",
      "rules": [
        {
          "id": 544,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 4, s169-5",
          "section": "Kinds of registered provider to which the obligation applies",
          "requirement": "Obligations",
          "subdivision": "Suitability of responsible persons",
          "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
          "topic": [
            "reporting",
            "unspecified"
          ],
          "summary": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "summaryHTML": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "extract": "For the purposes of paragraph 169(1)(a) of the Act, every kind of registered provider is prescribed except a provider that is a sole trader.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s169(1)"
        },
        {
          "id": 545,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 4, s169-5",
          "section": "Kinds of registered provider to which the obligation applies",
          "requirement": "Obligations",
          "subdivision": "Suitability of responsible persons",
          "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "summaryHTML": "Section 169(1) of the Act provides that if a person is one of the responsible persons of a registered provider, and becomes aware of a change in circumstances that relates to a suitability matter in relation to the person, the person must notify the provider of the change. Section 169(2) of the Act sets out the requirement for the notification to the provider.\n\nThis rule prescribes that the requirement applies to every kind of registered provider except a provider that is a sole trader.",
          "extract": "For the purposes of paragraph 169(1)(a) of the Act, every kind of registered provider is prescribed except a provider that is a sole trader.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": true
          },
          "type": "Rule",
          "ref": "s169(1)"
        }
      ]
    },
    {
      "id": 47,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div B, s169(2)",
      "section": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "requirement": "Obligations",
      "subdivision": "Suitability of responsible persons",
      "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "topic": [
        "reporting",
        "unspecified"
      ],
      "summary": "The notification must be in writing, submitted within 14 days of becoming aware of the change in circumstances, and include details related to the suitability matter.",
      "summaryHTML": "The notification must be in writing, submitted within 14 days of becoming aware of the change in circumstances, and include details related to the suitability matter.",
      "extract": "(2) The notification must: \n\n(a) be given in writing; and \n\n(b) be given within 14 days after the person becomes aware of the change of circumstances; and \n\n(c) set out the details of the change of circumstances that relates to a suitability matter in relation to the person.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631512",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 48,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div B, s169(2)",
      "section": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "requirement": "Obligations",
      "subdivision": "Suitability of responsible persons",
      "sublevel": "Responsible persons of a registered provider must notify of change of circumstances relating to suitability",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The notification must be in writing, submitted within 14 days of becoming aware of the change in circumstances, and include details related to the suitability matter.",
      "summaryHTML": "The notification must be in writing, submitted within 14 days of becoming aware of the change in circumstances, and include details related to the suitability matter.",
      "extract": "(2) The notification must: \n\n(a) be given in writing; and \n\n(b) be given within 14 days after the person becomes aware of the change of circumstances; and \n\n(c) set out the details of the change of circumstances that relates to a suitability matter in relation to the person.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631512",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": true
      },
      "type": "Hook"
    },
    {
      "id": 49,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div B, s172(1)",
      "section": "Offence relating to failure to comply with responsibility to consider suitability matters relating to responsible persons",
      "requirement": "Obligations",
      "subdivision": "Suitability of responsible persons",
      "sublevel": "Offence relating to failure to comply with responsibility to consider suitability matters relating to responsible persons",
      "topic": [
        "workforce",
        "unspecified"
      ],
      "summary": "At least every 12 months the registered provider of a kind must consider the suitability of the responsible person in accordance with the rules and be reasonably satisfied that the person is suitable to be involved in the delivery of services. The provider must also keep a record of those matters and comply with any other requirements in the rules.",
      "summaryHTML": "At least every 12 months the registered provider of a kind must consider the suitability of the responsible person in accordance with the rules and be reasonably satisfied that the person is suitable to be involved in the delivery of services. The provider must also keep a record of those matters and comply with any other requirements in the rules.",
      "extract": "(1) A registered provider of a kind prescribed by the rules must, in relation to a person who is one of the responsible persons of the registered provider: \n\n(a) at least once every 12 months: \n\n(i) consider the suitability matters in relation to the person in accordance with any requirements prescribed by the rules; and \n\n(ii) be reasonably satisfied that the person is suitable to be involved in the delivery of funded aged care services; and \n\n(b) keep a record of those matters that complies with any requirements prescribed by the rules; and \n\n(c) comply with any other requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631515",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 546,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 5, s172-5-10",
          "section": "Kinds of registered provider to which the obligation applies",
          "requirement": "Obligations",
          "subdivision": "Suitability of responsible persons",
          "sublevel": "Offence relating to failure to comply with responsibility to consider suitability matters relating to responsible persons",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "These rules (made under subsection 172(1) and paragraph 172(1)(b) of the Act) provide that the requirement to consider suitability matters in relation to a responsible person, at least once every 12 months, applies to every kind of registered provider and that the provider must keep a record of its consideration of suitability matters that includes the following:\n\n(a) The name of the person in relation to whom the suitability matters were considered.\n\n(b) The date or dates on which the suitability matters were considered in relation to the person.\n\n(c) The outcome of the provider’s consideration of each suitability matter in relation to the person.\n\n(d) The reasons for reaching that outcome.",
          "summaryHTML": "These rules (made under subsection 172(1) and paragraph 172(1)(b) of the Act) provide that the requirement to consider suitability matters in relation to a responsible person, at least once every 12 months, applies to every kind of registered provider and that the provider must keep a record of its consideration of suitability matters that includes the following:\n\n(a) The name of the person in relation to whom the suitability matters were considered.\n\n(b) The date or dates on which the suitability matters were considered in relation to the person.\n\n(c) The outcome of the provider’s consideration of each suitability matter in relation to the person.\n\n(d) The reasons for reaching that outcome.",
          "extract": "For the purposes of subsection 172(1) of the Act, every kind of registered provider is prescribed.\n\nFor the purposes of paragraph 172(1)(b) of the Act, a registered provider must keep a record of its consideration of suitability matters in relation to a person that includes the following:\n\n(a) the name of the person in relation to whom the suitability matters were considered;\n\n(b) the date or dates on which the suitability matters were considered in relation to the person;\n\n(c) the outcome of the provider’s consideration of each suitability matter in relation to the person;\n\n(d) the reasons for reaching that outcome.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": true,
          "cohort": {
            "natsifacp": null,
            "sah": null,
            "resi": null,
            "mps": null,
            "chsp": null,
            "tcp": null
          },
          "providerType": {
            "individual": null,
            "bodyCorp": null,
            "bodyPolitic": null,
            "partnerships": null,
            "otherUnico": null,
            "govt": null
          },
          "registeredCategories": {
            "cat1": {
              "category": null,
              "subcategories": {
                "da": null,
                "hmr": null,
                "meals": null,
                "transport": null
              }
            },
            "cat2": {
              "category": null,
              "subcategories": {
                "ep": null,
                "ha": null
              }
            },
            "cat3": {
              "category": null,
              "subcategories": {
                "hsa": null,
                "ssce": null
              }
            },
            "cat4": {
              "category": null,
              "subcategories": {
                "aht": null,
                "pc": null,
                "nutrition": null,
                "tsil": null,
                "hcgr": null,
                "ccr": null,
                "cm": null,
                "rcm": null
              }
            },
            "cat5": {
              "category": null,
              "subcategories": {
                "nc": null,
                "atc": null
              }
            },
            "cat6": {
              "category": null,
              "subcategories": {
                "ra": null,
                "rcc": null,
                "rel": null,
                "rncc": null
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s172(1)"
        }
      ]
    },
    {
      "id": 50,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s173(1)",
      "section": "Aged care workers of registered providers must comply with Aged Care Code of Conduct",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Aged care workers of registered providers must comply with Aged Care Code of Conduct",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "An aged care worker of a registered provider must comply with the Aged Care Code of Conduct.",
      "summaryHTML": "An aged care worker of a registered provider must comply with the Aged Care Code of Conduct.",
      "extract": "(1) An aged care worker of a registered provider must comply with the Aged Care Code of Conduct.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631517",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": true,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 51,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s174(1)",
      "section": "Responsible persons of registered providers must comply with Aged Care Code of Conduct",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Responsible persons of registered providers must comply with Aged Care Code of Conduct",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A responsible person of a registered provider must comply with the Aged Care Code of Conduct.",
      "summaryHTML": "A responsible person of a registered provider must comply with the Aged Care Code of Conduct.",
      "extract": "(1) A responsible person of a registered provider must comply with the Aged Care Code of Conduct.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631518",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": true
      },
      "type": "Hook"
    },
    {
      "id": 52,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s175(1)-(2)",
      "section": "Registered nurses",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Registered nurses",
      "topic": [
        "workforce",
        "reporting"
      ],
      "summary": "A registered provider must ensure that at least one registered nurse is on site, and on duty, at all times at an approved residential care home of the registered provider.\n\nThe requirements in subsection (1) do not apply if the System Governor grants an exemption or if the registered provider is delivering funded aged care services under MPSP and TCP.",
      "summaryHTML": "A registered provider must ensure that at least one registered nurse is on site, and on duty, at all times at an approved residential care home of the registered provider.\n\nThe requirements in subsection (1) do not apply if the System Governor grants an exemption or if the registered provider is delivering funded aged care services under MPSP and TCP.",
      "extract": "(1) A registered provider must ensure that at least one registered nurse is on site, and on duty, at all times at an approved residential care home of the registered provider. \n\n(2) Subsection (1) does not apply if: \n\n(a) the System Governor grants the registered provider an exemption in accordance with any rules made for the purposes of subsection (3); or \n\n(b) the registered provider is delivering funded aged care services at the approved residential care home only under a specialist aged care program that is prescribed by the rules",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631519",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 547,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 1, Sub Div A, s175-5",
          "section": "Specialist aged care programs to which the registered nurse obligation does not apply—MPSP and TCP",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Registered nurses",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This rule (made under paragraph 175(2)(b) of the Act) prescribes MPSP and TCP as the relevant specialist aged care programs to which this requirement does not apply.",
          "summaryHTML": "This rule (made under paragraph 175(2)(b) of the Act) prescribes MPSP and TCP as the relevant specialist aged care programs to which this requirement does not apply.",
          "extract": "For the purposes of paragraph 175(2)(b) of the Act, a registered provider delivering funded aged care services at an approved residential care home under any of the following specialist aged care programs is prescribed:\n\n(a) MPSP;\n\n(b) TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s175(1)-(2)"
        }
      ]
    },
    {
      "id": 53,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s175(3)",
      "section": "Registered nurses",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Registered nurses",
      "topic": [
        "workforce",
        "reporting"
      ],
      "summary": "The rules may include guidelines for granting an exemption from the requirement mentioned in subsection (1).",
      "summaryHTML": "The rules may include guidelines for granting an exemption from the requirement mentioned in subsection (1).",
      "extract": "(3) The rules may make provision for, or in relation to, the granting of an exemption to the requirement in subsection (1).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631519",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 54,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s175(4)",
      "section": "Registered nurses",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Registered nurses",
      "topic": [
        "workforce",
        "unspecified"
      ],
      "summary": "The rules related to granting an exemption from subsection (1), must provide the circumstances for approval, the requirement for the System Governor to ensure clinical care needs are met of individuals in approved residential homes during the period for which the exemption applies, which is a maximum duration of 12 months for each exemption. The rules must provide the possibility of granting multiple exemptions, and any applicable conditions for those exemptions in relation to an approved residential home.",
      "summaryHTML": "The rules related to granting an exemption from subsection (1), must provide the circumstances for approval, the requirement for the System Governor to ensure clinical care needs are met of individuals in approved residential homes during the period for which the exemption applies, which is a maximum duration of 12 months for each exemption. The rules must provide the possibility of granting multiple exemptions, and any applicable conditions for those exemptions in relation to an approved residential home.",
      "extract": "(4) Without limiting subsection (3), rules made for the purposes of that subsection must: \n\n(a) provide for the circumstances in which an exemption from subsection (1) may be granted (on application or otherwise) to a registered provider in relation to an approved residential care home; and \n\n(b) provide that before granting such an exemption, the System Governor must be satisfied that the provider has taken reasonable steps to ensure that the clinical care needs of the individuals residing in the approved residential care home will be met during the period for which the exemption is in force; and \n\n(c) provide that such an exemption that is granted to a registered provider in relation to an approved residential care home must not be in force for more than 12 months; and \n\n(d) provide that more than one such exemption may be granted to a registered provider in relation to an approved residential care home; and \n\n(e) provide for the conditions that may apply to such an exemption that is granted to a registered provider in relation to an approved residential care home.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631519",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 55,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div C, s176",
      "section": "Delivery of direct care",
      "requirement": "Obligations",
      "subdivision": "Obligations relating to aged care workers",
      "sublevel": "Delivery of direct care",
      "topic": [
        "workforce",
        "unspecified"
      ],
      "summary": "A registered provider in registration Category 6 - residential care must deliver direct care in accordance with the rules.",
      "summaryHTML": "A registered provider in registration Category 6 - residential care must deliver direct care in accordance with the rules.",
      "extract": "A registered provider of a kind prescribed by the rules must deliver direct care in accordance with any requirements prescribed by the rules.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631520",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 548,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div A, s176-5",
          "section": "Kinds of provider to which the obligation applies, and requirements",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Subdivision A sets out the requirements for the delivery of direct care for mainstream registered providers registered in Category 6 - residential care.",
          "summaryHTML": "Subdivision A sets out the requirements for the delivery of direct care for mainstream registered providers registered in Category 6 - residential care.",
          "extract": "For the purposes of section 176 of the Act:\n\n(a) a registered provider registered in the provider registration category residential care is prescribed; and\n\n(b) this Subdivision sets out the requirements for delivering direct care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 549,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div A, s176-10",
          "section": "Application of this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "The requirements of this Subdivision do not apply in respect to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP;\n\n(b) MPSP;\n\n(c) NATSIFACP.",
          "summaryHTML": "The requirements of this Subdivision do not apply in respect to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP;\n\n(b) MPSP;\n\n(c) NATSIFACP.",
          "extract": "The requirements of this Subdivision do not apply in respect to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP;\n\n(b) MPSP;\n\n(c) NATSIFACP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 550,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div A, s176-15(1)-(5)",
          "section": "Care minutes that must be delivered",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Care minutes that must be delivered\n\nThis section sets out the number of care minutes that must be provided if a provider is delivering funded aged care services in an approved residential care home in a quarter. It does not apply to the delivery of funded aged care services under any of the specialist aged care programs, TCP, MPSP or NATSIFACP. The section contains the following requirements:\n\nCare minutes delivered by direct care staff members \n(2): The provider must ensure that the average number of care minutes delivered in the home by direct care staff members of the provider per counted mainstream individual per day is at least the required combined staff average number of care minutes per individual per day worked out under subsection 176 -20(1) in respect of the home for the quarter. (Note: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act)).\n\nCare minutes delivered by registered nurse staff members\n(3): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members of the provider per counted mainstream individual per day is at least 90% of the required registered nurse average number of care minutes per individual per day worked out under subsection 176-20(2) in respect of the home for the quarter.\n\nCare minutes delivered by registered nurse staff members and enrolled nurse staff members\n(4): The registered provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members and enrolled nurse staff members of the provider per counted mainstream individual per day is at least the required registered nurse average number of care minutes per individual per day worked out under subsection 176 -20(2) in respect of the home for the quarter.\n \nCounted individuals\n(5): An individual accessing funded aged care services in an approved residential care home on a day is a counted mainstream individual on the day unless:\n\n(a) the individual accesses the funded aged care services through a specialist aged care program referred to in section 176-10; or\n\n(b) the individual is on extended hospital leave, and the day is on or after the 29th day of the individual’s leave.",
          "summaryHTML": "<i>Care minutes that must be delivered</i>\n\nThis section sets out the number of care minutes that must be provided if a provider is delivering funded aged care services in an approved residential care home in a quarter. It does not apply to the delivery of funded aged care services under any of the specialist aged care programs, TCP, MPSP or NATSIFACP. The section contains the following requirements:\n\n<i>Care minutes delivered by direct care staff members</i> \n(2): The provider must ensure that the average number of care minutes delivered in the home by direct care staff members of the provider per counted mainstream individual per day is at least the required combined staff average number of care minutes per individual per day worked out under subsection 176 -20(1) in respect of the home for the quarter. (Note: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act)).\n\n<i>Care minutes delivered by registered nurse staff members\n</i>(3): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members of the provider per counted mainstream individual per day is at least 90% of the required registered nurse average number of care minutes per individual per day worked out under subsection 176-20(2) in respect of the home for the quarter.\n\n<i>Care minutes delivered by registered nurse staff members and enrolled nurse staff members\n</i>(4): The registered provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members and enrolled nurse staff members of the provider per counted mainstream individual per day is at least the required registered nurse average number of care minutes per individual per day worked out under subsection 176 -20(2) in respect of the home for the quarter.\n \n<i>Counted individuals\n</i>(5): An individual accessing funded aged care services in an approved residential care home on a day is a counted mainstream individual on the day unless:\n\n(a) the individual accesses the funded aged care services through a specialist aged care program referred to in section 176-10; or\n\n(b) the individual is on extended hospital leave, and the day is on or after the 29th day of the individual’s leave.",
          "extract": "(1) This section applies if the provider is delivering funded aged care services in an approved residential care home in a quarter.\n\nRequirement—direct care provided by direct care staff members\n\n(2) The provider must ensure that the average amount of direct care delivered in the home by direct care staff members of the provider per counted mainstream individual per day is at least the required combined staff average amount of direct care per individual per day worked out under subsection 176-20(1) in respect of the home for the quarter.\n\nNote: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act).\n\nRequirement—direct care provided by registered nurse staff members\n\n(3) The provider must ensure that the average amount of direct care delivered in the home by registered nurse staff members of the provider per counted mainstream individual per day is at least 90% of the required registered nurse average amount of direct care per individual per day worked out under subsection 176-20(2) in respect of the home for the quarter.\n\nResponsibility—direct care provided by registered nurse staff members and enrolled nurse staff members\n\n(4) The registered provider must ensure that the average amount of direct care delivered through the home by registered nurse staff members and enrolled nurse staff members of the provider per counted mainstream individual per day is at least the required registered nurse average amount of direct care per individual per day worked out under subsection 176-20(2) in respect of the home for the quarter.\n\nCounted individuals \n\n(5) An individual accessing funded aged care services in an approved residential care home on a day is a counted mainstream individual on the day unless: \n\n(a) the individual accesses the funded aged care services through a specialist aged care program referred to in section 176-10; or \n\n(b) the individual is on extended hospital leave, and the day is on or after the 29th day of the individual’s leave.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 551,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div A, s176-20(1)-(8)",
          "section": "Average numbers of care minutes",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "This section contains provisions about how to work out the average numbers of care minutes as referred to in, and required by, section 176-15 of the rules. It contains the following subsections:\n\n(1): Required combined staff average number of care minutes.\n\n(2): Required registered nurse average number of care minutes.\n\n(3): Daily amounts.\n\n(4) and (5): Day of recognised residential care.\n\n(6): Reference period.\n\n(7): Information to be disregarded for calculations.\n\n(8): Calculation if no days of recognised residential care provided during reference period.",
          "summaryHTML": "This section contains provisions about how to work out the average numbers of care minutes as referred to in, and required by, section 176-15 of the rules. It contains the following subsections:\n\n(1): Required combined staff average number of care minutes.\n\n(2): Required registered nurse average number of care minutes.\n\n(3): Daily amounts.\n\n(4) and (5): Day of recognised residential care.\n\n(6): Reference period.\n\n(7): Information to be disregarded for calculations.\n\n(8): Calculation if no days of recognised residential care provided during reference period.",
          "extract": "Required combined staff average amount of direct care \n\n(1) The required combined staff average amount of direct care per individual per day in respect of an approved residential care home for a quarter is worked out by: \n\n(a) starting with the sum of the combined staff daily amounts for all of the days of recognised residential care provided in respect of individuals in the home during the reference period for the quarter; and \n\n(b) dividing that sum by the total number of days of recognised residential care provided in respect of individuals in the home during the reference period for the quarter; and \n\n(c) rounding the result of that division to 2 decimal places (rounding up if the third decimal place is 5 or more). \n\nRequired registered nurse average amount of direct care \n\n(2) The required registered nurse average amount of direct care per individual per day in respect of an approved residential care home for a quarter is worked out by: \n\n(a) starting with the sum of the registered nurse daily amounts for all of the days of recognised residential care provided in respect of individuals in the home during the reference period for the quarter; and \n\n(b) dividing that sum by the total number of days of recognised residential care provided in respect of individuals in the home during the reference period for the quarter; and \n\n(c) rounding the result of that division to 2 decimal places (rounding up if the third decimal place is 5 or more). \n\nDaily amounts \n\n(3) The following table sets out, for a day of recognised residential care provided in respect of an individual in an approved residential care home: \n\n(a) the combined staff daily amount for the day for the individual; and \n\n(b) the registered nurse daily amount for the day for the individual. \n\nDay of recognised residential care \n\n(4) A day of recognised residential care is provided in respect of an individual in an approved residential care home if funded aged care services are delivered to the individual in the home through the residential care service category on that day. \n\n(5) Despite subsection (4), a day of recognised residential care does not include a day where: \n\n(a) funded aged care services are delivered through a specialist aged care program referred to in section 176-10; or \n\n(b) funded aged care services are provided to an individual classified as: \n\n(i) Class 0; or \n\n(ii) Respite Class 0. \n\nReference period \n\n(6) The reference period for a quarter is the period of 3 months beginning on the day that is 4 months before the first day of the quarter. \n\nInformation to be disregarded for calculations \n\n(7) For the purposes of a calculation under this section for a quarter: \n\n(a) information about an individual entering or exiting an approved residential care home during the reference period for the quarter is to be disregarded if it is given to the System Governor on or after the calculation day for the quarter; and \n\n(b) a change to a classification decision for an individual that is made on or after the calculation day for the quarter but takes effect before the calculation day is to be disregarded. \n\nCalculation if no days of recognised residential care provided during reference period \n\n(8) If no days of recognised residential care were provided in respect of individuals in an approved residential care home during the reference period for a quarter, the result of the calculations in subsections (1) and (2) in relation to the quarter is taken to be zero minutes per individual per day. \n\nNote: This subsection is to avoid an undefined result when dividing by zero.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 552,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div B, s176-25",
          "section": "Kinds of provider to which the obligation applies, and requirements",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Subdivision B sets out requirements for the delivery of direct care for NATSIFACP providers in Category 6 - residential care.",
          "summaryHTML": "Subdivision B sets out requirements for the delivery of direct care for NATSIFACP providers in Category 6 - residential care.",
          "extract": "For the purposes of section 176 of the Act:\n\n(a) a registered provider registered in the provider registration category residential care is prescribed; and\n\n(b) this Subdivision sets out the requirements for delivering direct care.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 553,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div B, s176-30",
          "section": "Application of this Subdivision",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "These requirements do not apply to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP.\n\n(b) MPSP.",
          "summaryHTML": "These requirements do not apply to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP.\n\n(b) MPSP.",
          "extract": "The requirements of this Subdivision do not apply in respect to the delivery of funded aged care services provided under any of the following specialist aged care programs:\n\n(a) TCP;\n\n(b) MPSP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        },
        {
          "id": 554,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 6, Div 2, Sub Div B, s176-35(1)-(6)",
          "section": "Care minutes that must be delivered—NATSIFACP providers",
          "requirement": "Obligations",
          "subdivision": "Obligations relating to aged care workers",
          "sublevel": "Delivery of direct care",
          "topic": [
            "workforce",
            "unspecified"
          ],
          "summary": "Care minutes that must be delivered - NATSIFACP providers\n\nThis section sets out the care minutes that must be delivered if a provider is delivering funded aged care services in an approved residential care home in a quarter under the specialist aged care program NATSIFACP. It does not apply to the delivery of funded aged care services under either of the specialist aged care programs, TCP or MPSP. The section contains the following requirements:\n\nCare minutes delivered by direct care staff members \n(2): The provider must ensure that the average number of care minutes delivered in the home by direct care staff members of the provider per counted NATSIFACP individual per day is at least 215 minutes per individual per day in respect of the home for the reporting period for the provider. (Note: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act)).\n\nCare minutes delivered by registered nurse staff members\n(3): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members of the provider per counted NATSIFACP individual per day is at least 39.6 minutes per individual per day in respect of the home for the reporting period for the provider.\n\nCare minutes delivered by registered nurse staff members and enrolled nurse staff members \n(4): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members and enrolled nurse staff members of the provider per counted NATSIFACP individual per day is at least 44 minutes per individual per day in respect of the home for the reporting period for the provider.\n\nCounted individuals \n(5): An individual accessing funded aged care services in an approved residential care home on a day under the specialist aged care program NATSIFACP is a counted NATSIFACP individual on the day unless:\n\n(a) the individual is on extended hospital leave; and\n\n(b) the day is on or after the 29th day of the individual’s leave.\n\nReporting period \n(6): The reporting period for the provider is the period specified for a service activity report under section 166-645.",
          "summaryHTML": "<i>Care minutes that must be delivered - NATSIFACP providers</i>\n\nThis section sets out the care minutes that must be delivered if a provider is delivering funded aged care services in an approved residential care home in a quarter under the specialist aged care program NATSIFACP. It does not apply to the delivery of funded aged care services under either of the specialist aged care programs, TCP or MPSP. The section contains the following requirements:\n\n<i>Care minutes delivered by direct care staff members </i>\n(2): The provider must ensure that the average number of care minutes delivered in the home by direct care staff members of the provider per counted NATSIFACP individual per day is at least 215 minutes per individual per day in respect of the home for the reporting period for the provider. (Note: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act)).\n\n<i>Care minutes delivered by registered nurse staff members\n</i>(3): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members of the provider per counted NATSIFACP individual per day is at least 39.6 minutes per individual per day in respect of the home for the reporting period for the provider.\n\n<i>Care minutes delivered by registered nurse staff members and enrolled nurse staff members </i>\n(4): The provider must ensure that the average number of care minutes delivered in the home by registered nurse staff members and enrolled nurse staff members of the provider per counted NATSIFACP individual per day is at least 44 minutes per individual per day in respect of the home for the reporting period for the provider.\n\n<i>Counted individuals </i>\n(5): An individual accessing funded aged care services in an approved residential care home on a day under the specialist aged care program NATSIFACP is a counted NATSIFACP individual on the day unless:\n\n(a) the individual is on extended hospital leave; and\n\n(b) the day is on or after the 29th day of the individual’s leave.\n\n<i>Reporting period </i>\n(6): The reporting period for the provider is the period specified for a service activity report under section 166-645.",
          "extract": "(1) This section applies if the registered provider is delivering funded aged care services in an approved residential care home in a quarter through the specialist aged care program NATSIFACP.\n\nRequirement—direct care provided by direct care staff members\n\n(2) The provider must ensure that the average amount of direct care delivered in the home by direct care staff members of the provider per counted NATSIFACP individual per day is at least 215 minutes per individual per day in respect of the home for the reporting period for the provider.\n\nNote: Direct care staff members of the provider include registered nurse staff members of the provider (see the definition of direct care staff member in section 7 of the Act).\n\nRequirement—direct care provided by registered nurse staff members\n\n(3) The provider must ensure that the average amount of direct care delivered in the home by registered nurse staff members of the provider per counted NATSIFACP individual per day is at least 39.6 minutes per individual per day in respect of the home for the reporting period for the provider.\n\nResponsibility—direct care provided by registered nurse staff members and enrolled nurse staff members\n\n(4) The provider must ensure that the average amount of direct care delivered through the home by registered nurse staff members and enrolled nurse staff members of the provider per counted NATSIFACP individual per day is at least 44 minutes per individual per day in respect of the home for the reporting period for the provider.\n\nCounted individuals \n\n(5) An individual accessing funded aged care services in an approved residential care home on a day through the specialist aged care program NATSIFACP is a counted NATSIFACP individual on the day unless: \n\n(a) the individual is on extended hospital leave; and \n\n(b) the day is on or after the 29th day of the individual’s leave. \n\nReporting period \n\n(6) The reporting period for the provider is the period specified for a service activity report under section 166-645.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s176"
        }
      ]
    },
    {
      "id": 56,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div D, s177(1)",
      "section": "Cooperation with other persons",
      "requirement": "Obligations",
      "subdivision": "Other obligations",
      "sublevel": "Cooperation with other persons",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A registered provider must cooperate with any person who is performing functions, or exercising powers, under this Act.",
      "summaryHTML": "A registered provider must cooperate with any person who is performing functions, or exercising powers, under this Act.",
      "extract": "(1) A registered provider must cooperate with any person who is performing functions, or exercising powers, under this Act. \n\nNote: The expression this Act (see section 7) includes: \n\n(a) legislative instruments made under this Act; and \n\n(b) the Regulatory Powers Act as it applies in relation to this Act.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631522",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 57,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div D, s177(2)",
      "section": "Cooperation with other persons",
      "requirement": "Obligations",
      "subdivision": "Other obligations",
      "sublevel": "Cooperation with other persons",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A registered provider must work with and provide necessary support to anyone conducting activities related to the Pricing Authority's functions under the National Health Reform Act 2011, as required by the rules.",
      "summaryHTML": "A registered provider must work with and provide necessary support to anyone conducting activities related to the Pricing Authority's functions under the National Health Reform Act 2011, as required by the rules.",
      "extract": "(2) A registered provider must cooperate with, and provide all reasonable facilities and assistance necessary to, any person who is undertaking activities mentioned in paragraph 131A(1)(c) of the National Health Reform Act 2011 in accordance with any requirements prescribed by the rules, for the purposes of the Pricing Authority performing the function mentioned in paragraph 131A(1)(a) of that Act.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631522",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": true,
        "resi": true,
        "mps": true,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": true,
          "subcategories": {
            "ep": true,
            "ha": true
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 555,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-10(1)-(2)",
          "section": "Giving data or records to the Pricing Authority",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Giving data or records to the Pricing Authority\n\nFor this rule all registered providers are prescribed unless they deliver funded aged care services under a CHSP or TCP.",
          "summaryHTML": "<i>Giving data or records to the Pricing Authority</i>\n\nFor this rule all registered providers are prescribed unless they deliver funded aged care services under a CHSP or TCP.",
          "extract": "Application of this section\n\n(1) Subject to subsection (2), this section applies to every kind of registered provider.\n\n(2) The requirements of this section do not apply to a registered provider in respect of the delivery of funded aged care services under the following specialist aged care programs: \n\n(a) CHSP; \n\n(b) TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        },
        {
          "id": 556,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-10(3)",
          "section": "Giving data or records to the Pricing Authority",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to comply with notice\n\nRegistered providers are required to comply with requests made by the Pricing Authority under subsections (4) or (6) of section 177-10.\n\nThe Pricing Authority can ask a registered provider in writing to provide necessary data or records for their activities, specifying how and when to submit this information, which must be at least 14 days after the request.",
          "summaryHTML": "<i>Requirement to comply with notice</i>\n\nRegistered providers are required to comply with requests made by the Pricing Authority under subsections (4) or (6) of section 177-10.\n\nThe Pricing Authority can ask a registered provider in writing to provide necessary data or records for their activities, specifying how and when to submit this information, which must be at least 14 days after the request.",
          "extract": "Requirement to comply with notice \n\n(3) For the purposes of subsection 177(2) of the Act, it is a requirement that a registered provider must comply with a request made under subsection (4) or (6).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        },
        {
          "id": 557,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-15(1)-(2)",
          "section": "Allowing access by the Pricing Authority to certain persons",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Allowing access by the Pricing Authority to certain persons\n\nFor this rule all registered providers are prescribed unless they deliver funded aged care services under a CHSP or TCP.",
          "summaryHTML": "<i>Allowing access by the Pricing Authority to certain persons</i>\n\nFor this rule all registered providers are prescribed unless they deliver funded aged care services under a CHSP or TCP.",
          "extract": "Application of this section\n\n(1) Subject to subsection (2), this section applies to every kind of registered provider. \n\n(2) The requirements of this section do not apply to a registered provider in respect of the delivery of funded aged care services under the following specialist aged care programs: \n\n(a) CHSP; \n\n(b) TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        },
        {
          "id": 558,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-15(3)",
          "section": "Allowing access by the Pricing Authority to certain persons",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to comply with notice\n\nRegistered providers must comply with requests made by the Pricing Authority under subsection (4) of section 177-15.\n\nThe Pricing Authority can send a written request to a registered provider to allow their official access to certain individuals for specific activities, and the provider must arrange this access within a reasonable timeframe, at least 14 days after the request.",
          "summaryHTML": "<i>Requirement to comply with notice</i>\n\nRegistered providers must comply with requests made by the Pricing Authority under subsection (4) of section 177-15.\n\nThe Pricing Authority can send a written request to a registered provider to allow their official access to certain individuals for specific activities, and the provider must arrange this access within a reasonable timeframe, at least 14 days after the request.",
          "extract": "Requirement to comply with notice \n\n(3) For the purposes of subsection 177(2) of the Act, it is a requirement that a registered provider must comply with a request made under subsection (4).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": true,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        },
        {
          "id": 559,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-20(1)-(2)",
          "section": "Allowing access by the Pricing Authority to residential care homes",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Allowing access by the Pricing Authority to residential care homes\n\nThis section applies to registered providers in Category 6 - residential care, except for those delivering funded aged care services under the CHSP or TCP.",
          "summaryHTML": "<i>Allowing access by the Pricing Authority to residential care homes</i>\n\nThis section applies to registered providers in Category 6 - residential care, except for those delivering funded aged care services under the CHSP or TCP.",
          "extract": "Application of this section\n\n(1) Subject to subsection (2), this section applies to a registered provider in the provider registration category residential care.\n\n(2) The requirements of this section do not apply to a registered provider in respect of the delivery of funded aged care services under the following specialist aged care programs: \n\n(a) CHSP; \n\n(b) TCP.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        },
        {
          "id": 560,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 5, Part 7, Div 1, s177-20(3)",
          "section": "Allowing access by the Pricing Authority to residential care homes",
          "requirement": "Obligations",
          "subdivision": "Other obligations",
          "sublevel": "Cooperation with other persons",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Requirement to comply with notice\n\nRegistered providers are required to comply with requests made by the Pricing Authority under subsection (4) of section 177-20.\n\nThe Pricing Authority can send a written request to a registered provider to allow their official access to a residential care home for specific activities on a specified day, which must be at least 14 days after the notice is given. The provider must ensure reasonable support for the official, including site orientation, information access for staff and residents, and access to all areas of the home, except private rooms and bathrooms of individuals who do not consent.",
          "summaryHTML": "<i>Requirement to comply with notice</i>\n\nRegistered providers are required to comply with requests made by the Pricing Authority under subsection (4) of section 177-20.\n\nThe Pricing Authority can send a written request to a registered provider to allow their official access to a residential care home for specific activities on a specified day, which must be at least 14 days after the notice is given. The provider must ensure reasonable support for the official, including site orientation, information access for staff and residents, and access to all areas of the home, except private rooms and bathrooms of individuals who do not consent.",
          "extract": "Requirement to comply with notice\n\n(3) For the purposes of subsection 177(2) of the Act, it is a requirement that a registered provider must comply with a request made under subsection (4).",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": true,
            "mps": true,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s177(2)"
        }
      ]
    },
    {
      "id": 58,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 4, Div 2, Sub Div D, s177(3)",
      "section": "Cooperation with other persons",
      "requirement": "Obligations",
      "subdivision": "Other obligations",
      "sublevel": "Cooperation with other persons",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Cooperating with a person also means allowing them access to any approved residential care home operated by the registered provider.",
      "summaryHTML": "Cooperating with a person also means allowing them access to any approved residential care home operated by the registered provider.",
      "extract": "(3) Without limiting subsection (1) or (2), cooperating with a person includes providing access to any approved residential care home of the registered provider.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631522",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": true,
        "mps": true,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 59,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 5, Div 1, s179(1)",
      "section": "Registered provider duty",
      "requirement": "Statutory Duties",
      "subdivision": "Provider and responsible person duties",
      "sublevel": "Registered provider duty",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A registered provider must do everything reasonably possible to ensure that their actions do not harm the health and safety of individuals receiving funded aged care services while they are providing those services.",
      "summaryHTML": "A registered provider must do everything reasonably possible to ensure that their actions do not harm the health and safety of individuals receiving funded aged care services while they are providing those services.",
      "extract": "(1) A registered provider must ensure, so far as is reasonably practicable, that the conduct of the provider does not cause adverse effects to the health and safety of individuals to whom the provider is delivering funded aged care services while the provider is delivering those services.",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631527",
      "allProviders": true,
      "cohort": {
        "natsifacp": null,
        "sah": null,
        "resi": null,
        "mps": null,
        "chsp": null,
        "tcp": null
      },
      "providerType": {
        "individual": null,
        "bodyCorp": null,
        "bodyPolitic": null,
        "partnerships": null,
        "otherUnico": null,
        "govt": null
      },
      "registeredCategories": {
        "cat1": {
          "category": null,
          "subcategories": {
            "da": null,
            "hmr": null,
            "meals": null,
            "transport": null
          }
        },
        "cat2": {
          "category": null,
          "subcategories": {
            "ep": null,
            "ha": null
          }
        },
        "cat3": {
          "category": null,
          "subcategories": {
            "hsa": null,
            "ssce": null
          }
        },
        "cat4": {
          "category": null,
          "subcategories": {
            "aht": null,
            "pc": null,
            "nutrition": null,
            "tsil": null,
            "hcgr": null,
            "ccr": null,
            "cm": null,
            "rcm": null
          }
        },
        "cat5": {
          "category": null,
          "subcategories": {
            "nc": null,
            "atc": null
          }
        },
        "cat6": {
          "category": null,
          "subcategories": {
            "ra": null,
            "rcc": null,
            "rel": null,
            "rncc": null
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 60,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 5, Div 1, s180(1)",
      "section": "Duty for certain responsible persons",
      "requirement": "Statutory Duties",
      "subdivision": "Provider and responsible person duties",
      "sublevel": "Duty for certain responsible persons ",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "A responsible person of a registered provider must take reasonable care to make sure that the provider follows its obligations under section 179.",
      "summaryHTML": "A responsible person of a registered provider must take reasonable care to make sure that the provider follows its obligations under section 179.",
      "extract": "(1) A person who is a responsible person of a registered provider under paragraph 12(1)(a) or (b) must exercise due diligence to ensure that the provider complies with the provider’s duty under section 179.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631528",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": true
      },
      "type": "Hook"
    },
    {
      "id": 61,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 6, s187(1)-(4)",
      "section": "Meaning of aged care digital platform",
      "requirement": "Digital Platform Operators",
      "subdivision": "Aged care digital platform operators",
      "sublevel": "Meaning of aged care digital platform",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules may specify an online application, website, or system by name or category for the purposes of subsections (2) or (3), either for all services in the Commonwealth aged care system or for specific services within that system.",
      "summaryHTML": "The rules may specify an online application, website, or system by name or category for the purposes of subsections (2) or (3), either for all services in the Commonwealth aged care system or for specific services within that system.",
      "extract": "(1)\tAn aged care digital platform means an online enabled application, website or system operated to facilitate the delivery of services in the Commonwealth aged care system (whether funded aged care services or not), where:\n\t(a)\tthe operator of the application, website or system acts as an intermediary for entities seeking to access those services who interact with entities providing the services via the application, website or system; and\n\t(b)\tany of the following requires, and processes, payments referable to that intermediary function:\n\t(i)\tthe operator of the application, website or system;\n\t(ii)\tan associated entity (within the meaning of the Corporations Act 2001) of the operator;\n\t(iii)\ta person contracted, whether directly or through one or more interposed entities, by the operator or an associated entity of the operator to process the payments.\n\t(2)\tAn aged care digital platform also means an online enabled application, website or system that is prescribed by the rules.\n\t(3)\tAn aged care digital platform does not include an online enabled application, website or system prescribed by the rules.\n\n(4) For the purposes of subsection (2) or (3), the rules may: \n\n(a) prescribe an online enabled application, website or system by name or by inclusion in a specified class or specified classes; or \n\n(b) prescribe an online enabled application, website or system in respect of all services in the Commonwealth aged care system, or in respect of specified services in the Commonwealth aged care system.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631539",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": true,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 62,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 6, s188(1)",
      "section": "Duty of operators of aged care digital platforms",
      "requirement": "Digital Platform Operators",
      "subdivision": "Aged care digital platform operators",
      "sublevel": "Duty of operators of aged care digital platforms",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "Operators of aged care digital platforms must check and display key registration and compliance details for any entity claiming to deliver aged care services via the platform.",
      "summaryHTML": "Operators of aged care digital platforms must check and display key registration and compliance details for any entity claiming to deliver aged care services via the platform.",
      "extract": "(1) An operator of an aged care digital platform contravenes this subsection if:\n\n(a) an entity represents via the platform that the entity can deliver a service in the Commonwealth aged care system; and\n\n(b) the operator does not check and display on the platform:\n\n(i) whether the entity is a registered provider or not; and\n\n(ii) if the entity is a registered provider—the registration categories in which the entity is registered; and\n\n(iii) whether a banning order against the entity is, or has at any time been, in force; and\n\n(iv) whether an NDIS banning order against the entity is, or has at any time been, in force; and\n\n(v) whether a banning order (within the meaning of the Commission Act as in force at any time before the commencement of this Act) against the entity has at any time been in force; and\n\n(vi) any other information prescribed by the rules.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631540",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": true,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 561,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s188-1",
          "section": "Duty of operators of aged care digital platforms",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Duty of operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "For the purposes of subparagraph 188(1)(b)(vi) of the Act, an operator of an aged care digital platform must check and display the below information in relation to an entity that represents via the platform:\n\n(a) for an entity that is an aged care worker of a registered provider—that the entity complies with worker screening requirements prescribed by rules made under paragraph 152(1)(b) of the Act that apply to the entity; and \n\n(b) the credentials or qualifications that the entity holds and are stated on the aged care digital platform; and \n\n(c) general information about the processes undertaken in order to check an entity’s credentials or qualifications.",
          "summaryHTML": "For the purposes of subparagraph 188(1)(b)(vi) of the Act, an operator of an aged care digital platform must check and display the below information in relation to an entity that represents via the platform:\n\n(a) for an entity that is an aged care worker of a registered provider—that the entity complies with worker screening requirements prescribed by rules made under paragraph 152(1)(b) of the Act that apply to the entity; and \n\n(b) the credentials or qualifications that the entity holds and are stated on the aged care digital platform; and \n\n(c) general information about the processes undertaken in order to check an entity’s credentials or qualifications.",
          "extract": "For the purposes of subparagraph 188(1)(b)(vi) of the Act, the information that the operator of an aged care digital platform must check and display in relation to an entity that represents via the platform that the entity can deliver a service in the Commonwealth aged care system is: \n\n(a) for an entity that is an aged care worker of a registered provider—that the entity complies with any applicable worker screening requirements prescribed by rules made under paragraph 152(1)(b) of the Act that apply to the entity; and \n\n(b) for an entity that seeks to deliver services in the Commonwealth aged care system—that the entity holds the credentials or qualifications that are stated on the aged care digital platform; and \n\n(c) general information about the processes undertaken in order to check an entity’s credentials or qualifications for the purposes of paragraph (b) of this section.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s188(1)"
        }
      ]
    },
    {
      "id": 63,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 6, s189(1)",
      "section": "Other obligations of certain operators of aged care digital platforms",
      "requirement": "Digital Platform Operators",
      "subdivision": "Aged care digital platform operators",
      "sublevel": "Other obligations of certain operators of aged care digital platforms",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "An entity that operates an aged care digital platform must:\n - Inform the Commissioner that it operates the platform, following specific rules.\n- Set up a system to handle complaints and manage them according to that system and the rules.\n- Create a system to manage incidents and handle them according to that system and the rules.\n- Show a summary and explanation of both the complaints and incident management systems on the platform.\n- Report certain information to the Commissioner or other relevant authorities as required by the rules.\n- Clearly display the Statement of Rights on the platform for users accessing funded aged care services.\n- Keep specific records as required by the rules and share information from those records as needed.\n\nNote: Registered providers must meet certain obligations related to managing incidents, handling complaints, and reporting as part of their registration.",
      "summaryHTML": "An entity that operates an aged care digital platform must:\n - Inform the Commissioner that it operates the platform, following specific rules.\n- Set up a system to handle complaints and manage them according to that system and the rules.\n- Create a system to manage incidents and handle them according to that system and the rules.\n- Show a summary and explanation of both the complaints and incident management systems on the platform.\n- Report certain information to the Commissioner or other relevant authorities as required by the rules.\n- Clearly display the Statement of Rights on the platform for users accessing funded aged care services.\n- Keep specific records as required by the rules and share information from those records as needed.\n\nNote: Registered providers must meet certain obligations related to managing incidents, handling complaints, and reporting as part of their registration.",
      "extract": "(1) An entity that is a constitutional corporation and the operator of an aged care digital platform must: \n\n(a) notify the Commissioner, in accordance with any requirements prescribed by the rules, that the entity operates the platform; and \n\n(b) implement a complaints management system and manage complaints in accordance with that system and any other requirements prescribed by the rules; and \n\n(c) implement an incident management system and manage incidents in accordance with that system and any other requirements prescribed by the rules; and\n \n(d) display on the platform a summary and explanation of the complaints management system referred to and the incident management system referred to; and\n \n(e) report to the Commissioner, the System Governor, the Complaints Commissioner, or the Inspector-General of Aged Care, any information prescribed by the rules to be reported to that person; and\n \n(f) display on the platform, in a way that is prominent to individuals using the platform to access funded aged care services, the Statement of Rights; and\n \n(g) keep and retain the kinds of records prescribed by the rules, and disclose information contained in those records, in accordance with any requirements prescribed by the rules.\n\nNote: Registered providers, as a condition of their registration, have obligations in relation to incident management, complaints management, and reporting.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631541",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": true,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 562,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-1(1)",
          "section": "Notifying Commissioner of operation of aged care digital platforms",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators who are also a constitutional corporation must notify the Commissioner within 14 days of either first displaying a service provider or becoming the platform operator, to ensure compliance with aged care representation rules.",
          "summaryHTML": "Digital platform operators who are also a constitutional corporation must notify the Commissioner within 14 days of either first displaying a service provider or becoming the platform operator, to ensure compliance with aged care representation rules.",
          "extract": "Period within which notice must be given\n\n(1) For the purposes of paragraph 189(1)(a) of the Act, a notice given by an entity that is both a constitutional corporation and the operator of an aged care digital platform must be given:\n\n(a) not later than 14 days after the first day on which the platform displays a representation by another entity that the other entity can deliver a service in the Commonwealth aged care system; or\n\n(b) if the entity becomes the operator of the aged care digital platform after the end of the period referred to in paragraph (a) of this subsection—not later than 14 days after the entity becomes the operator of the aged care digital platform.\n\nNote: Paragraph (b) is to ensure that the provision covers changes in operators.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 563,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-1(2)",
          "section": "Notifying Commissioner of operation of aged care digital platforms",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The notice must include the following information:\n\n(a) the name of the aged care digital platform;\n\n(b) details of the operator, including a key contact person;\n\n(c) if the operator has an ABN—the ABN;\n\n(d) the date on which the operator started to operate the aged care digital platform;\n\n(e) details of the service types that the operator intends to facilitate;\n\n(f) details of any relationships between the operator and registered providers in their corporate structures.",
          "summaryHTML": "The notice must include the following information:\n\n(a) the name of the aged care digital platform;\n\n(b) details of the operator, including a key contact person;\n\n(c) if the operator has an ABN—the ABN;\n\n(d) the date on which the operator started to operate the aged care digital platform;\n\n(e) details of the service types that the operator intends to facilitate;\n\n(f) details of any relationships between the operator and registered providers in their corporate structures.",
          "extract": "Content of notice\n\n(2) The notice must include the following information:\n\n(a) the name of the aged care digital platform;\n\n(b) details of the operator, including a key contact person;\n\n(c) if the operator has an ABN—the ABN;\n\n(d) the date on which the operator started to operate the aged care digital platform;\n\n(e) details of the service types that the operator intends to facilitate;\n\n(f) details of any relationships between the operator and registered providers in their corporate structures.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 578,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-5(2)",
          "section": "Managing complaints",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "General requirements relating to management of receipt etc. of complaints\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nWhen handling complaints, a digital platform operator must record each complaint and send it to the relevant registered provider, collect data on complaints for reporting purposes, keep the information secure and confidential, allow anyone to make complaints (including anonymously and the option to withdraw them), and not charge any fees for receiving or addressing complaints.",
          "summaryHTML": "<i>General requirements relating to management of receipt etc. of complaints</i>\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nWhen handling complaints, a digital platform operator must record each complaint and send it to the relevant registered provider, collect data on complaints for reporting purposes, keep the information secure and confidential, allow anyone to make complaints (including anonymously and the option to withdraw them), and not charge any fees for receiving or addressing complaints.",
          "extract": "General requirements relating to management of receipt etc. of complaints\n\n(2) In managing complaints, the operator of the aged care digital platform must: \n\n(a) ensure that each complaint received is recorded, and referred to the registered provider to which the complaint relates, in accordance with procedures that give effect to the requirements of subsections (3) and (4); and \n\n(b) collect data relating to each complaint received for the purposes of meeting any applicable reporting requirements; and \n\n(c) protect the security and confidentiality of information relating to each complaint received; and \n\n(d) ensure that complaints: \n\n(i) can be made by any person; and \n\n(ii) can be made anonymously; and \n\n(iii) can be withdrawn; and \n\n(e) not impose a fee or charge (however described) for receiving a complaint or for dealing with a complaint.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 579,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-5(3)",
          "section": "Managing complaints",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Specific requirements relating to management of receipt and referral of complaints\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nWhen managing complaints, digital platform operators must: acknowledge each complaint in writing within 3 days, send the complaint to the relevant registered provider in writing within 7 days if appropriate, provide the registered provider with details about the complaint and the complainant's contact information (if possible), and inform the registered provider within 2 days if a referred complaint is withdrawn.",
          "summaryHTML": "<i>Specific requirements relating to management of receipt and referral of complaints</i>\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nWhen managing complaints, digital platform operators must: acknowledge each complaint in writing within 3 days, send the complaint to the relevant registered provider in writing within 7 days if appropriate, provide the registered provider with details about the complaint and the complainant's contact information (if possible), and inform the registered provider within 2 days if a referred complaint is withdrawn.",
          "extract": "Specific requirements relating to management of receipt and referral of complaints \n\n(3) In managing complaints, the operator of the aged care digital platform must:\n\n(a) acknowledge each complaint in writing within 3 days of receipt; and\n\n(b) refer each complaint in writing to the registered provider to which the complaint relates no more than 7 days after receipt, if referral is appropriate; and\n\n(c) ensure that information about the nature of each complaint, and contact details of the person making the complaint (if practicable), is provided to the registered provider to which the complaint relates, to the extent that the information is reasonably necessary to address the complaint; and\n\n(d) if a complaint that has been referred to a registered provider is withdrawn after the referral—notify the registered provider of the withdrawal no more than 2 days after the complaint is withdrawn.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 580,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-5(4)",
          "section": "Managing complaints",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Other requirements relating to management of complaints\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nA digital platform operator must keep complaints confidential unless the complainant agrees to share them, provide support like translation services, inform complainants they can contact the registered provider directly, and conduct annual reviews of the complaints management system to ensure it meets required standards.",
          "summaryHTML": "<i>Other requirements relating to management of complaints</i>\n\nThis rule is relevant to subsection (b) of section 189(1).\n\nA digital platform operator must keep complaints confidential unless the complainant agrees to share them, provide support like translation services, inform complainants they can contact the registered provider directly, and conduct annual reviews of the complaints management system to ensure it meets required standards.",
          "extract": "Other requirements relating to management of complaints\n\n(4) In managing complaints, the operator of an aged care digital platform must ensure: \n\n(a) that the operator does not refer a complaint, or give information about a complaint, to a registered provider without the informed consent of the person making the complaint (or their authorised supporter or advocate); and \n\n(b) that the operator provides support and assistance to a person making a complaint (or making an enquiry that may form a complaint), for example, by facilitating access to translation services; and \n\n(c) that the operator provides information that complaints may be made directly to the registered provider to which the complaint relates; and \n\n(d) that the operator undertakes reviews as required, and at least annually, to ensure the complaints management system meets the requirements of this section.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 564,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-10(2)",
          "section": "Managing reportable incidents",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "General requirements relating to management of reportable incidents\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must record and refer any reported incidents to the relevant registered provider, collect data on these incidents for reporting purposes, keep the information secure and confidential, allow anyone to report incidents without charge, and ensure there are no fees for reporting or assisting providers in responding to incidents.",
          "summaryHTML": "<i>General requirements relating to management of reportable incidents</i>\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must record and refer any reported incidents to the relevant registered provider, collect data on these incidents for reporting purposes, keep the information secure and confidential, allow anyone to report incidents without charge, and ensure there are no fees for reporting or assisting providers in responding to incidents.",
          "extract": "General requirements relating to management of reportable incidents\n\n(2)  In managing reportable incidents, the operator of the aged care digital platform must: \n\n(a) ensure that if a reportable incident is reported, it is recorded, and referral to he registered provider to which the reportable incident relates is facilitated, in accordance with procedures that give effect to the requirements of subsections (3) and (4); and \n\n(b) collect data relating to each reportable incident that is reported, for the purposes of meeting reporting requirements; and \n\n(c) protect the security and confidentiality of information relating to each reportable incident that is reported; and \n\n(d) ensure that any person may report a reportable incident; and \n\n(e) not impose a fee or charge (however described) for reporting of reportable incidents or supporting registered providers in responding to such incidents.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 565,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-10(3)",
          "section": "Managing reportable incidents",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Specific requirements relating to management of reportable incidents\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must acknowledge each reported incident in writing and refer it to the relevant registered provider within 24 hours, including details such as the harm caused, consequences, time and date of the incident, and contact information for those involved or who witnessed it.",
          "summaryHTML": "<i>Specific requirements relating to management of reportable incidents</i>\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must acknowledge each reported incident in writing and refer it to the relevant registered provider within 24 hours, including details such as the harm caused, consequences, time and date of the incident, and contact information for those involved or who witnessed it.",
          "extract": "Specific requirements relating to management of reportable incidents\n\n(3) In managing reportable incidents, the operator of an aged care digital platform must: \n\n(a) acknowledge each report of a reportable incident in writing; and \n\n(b) refer a report of a reportable incident in writing to the registered provider to which the incident relates no more than 24 hours after receipt of the report; and \n\n(c) ensure that each referral of a reportable incident covers the following (if known) in order to support the registered provider in meeting their obligations in relation to the reporting of reportable incidents: \n\n(i) the harm that was caused, or that could reasonably have been expected to have been caused, to each person affected by the reportable incident; \n\n(ii) to the extent known—the consequences of that harm; \n\n(iii) the time and date when the reportable incident was identified; \n\n(iv) the name and contact details of the person recording the details of the reportable incident; \n\n(v) whether or not the reportable incident was reported to the police; \n\n(vi) to the extent known—the time, date and place at which the reportable incident occurred or was alleged or suspected to have occurred; \n\n(vii) to the extent known—the names and contact details of the persons directly involved in the reportable incident; \n\n(viii) to the extent known—the names and contact details of any witnesses to the reportable incident.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 566,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-10(4)",
          "section": "Managing reportable incidents",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Other requirements relating to management of reportable incidents\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must assist individuals wishing to report incidents, provide guidance to service providers on how to report incidents, inform them that they can report directly to the relevant registered provider, conduct annual reviews of the incident management system, ensure registered providers understand their reporting obligations, and train staff on identifying and referring reportable incidents.",
          "summaryHTML": "<i>Other requirements relating to management of reportable incidents</i>\n\nThis rule is relevant to subsection (c) of section 189(1).\n\nA digital platform operator must assist individuals wishing to report incidents, provide guidance to service providers on how to report incidents, inform them that they can report directly to the relevant registered provider, conduct annual reviews of the incident management system, ensure registered providers understand their reporting obligations, and train staff on identifying and referring reportable incidents.",
          "extract": "Other requirements relating to management of reportable incidents\n\n(4) In managing reportable incidents, the operator of an aged care digital platform must ensure: \n\n(a) that the operator provides support and assistance to a person wishing to report a reportable incident (or making an enquiry that may relate to reporting such an incident), for example, by facilitating access to translation services; and \n\n(b) that the operator provides advice to entities that represent that they can deliver funded aged care services via the platform on how to report a reportable incident; and \n\n(c) that the operator provides information that reportable incidents may be reported directly to the registered provider to which the incident relates; and \n\n(d) that the operator undertakes reviews as required, and at least annually, to ensure the incident management system meets the requirements of this section; and \n\n(e) that the operator has regard to the obligations of registered providers in relation to reporting reportable incidents, and gives them information in a manner that facilitates compliance with those obligations; and \n\n(f) that the operator provides training to staff in identifying and taking responsibility for referring reportable incidents including, but not limited to, referring them to registered providers or emergency services if required. \n\nNote: Reportable incident is defined in section 16 of the Act.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 567,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-15(2)-(4)",
          "section": "Reporting requirements",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Reporting requirements\n\nThis rule is relevant to subsection (e) of section 189(1).\n\nEach quarter, digital platform operators must report on complaints, reportable incidents, removals, platform participation numbers, and service delivery volumes related to funded aged care services.\n\nEach complaint or incident report must be reported individually for every provider and aged care worker involved.\n\nEach entity and individual removed from the platform must be reported separately in the quarterly report.",
          "summaryHTML": "<i>Reporting requirements</i>\n\nThis rule is relevant to subsection (e) of section 189(1).\n\nEach quarter, digital platform operators must report on complaints, reportable incidents, removals, platform participation numbers, and service delivery volumes related to funded aged care services.\n\nEach complaint or incident report must be reported individually for every provider and aged care worker involved.\n\nEach entity and individual removed from the platform must be reported separately in the quarterly report.",
          "extract": "(2) The operator must report the following information for each quarter:\n\n(a) the number and type of complaints received, referred, or otherwise handled during that quarter about the following:\n\n(i) registered providers;\n\n(ii) aged care workers of registered providers;\n\n(b) the number and type of reportable incidents reported, referred to another person or body, or otherwise handled, during that quarter about the following:\n\n(i) registered providers;\n\n(ii) aged care workers of registered providers;\n\n(c) the number and details of the following that were removed from the platform by the operator during that quarter, and the reasons why they were removed:\n\n(i) entities that represented via the platform that the entity could deliver funded aged care services;\n\n(ii) individuals to whom funded aged care services were delivered via the platform;\n\n(d) the aggregate number of the following on the platform during that quarter:\n\n(i) aged care workers of registered providers;\n\n(ii) registered providers;\n\n(iii) other entities seeking to deliver funded aged care services via the platform;\n\n(e) if available, the aggregate number of individuals to whom funded aged care services were delivered via the platform during that quarter.\n\n(3) For the purposes of paragraphs (2)(a) and (b), the report must deal separately with each registered provider, and each aged care worker of a registered provider, about whom a complaint or a report of a reportable incident was received, referred, or otherwise handled during the quarter concerned.\n\n(4) For the purposes of paragraph (2)(c), the report must deal separately with each entity, and each individual, removed from the platform by the operator during the quarter concerned.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 568,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-18",
          "section": "Reporting changes to the Commissioner",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Reporting changes to the Commissioner\n\nThis rule is relevant to subsection (e) of section 189(1).\n\nEntities operating as a digital platform must notify the Commissioner within 14 days of any changes to information previously submitted in a notice.",
          "summaryHTML": "<i>Reporting changes to the Commissioner</i>\n\nThis rule is relevant to subsection (e) of section 189(1).\n\nEntities operating as a digital platform must notify the Commissioner within 14 days of any changes to information previously submitted in a notice.",
          "extract": "For the purposes of paragraph 189(1)(e) of the Act, if:\n\n(a) an entity that is both a constitutional corporation and the operator of an aged care digital platform has given a notice to the Commissioner under paragraph 189(1)(a) of the Act in accordance with subsection 189-1(1) of this instrument; and\n\n(b) there is a change in the information included in the notice;\n\nthe entity must report the change to the Commissioner not later than 14 days after the change.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 569,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(1)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Keeping and retaining records, etc\n\nThis section outlines the specific records that digital platform operators must keep under section 189(1)(g) of the Act.",
          "summaryHTML": "<i>Keeping and retaining records, etc</i>\n\nThis section outlines the specific records that digital platform operators must keep under section 189(1)(g) of the Act.",
          "extract": "(1) For the purposes of paragraph 189(1)(g) of the Act, the records to be kept and retained by an entity that is both a constitutional corporation and the operator of an aged care digital platform are prescribed by this section.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 570,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(2)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "The digital platform operator must maintain records for each complaint and reportable incident, including the details of the complaint or report, how it was managed, when it was referred to the relevant registered provider, and the date the provider acknowledged receipt.",
          "summaryHTML": "The digital platform operator must maintain records for each complaint and reportable incident, including the details of the complaint or report, how it was managed, when it was referred to the relevant registered provider, and the date the provider acknowledged receipt.",
          "extract": "(2) The operator must keep and retain the following records for each complaint made and each report of a reportable incident received: \n\n(a) the complaint made, or the report of the reportable incident, and any information relating to the complaint or report, as the case requires; \n\n(b) how the complaint or report was managed through the operator’s systems; \n\n(c) details of when the complaint or report was referred to the relevant registered provider; \n\n(d) the date of acknowledgement of receipt by the relevant registered provider.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 571,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(3)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators must maintain records of aged care workers, registered providers, and associated providers who claim to deliver funded aged care services via the platform.",
          "summaryHTML": "Digital platform operators must maintain records of aged care workers, registered providers, and associated providers who claim to deliver funded aged care services via the platform.",
          "extract": "(3) The operator must keep and retain records of the following entities that represent via the platform that they can deliver a funded aged care service:\n\n(a) aged care workers of registered providers;\n\n(b) registered providers and their associated providers.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 572,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(4)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators must retain records of services delivered to individuals and identify the responsible workers and providers.",
          "summaryHTML": "Digital platform operators must retain records of services delivered to individuals and identify the responsible workers and providers.",
          "extract": "(4) The operator must keep and retain records of: \n\n\n(a) the funded aged care services delivered to an individual; and \n\n(b) the aged care workers and the registered providers responsible for the delivery of those services.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 573,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(5)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators must keep records of any aged care workers, providers, associated providers or individuals who received services that were removed from the platform and the reasons for their removal.",
          "summaryHTML": "Digital platform operators must keep records of any aged care workers, providers, associated providers or individuals who received services that were removed from the platform and the reasons for their removal.",
          "extract": "(5) The operator must keep and retain records of the following that the operator removed from the platform, and the reasons why: \n\n(a) the names and numbers of aged care workers of registered providers; \n\n(b) registered providers and associated providers of registered providers; \n\n(c) individuals to whom funded aged care services were delivered via the platform.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 574,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(6)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators must keep and retain records of correction to information requests and how they responded to them.",
          "summaryHTML": "Digital platform operators must keep and retain records of correction to information requests and how they responded to them.",
          "extract": "(6) The operator must keep and retain records of the details of requests for corrections to information held on the platform, and the operator’s responses to those requests.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 575,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-20(7)",
          "section": "Keeping and retaining records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Digital platform operators must have procedures to ensure all required records are retained for a minimum of 7 years.",
          "summaryHTML": "Digital platform operators must have procedures to ensure all required records are retained for a minimum of 7 years.",
          "extract": "(7) The operator must ensure that procedures are in place requiring that all records that must be kept and retained by the operator are retained for at least 7 years.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 576,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-25(2)",
          "section": "Disclosing information included in records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Disclosing information included in records, etc\n\nThis rule is relevant to subsection (g) of section 189(1).\n\nDigital platform operators must promptly provide aged care service records to individuals or, with consent, to their supporters, advocates, or providers.",
          "summaryHTML": "<i>Disclosing information included in records, etc</i>\n\nThis rule is relevant to subsection (g) of section 189(1).\n\nDigital platform operators must promptly provide aged care service records to individuals or, with consent, to their supporters, advocates, or providers.",
          "extract": "(2) If the operator has records about an individual to whom funded aged care services are being or have been delivered, the operator must provide that information on request in a timely manner:\n\n(a) to the individual; and\n\n(b) with the individual’s informed consent—to their supporters or advocates, or to a registered provider.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        },
        {
          "id": 577,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 6, Part 2, s189-30(2)-(3)",
          "section": "Correcting records, etc.",
          "requirement": "Digital Platform Operators",
          "subdivision": "Aged care digital platform operators",
          "sublevel": "Other obligations of certain operators of aged care digital platforms",
          "topic": [
            "unspecified",
            "unspecified"
          ],
          "summary": "Correcting records, etc.\n\nThis rule is relevant to subsection (g) of section 189(1).\n\nAn entity can ask the digital platform operator, verbally or in writing, to correct their personal information held in records. \n\nDigital platform operators must reasonably correct any record it finds to be inaccurate, outdated, irrelevant, incomplete, or misleading.",
          "summaryHTML": "<i>Correcting records, etc.</i>\n\nThis rule is relevant to subsection (g) of section 189(1).\n\nAn entity can ask the digital platform operator, verbally or in writing, to correct their personal information held in records. \n\nDigital platform operators must reasonably correct any record it finds to be inaccurate, outdated, irrelevant, incomplete, or misleading.",
          "extract": "(2) Another entity may request, in writing or orally, that the operator make a correction to information relating to the other entity that is included in the operator’s records.\n\n(3) If the operator is satisfied that information included in its records is inaccurate, incomplete, out of date, irrelevant or misleading, the operator must take reasonable steps to correct the information.",
          "individualProvider": "Individual",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": false,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": false,
            "tcp": false
          },
          "providerType": {
            "individual": false,
            "bodyCorp": false,
            "bodyPolitic": false,
            "partnerships": false,
            "otherUnico": false,
            "govt": false
          },
          "registeredCategories": {
            "cat1": {
              "category": false,
              "subcategories": {
                "da": false,
                "hmr": false,
                "meals": false,
                "transport": false
              }
            },
            "cat2": {
              "category": false,
              "subcategories": {
                "ep": false,
                "ha": false
              }
            },
            "cat3": {
              "category": false,
              "subcategories": {
                "hsa": false,
                "ssce": false
              }
            },
            "cat4": {
              "category": false,
              "subcategories": {
                "aht": false,
                "pc": false,
                "nutrition": false,
                "tsil": false,
                "hcgr": false,
                "ccr": false,
                "cm": false,
                "rcm": false
              }
            },
            "cat5": {
              "category": false,
              "subcategories": {
                "nc": false,
                "atc": false
              }
            },
            "cat6": {
              "category": false,
              "subcategories": {
                "ra": false,
                "rcc": false,
                "rel": false,
                "rncc": false
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": true,
            "rp": false
          },
          "type": "Rule",
          "ref": "s189(1)"
        }
      ]
    },
    {
      "id": 64,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 3, Part 6, s189(3)",
      "section": "Other obligations of certain operators of aged care digital platforms",
      "requirement": "Digital Platform Operators",
      "subdivision": "Aged care digital platform operators",
      "sublevel": "Other obligations of certain operators of aged care digital platforms",
      "topic": [
        "unspecified",
        "unspecified"
      ],
      "summary": "The rules may establish requirements for complaints and incident management systems to ensure that operators of aged care digital platforms assist registered providers in fulfilling their reporting, incident management, and complaints management obligations.",
      "summaryHTML": "The rules may establish requirements for complaints and incident management systems to ensure that operators of aged care digital platforms assist registered providers in fulfilling their reporting, incident management, and complaints management obligations.",
      "extract": "Requirements relating to rules\n\n(3) The rules may prescribe requirements for the purposes of paragraph (1)(b) or (c) only for the purpose of ensuring that the systems implemented by operators of aged care digital platforms support compliance by registered providers with their obligations in relation to reporting, incident management and complaints management.",
      "individualProvider": "Individual",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631541",
      "allProviders": false,
      "cohort": {
        "natsifacp": false,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": false,
        "tcp": false
      },
      "providerType": {
        "individual": false,
        "bodyCorp": false,
        "bodyPolitic": false,
        "partnerships": false,
        "otherUnico": false,
        "govt": false
      },
      "registeredCategories": {
        "cat1": {
          "category": false,
          "subcategories": {
            "da": false,
            "hmr": false,
            "meals": false,
            "transport": false
          }
        },
        "cat2": {
          "category": false,
          "subcategories": {
            "ep": false,
            "ha": false
          }
        },
        "cat3": {
          "category": false,
          "subcategories": {
            "hsa": false,
            "ssce": false
          }
        },
        "cat4": {
          "category": false,
          "subcategories": {
            "aht": false,
            "pc": false,
            "nutrition": false,
            "tsil": false,
            "hcgr": false,
            "ccr": false,
            "cm": false,
            "rcm": false
          }
        },
        "cat5": {
          "category": false,
          "subcategories": {
            "nc": false,
            "atc": false
          }
        },
        "cat6": {
          "category": false,
          "subcategories": {
            "ra": false,
            "rcc": false,
            "rel": false,
            "rncc": false
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": true,
        "rp": false
      },
      "type": "Hook"
    },
    {
      "id": 65,
      "source": "Aged Care Act 2024",
      "citation": "Aged Care Act 2024, Ch 4, Part 2, Div 7, s268(1)",
      "section": "Grantee Code of Conduct",
      "requirement": "Conditions of Registration",
      "subdivision": "Delivery of funded aged care services",
      "sublevel": "Grantee Code of Conduct",
      "topic": [
        "governance",
        "unspecified"
      ],
      "summary": "The rules can establish a code of conduct for providers that may receive money from an arrangement or those who receive financial assistance through a grant.",
      "summaryHTML": "The rules can establish a code of conduct for providers that may receive money from an arrangement or those who receive financial assistance through a grant.",
      "extract": "(1) The rules may make provision for, or in relation to, a code of conduct that applies to persons or bodies:\n\n(a) to whom money may be payable under an arrangement made under subsection 265(1); or\n\n(b) who receive a grant of financial assistance made under subsection 265(1).",
      "individualProvider": "Provider",
      "link": "https://www.legislation.gov.au/C2024A00104/2025-11-01/2025-11-01/text/original/epub/OEBPS/document_1/document_1.html#_Toc212631662",
      "allProviders": false,
      "cohort": {
        "natsifacp": true,
        "sah": false,
        "resi": false,
        "mps": false,
        "chsp": true,
        "tcp": false
      },
      "providerType": {
        "individual": true,
        "bodyCorp": true,
        "bodyPolitic": true,
        "partnerships": true,
        "otherUnico": true,
        "govt": true
      },
      "registeredCategories": {
        "cat1": {
          "category": true,
          "subcategories": {
            "da": true,
            "hmr": true,
            "meals": true,
            "transport": true
          }
        },
        "cat2": {
          "category": true,
          "subcategories": {
            "ep": true,
            "ha": true
          }
        },
        "cat3": {
          "category": true,
          "subcategories": {
            "hsa": true,
            "ssce": true
          }
        },
        "cat4": {
          "category": true,
          "subcategories": {
            "aht": true,
            "pc": true,
            "nutrition": true,
            "tsil": true,
            "hcgr": true,
            "ccr": true,
            "cm": true,
            "rcm": true
          }
        },
        "cat5": {
          "category": true,
          "subcategories": {
            "nc": true,
            "atc": true
          }
        },
        "cat6": {
          "category": true,
          "subcategories": {
            "ra": true,
            "rcc": true,
            "rel": true,
            "rncc": true
          }
        }
      },
      "other": {
        "acw": false,
        "dpo": false,
        "rp": false
      },
      "type": "Hook",
      "rules": [
        {
          "id": 581,
          "source": "Aged Care Rules 2025",
          "citation": "Aged Care Rules 2025, Ch 7, Part 11, Div 2, s268-10(2)",
          "section": "Grantee Code of Conduct",
          "requirement": "Conditions of Registration",
          "subdivision": "Delivery of funded aged care services",
          "sublevel": "Grantee Code of Conduct",
          "topic": [
            "governance",
            "unspecified"
          ],
          "summary": "(2) In undertaking an activity under such an arrangement or grant, the person or body (the grantee) must: \n\n(a) undertake the activity in a safe and competent manner, with care and skill; and \n\n(b) promptly take steps to raise and act on concerns about matters that may affect the quality and safety of the activity; and \n\n(c) promptly disclose to the System Governor, and avoid or manage, any actual, perceived or potential conflicts of interest that could affect the proper undertaking of the activity by any of the following: \n\n(i) the grantee; \n\n(ii) key personnel of the grantee; \n\n(iii) a person who is otherwise employed or engaged by the grantee; and \n\n(d) act with integrity, honesty and transparency; and \n\n(e) treat the following individuals with dignity and respect, and without bullying or harassment, including by valuing the individual’s diversity: \n\n(i) any individual for whom the activity is being undertaken; \n\n(ii) any family member, carer or supporter of the individual for whom the activity is being undertaken; \n\n(iii) any individual engaged in, or participating in, the activity; \n\n(iv) any individual administering the arrangement or grant (whether the individual is an official of the Department or otherwise); and \n\n(f) not provide false or misleading information: \n\n(i) when undertaking the activity; or \n\n(ii) in response to a request for information made for the purposes of this Act in relation to the arrangement or grant.",
          "summaryHTML": "(2) In undertaking an activity under such an arrangement or grant, the person or body (the grantee) must: \n\n(a) undertake the activity in a safe and competent manner, with care and skill; and \n\n(b) promptly take steps to raise and act on concerns about matters that may affect the quality and safety of the activity; and \n\n(c) promptly disclose to the System Governor, and avoid or manage, any actual, perceived or potential conflicts of interest that could affect the proper undertaking of the activity by any of the following: \n\n(i) the grantee; \n\n(ii) key personnel of the grantee; \n\n(iii) a person who is otherwise employed or engaged by the grantee; and \n\n(d) act with integrity, honesty and transparency; and \n\n(e) treat the following individuals with dignity and respect, and without bullying or harassment, including by valuing the individual’s diversity: \n\n(i) any individual for whom the activity is being undertaken; \n\n(ii) any family member, carer or supporter of the individual for whom the activity is being undertaken; \n\n(iii) any individual engaged in, or participating in, the activity; \n\n(iv) any individual administering the arrangement or grant (whether the individual is an official of the Department or otherwise); and \n\n(f) not provide false or misleading information: \n\n(i) when undertaking the activity; or \n\n(ii) in response to a request for information made for the purposes of this Act in relation to the arrangement or grant.",
          "extract": "(2) In undertaking an activity under such an arrangement or grant, the person or body (the grantee) must: \n\n(a) undertake the activity in a safe and competent manner, with care and skill; and \n\n(b) promptly take steps to raise and act on concerns about matters that may affect the quality and safety of the activity; and \n\n(c) promptly disclose to the System Governor, and avoid or manage, any actual, perceived or potential conflicts of interest that could affect the proper undertaking of the activity by any of the following: \n\n(i) the grantee; \n\n(ii) key personnel of the grantee; \n\n(iii) a person who is otherwise employed or engaged by the grantee; and \n\n(d) act with integrity, honesty and transparency; and \n\n(e) treat the following individuals with dignity and respect, and without bullying or harassment, including by valuing the individual’s diversity: \n\n(i) any individual for whom the activity is being undertaken; \n\n(ii) any family member, carer or supporter of the individual for whom the activity is being undertaken; \n\n(iii) any individual engaged in, or participating in, the activity; \n\n(iv) any individual administering the arrangement or grant (whether the individual is an official of the Department or otherwise); and \n\n(f) not provide false or misleading information: \n\n(i) when undertaking the activity; or \n\n(ii) in response to a request for information made for the purposes of this Act in relation to the arrangement or grant.",
          "individualProvider": "Provider",
          "link": "https://www.legislation.gov.au/F2025L01173/latest/text",
          "allProviders": false,
          "cohort": {
            "natsifacp": true,
            "sah": false,
            "resi": false,
            "mps": false,
            "chsp": true,
            "tcp": false
          },
          "providerType": {
            "individual": true,
            "bodyCorp": true,
            "bodyPolitic": true,
            "partnerships": true,
            "otherUnico": true,
            "govt": true
          },
          "registeredCategories": {
            "cat1": {
              "category": true,
              "subcategories": {
                "da": true,
                "hmr": true,
                "meals": true,
                "transport": true
              }
            },
            "cat2": {
              "category": true,
              "subcategories": {
                "ep": true,
                "ha": true
              }
            },
            "cat3": {
              "category": true,
              "subcategories": {
                "hsa": true,
                "ssce": true
              }
            },
            "cat4": {
              "category": true,
              "subcategories": {
                "aht": true,
                "pc": true,
                "nutrition": true,
                "tsil": true,
                "hcgr": true,
                "ccr": true,
                "cm": true,
                "rcm": true
              }
            },
            "cat5": {
              "category": true,
              "subcategories": {
                "nc": true,
                "atc": true
              }
            },
            "cat6": {
              "category": true,
              "subcategories": {
                "ra": true,
                "rcc": true,
                "rel": true,
                "rncc": true
              }
            }
          },
          "other": {
            "acw": false,
            "dpo": false,
            "rp": false
          },
          "type": "Rule",
          "ref": "s268(1)"
        }
      ]
    }
  ]
}